const extra_vocabulary = [
  {
    "id": 1,
    "question": "jumalaisen puheen",
    "answer": "Divine speech",
    "ru": "Божественная речь"
  },
  {
    "id": 2,
    "question": "Järjettömän",
    "answer": "Insanely",
    "ru": "Безумно"
  },
  {
    "id": 3,
    "question": "Takia",
    "answer": "About",
    "ru": "Из-за"
  },
  {
    "id": 4,
    "question": "Vuoksi",
    "answer": "For",
    "ru": "Ради"
  },
  {
    "id": 5,
    "question": "suostuisit",
    "answer": "Agree",
    "ru": "Согласиться"
  },
  {
    "id": 6,
    "question": "Kunnon",
    "answer": "Good",
    "ru": "Хороший"
  },
  {
    "id": 7,
    "question": "Tilava",
    "answer": "Spacious",
    "ru": "Просторный"
  },
  {
    "id": 8,
    "question": "Nolata",
    "answer": "Embarrass",
    "ru": "Смущать"
  },
  {
    "id": 9,
    "question": "Kannustus",
    "answer": "Encouragement",
    "ru": "Поощрение"
  },
  {
    "id": 10,
    "question": "keventää",
    "answer": "Lighten",
    "ru": "Облегчить"
  },
  {
    "id": 11,
    "question": "Pysyttelen",
    "answer": "I will stay",
    "ru": "Я останусь"
  },
  {
    "id": 12,
    "question": "Erossa",
    "answer": "Separated",
    "ru": "В разлуке"
  },
  {
    "id": 13,
    "question": "päihteistä",
    "answer": "intoxicated",
    "ru": "Опьянённый"
  },
  {
    "id": 14,
    "question": "Rupea",
    "answer": "Start",
    "ru": "Начать"
  },
  {
    "id": 15,
    "question": "Nillittämän",
    "answer": "Annoy",
    "ru": "Раздражать"
  },
  {
    "id": 16,
    "question": "vasta alussa",
    "answer": "Only started",
    "ru": "Только начали"
  },
  {
    "id": 17,
    "question": "Kytkin",
    "answer": "Switch",
    "ru": "Выключатель"
  },
  {
    "id": 18,
    "question": "Yritän",
    "answer": "Trying",
    "ru": "Стараюсь"
  },
  {
    "id": 19,
    "question": "Hoitaa",
    "answer": "Handle",
    "ru": "Заниматься"
  },
  {
    "id": 20,
    "question": "Selvitelläänkö",
    "answer": "Lets find out",
    "ru": "Давай разберёмся"
  },
  {
    "id": 21,
    "question": "vasta alussa",
    "answer": "Stings",
    "ru": "Жжёт"
  },
  {
    "id": 22,
    "question": "äskeisen",
    "answer": "Recent",
    "ru": "Недавний"
  },
  {
    "id": 23,
    "question": "Kusen",
    "answer": "Piss",
    "ru": "Моча"
  },
  {
    "id": 24,
    "question": "näköjään",
    "answer": "Apparently",
    "ru": "По всей видимости"
  },
  {
    "id": 25,
    "question": "aika nätti",
    "answer": "Quite pretty",
    "ru": "Довольно симпатичный"
  },
  {
    "id": 26,
    "question": "Taitaa olla",
    "answer": "Seems to be",
    "ru": "Похоже на то"
  },
  {
    "id": 27,
    "question": "Kamat",
    "answer": "Stuff",
    "ru": "Вещи"
  },
  {
    "id": 28,
    "question": "Viedään",
    "answer": "Take our things",
    "ru": "Возьмём наши вещи"
  },
  {
    "id": 29,
    "question": "Ekaksi",
    "answer": "First",
    "ru": "Сначала"
  },
  {
    "id": 30,
    "question": "Pihviä",
    "answer": "Steak",
    "ru": "Стейк"
  },
  {
    "id": 31,
    "question": "Muuta yhteen",
    "answer": "Move in together",
    "ru": "Переехать вместе"
  },
  {
    "id": 32,
    "question": "Taida",
    "answer": "Guess",
    "ru": "Думаю"
  },
  {
    "id": 33,
    "question": "Kunnioittaa",
    "answer": "Respect",
    "ru": "Уважать"
  },
  {
    "id": 34,
    "question": "Rumaa",
    "answer": "Ugly",
    "ru": "Некрасивый"
  },
  {
    "id": 35,
    "question": "Läskiä",
    "answer": "Fat",
    "ru": "Жирный"
  },
  {
    "id": 36,
    "question": "Neuvo",
    "answer": "Advice",
    "ru": "Совет"
  },
  {
    "id": 37,
    "question": "Hirveästi",
    "answer": "Terrifically",
    "ru": "Ужасно"
  },
  {
    "id": 38,
    "question": "jäljellä",
    "answer": "Remaining",
    "ru": "Оставшийся"
  },
  {
    "id": 39,
    "question": "Tietenkin",
    "answer": "Of course",
    "ru": "Конечно"
  },
  {
    "id": 40,
    "question": "Miksi ihmeessä",
    "answer": "Why on Earth",
    "ru": "Почему же на свете"
  },
  {
    "id": 41,
    "question": "Hässit",
    "answer": "Mess",
    "ru": "Беспорядок"
  },
  {
    "id": 42,
    "question": "Tarkoita",
    "answer": "Mean",
    "ru": "Имеешь в виду"
  },
  {
    "id": 43,
    "question": "Perään",
    "answer": "After",
    "ru": "После"
  },
  {
    "id": 44,
    "question": "Sisäpuoli",
    "answer": "Inside",
    "ru": "Внутри"
  },
  {
    "id": 45,
    "question": "Välissä",
    "answer": "Between",
    "ru": "Между"
  },
  {
    "id": 46,
    "question": "Sahaa",
    "answer": "Saw",
    "ru": "Пилить"
  },
  {
    "id": 47,
    "question": "sorkkarautaa",
    "answer": "Crowbar",
    "ru": "Лом"
  },
  {
    "id": 48,
    "question": "Kuluttua",
    "answer": "After",
    "ru": "Спустя"
  },
  {
    "id": 49,
    "question": "pesutupaa",
    "answer": "Laundry room",
    "ru": "Прачечная"
  },
  {
    "id": 50,
    "question": "täyttäkää",
    "answer": "Fill in",
    "ru": "Заполните"
  },
  {
    "id": 51,
    "question": "Pysty",
    "answer": "Upright",
    "ru": "Вертикально"
  },
  {
    "id": 52,
    "question": "Edes",
    "answer": "Even",
    "ru": "Даже"
  },
  {
    "id": 53,
    "question": "Koskemaan",
    "answer": "Touch",
    "ru": "Прикоснуться"
  },
  {
    "id": 54,
    "question": "lisähuomio",
    "answer": "Additional note",
    "ru": "Дополнительное замечание"
  },
  {
    "id": 55,
    "question": "Pitäsi",
    "answer": "You should",
    "ru": "Тебе следует"
  },
  {
    "id": 56,
    "question": "Pärjätä",
    "answer": "Manage",
    "ru": "Справляться"
  },
  {
    "id": 57,
    "question": "Voimin",
    "answer": "Power",
    "ru": "Силой"
  },
  {
    "id": 58,
    "question": "Häittä",
    "answer": "Disadvantage",
    "ru": "Недостаток"
  },
  {
    "id": 59,
    "question": "Aikaiseksi",
    "answer": "Accomplished",
    "ru": "Сделано"
  },
  {
    "id": 60,
    "question": "Olipas",
    "answer": "It was",
    "ru": "Оно было"
  },
  {
    "id": 61,
    "question": "Siinä",
    "answer": "That",
    "ru": "Это"
  },
  {
    "id": 62,
    "question": "Ruskettunut",
    "answer": "Tanned",
    "ru": "Загорелый"
  },
  {
    "id": 63,
    "question": "Entinen",
    "answer": "Former",
    "ru": "Бывший"
  },
  {
    "id": 64,
    "question": "johtajauros",
    "answer": "leader male",
    "ru": "Самец-вожак"
  },
  {
    "id": 65,
    "question": "joutuu",
    "answer": "has to",
    "ru": "Вынужден"
  },
  {
    "id": 66,
    "question": "tyytymään",
    "answer": "to be satisfied",
    "ru": "Довольствоваться"
  },
  {
    "id": 67,
    "question": "lauman",
    "answer": "Herd",
    "ru": "Стадо"
  },
  {
    "id": 68,
    "question": "kumppaninsa",
    "answer": "His/her partner.",
    "ru": "Его/её партнёр"
  },
  {
    "id": 69,
    "question": "lemmenleikkejä",
    "answer": "love games",
    "ru": "Любовные игры"
  },
  {
    "id": 70,
    "question": "katseluun",
    "answer": "for viewing",
    "ru": "Для просмотра"
  },
  {
    "id": 71,
    "question": "koittanut",
    "answer": "arrived",
    "ru": "Наступил"
  },
  {
    "id": 72,
    "question": "naamassa",
    "answer": "in the face",
    "ru": "В лицо"
  },
  {
    "id": 73,
    "question": "pikkasen",
    "answer": "a bit",
    "ru": "Немного"
  },
  {
    "id": 74,
    "question": "hiusväriä",
    "answer": "hair dye",
    "ru": "Краска для волос"
  },
  {
    "id": 75,
    "question": "pese se pois",
    "answer": "wash it off",
    "ru": "Смой это"
  },
  {
    "id": 76,
    "question": "yrittänyt",
    "answer": "tried",
    "ru": "Пытался"
  },
  {
    "id": 77,
    "question": "tehdä",
    "answer": "Do",
    "ru": "Делать"
  },
  {
    "id": 78,
    "question": "polteltuja",
    "answer": "burnt",
    "ru": "Обожжённый"
  },
  {
    "id": 79,
    "question": "eiköhän",
    "answer": "I suppose so",
    "ru": "Наверное, так"
  },
  {
    "id": 80,
    "question": "reissu",
    "answer": "trip",
    "ru": "Поездка"
  },
  {
    "id": 81,
    "question": "se siitä",
    "answer": "that's it",
    "ru": "Вот и всё"
  },
  {
    "id": 82,
    "question": "limppu",
    "answer": "loaf",
    "ru": "Буханка"
  },
  {
    "id": 83,
    "question": "äijä",
    "answer": "old man",
    "ru": "Старик"
  },
  {
    "id": 84,
    "question": "kunnon",
    "answer": "good",
    "ru": "Хороший"
  },
  {
    "id": 85,
    "question": "tietenkin",
    "answer": "Of course",
    "ru": "Конечно"
  },
  {
    "id": 86,
    "question": "laittaa",
    "answer": "put",
    "ru": "Класть"
  },
  {
    "id": 87,
    "question": "tuo yhdet vielä",
    "answer": "bring one more",
    "ru": "Принеси ещё один"
  },
  {
    "id": 88,
    "question": "ei pysty",
    "answer": "no can do",
    "ru": "Не могу"
  },
  {
    "id": 89,
    "question": "illanjatkoa",
    "answer": "evening continuation",
    "ru": "Продолжение вечера"
  },
  {
    "id": 90,
    "question": "se ollut siinä",
    "answer": "That was it",
    "ru": "Вот и всё"
  },
  {
    "id": 91,
    "question": "täynnä",
    "answer": "full",
    "ru": "Полный"
  },
  {
    "id": 92,
    "question": "suostuisit",
    "answer": "you would agree",
    "ru": "Ты бы согласился"
  },
  {
    "id": 93,
    "question": "ole kiltti",
    "answer": "please",
    "ru": "Пожалуйста"
  },
  {
    "id": 94,
    "question": "kainaloon",
    "answer": "armpit",
    "ru": "Подмышка"
  },
  {
    "id": 95,
    "question": "yläasteensa",
    "answer": "High school",
    "ru": "Средняя школа"
  },
  {
    "id": 96,
    "question": "pätkäisi",
    "answer": "stuttered",
    "ru": "Запнулся"
  },
  {
    "id": 97,
    "question": "vai oliko se siinä?",
    "answer": "or was that it?",
    "ru": "Или на этом всё?"
  },
  {
    "id": 98,
    "question": "Palat",
    "answer": "Part",
    "ru": "Часть"
  },
  {
    "id": 99,
    "question": "rentoutumaan",
    "answer": "to relax",
    "ru": "Расслабиться"
  },
  {
    "id": 100,
    "question": "Pysty",
    "answer": "Able",
    "ru": "Способен"
  },
  {
    "id": 101,
    "question": "vetistely",
    "answer": "watering/crying",
    "ru": "Слёзы/нытьё"
  },
  {
    "id": 102,
    "question": "taidan",
    "answer": "I guess",
    "ru": "Думаю"
  },
  {
    "id": 103,
    "question": "todellakin",
    "answer": "Indeksejä",
    "ru": "В самом деле"
  },
  {
    "id": 104,
    "question": "pidä hauskaa",
    "answer": "Have fun",
    "ru": "Развлекайся"
  },
  {
    "id": 105,
    "question": "Jumaliste",
    "answer": "Oh god",
    "ru": "О боже"
  },
  {
    "id": 106,
    "question": "vihjeen",
    "answer": "a hint",
    "ru": "Подсказка"
  },
  {
    "id": 107,
    "question": "rohkaisuryyppyä",
    "answer": "cheers of encouragement",
    "ru": "Ободряющий тост"
  },
  {
    "id": 108,
    "question": "ei se häittää",
    "answer": "it does not matter",
    "ru": "Не важно"
  },
  {
    "id": 109,
    "question": "ilmoittautua",
    "answer": "register",
    "ru": "Зарегистрироваться"
  },
  {
    "id": 110,
    "question": "pöllinyt",
    "answer": "drunk",
    "ru": "Пьяный"
  },
  {
    "id": 111,
    "question": "mitä äijä",
    "answer": "what's up dude",
    "ru": "Что случилось, приятель"
  },
  {
    "id": 112,
    "question": "syötit vedessä",
    "answer": "bait in the water",
    "ru": "Наживка в воде"
  },
  {
    "id": 113,
    "question": "kalaonnea",
    "answer": "Good luck getting fish",
    "ru": "Удачной рыбалки"
  },
  {
    "id": 114,
    "question": "viehe",
    "answer": "lure",
    "ru": "Приманка"
  },
  {
    "id": 115,
    "question": "Vinkki",
    "answer": "Tip",
    "ru": "Совет"
  },
  {
    "id": 116,
    "question": "Kutsu",
    "answer": "Invitation",
    "ru": "Приглашение"
  },
  {
    "id": 117,
    "question": "Vikaa",
    "answer": "Fault",
    "ru": "Вина"
  },
  {
    "id": 118,
    "question": "kuitenkin",
    "answer": "however",
    "ru": "Однако"
  },
  {
    "id": 119,
    "question": "Himo",
    "answer": "Lust",
    "ru": "Похоть"
  },
  {
    "id": 120,
    "question": "Sedät",
    "answer": "Uncles",
    "ru": "Дяди"
  },
  {
    "id": 121,
    "question": "Keitäs",
    "answer": "Who are",
    "ru": "Кто такие"
  },
  {
    "id": 122,
    "question": "arvaan",
    "answer": "i guess",
    "ru": "Думаю"
  },
  {
    "id": 123,
    "question": "polttari",
    "answer": "bachelor party",
    "ru": "Мальчишник"
  },
  {
    "id": 124,
    "question": "sulhanen",
    "answer": "groom",
    "ru": "Жених"
  },
  {
    "id": 125,
    "question": "monimutkaista",
    "answer": "complicated",
    "ru": "Сложно"
  },
  {
    "id": 126,
    "question": "Sellaisia",
    "answer": "Such",
    "ru": "Такие"
  },
  {
    "id": 127,
    "question": "puhdistusliinoja",
    "answer": "Clean clothes",
    "ru": "Чистящие салфетки"
  },
  {
    "id": 128,
    "question": "Synnytätkö",
    "answer": "Are you giving birth",
    "ru": "Ты рожаешь"
  },
  {
    "id": 129,
    "question": "hillitsemään",
    "answer": "to restrain",
    "ru": "Сдерживать"
  },
  {
    "id": 130,
    "question": "tavoin",
    "answer": "ways",
    "ru": "Способами"
  },
  {
    "id": 131,
    "question": "suunnan",
    "answer": "direction",
    "ru": "Направление"
  },
  {
    "id": 132,
    "question": "Joku",
    "answer": "Someone",
    "ru": "Кто-то"
  },
  {
    "id": 133,
    "question": "riehuu",
    "answer": "raging",
    "ru": "Буйствует"
  },
  {
    "id": 134,
    "question": "laitatko",
    "answer": "do you put",
    "ru": "Ты кладёшь"
  },
  {
    "id": 135,
    "question": "hullun",
    "answer": "crazed",
    "ru": "Обезумевший"
  },
  {
    "id": 136,
    "question": "ilomielin",
    "answer": "joyfully",
    "ru": "С радостью"
  },
  {
    "id": 137,
    "question": "ei varmaan auta",
    "answer": "probably won't help",
    "ru": "Наверное, не поможет"
  },
  {
    "id": 138,
    "question": "epävakaa",
    "answer": "erratic",
    "ru": "Неустойчивый"
  },
  {
    "id": 139,
    "question": "kirkastaa",
    "answer": "Clear",
    "ru": "Прояснить"
  },
  {
    "id": 140,
    "question": "rauhoitta",
    "answer": "calm down",
    "ru": "Успокоиться"
  },
  {
    "id": 141,
    "question": "mielen",
    "answer": "mind",
    "ru": "Разум"
  },
  {
    "id": 142,
    "question": "kestäisi",
    "answer": "would last",
    "ru": "Продолжалось бы"
  },
  {
    "id": 143,
    "question": "iän myötä",
    "answer": "with age",
    "ru": "С возрастом"
  },
  {
    "id": 144,
    "question": "sullakin",
    "answer": "you too",
    "ru": "Ты тоже"
  },
  {
    "id": 145,
    "question": "aikahyppy",
    "answer": "time jump",
    "ru": "Прыжок во времени"
  },
  {
    "id": 146,
    "question": "huoleton",
    "answer": "carefree",
    "ru": "Беззаботный"
  },
  {
    "id": 147,
    "question": "kaivannut",
    "answer": "longed for",
    "ru": "Скучал по"
  },
  {
    "id": 148,
    "question": "Juttuja",
    "answer": "Things",
    "ru": "Вещи"
  },
  {
    "id": 149,
    "question": "räpäytystä",
    "answer": "Blinks",
    "ru": "Моргания"
  },
  {
    "id": 150,
    "question": "törkeimmät",
    "answer": "the most outrageous",
    "ru": "Самые возмутительные"
  },
  {
    "id": 151,
    "question": "kohta takaisin",
    "answer": "right back",
    "ru": "Сейчас вернусь"
  },
  {
    "id": 152,
    "question": "tavallaan",
    "answer": "kind of",
    "ru": "Своего рода"
  },
  {
    "id": 153,
    "question": "kutinasta",
    "answer": "from itching",
    "ru": "От зуда"
  },
  {
    "id": 154,
    "question": "tuskallista",
    "answer": "painful",
    "ru": "Болезненно"
  },
  {
    "id": 155,
    "question": "ihan kuin",
    "answer": "just like",
    "ru": "Прямо как"
  },
  {
    "id": 156,
    "question": "luulin",
    "answer": "i thought",
    "ru": "Я думал"
  },
  {
    "id": 157,
    "question": "saaneeni",
    "answer": "that I received",
    "ru": "Что я получил"
  },
  {
    "id": 158,
    "question": "pyytää",
    "answer": "request",
    "ru": "Просить"
  },
  {
    "id": 159,
    "question": "poltti",
    "answer": "smoked",
    "ru": "Курил"
  },
  {
    "id": 160,
    "question": "suunsa",
    "answer": "her mouth",
    "ru": "Её рот"
  },
  {
    "id": 161,
    "question": "vaan",
    "answer": "but",
    "ru": "Но"
  },
  {
    "id": 162,
    "question": "kutina",
    "answer": "itch",
    "ru": "Зуд"
  },
  {
    "id": 163,
    "question": "viranomaisten",
    "answer": "authorities",
    "ru": "Властей"
  },
  {
    "id": 164,
    "question": "kuulepas",
    "answer": "Listen",
    "ru": "Послушай"
  },
  {
    "id": 165,
    "question": "luonnollinen",
    "answer": "natural",
    "ru": "Естественный"
  },
  {
    "id": 166,
    "question": "selitys",
    "answer": "explanation",
    "ru": "Объяснение"
  },
  {
    "id": 167,
    "question": "ajeltu",
    "answer": "shaved",
    "ru": "Выбритый"
  },
  {
    "id": 168,
    "question": "koetettu",
    "answer": "tested",
    "ru": "Проверенный"
  },
  {
    "id": 169,
    "question": "selvittää",
    "answer": "sort out",
    "ru": "Разобраться"
  },
  {
    "id": 170,
    "question": "käyytää",
    "answer": "visit",
    "ru": "Навещать"
  },
  {
    "id": 171,
    "question": "kyse susta",
    "answer": "it's about you",
    "ru": "Речь о тебе"
  },
  {
    "id": 172,
    "question": "määrä",
    "answer": "amount",
    "ru": "Количество"
  },
  {
    "id": 173,
    "question": "alhainen",
    "answer": "low",
    "ru": "Низкий"
  },
  {
    "id": 174,
    "question": "ei se sitä katso",
    "answer": "it doesn't look at it",
    "ru": "Это не смотрит на это"
  },
  {
    "id": 175,
    "question": "huono näkö",
    "answer": "bad sight",
    "ru": "Плохое зрение"
  },
  {
    "id": 176,
    "question": "vaikutusta",
    "answer": "effect",
    "ru": "Влияние"
  },
  {
    "id": 177,
    "question": "iällä",
    "answer": "in age",
    "ru": "По возрасту"
  },
  {
    "id": 178,
    "question": "yhtä",
    "answer": "Same/equally",
    "ru": "Одинаково"
  },
  {
    "id": 179,
    "question": "tapauksessa",
    "answer": "case",
    "ru": "В случае"
  },
  {
    "id": 180,
    "question": "katkoa",
    "answer": "misfire",
    "ru": "Сбой"
  },
  {
    "id": 181,
    "question": "ellet",
    "answer": "unless you",
    "ru": "Если только ты не"
  },
  {
    "id": 182,
    "question": "välttämättä",
    "answer": "necessarily",
    "ru": "Обязательно"
  },
  {
    "id": 183,
    "question": "yöpuvun",
    "answer": "a nightgown",
    "ru": "Ночная рубашка"
  },
  {
    "id": 184,
    "question": "toverit",
    "answer": "comrades",
    "ru": "Товарищи"
  },
  {
    "id": 185,
    "question": "paljaan",
    "answer": "bare",
    "ru": "Голый"
  },
  {
    "id": 186,
    "question": "merkityille",
    "answer": "for those marked",
    "ru": "Для отмеченных"
  },
  {
    "id": 187,
    "question": "vanha kunnon",
    "answer": "good old",
    "ru": "Добрый старый"
  },
  {
    "id": 188,
    "question": "Kuski",
    "answer": "Driver",
    "ru": "Водитель"
  },
  {
    "id": 189,
    "question": "niin siisti",
    "answer": "so cool",
    "ru": "Так круто"
  },
  {
    "id": 190,
    "question": "mihin vaan",
    "answer": "to whatever",
    "ru": "Куда угодно"
  },
  {
    "id": 191,
    "question": "rajoittaa",
    "answer": "restrict",
    "ru": "Ограничивать"
  },
  {
    "id": 192,
    "question": "sinkku",
    "answer": "single",
    "ru": "Одинокий"
  },
  {
    "id": 193,
    "question": "vaativa",
    "answer": "demanding",
    "ru": "Требовательный"
  },
  {
    "id": 194,
    "question": "väliaikainen",
    "answer": "temporary",
    "ru": "Временный"
  },
  {
    "id": 195,
    "question": "valinnainen",
    "answer": "optional",
    "ru": "Необязательный"
  },
  {
    "id": 196,
    "question": "vaikka",
    "answer": "although",
    "ru": "Хотя"
  },
  {
    "id": 197,
    "question": "jotta",
    "answer": "so",
    "ru": "Чтобы"
  },
  {
    "id": 198,
    "question": "toisaalta",
    "answer": "On the other hand",
    "ru": "С другой стороны"
  },
  {
    "id": 199,
    "question": "kuitenkin",
    "answer": "however",
    "ru": "Однако"
  },
  {
    "id": 200,
    "question": "Sillä tavalla",
    "answer": "In that way",
    "ru": "Таким образом"
  },
  {
    "id": 201,
    "question": "Harva",
    "answer": "Few",
    "ru": "Немногие"
  },
  {
    "id": 202,
    "question": "valitat",
    "answer": "you complain",
    "ru": "Ты жалуешься"
  },
  {
    "id": 203,
    "question": "jätän",
    "answer": "I leave",
    "ru": "Я оставляю"
  },
  {
    "id": 204,
    "question": "kuulua",
    "answer": "belong",
    "ru": "Принадлежать"
  },
  {
    "id": 205,
    "question": "jättää",
    "answer": "leave",
    "ru": "Оставить"
  },
  {
    "id": 206,
    "question": "muuttaa",
    "answer": "change",
    "ru": "Изменить"
  },
  {
    "id": 207,
    "question": "hakemuksen",
    "answer": "the application",
    "ru": "Заявление"
  },
  {
    "id": 208,
    "question": "ilmoitti",
    "answer": "announced",
    "ru": "Объявил"
  },
  {
    "id": 209,
    "question": "vaati",
    "answer": "demanded",
    "ru": "Потребовал"
  },
  {
    "id": 210,
    "question": "hyväksyi",
    "answer": "accepted",
    "ru": "Принял"
  },
  {
    "id": 211,
    "question": "ratkaista",
    "answer": "solve",
    "ru": "Решить"
  },
  {
    "id": 212,
    "question": "osata",
    "answer": "know",
    "ru": "Уметь"
  },
  {
    "id": 213,
    "question": "onnistua",
    "answer": "succeed",
    "ru": "Преуспеть"
  },
  {
    "id": 214,
    "question": "joutuu",
    "answer": "has to",
    "ru": "Вынужден"
  },
  {
    "id": 215,
    "question": "kokeilla",
    "answer": "try out",
    "ru": "Попробовать"
  },
  {
    "id": 216,
    "question": "yrittää",
    "answer": "try",
    "ru": "Пытаться"
  },
  {
    "id": 217,
    "question": "perustaa",
    "answer": "establish",
    "ru": "Основать"
  },
  {
    "id": 218,
    "question": "myöntää",
    "answer": "grant",
    "ru": "Предоставить"
  },
  {
    "id": 219,
    "question": "virheensä",
    "answer": "her mistake",
    "ru": "Её ошибка"
  },
  {
    "id": 220,
    "question": "arvioit",
    "answer": "you estimate",
    "ru": "Ты оцениваешь"
  },
  {
    "id": 221,
    "question": "onnistut",
    "answer": "you will succeed",
    "ru": "Ты преуспеешь"
  },
  {
    "id": 222,
    "question": "hyväksyt",
    "answer": "you accept",
    "ru": "Ты принимаешь"
  },
  {
    "id": 223,
    "question": "kärsii",
    "answer": "suffers",
    "ru": "Страдает"
  },
  {
    "id": 224,
    "question": "sattuu",
    "answer": "hurts",
    "ru": "Болит"
  },
  {
    "id": 225,
    "question": "nauttii",
    "answer": "enjoys",
    "ru": "Наслаждается"
  },
  {
    "id": 226,
    "question": "jakaa",
    "answer": "share",
    "ru": "Делиться"
  },
  {
    "id": 227,
    "question": "pysyy",
    "answer": "remains",
    "ru": "Остаётся"
  },
  {
    "id": 228,
    "question": "seuraa",
    "answer": "will follow",
    "ru": "Последует"
  },
  {
    "id": 229,
    "question": "joutui",
    "answer": "had to",
    "ru": "Был вынужден"
  },
  {
    "id": 230,
    "question": "keskittyä",
    "answer": "Focus on",
    "ru": "Сосредоточиться на"
  },
  {
    "id": 231,
    "question": "pelottaa",
    "answer": "scare",
    "ru": "Пугать"
  },
  {
    "id": 232,
    "question": "riittävästi",
    "answer": "sufficiently",
    "ru": "Достаточно"
  },
  {
    "id": 233,
    "question": "Kohtuullinen",
    "answer": "Reasonable",
    "ru": "Разумный"
  },
  {
    "id": 234,
    "question": "Vakituinen",
    "answer": "Permanent",
    "ru": "Постоянный"
  },
  {
    "id": 235,
    "question": "määräaikainen",
    "answer": "temporary",
    "ru": "Временный"
  },
  {
    "id": 236,
    "question": "Vaarallinen",
    "answer": "Dangerous",
    "ru": "Опасный"
  },
  {
    "id": 237,
    "question": "vapaaehtoinen",
    "answer": "voluntary",
    "ru": "Добровольный"
  },
  {
    "id": 238,
    "question": "pakollinen",
    "answer": "obligatory",
    "ru": "Обязательный"
  },
  {
    "id": 239,
    "question": "Myönteinen",
    "answer": "Positive",
    "ru": "Положительный"
  },
  {
    "id": 240,
    "question": "Käytös",
    "answer": "Behavior",
    "ru": "Поведение"
  },
  {
    "id": 241,
    "question": "Perustella",
    "answer": "Justify",
    "ru": "Обосновать"
  },
  {
    "id": 242,
    "question": "jouduin",
    "answer": "I had to",
    "ru": "Мне пришлось"
  },
  {
    "id": 243,
    "question": "mahdollista",
    "answer": "possible",
    "ru": "Возможно"
  },
  {
    "id": 244,
    "question": "jutuista",
    "answer": "of things",
    "ru": "О вещах"
  },
  {
    "id": 245,
    "question": "Kuin",
    "answer": "than",
    "ru": "Чем"
  },
  {
    "id": 246,
    "question": "juuri ne",
    "answer": "exactly those",
    "ru": "Именно те"
  },
  {
    "id": 247,
    "question": "enemmän kuin",
    "answer": "more than",
    "ru": "Больше чем"
  },
  {
    "id": 248,
    "question": "Silti",
    "answer": "still",
    "ru": "Всё равно"
  },
  {
    "id": 249,
    "question": "Taida",
    "answer": "i guess",
    "ru": "Думаю"
  },
  {
    "id": 250,
    "question": "törkeää",
    "answer": "outrageous",
    "ru": "Возмутительно"
  },
  {
    "id": 251,
    "question": "anna jo olla",
    "answer": "leave it alone",
    "ru": "Оставь в покое"
  },
  {
    "id": 252,
    "question": "vielä ehdit mukaan",
    "answer": "you Can still join",
    "ru": "Ты ещё можешь присоединиться"
  },
  {
    "id": 253,
    "question": "järjestänyt",
    "answer": "arrange",
    "ru": "Организовать"
  },
  {
    "id": 254,
    "question": "sen verran",
    "answer": "It’s enough",
    "ru": "Этого достаточно"
  },
  {
    "id": 255,
    "question": "pysyn",
    "answer": "stay",
    "ru": "Остаюсь"
  },
  {
    "id": 256,
    "question": "Hereillä",
    "answer": "awake",
    "ru": "Бодрствующий"
  },
  {
    "id": 257,
    "question": "Laskea",
    "answer": "count/calculate",
    "ru": "Считать/вычислять"
  },
  {
    "id": 258,
    "question": "Väkiluvu",
    "answer": "population",
    "ru": "Население"
  },
  {
    "id": 259,
    "question": "määritellään",
    "answer": "defined",
    "ru": "Определяется"
  },
  {
    "id": 260,
    "question": "kelpaavat",
    "answer": "valid",
    "ru": "Действительны"
  },
  {
    "id": 261,
    "question": "hiustesi",
    "answer": "your hair",
    "ru": "Твои волосы"
  },
  {
    "id": 262,
    "question": "Ansiosta",
    "answer": "thanks to",
    "ru": "Благодаря"
  },
  {
    "id": 263,
    "question": "älykkäitä",
    "answer": "smart",
    "ru": "Умные"
  },
  {
    "id": 264,
    "question": "Luottamaan",
    "answer": "to trust",
    "ru": "Доверять"
  },
  {
    "id": 265,
    "question": "Totella",
    "answer": "to obey",
    "ru": "Слушаться"
  },
  {
    "id": 266,
    "question": "sisintään",
    "answer": "innermost",
    "ru": "Своё нутро"
  },
  {
    "id": 267,
    "question": "ei kannata",
    "answer": "it’s better not to",
    "ru": "Не стоит"
  },
  {
    "id": 268,
    "question": "yhteiseloa",
    "answer": "living together",
    "ru": "Совместная жизнь"
  },
  {
    "id": 269,
    "question": "nyt keksin",
    "answer": "now I figured out",
    "ru": "Теперь я понял"
  },
  {
    "id": 270,
    "question": "aiheita",
    "answer": "subjects",
    "ru": "Темы"
  },
  {
    "id": 271,
    "question": "Toki",
    "answer": "sure",
    "ru": "Конечно"
  },
  {
    "id": 272,
    "question": "Oikeastaan",
    "answer": "actually",
    "ru": "На самом деле"
  },
  {
    "id": 273,
    "question": "Inhoan",
    "answer": "hate",
    "ru": "Ненавижу"
  },
  {
    "id": 274,
    "question": "kuitenkin",
    "answer": "however",
    "ru": "Однако"
  },
  {
    "id": 275,
    "question": "Sijaan",
    "answer": "in exchange for",
    "ru": "Вместо"
  },
  {
    "id": 276,
    "question": "ilo irti",
    "answer": "have fun",
    "ru": "Повеселиться"
  },
  {
    "id": 277,
    "question": "Toteutukoot",
    "answer": "let them come true",
    "ru": "Пусть сбудутся"
  },
  {
    "id": 278,
    "question": "hyi olkoon",
    "answer": "let it be",
    "ru": "Пусть будет"
  },
  {
    "id": 279,
    "question": "vihdoinkin",
    "answer": "finally",
    "ru": "Наконец-то"
  },
  {
    "id": 280,
    "question": "pidätettiin",
    "answer": "arrested",
    "ru": "Арестован"
  },
  {
    "id": 281,
    "question": "kiroilusta",
    "answer": "swearing",
    "ru": "Ругань"
  },
  {
    "id": 282,
    "question": "julkisella",
    "answer": "public",
    "ru": "Публичный"
  },
  {
    "id": 283,
    "question": "siepannut",
    "answer": "abduct",
    "ru": "Похитить"
  },
  {
    "id": 284,
    "question": "todennäköisesti",
    "answer": "probably",
    "ru": "Вероятно"
  },
  {
    "id": 285,
    "question": "oletko kunnossa",
    "answer": "are you okay",
    "ru": "Ты в порядке"
  },
  {
    "id": 286,
    "question": "Kivuliaalta",
    "answer": "painful",
    "ru": "Болезненный"
  },
  {
    "id": 287,
    "question": "Kaatunut",
    "answer": "fell down",
    "ru": "Упал"
  },
  {
    "id": 288,
    "question": "Liukastuit",
    "answer": "slipped",
    "ru": "Поскользнулся"
  },
  {
    "id": 289,
    "question": "johdatti",
    "answer": "led / show way",
    "ru": "Вёл/указывал путь"
  },
  {
    "id": 290,
    "question": "Tuuri",
    "answer": "luck",
    "ru": "Удача"
  },
  {
    "id": 291,
    "question": "Toin",
    "answer": "i Brought",
    "ru": "Я принёс"
  },
  {
    "id": 292,
    "question": "Jotakin",
    "answer": "something",
    "ru": "Что-то"
  },
  {
    "id": 293,
    "question": "hyppaa kyytiin",
    "answer": "Hop on",
    "ru": "Запрыгни"
  },
  {
    "id": 294,
    "question": "se tyyppi",
    "answer": "that Guy",
    "ru": "Тот парень"
  },
  {
    "id": 295,
    "question": "Varasti",
    "answer": "stole",
    "ru": "Украл"
  },
  {
    "id": 296,
    "question": "Nauhalla",
    "answer": "on the tape",
    "ru": "На плёнке"
  },
  {
    "id": 297,
    "question": "piti jäädä",
    "answer": "Had to stay",
    "ru": "Должен был остаться"
  },
  {
    "id": 298,
    "question": "töiden takia",
    "answer": "because of work",
    "ru": "Из-за работы"
  },
  {
    "id": 299,
    "question": "asua siinä",
    "answer": "live in",
    "ru": "Жить в"
  },
  {
    "id": 300,
    "question": "sellaista",
    "answer": "that kind of",
    "ru": "Такое"
  },
  {
    "id": 301,
    "question": "tapettia",
    "answer": "wallpaper",
    "ru": "Обои"
  },
  {
    "id": 302,
    "question": "kalusteita",
    "answer": "furniture",
    "ru": "Мебель"
  },
  {
    "id": 303,
    "question": "kuuluneet",
    "answer": "belonged to",
    "ru": "Принадлежали"
  },
  {
    "id": 304,
    "question": "siistiä",
    "answer": "cool",
    "ru": "Классно"
  },
  {
    "id": 305,
    "question": "kaipaisin",
    "answer": "i would miss",
    "ru": "Я бы скучал"
  },
  {
    "id": 306,
    "question": "rehellisesti",
    "answer": "honest",
    "ru": "Честно"
  },
  {
    "id": 307,
    "question": "Luulin",
    "answer": "i thought",
    "ru": "Я думал"
  },
  {
    "id": 308,
    "question": "kohta ollaan",
    "answer": "we are about to be",
    "ru": "Мы вот-вот будем"
  },
  {
    "id": 309,
    "question": "Miten",
    "answer": "how",
    "ru": "Как"
  },
  {
    "id": 310,
    "question": "Tietty",
    "answer": "certain",
    "ru": "Определённый"
  },
  {
    "id": 311,
    "question": "Lohta",
    "answer": "salmon",
    "ru": "Лосось"
  },
  {
    "id": 312,
    "question": "sitäkään",
    "answer": "that too",
    "ru": "И то тоже"
  },
  {
    "id": 313,
    "question": "Tarkista",
    "answer": "to check",
    "ru": "Проверить"
  },
  {
    "id": 314,
    "question": "joutunut",
    "answer": "had to",
    "ru": "Пришлось"
  },
  {
    "id": 315,
    "question": "kestämään",
    "answer": "to endure",
    "ru": "Терпеть"
  },
  {
    "id": 316,
    "question": "tavannut pahempiakin",
    "answer": "met worse",
    "ru": "Встречал и похуже"
  },
  {
    "id": 317,
    "question": "kaikki käy",
    "answer": "everything goes",
    "ru": "Всё идёт"
  },
  {
    "id": 318,
    "question": "tuo mitä tuot",
    "answer": "bring what you bring",
    "ru": "Принеси что принесёшь"
  },
  {
    "id": 319,
    "question": "pieleen",
    "answer": "Wrong",
    "ru": "Неправильно"
  },
  {
    "id": 320,
    "question": "mitään tuollaista",
    "answer": "nothing like that",
    "ru": "Ничего подобного"
  },
  {
    "id": 321,
    "question": "Kohtalo",
    "answer": "destiny",
    "ru": "Судьба"
  },
  {
    "id": 322,
    "question": "Johdattaa",
    "answer": "to Lead",
    "ru": "Вести"
  },
  {
    "id": 323,
    "question": "Typera",
    "answer": "silly",
    "ru": "Глупый"
  },
  {
    "id": 324,
    "question": "Ajatus",
    "answer": "thought",
    "ru": "Мысль"
  },
  {
    "id": 325,
    "question": "anna tänne se",
    "answer": "give it here",
    "ru": "Дай это сюда"
  },
  {
    "id": 326,
    "question": "perillä ollaan",
    "answer": "we are here",
    "ru": "Мы на месте"
  },
  {
    "id": 327,
    "question": "oppaan",
    "answer": "guide",
    "ru": "Гид"
  },
  {
    "id": 328,
    "question": "Ei onnistu",
    "answer": "no luck",
    "ru": "Не получается"
  },
  {
    "id": 329,
    "question": "Juuttuisi",
    "answer": "stuck",
    "ru": "Застрял бы"
  },
  {
    "id": 330,
    "question": "tarkalleen",
    "answer": "exactly",
    "ru": "Именно"
  },
  {
    "id": 331,
    "question": "Edes",
    "answer": "even",
    "ru": "Даже"
  },
  {
    "id": 332,
    "question": "Kunnollista",
    "answer": "decent",
    "ru": "Приличный"
  },
  {
    "id": 333,
    "question": "Tietä",
    "answer": "road",
    "ru": "Дорога"
  },
  {
    "id": 334,
    "question": "Ehdota",
    "answer": "suggest",
    "ru": "Предложить"
  },
  {
    "id": 335,
    "question": "Turistikierros",
    "answer": "tourist tour",
    "ru": "Экскурсия для туристов"
  },
  {
    "id": 336,
    "question": "Tarjota",
    "answer": "offer",
    "ru": "Предложить"
  },
  {
    "id": 337,
    "question": "Tappiot",
    "answer": "losses",
    "ru": "Потери"
  },
  {
    "id": 338,
    "question": "Vähäiset",
    "answer": "few",
    "ru": "Немного"
  },
  {
    "id": 339,
    "question": "huolehdittiin",
    "answer": "was taken care of",
    "ru": "О нём заботились"
  },
  {
    "id": 340,
    "question": "suojauksesta",
    "answer": "protection",
    "ru": "Защита"
  },
  {
    "id": 341,
    "question": "siviilien",
    "answer": "civilians",
    "ru": "Гражданских лиц"
  },
  {
    "id": 342,
    "question": "ohjaamisesta",
    "answer": "about directing",
    "ru": "Об управлении"
  },
  {
    "id": 343,
    "question": "Opas",
    "answer": "guide",
    "ru": "Гид"
  },
  {
    "id": 344,
    "question": "ilmankos",
    "answer": "Weather",
    "ru": "Погода"
  },
  {
    "id": 345,
    "question": "jollakin",
    "answer": "with Someone",
    "ru": "С кем-то"
  },
  {
    "id": 346,
    "question": "Tavalla",
    "answer": "way",
    "ru": "Способ"
  },
  {
    "id": 347,
    "question": "tutkijat",
    "answer": "researchers",
    "ru": "Исследователи"
  },
  {
    "id": 348,
    "question": "mahdotonta",
    "answer": "impossible",
    "ru": "Невозможно"
  },
  {
    "id": 349,
    "question": "ikävä kuulla",
    "answer": "sorry to hear",
    "ru": "Жаль слышать"
  },
  {
    "id": 350,
    "question": "Mielenkiintoista",
    "answer": "interesting",
    "ru": "Интересно"
  },
  {
    "id": 351,
    "question": "Vaikka",
    "answer": "although",
    "ru": "Хотя"
  },
  {
    "id": 352,
    "question": "Vastaanotto",
    "answer": "Reception",
    "ru": "Приём"
  },
  {
    "id": 353,
    "question": "teitä odotetaan",
    "answer": "you are expected",
    "ru": "Вас ждут"
  },
  {
    "id": 354,
    "question": "mahdollista",
    "answer": "possible",
    "ru": "Возможно"
  },
  {
    "id": 355,
    "question": "Laiskoja",
    "answer": "lazy ones",
    "ru": "Лентяи"
  },
  {
    "id": 356,
    "question": "Tuttuja",
    "answer": "acquaintances",
    "ru": "Знакомые"
  },
  {
    "id": 357,
    "question": "Halki",
    "answer": "through",
    "ru": "Через"
  },
  {
    "id": 358,
    "question": "hengenvaarallinen",
    "answer": "life threatening",
    "ru": "Опасный для жизни"
  },
  {
    "id": 359,
    "question": "paiskautui",
    "answer": "lashed out",
    "ru": "Ударился"
  },
  {
    "id": 360,
    "question": "Takia",
    "answer": "because of",
    "ru": "Из-за"
  },
  {
    "id": 361,
    "question": "hiukan rantaa pitkin",
    "answer": "Little along the shore",
    "ru": "Немного вдоль берега"
  },
  {
    "id": 362,
    "question": "annetaan olla",
    "answer": "let it be",
    "ru": "Пусть будет"
  },
  {
    "id": 363,
    "question": "Ihan kuin",
    "answer": "just like",
    "ru": "Прямо как"
  },
  {
    "id": 364,
    "question": "Jossakin",
    "answer": "somewhere",
    "ru": "Где-то"
  },
  {
    "id": 365,
    "question": "Vaiheessa",
    "answer": "stage",
    "ru": "Этап"
  },
  {
    "id": 366,
    "question": "neidillä",
    "answer": "to girls",
    "ru": "Девушкам"
  },
  {
    "id": 367,
    "question": "Mielestä",
    "answer": "opinion / according",
    "ru": "Мнение/по мнению"
  },
  {
    "id": 368,
    "question": "Näytän",
    "answer": "look",
    "ru": "Выгляжу"
  },
  {
    "id": 369,
    "question": "tarkkuudella",
    "answer": "accuracy",
    "ru": "Точность"
  },
  {
    "id": 370,
    "question": "Kutsu",
    "answer": "invite",
    "ru": "Пригласить"
  },
  {
    "id": 371,
    "question": "On kulunut",
    "answer": "Its been over",
    "ru": "Прошло"
  },
  {
    "id": 372,
    "question": "teidemme erkanemisesta",
    "answer": "Parted on our ways",
    "ru": "Разошлись своими путями"
  },
  {
    "id": 373,
    "question": "Täten",
    "answer": "thus",
    "ru": "Таким образом"
  },
  {
    "id": 374,
    "question": "Ilo",
    "answer": "happy",
    "ru": "Радость"
  },
  {
    "id": 375,
    "question": "moikkaamaan pappaa",
    "answer": "say hello to pappa",
    "ru": "Поздороваться с дедушкой"
  },
  {
    "id": 376,
    "question": "Johtaja",
    "answer": "Chairman",
    "ru": "Председатель"
  },
  {
    "id": 377,
    "question": "vatsavaiva",
    "answer": "upset stomach",
    "ru": "Расстройство желудка"
  },
  {
    "id": 378,
    "question": "sellaista",
    "answer": "that kind of thing",
    "ru": "Такое дело"
  },
  {
    "id": 379,
    "question": "on varmaan parempi",
    "answer": "Its probably better",
    "ru": "Наверное, лучше"
  },
  {
    "id": 380,
    "question": "pidempään",
    "answer": "longer",
    "ru": "Дольше"
  },
  {
    "id": 381,
    "question": "Työreissulla",
    "answer": "Business trip",
    "ru": "В командировке"
  },
  {
    "id": 382,
    "question": "Kai",
    "answer": "guess",
    "ru": "Думаю"
  },
  {
    "id": 383,
    "question": "vitsi vaan",
    "answer": "just kidding",
    "ru": "Просто шутка"
  },
  {
    "id": 384,
    "question": "ehdottomasti",
    "answer": "absolutely",
    "ru": "Абсолютно"
  },
  {
    "id": 385,
    "question": "eikö näin",
    "answer": "right",
    "ru": "Правильно"
  },
  {
    "id": 386,
    "question": "Puolella",
    "answer": "on the side",
    "ru": "На стороне"
  },
  {
    "id": 387,
    "question": "kurkkaat",
    "answer": "TaKe a look",
    "ru": "Взгляни"
  },
  {
    "id": 388,
    "question": "appiukko",
    "answer": "Father in law",
    "ru": "Тесть"
  },
  {
    "id": 389,
    "question": "näkemättä",
    "answer": "without seeing",
    "ru": "Не видя"
  },
  {
    "id": 390,
    "question": "aikamoiset",
    "answer": "balls",
    "ru": "Смелость"
  },
  {
    "id": 391,
    "question": "Luumu",
    "answer": "plum",
    "ru": "Слива"
  },
  {
    "id": 392,
    "question": "juoppo",
    "answer": "drunkard",
    "ru": "Пьяница"
  },
  {
    "id": 393,
    "question": "Vahtimestari",
    "answer": "doorman",
    "ru": "Швейцар"
  },
  {
    "id": 394,
    "question": "Terttu",
    "answer": "bunch",
    "ru": "Гроздь"
  },
  {
    "id": 395,
    "question": "Pitäisi",
    "answer": "should",
    "ru": "Следует"
  },
  {
    "id": 396,
    "question": "Tallennettua",
    "answer": "record / save",
    "ru": "Записывать/сохранять"
  },
  {
    "id": 397,
    "question": "loppupää",
    "answer": "end",
    "ru": "Конец"
  },
  {
    "id": 398,
    "question": "Ilme",
    "answer": "Expression",
    "ru": "Выражение"
  },
  {
    "id": 399,
    "question": "Synkeätä",
    "answer": "sullen",
    "ru": "Мрачный"
  },
  {
    "id": 400,
    "question": "aivan mahtavia",
    "answer": "absolutely great",
    "ru": "Совершенно замечательные"
  },
  {
    "id": 401,
    "question": "Isukki",
    "answer": "Daddy",
    "ru": "Папочка"
  },
  {
    "id": 402,
    "question": "Kypärän",
    "answer": "helmet",
    "ru": "Шлем"
  },
  {
    "id": 403,
    "question": "esikuva",
    "answer": "role model",
    "ru": "Образец для подражания"
  },
  {
    "id": 404,
    "question": "Luulla",
    "answer": "think",
    "ru": "Думать"
  },
  {
    "id": 405,
    "question": "Johtaa",
    "answer": "lead",
    "ru": "Вести"
  },
  {
    "id": 406,
    "question": "Kadehtia",
    "answer": "envy",
    "ru": "Завидовать"
  },
  {
    "id": 407,
    "question": "Homma",
    "answer": "job",
    "ru": "Работа"
  },
  {
    "id": 408,
    "question": "Sytytä",
    "answer": "Turn on",
    "ru": "Включить"
  },
  {
    "id": 409,
    "question": "Tajusi",
    "answer": "realized",
    "ru": "Осознал"
  },
  {
    "id": 410,
    "question": "pitää alkaa",
    "answer": "have to start",
    "ru": "Надо начать"
  },
  {
    "id": 411,
    "question": "Tosissaan",
    "answer": "seriously",
    "ru": "Серьёзно"
  },
  {
    "id": 412,
    "question": "Pelastaa",
    "answer": "save",
    "ru": "Спасти"
  },
  {
    "id": 413,
    "question": "Suhdetta",
    "answer": "Relationship",
    "ru": "Отношения"
  },
  {
    "id": 414,
    "question": "Silti",
    "answer": "still",
    "ru": "Всё равно"
  },
  {
    "id": 415,
    "question": "Pärjää",
    "answer": "to be fine",
    "ru": "Справляться"
  },
  {
    "id": 416,
    "question": "Mieti vähän",
    "answer": "think a little",
    "ru": "Подумай немного"
  },
  {
    "id": 417,
    "question": "parisuhdetta",
    "answer": "Relationship",
    "ru": "Отношения"
  },
  {
    "id": 418,
    "question": "viemäristä",
    "answer": "sewer / drain",
    "ru": "Канализация/слив"
  },
  {
    "id": 419,
    "question": "Alas",
    "answer": "down",
    "ru": "Вниз"
  },
  {
    "id": 420,
    "question": "hirveä juttu",
    "answer": "terrible News",
    "ru": "Ужасная новость"
  },
  {
    "id": 421,
    "question": "Tuskin",
    "answer": "hardly",
    "ru": "Едва ли"
  },
  {
    "id": 422,
    "question": "kuvitella",
    "answer": "imagine",
    "ru": "Представить"
  },
  {
    "id": 423,
    "question": "Jotain",
    "answer": "something",
    "ru": "Что-то"
  },
  {
    "id": 424,
    "question": "polkee",
    "answer": "peddalling",
    "ru": "Крутит педали"
  },
  {
    "id": 425,
    "question": "pärikymppisiä",
    "answer": "twenties",
    "ru": "Двадцатые"
  },
  {
    "id": 426,
    "question": "Tuulettumaan",
    "answer": "ventilate",
    "ru": "Проветриться"
  },
  {
    "id": 427,
    "question": "Pitää päästä",
    "answer": "have to pass",
    "ru": "Надо пройти"
  },
  {
    "id": 428,
    "question": "houkutellaan",
    "answer": "attracted",
    "ru": "Привлечены"
  },
  {
    "id": 429,
    "question": "Jätän",
    "answer": "skip",
    "ru": "Пропущу"
  },
  {
    "id": 430,
    "question": "Rassaa",
    "answer": "fat",
    "ru": "Жир"
  },
  {
    "id": 431,
    "question": "sinnepäin",
    "answer": "that way",
    "ru": "В том направлении"
  },
  {
    "id": 432,
    "question": "alun perin",
    "answer": "originally",
    "ru": "Изначально"
  },
  {
    "id": 433,
    "question": "sitaatti",
    "answer": "citation",
    "ru": "Цитата"
  },
  {
    "id": 434,
    "question": "kuuluu",
    "answer": "belongs",
    "ru": "Принадлежит"
  },
  {
    "id": 435,
    "question": "alueelle",
    "answer": "to the area",
    "ru": "В эту зону"
  },
  {
    "id": 436,
    "question": "Sehän",
    "answer": "That's it",
    "ru": "Вот оно"
  },
  {
    "id": 437,
    "question": "Tarve",
    "answer": "Need",
    "ru": "Потребность"
  },
  {
    "id": 438,
    "question": "luonnollinen",
    "answer": "natural",
    "ru": "Естественный"
  },
  {
    "id": 439,
    "question": "taustansa",
    "answer": "its background",
    "ru": "Его происхождение"
  },
  {
    "id": 440,
    "question": "Nostaa",
    "answer": "Lift",
    "ru": "Поднять"
  },
  {
    "id": 441,
    "question": "Maljan",
    "answer": "A toast",
    "ru": "Тост"
  },
  {
    "id": 442,
    "question": "Kauas",
    "answer": "Far",
    "ru": "Далеко"
  },
  {
    "id": 443,
    "question": "tulkoon matkastasi unohtumaton",
    "answer": "make your trip unforgettable",
    "ru": "Пусть твоя поездка будет незабываемой"
  },
  {
    "id": 444,
    "question": "Aivan",
    "answer": "Right",
    "ru": "Именно"
  },
  {
    "id": 445,
    "question": "yhte",
    "answer": "together",
    "ru": "Вместе"
  },
  {
    "id": 446,
    "question": "sotketa",
    "answer": "to mess up",
    "ru": "Напутать"
  },
  {
    "id": 447,
    "question": "Valtio",
    "answer": "State",
    "ru": "Государство"
  },
  {
    "id": 448,
    "question": "Kuuhun",
    "answer": "To the moon",
    "ru": "На луну"
  },
  {
    "id": 449,
    "question": "Haista",
    "answer": "Smell",
    "ru": "Понюхай"
  },
  {
    "id": 450,
    "question": "tajusi",
    "answer": "realized",
    "ru": "Осознал"
  },
  {
    "id": 451,
    "question": "suunnilleen",
    "answer": "approximately",
    "ru": "Приблизительно"
  },
  {
    "id": 452,
    "question": "Varkaana",
    "answer": "As a thief",
    "ru": "Как вор"
  },
  {
    "id": 453,
    "question": "Rinkan",
    "answer": "Rink",
    "ru": "Рюкзак"
  },
  {
    "id": 454,
    "question": "aikonut",
    "answer": "intended to",
    "ru": "Собирался"
  },
  {
    "id": 455,
    "question": "vakavalta",
    "answer": "serious",
    "ru": "Серьёзный"
  },
  {
    "id": 456,
    "question": "ryppyjä",
    "answer": "wrinkles",
    "ru": "Морщины"
  },
  {
    "id": 457,
    "question": "mitä varten",
    "answer": "what for",
    "ru": "Для чего"
  },
  {
    "id": 458,
    "question": "nykyhetkeä",
    "answer": "the present moment",
    "ru": "Настоящий момент"
  },
  {
    "id": 459,
    "question": "menneisyyden",
    "answer": "of the past",
    "ru": "Прошлого"
  },
  {
    "id": 460,
    "question": "sellainen",
    "answer": "such",
    "ru": "Такой"
  },
  {
    "id": 461,
    "question": "konttoria varten",
    "answer": "for the office",
    "ru": "Для офиса"
  },
  {
    "id": 462,
    "question": "konttoria",
    "answer": "office",
    "ru": "Офис"
  },
  {
    "id": 463,
    "question": "Väliä",
    "answer": "It doesn't matter",
    "ru": "Не важно"
  },
  {
    "id": 464,
    "question": "mitä aiot",
    "answer": "what are you going to do",
    "ru": "Что ты собираешься делать"
  },
  {
    "id": 465,
    "question": "tiennyt",
    "answer": "knew",
    "ru": "Знал"
  },
  {
    "id": 466,
    "question": "tiesin",
    "answer": "i knew",
    "ru": "Я знал"
  },
  {
    "id": 467,
    "question": "aiotko",
    "answer": "are you going to",
    "ru": "Ты собираешься"
  },
  {
    "id": 468,
    "question": "Aion",
    "answer": "I will",
    "ru": "Я буду"
  },
  {
    "id": 469,
    "question": "Loistava",
    "answer": "Glorious",
    "ru": "Великолепный"
  },
  {
    "id": 470,
    "question": "tunnen sieltä",
    "answer": "I know from there",
    "ru": "Я знаю оттуда"
  },
  {
    "id": 471,
    "question": "potki",
    "answer": "kicked",
    "ru": "Пнул"
  },
  {
    "id": 472,
    "question": "reklamaatio",
    "answer": "complaint, claim",
    "ru": "Рекламация/претензия"
  },
  {
    "id": 473,
    "question": "valitus",
    "answer": "complaint, appeal",
    "ru": "Жалоба/апелляция"
  },
  {
    "id": 474,
    "question": "huomasit",
    "answer": "you noticed",
    "ru": "Ты заметил"
  },
  {
    "id": 475,
    "question": "jotain vikaa",
    "answer": "something wrong",
    "ru": "Что-то не так"
  },
  {
    "id": 476,
    "question": "keksi itse",
    "answer": "describe yourself",
    "ru": "Опиши себя"
  },
  {
    "id": 477,
    "question": "ruoanvalmistaja",
    "answer": "food manufacturer",
    "ru": "Производитель еды"
  },
  {
    "id": 478,
    "question": "työhön",
    "answer": "at the job",
    "ru": "На работе"
  },
  {
    "id": 479,
    "question": "perehdytyksessä",
    "answer": "job orientation",
    "ru": "Введение в должность"
  },
  {
    "id": 480,
    "question": "tutustumassa",
    "answer": "getitng to know each other",
    "ru": "Знакомиться"
  },
  {
    "id": 481,
    "question": "Nykymuoti",
    "answer": "fashion",
    "ru": "Современная мода"
  },
  {
    "id": 482,
    "question": "mautonta",
    "answer": "vulger",
    "ru": "Пошлый"
  },
  {
    "id": 483,
    "question": "viihteellisempään",
    "answer": "entertaining",
    "ru": "Развлекательный"
  },
  {
    "id": 484,
    "question": "suuntaan",
    "answer": "direction",
    "ru": "Направление"
  },
  {
    "id": 485,
    "question": "Kansalaisaktivismia",
    "answer": "Citizen activism",
    "ru": "Гражданский активизм"
  },
  {
    "id": 486,
    "question": "yrittäjyys",
    "answer": "entrepreneurship",
    "ru": "Предпринимательство"
  },
  {
    "id": 486,
    "question": "tiedustella",
    "answer": "inquire",
    "ru": "Предпринимательство"
  },
  {
    "id": 487,
    "question": "tietoja käytettävissä",
    "answer": "information available",
    "ru": "Информация доступна"
  },
  {
    "id": 488,
    "question": "menettelyn",
    "answer": "procedure",
    "ru": "Процедура"
  },
  {
    "id": 489,
    "question": "aloittamiseksi",
    "answer": "to start",
    "ru": "Для начала"
  },
  {
    "id": 490,
    "question": "Kiitos avustanne",
    "answer": "Thank you for your assistance",
    "ru": "Спасибо за помощь"
  },
  {
    "id": 491,
    "question": "äskettäin",
    "answer": "recently",
    "ru": "Недавно"
  },
  {
    "id": 492,
    "question": "suunnittelussa",
    "answer": "design",
    "ru": "Дизайн"
  },
  {
    "id": 493,
    "question": "täysin",
    "answer": "entirely",
    "ru": "Полностью"
  },
  {
    "id": 494,
    "question": "tyytyväinen",
    "answer": "satisfied",
    "ru": "Удовлетворён"
  },
  {
    "id": 495,
    "question": "lopputulokseen",
    "answer": "with the final result",
    "ru": "Конечным результатом"
  },
  {
    "id": 496,
    "question": "vastanneet",
    "answer": "Meet",
    "ru": "Соответствовать"
  },
  {
    "id": 497,
    "question": "odotuksiani",
    "answer": "my expectations",
    "ru": "Мои ожидания"
  },
  {
    "id": 498,
    "question": "parantamisen",
    "answer": "improvement",
    "ru": "Улучшение"
  },
  {
    "id": 499,
    "question": "varaa on",
    "answer": "there is room",
    "ru": "Есть место"
  },
  {
    "id": 500,
    "question": "ratkaista",
    "answer": "solve",
    "ru": "Решить"
  },
  {
    "id": 501,
    "question": "huolenaiheet",
    "answer": "concerns",
    "ru": "Беспокойства"
  },
  {
    "id": 502,
    "question": "Arvostan",
    "answer": "I appreciate",
    "ru": "Я ценю"
  },
  {
    "id": 503,
    "question": "joitain puolia",
    "answer": "some aspects",
    "ru": "Некоторые аспекты"
  },
  {
    "id": 504,
    "question": "perhesitoumus",
    "answer": "family commitment",
    "ru": "Семейное обязательство"
  },
  {
    "id": 505,
    "question": "jättää väliin",
    "answer": "skip",
    "ru": "Пропустить"
  },
  {
    "id": 506,
    "question": "päästäkseni",
    "answer": "to get to",
    "ru": "Чтобы добраться"
  },
  {
    "id": 507,
    "question": "mahdollisimman pian",
    "answer": "as soon as possible",
    "ru": "Как можно скорее"
  },
  {
    "id": 508,
    "question": "Pyydän anteeksi",
    "answer": "I apologize",
    "ru": "Я извиняюсь"
  },
  {
    "id": 509,
    "question": "jatkuva",
    "answer": "continuous",
    "ru": "Постоянный"
  },
  {
    "id": 510,
    "question": "mietin",
    "answer": "Wondering",
    "ru": "Задумываюсь"
  },
  {
    "id": 511,
    "question": "suositella",
    "answer": "recommend",
    "ru": "Рекомендовать"
  },
  {
    "id": 512,
    "question": "lääkkeitä",
    "answer": "medication",
    "ru": "Лекарства"
  },
  {
    "id": 513,
    "question": "lievittämään",
    "answer": "to alleviate",
    "ru": "Чтобы облегчить"
  },
  {
    "id": 514,
    "question": "melko rasittavaa",
    "answer": "quite bothersome",
    "ru": "Довольно обременительно"
  },
  {
    "id": 515,
    "question": "kaikesta avusta",
    "answer": "for all the help",
    "ru": "За всю помощь"
  },
  {
    "id": 516,
    "question": "vaadittavasta",
    "answer": "required",
    "ru": "Требуемый"
  },
  {
    "id": 517,
    "question": "alkutakuusta",
    "answer": "initial deposit",
    "ru": "Первоначальный залог"
  },
  {
    "id": 518,
    "question": "muuttoa varten",
    "answer": "for moving in",
    "ru": "Для переезда"
  },
  {
    "id": 519,
    "question": "saatavuutta",
    "answer": "availability",
    "ru": "Наличие"
  },
  {
    "id": 520,
    "question": "Tarkemmin sanottuna",
    "answer": "More precisely, specifically",
    "ru": "Точнее говоря"
  },
  {
    "id": 521,
    "question": "viikoksi",
    "answer": "for a week",
    "ru": "На неделю"
  },
  {
    "id": 522,
    "question": "ystävällisesti antaa",
    "answer": "kindly give",
    "ru": "Любезно предоставить"
  },
  {
    "id": 523,
    "question": "olevista",
    "answer": "Existing",
    "ru": "Существующий"
  },
  {
    "id": 524,
    "question": "Harkitsen",
    "answer": "I'm considering",
    "ru": "Я рассматриваю"
  },
  {
    "id": 525,
    "question": "matkustamista",
    "answer": "travelling",
    "ru": "Путешествие"
  },
  {
    "id": 526,
    "question": "viime aikoina",
    "answer": "lately",
    "ru": "В последнее время"
  },
  {
    "id": 527,
    "question": "lempeällä tuulella",
    "answer": "with a gentle breeze",
    "ru": "С лёгким бризом"
  },
  {
    "id": 528,
    "question": "täydellinen",
    "answer": "perfect",
    "ru": "Идеальный"
  },
  {
    "id": 529,
    "question": "nauttimiseen",
    "answer": "For enjoying",
    "ru": "Для наслаждения"
  },
  {
    "id": 530,
    "question": "todellista",
    "answer": "real",
    "ru": "Настоящий"
  },
  {
    "id": 531,
    "question": "kerrankin",
    "answer": "for once",
    "ru": "Хоть раз"
  },
  {
    "id": 532,
    "question": "suosikki",
    "answer": "favourite",
    "ru": "Любимый"
  },
  {
    "id": 533,
    "question": "sydäntä lämmittävä",
    "answer": "heart warming",
    "ru": "Согревающий сердце"
  },
  {
    "id": 534,
    "question": "tossu",
    "answer": "slipper",
    "ru": "Тапочка"
  },
  {
    "id": 535,
    "question": "lujaa",
    "answer": "hard, fast",
    "ru": "Крепко/быстро"
  },
  {
    "id": 536,
    "question": "majava",
    "answer": "beaver",
    "ru": "Бобёр"
  },
  {
    "id": 537,
    "question": "kulkuneuvo",
    "answer": "vehicle, transportation",
    "ru": "Транспортное средство"
  },
  {
    "id": 538,
    "question": "mieleisekseen",
    "answer": "to your liking",
    "ru": "По своему вкусу"
  },
  {
    "id": 539,
    "question": "sisustaa",
    "answer": "style",
    "ru": "Декорировать"
  },
  {
    "id": 540,
    "question": "luulemaan",
    "answer": "to think",
    "ru": "Думать"
  },
  {
    "id": 541,
    "question": "hukkua",
    "answer": "drown",
    "ru": "Тонуть"
  },
  {
    "id": 542,
    "question": "ämpäri",
    "answer": "bucket",
    "ru": "Ведро"
  },
  {
    "id": 543,
    "question": "liikennevalot",
    "answer": "traffic lights",
    "ru": "Светофоры"
  },
  {
    "id": 544,
    "question": "sammakko",
    "answer": "frog",
    "ru": "Лягушка"
  },
  {
    "id": 545,
    "question": "virallisen",
    "answer": "official",
    "ru": "Официальный"
  },
  {
    "id": 546,
    "question": "valituksen",
    "answer": "complaint",
    "ru": "Жалоба"
  },
  {
    "id": 547,
    "question": "välttämiseksi",
    "answer": "to avoid",
    "ru": "Чтобы избежать"
  },
  {
    "id": 548,
    "question": "toimenpiteet",
    "answer": "measures",
    "ru": "Меры"
  },
  {
    "id": 549,
    "question": "Molemmissa",
    "answer": "both",
    "ru": "В обоих"
  },
  {
    "id": 550,
    "question": "vaihtoehdoissa",
    "answer": "choices, options",
    "ru": "Варианты"
  },
  {
    "id": 551,
    "question": "tavoitteillesi",
    "answer": "to your goals",
    "ru": "К твоим целям"
  },
  {
    "id": 552,
    "question": "vaalimaan",
    "answer": "to cherish",
    "ru": "Беречь"
  },
  {
    "id": 553,
    "question": "ajan tasalla",
    "answer": "up to date",
    "ru": "В курсе"
  },
  {
    "id": 554,
    "question": "tasapainon",
    "answer": "balance",
    "ru": "Баланс"
  },
  {
    "id": 555,
    "question": "vähättelevästi",
    "answer": "dismissively",
    "ru": "Пренебрежительно"
  },
  {
    "id": 556,
    "question": "puuhastelua",
    "answer": "mess around",
    "ru": "Возня"
  },
  {
    "id": 557,
    "question": "sellaista",
    "answer": "that kind of",
    "ru": "Такое"
  },
  {
    "id": 558,
    "question": "nisäkkäät",
    "answer": "mammals",
    "ru": "Млекопитающие"
  },
  {
    "id": 559,
    "question": "taitoja",
    "answer": "skill",
    "ru": "Навык"
  },
  {
    "id": 560,
    "question": "myöhemmässä",
    "answer": "later on",
    "ru": "Позже"
  },
  {
    "id": 561,
    "question": "verrata",
    "answer": "compare",
    "ru": "Сравнивать"
  },
  {
    "id": 562,
    "question": "kykyjään",
    "answer": "abilities",
    "ru": "Способности"
  },
  {
    "id": 563,
    "question": "suhdettaan",
    "answer": "our relationship",
    "ru": "Наши отношения"
  },
  {
    "id": 564,
    "question": "toisiinsa",
    "answer": "to each other",
    "ru": "Друг к другу"
  },
  {
    "id": 565,
    "question": "leikittäessä",
    "answer": "while playing",
    "ru": "Во время игры"
  },
  {
    "id": 566,
    "question": "Ryhmässä",
    "answer": "In a group",
    "ru": "В группе"
  },
  {
    "id": 567,
    "question": "joutuvat",
    "answer": "have to",
    "ru": "Вынуждены"
  },
  {
    "id": 568,
    "question": "viestimään",
    "answer": "to communicate",
    "ru": "Общаться"
  },
  {
    "id": 569,
    "question": "keskenään",
    "answer": "among themselves",
    "ru": "Между собой"
  },
  {
    "id": 570,
    "question": "yhdessä",
    "answer": "together",
    "ru": "Вместе"
  },
  {
    "id": 571,
    "question": "joukossa",
    "answer": "among",
    "ru": "Среди"
  },
  {
    "id": 572,
    "question": "teeskennellään",
    "answer": "pretending",
    "ru": "Притворяясь"
  },
  {
    "id": 573,
    "question": "Teeskentely",
    "answer": "pretending",
    "ru": "Притворство"
  },
  {
    "id": 574,
    "question": "erottamaan",
    "answer": "distinguish",
    "ru": "Различать"
  },
  {
    "id": 575,
    "question": "miltä",
    "answer": "how",
    "ru": "Как"
  },
  {
    "id": 576,
    "question": "näyttää",
    "answer": "looks",
    "ru": "Выглядит"
  },
  {
    "id": 577,
    "question": "verrattuna",
    "answer": "compared",
    "ru": "По сравнению"
  },
  {
    "id": 578,
    "question": "oikeasti",
    "answer": "for real",
    "ru": "По-настоящему"
  },
  {
    "id": 579,
    "question": "pakenemista",
    "answer": "escape",
    "ru": "Побег"
  },
  {
    "id": 580,
    "question": "tappeluakin",
    "answer": "even a fight",
    "ru": "Даже драка"
  },
  {
    "id": 581,
    "question": "kosiskelu",
    "answer": "courtship",
    "ru": "Ухаживание"
  },
  {
    "id": 582,
    "question": "vaatii",
    "answer": "demands",
    "ru": "Требует"
  },
  {
    "id": 583,
    "question": "harjoittelua",
    "answer": "practice",
    "ru": "Практика"
  },
  {
    "id": 584,
    "question": "toistavat",
    "answer": "are repeating",
    "ru": "Повторяют"
  },
  {
    "id": 585,
    "question": "toisiltaan",
    "answer": "from each other",
    "ru": "Друг у друга"
  },
  {
    "id": 586,
    "question": "Välillä",
    "answer": "Between",
    "ru": "Между"
  },
  {
    "id": 587,
    "question": "haittaakin",
    "answer": "no harm",
    "ru": "Не вредит"
  },
  {
    "id": 588,
    "question": "saattaa",
    "answer": "It might",
    "ru": "Может"
  },
  {
    "id": 589,
    "question": "altistaa",
    "answer": "expose",
    "ru": "Подвергать"
  },
  {
    "id": 590,
    "question": "leikkijät",
    "answer": "players",
    "ru": "Игроки"
  },
  {
    "id": 591,
    "question": "saalistajien",
    "answer": "predators",
    "ru": "Хищников"
  },
  {
    "id": 592,
    "question": "hyökkäyksille",
    "answer": "for attacks",
    "ru": "Для атак"
  },
  {
    "id": 593,
    "question": "ruuan",
    "answer": "food",
    "ru": "Еда"
  },
  {
    "id": 594,
    "question": "Se vie",
    "answer": "It takes",
    "ru": "Это занимает"
  },
  {
    "id": 595,
    "question": "jatkumisen",
    "answer": "continuation",
    "ru": "Продолжение"
  },
  {
    "id": 596,
    "question": "suuri osa",
    "answer": "a large part of the",
    "ru": "Большая часть"
  },
  {
    "id": 597,
    "question": "kannalta",
    "answer": "in terms of",
    "ru": "С точки зрения"
  },
  {
    "id": 598,
    "question": "pärjää",
    "answer": "will be fine",
    "ru": "Будет хорошо"
  },
  {
    "id": 599,
    "question": "luksusta",
    "answer": "luxury",
    "ru": "Роскошь"
  },
  {
    "id": 600,
    "question": "turvaa",
    "answer": "shelter",
    "ru": "Убежище"
  },
  {
    "id": 601,
    "question": "Lopulta",
    "answer": "Eventually",
    "ru": "В конце концов"
  },
  {
    "id": 602,
    "question": "väsyttää",
    "answer": "get tired",
    "ru": "Уставать"
  },
  {
    "id": 603,
    "question": "keskeyttää",
    "answer": "interrupt",
    "ru": "Прерывать"
  },
  {
    "id": 604,
    "question": "Yksinkertaisin",
    "answer": "The simplest",
    "ru": "Самый простой"
  },
  {
    "id": 605,
    "question": "selitys",
    "answer": "explanation",
    "ru": "Объяснение"
  },
  {
    "id": 606,
    "question": "sittenkin kai se",
    "answer": "I guess it is",
    "ru": "Думаю, это оно"
  },
  {
    "id": 607,
    "question": "Talkoisiin",
    "answer": "Let's talk!",
    "ru": "Поговорим!"
  },
  {
    "id": 608,
    "question": "osallistuit",
    "answer": "attended",
    "ru": "Участвовал"
  },
  {
    "id": 609,
    "question": "muistaakseni",
    "answer": "I remember",
    "ru": "Насколько помню"
  },
  {
    "id": 610,
    "question": "haju",
    "answer": "sense",
    "ru": "Обоняние"
  },
  {
    "id": 611,
    "question": "perustuvaa",
    "answer": "based on",
    "ru": "Основанный на"
  },
  {
    "id": 612,
    "question": "työurakkaa",
    "answer": "work contract",
    "ru": "Трудовой договор"
  },
  {
    "id": 613,
    "question": "yhteistä",
    "answer": "common",
    "ru": "Общий"
  },
  {
    "id": 614,
    "question": "työväentaloja",
    "answer": "workers' houses",
    "ru": "Рабочие дома"
  },
  {
    "id": 615,
    "question": "rukoushuoneita",
    "answer": "prayer rooms",
    "ru": "Молельные комнаты"
  },
  {
    "id": 616,
    "question": "puhumattakaan",
    "answer": "not to mention",
    "ru": "Не говоря уже"
  },
  {
    "id": 617,
    "question": "syttyneet",
    "answer": "ignited",
    "ru": "Воспылали"
  },
  {
    "id": 618,
    "question": "hyville",
    "answer": "for good",
    "ru": "На благо"
  },
  {
    "id": 619,
    "question": "yhteisöä",
    "answer": "community",
    "ru": "Сообщество"
  },
  {
    "id": 620,
    "question": "rakentaville",
    "answer": "for builders",
    "ru": "Для строителей"
  },
  {
    "id": 621,
    "question": "hankkeille",
    "answer": "for projects",
    "ru": "Для проектов"
  },
  {
    "id": 622,
    "question": "tulleet",
    "answer": "have come",
    "ru": "Пришли"
  },
  {
    "id": 623,
    "question": "selvinnyt",
    "answer": "survived",
    "ru": "Выжил"
  },
  {
    "id": 624,
    "question": "sovelluksia",
    "answer": "applications",
    "ru": "Приложения"
  },
  {
    "id": 625,
    "question": "seurojentaloja",
    "answer": "clubhouses",
    "ru": "Клубные дома"
  },
  {
    "id": 626,
    "question": "nostavat",
    "answer": "raise",
    "ru": "Поднимают"
  },
  {
    "id": 627,
    "question": "viljan",
    "answer": "grain",
    "ru": "Зерно"
  },
  {
    "id": 628,
    "question": "pelloilta",
    "answer": "from the fields",
    "ru": "С полей"
  },
  {
    "id": 629,
    "question": "Tosiasiassa",
    "answer": "In fact",
    "ru": "На самом деле"
  },
  {
    "id": 630,
    "question": "yhä",
    "answer": "still",
    "ru": "По-прежнему"
  },
  {
    "id": 631,
    "question": "löytyy",
    "answer": "can be found",
    "ru": "Можно найти"
  },
  {
    "id": 632,
    "question": "vapaaehtoistyö",
    "answer": "voluntary work",
    "ru": "Волонтёрская работа"
  },
  {
    "id": 633,
    "question": "operaattoreita",
    "answer": "operators",
    "ru": "Операторы"
  },
  {
    "id": 634,
    "question": "järjestöjä",
    "answer": "organizations",
    "ru": "Организации"
  },
  {
    "id": 635,
    "question": "yhdistyksiä",
    "answer": "associations",
    "ru": "Ассоциации"
  },
  {
    "id": 636,
    "question": "kansalaisten",
    "answer": "citizens",
    "ru": "Граждан"
  },
  {
    "id": 637,
    "question": "valmiuden",
    "answer": "readiness",
    "ru": "Готовность"
  },
  {
    "id": 638,
    "question": "yhteiseen hyvään",
    "answer": "for the common good",
    "ru": "Для общего блага"
  },
  {
    "id": 639,
    "question": "antaa",
    "answer": "give",
    "ru": "Давать"
  },
  {
    "id": 640,
    "question": "aikaansa",
    "answer": "its time",
    "ru": "Своё время"
  },
  {
    "id": 641,
    "question": "Uuden ajan",
    "answer": "New Age",
    "ru": "Новый век"
  },
  {
    "id": 642,
    "question": "vapaaehtoiset",
    "answer": "volunteers",
    "ru": "Волонтёры"
  },
  {
    "id": 643,
    "question": "siirtymään",
    "answer": "to move",
    "ru": "Переходить"
  },
  {
    "id": 644,
    "question": "digikummit",
    "answer": "digital godfathers",
    "ru": "Цифровые крёстные"
  },
  {
    "id": 645,
    "question": "jakoivat",
    "answer": "shared",
    "ru": "Делились"
  },
  {
    "id": 646,
    "question": "neuvoja",
    "answer": "advice",
    "ru": "Советы"
  },
  {
    "id": 647,
    "question": "riensivät",
    "answer": "rushed",
    "ru": "Спешили"
  },
  {
    "id": 648,
    "question": "hyvän olon",
    "answer": "good feeling",
    "ru": "Хорошее самочувствие"
  },
  {
    "id": 649,
    "question": "leviämisessä",
    "answer": "in spreading.",
    "ru": "В распространении"
  },
  {
    "id": 650,
    "question": "kokee iloa",
    "answer": "experience joy",
    "ru": "Испытывать радость"
  },
  {
    "id": 651,
    "question": "kerrankin",
    "answer": "for once",
    "ru": "Хоть раз"
  },
  {
    "id": 652,
    "question": "jotain hyötyä!",
    "answer": "something useful!",
    "ru": "Что-то полезное!"
  },
  {
    "id": 653,
    "question": "kokemus",
    "answer": "experience",
    "ru": "Опыт"
  },
  {
    "id": 654,
    "question": "yhä useammalle.",
    "answer": "to more and more.",
    "ru": "Всё большему числу людей"
  },
  {
    "id": 655,
    "question": "rajattuja",
    "answer": "limited",
    "ru": "Ограниченный"
  },
  {
    "id": 656,
    "question": "sitoutua",
    "answer": "commit",
    "ru": "Обязаться"
  },
  {
    "id": 657,
    "question": "määräämättömäksi",
    "answer": "indefinite",
    "ru": "Неопределённый"
  },
  {
    "id": 658,
    "question": "liittyi",
    "answer": "join/include",
    "ru": "Присоединился"
  },
  {
    "id": 659,
    "question": "hauskanpito",
    "answer": "having fun",
    "ru": "Веселье"
  },
  {
    "id": 660,
    "question": "paitsi",
    "answer": "except",
    "ru": "Кроме"
  },
  {
    "id": 661,
    "question": "tehokas",
    "answer": "effective",
    "ru": "Эффективный"
  },
  {
    "id": 662,
    "question": "porukalla",
    "answer": "with a group",
    "ru": "С группой"
  },
  {
    "id": 663,
    "question": "haaveilevat",
    "answer": "dreaming",
    "ru": "Мечтают"
  },
  {
    "id": 664,
    "question": "hurjia",
    "answer": "wild",
    "ru": "Бешеный"
  },
  {
    "id": 665,
    "question": "huikeita",
    "answer": "amazing",
    "ru": "Потрясающий"
  },
  {
    "id": 666,
    "question": "osuu",
    "answer": "hits",
    "ru": "Попадает"
  },
  {
    "id": 667,
    "question": "hämmästys",
    "answer": "surprise",
    "ru": "Удивление"
  },
  {
    "id": 668,
    "question": "tuttua",
    "answer": "familiar",
    "ru": "Знакомый"
  },
  {
    "id": 669,
    "question": "Itse",
    "answer": "itself",
    "ru": "Само по себе"
  },
  {
    "id": 670,
    "question": "välttämättä",
    "answer": "necessarily",
    "ru": "Обязательно"
  },
  {
    "id": 671,
    "question": "vaihda",
    "answer": "change",
    "ru": "Менять"
  },
  {
    "id": 672,
    "question": "täysin",
    "answer": "completely",
    "ru": "Полностью"
  },
  {
    "id": 673,
    "question": "yhtä",
    "answer": "equally",
    "ru": "Одинаково"
  },
  {
    "id": 674,
    "question": "mieltä siitä",
    "answer": "think that",
    "ru": "Думать об этом"
  },
  {
    "id": 675,
    "question": "rahapotti",
    "answer": "jackpot",
    "ru": "Джекпот"
  },
  {
    "id": 676,
    "question": "tuo",
    "answer": "brings",
    "ru": "Приносит"
  },
  {
    "id": 677,
    "question": "turvallisuutta",
    "answer": "security",
    "ru": "Безопасность"
  },
  {
    "id": 678,
    "question": "varmuutta",
    "answer": "certainty",
    "ru": "Уверенность"
  },
  {
    "id": 679,
    "question": "rauhoittaa",
    "answer": "calm",
    "ru": "Успокаивать"
  },
  {
    "id": 680,
    "question": "kummasti",
    "answer": "strangely",
    "ru": "Странно"
  },
  {
    "id": 681,
    "question": "myötä",
    "answer": "along/with",
    "ru": "Вместе с"
  },
  {
    "id": 682,
    "question": "mahdollisuus",
    "answer": "opportunity",
    "ru": "Возможность"
  },
  {
    "id": 683,
    "question": "huvittaa",
    "answer": "amuses / entertains",
    "ru": "Забавляет"
  },
  {
    "id": 684,
    "question": "Tietynlainen",
    "answer": "A certain kind",
    "ru": "Определённого рода"
  },
  {
    "id": 685,
    "question": "vapauden tunne",
    "answer": "a sense of freedom",
    "ru": "Чувство свободы"
  },
  {
    "id": 686,
    "question": "yhä useampi",
    "answer": "more and more",
    "ru": "Всё больше"
  },
  {
    "id": 687,
    "question": "ihmeelliseltä",
    "answer": "amazing",
    "ru": "Удивительный"
  },
  {
    "id": 688,
    "question": "maksoi",
    "answer": "paid",
    "ru": "Заплатил"
  },
  {
    "id": 689,
    "question": "kertaheitolla",
    "answer": "at once",
    "ru": "Сразу"
  },
  {
    "id": 690,
    "question": "arkielämä",
    "answer": "everyday life",
    "ru": "Повседневная жизнь"
  },
  {
    "id": 691,
    "question": "velaton",
    "answer": "free from debt",
    "ru": "Без долгов"
  },
  {
    "id": 692,
    "question": "tiukoilla",
    "answer": "strict/tight",
    "ru": "Жёсткий/напряжённый"
  },
  {
    "id": 693,
    "question": "perheen menojen",
    "answer": "family expenses",
    "ru": "Семейные расходы"
  },
  {
    "id": 694,
    "question": "riittänyt",
    "answer": "enough",
    "ru": "Хватило"
  },
  {
    "id": 695,
    "question": "tarpeeksi",
    "answer": "enough",
    "ru": "Достаточно"
  },
  {
    "id": 696,
    "question": "ylimääräiseen",
    "answer": "extra",
    "ru": "Дополнительный"
  },
  {
    "id": 697,
    "question": "Tähän asti",
    "answer": "So far / until now",
    "ru": "До сих пор"
  },
  {
    "id": 698,
    "question": "kokeneet",
    "answer": "experience",
    "ru": "Опыт"
  },
  {
    "id": 699,
    "question": "kokemus",
    "answer": "experience",
    "ru": "Опыт"
  },
  {
    "id": 700,
    "question": "kateellisia",
    "answer": "jealous",
    "ru": "Завистливые"
  },
  {
    "id": 701,
    "question": "saatu",
    "answer": "get",
    "ru": "Получить"
  },
  {
    "id": 702,
    "question": "Reilulla",
    "answer": "fair",
    "ru": "Честно"
  },
  {
    "id": 703,
    "question": "mietittiin",
    "answer": "thought",
    "ru": "Думали"
  },
  {
    "id": 704,
    "question": "jatkoivat",
    "answer": "continued",
    "ru": "Продолжали"
  },
  {
    "id": 705,
    "question": "edelleen",
    "answer": "still/again",
    "ru": "По-прежнему"
  },
  {
    "id": 706,
    "question": "antavat",
    "answer": "gives",
    "ru": "Даёт"
  },
  {
    "id": 707,
    "question": "ohjeeksi",
    "answer": "advice/guidance",
    "ru": "Совет/руководство"
  },
  {
    "id": 708,
    "question": "Häiriköt",
    "answer": "distractions",
    "ru": "Нарушители"
  },
  {
    "id": 709,
    "question": "vastuu",
    "answer": "responsibility",
    "ru": "Ответственность"
  },
  {
    "id": 710,
    "question": "häiriköivästä",
    "answer": "disturbing",
    "ru": "Беспокоящий"
  },
  {
    "id": 711,
    "question": "elokuvayleisöstä",
    "answer": "movie audience",
    "ru": "Зрители кино"
  },
  {
    "id": 712,
    "question": "odottaen",
    "answer": "in expectation of",
    "ru": "В ожидании"
  },
  {
    "id": 713,
    "question": "monen muun",
    "answer": "many others",
    "ru": "Многих других"
  },
  {
    "id": 714,
    "question": "vaikuttavaa",
    "answer": "impressive",
    "ru": "Впечатляющий"
  },
  {
    "id": 715,
    "question": "miellyttävä",
    "answer": "pleasant",
    "ru": "Приятный"
  },
  {
    "id": 716,
    "question": "millään tavoin",
    "answer": "in any way",
    "ru": "Никаким образом"
  },
  {
    "id": 717,
    "question": "Jotenkin",
    "answer": "somehow",
    "ru": "Как-то"
  },
  {
    "id": 718,
    "question": "alaikäistä",
    "answer": "minor",
    "ru": "Несовершеннолетний"
  },
  {
    "id": 719,
    "question": "pilasivat",
    "answer": "spoiled",
    "ru": "Испортили"
  },
  {
    "id": 720,
    "question": "nautinnon",
    "answer": "pleasure",
    "ru": "Удовольствие"
  },
  {
    "id": 721,
    "question": "tauotta",
    "answer": "non stop",
    "ru": "Не останавливаясь"
  },
  {
    "id": 722,
    "question": "läpi",
    "answer": "through",
    "ru": "Через"
  },
  {
    "id": 723,
    "question": "aikomuksensa",
    "answer": "intention",
    "ru": "Намерение"
  },
  {
    "id": 724,
    "question": "jäädä",
    "answer": "stay",
    "ru": "Остаться"
  },
  {
    "id": 725,
    "question": "Rohkeutta",
    "answer": "courage",
    "ru": "Смелость"
  },
  {
    "id": 726,
    "question": "kohtaamaan",
    "answer": "face",
    "ru": "Встретить"
  },
  {
    "id": 727,
    "question": "saakka",
    "answer": "until",
    "ru": "До"
  },
  {
    "id": 728,
    "question": "yleisön",
    "answer": "audience",
    "ru": "Зрители"
  },
  {
    "id": 729,
    "question": "kiukku",
    "answer": "anger",
    "ru": "Гнев"
  },
  {
    "id": 730,
    "question": "vaan",
    "answer": "instead",
    "ru": "Вместо этого"
  },
  {
    "id": 731,
    "question": "ryhtyvän",
    "answer": "undertake",
    "ru": "Приступить"
  },
  {
    "id": 732,
    "question": "kurinpitotoimenpiteisiin",
    "answer": "disciplinary measures,",
    "ru": "Дисциплинарные меры"
  },
  {
    "id": 733,
    "question": "vaikka",
    "answer": "although",
    "ru": "Хотя"
  },
  {
    "id": 734,
    "question": "kantanut",
    "answer": "carried",
    "ru": "Нёс"
  },
  {
    "id": 735,
    "question": "niskavilloista",
    "answer": "grab by the neck",
    "ru": "Схватить за шкирку"
  },
  {
    "id": 736,
    "question": "Tällainen",
    "answer": "however",
    "ru": "Однако"
  },
  {
    "id": 737,
    "question": "lisääntynyt",
    "answer": "increased",
    "ru": "Увеличился"
  },
  {
    "id": 738,
    "question": "pitäisi",
    "answer": "should",
    "ru": "Следует"
  },
  {
    "id": 739,
    "question": "Ehdottaisinkin",
    "answer": "I would suggest",
    "ru": "Я бы предложил"
  },
  {
    "id": 740,
    "question": "asenteen",
    "answer": "attitude",
    "ru": "Отношение"
  },
  {
    "id": 741,
    "question": "porttikielto",
    "answer": "curfew/ban",
    "ru": "Запрет на посещение"
  },
  {
    "id": 742,
    "question": "ainakin",
    "answer": "at least",
    "ru": "По крайней мере"
  },
  {
    "id": 743,
    "question": "Tahallisen",
    "answer": "On purpose",
    "ru": "Намеренный"
  },
  {
    "id": 744,
    "question": "sekin",
    "answer": "that too",
    "ru": "И то тоже"
  },
  {
    "id": 745,
    "question": "keskeytys",
    "answer": "interruption",
    "ru": "Прерывание"
  },
  {
    "id": 746,
    "question": "haitta",
    "answer": "disadvantage",
    "ru": "Недостаток"
  },
  {
    "id": 747,
    "question": "joutua",
    "answer": "get",
    "ru": "Попасть"
  },
  {
    "id": 748,
    "question": "kuin",
    "answer": "than",
    "ru": "Чем"
  },
  {
    "id": 749,
    "question": "asiattomia",
    "answer": "inappropriate",
    "ru": "Неуместный"
  },
  {
    "id": 750,
    "question": "vika",
    "answer": "fault",
    "ru": "Вина"
  },
  {
    "id": 751,
    "question": "Elokuvailtani",
    "answer": "movie night",
    "ru": "Кинофестиваль"
  },
  {
    "id": 752,
    "question": "vastaavalla",
    "answer": "with the equivalent",
    "ru": "С аналогичным"
  },
  {
    "id": 753,
    "question": "tavalla",
    "answer": "way",
    "ru": "Способ"
  },
  {
    "id": 754,
    "question": "pilalle",
    "answer": "to ruin",
    "ru": "Испортить"
  },
  {
    "id": 755,
    "question": "vaatimaan",
    "answer": "demanding",
    "ru": "Требуя"
  },
  {
    "id": 756,
    "question": "Vihainen",
    "answer": "angry",
    "ru": "Злой"
  },
  {
    "id": 757,
    "question": "Lainausoikeus",
    "answer": "Borrowing right",
    "ru": "Право на заём"
  },
  {
    "id": 758,
    "question": "esittämällä",
    "answer": "presenting",
    "ru": "Предъявляя"
  },
  {
    "id": 759,
    "question": "varustetun",
    "answer": "equipped",
    "ru": "Оснащённый"
  },
  {
    "id": 760,
    "question": "ilmoittamalla",
    "answer": "stating/informing",
    "ru": "Заявляя/сообщая"
  },
  {
    "id": 761,
    "question": "laitos",
    "answer": "institute",
    "ru": "Институт"
  },
  {
    "id": 762,
    "question": "yhteisö",
    "answer": "community",
    "ru": "Сообщество"
  },
  {
    "id": 763,
    "question": "takaajan",
    "answer": "guarantor",
    "ru": "Поручителя"
  },
  {
    "id": 764,
    "question": "joka",
    "answer": "which",
    "ru": "Который"
  },
  {
    "id": 765,
    "question": "sitoutuu",
    "answer": "undertakes",
    "ru": "Берёт на себя обязательство"
  },
  {
    "id": 766,
    "question": "aineistosta",
    "answer": "material",
    "ru": "Материал"
  },
  {
    "id": 767,
    "question": "oikeus",
    "answer": "right",
    "ru": "Право"
  },
  {
    "id": 768,
    "question": "perintätarkoituksiin",
    "answer": "for collection purposes",
    "ru": "Для целей взыскания"
  },
  {
    "id": 769,
    "question": "Henkilöllisyyden",
    "answer": "personality",
    "ru": "Личность"
  },
  {
    "id": 770,
    "question": "todistettuaan",
    "answer": "after proving",
    "ru": "После подтверждения"
  },
  {
    "id": 771,
    "question": "koskevat",
    "answer": "concering/relevant",
    "ru": "Касающийся/относящийся"
  },
  {
    "id": 772,
    "question": "luottamuksellista",
    "answer": "confidential",
    "ru": "Конфиденциальный"
  },
  {
    "id": 773,
    "question": "liittyvä",
    "answer": "related / connected",
    "ru": "Связанный"
  },
  {
    "id": 774,
    "question": "luovuta",
    "answer": "give up",
    "ru": "Сдаться"
  },
  {
    "id": 775,
    "question": "henkilökohtainen",
    "answer": "personal",
    "ru": "Личный"
  },
  {
    "id": 776,
    "question": "vastuussa",
    "answer": "accountable/responsible",
    "ru": "Ответственный"
  },
  {
    "id": 777,
    "question": "ulottuu",
    "answer": "extends",
    "ru": "Распространяется"
  },
  {
    "id": 778,
    "question": "kunnes",
    "answer": "until",
    "ru": "До тех пор пока"
  },
  {
    "id": 779,
    "question": "asettaa",
    "answer": "set / place/ put",
    "ru": "Устанавливать/размещать"
  },
  {
    "id": 780,
    "question": "käyttökieltoon",
    "answer": "ban on use",
    "ru": "Запрет на использование"
  },
  {
    "id": 781,
    "question": "purkaa",
    "answer": "unblock",
    "ru": "Снять блокировку"
  },
  {
    "id": 782,
    "question": "todistamalla",
    "answer": "by proving",
    "ru": "Доказав"
  },
  {
    "id": 783,
    "question": "uusimisesta",
    "answer": "renewal",
    "ru": "Продление"
  },
  {
    "id": 784,
    "question": "peritään",
    "answer": "will be collected",
    "ru": "Будет взиматься"
  },
  {
    "id": 785,
    "question": "henkilöllisyytensä",
    "answer": "identity",
    "ru": "Личность"
  },
  {
    "id": 786,
    "question": "osallistumaan",
    "answer": "to participate",
    "ru": "Участвовать"
  },
  {
    "id": 787,
    "question": "Kunnostuksen",
    "answer": "renovation / renewal",
    "ru": "Обновление/ремонт"
  },
  {
    "id": 788,
    "question": "osana",
    "answer": "as a part",
    "ru": "Как часть"
  },
  {
    "id": 789,
    "question": "Kuntoliikuntaliiton",
    "answer": "Fitness association",
    "ru": "Федерация фитнеса"
  },
  {
    "id": 790,
    "question": "valtakunnallista",
    "answer": "nationwide",
    "ru": "Общенациональный"
  },
  {
    "id": 791,
    "question": "erityisesti",
    "answer": "especially",
    "ru": "Особенно"
  },
  {
    "id": 792,
    "question": "joka",
    "answer": "who",
    "ru": "Кто"
  },
  {
    "id": 793,
    "question": "aikaisemmin",
    "answer": "previous/before/earlier",
    "ru": "Раньше/прежде"
  },
  {
    "id": 794,
    "question": "liikuntaa",
    "answer": "sports",
    "ru": "Спорт"
  },
  {
    "id": 795,
    "question": "tutustua",
    "answer": "get to know",
    "ru": "Познакомиться"
  },
  {
    "id": 796,
    "question": "liikuntamuotoihin",
    "answer": "forms of exercise",
    "ru": "Формы упражнений"
  },
  {
    "id": 797,
    "question": "venyttelyjumppa",
    "answer": "stretching exercise",
    "ru": "Упражнения на растяжку"
  },
  {
    "id": 798,
    "question": "kuntonyrkkeily",
    "answer": "fitness boxing",
    "ru": "Фитнес-бокс"
  },
  {
    "id": 799,
    "question": "käytettävä",
    "answer": "to be used",
    "ru": "Используемый"
  },
  {
    "id": 800,
    "question": "sisäliikuntajalkineita",
    "answer": "indoor sports shoes",
    "ru": "Кроссовки для зала"
  },
  {
    "id": 801,
    "question": "muihin ryhmiin",
    "answer": "come to the group",
    "ru": "Прийти в группу"
  },
  {
    "id": 802,
    "question": "avoimien ovien",
    "answer": "open door",
    "ru": "Открытые двери"
  },
  {
    "id": 803,
    "question": "kokeilemaan",
    "answer": "to try",
    "ru": "Попробовать"
  },
  {
    "id": 804,
    "question": "uudistunut",
    "answer": "updated",
    "ru": "Обновлённый"
  },
  {
    "id": 805,
    "question": "Esitäytetty",
    "answer": "pre filled",
    "ru": "Предварительно заполненный"
  },
  {
    "id": 806,
    "question": "korvaa",
    "answer": "replace",
    "ru": "Заменить"
  },
  {
    "id": 807,
    "question": "veroilmoituksen",
    "answer": "tax declaration",
    "ru": "Налоговая декларация"
  },
  {
    "id": 808,
    "question": "veroehdotuksen",
    "answer": "tax proposal",
    "ru": "Налоговое предложение"
  },
  {
    "id": 809,
    "question": "korjausohjeet",
    "answer": "repair instructions",
    "ru": "Инструкции по ремонту"
  },
  {
    "id": 810,
    "question": "toiminta",
    "answer": "operating",
    "ru": "Работа"
  },
  {
    "id": 811,
    "question": "Tutustu",
    "answer": "get to know / check",
    "ru": "Ознакомиться/проверить"
  },
  {
    "id": 812,
    "question": "luonnolliset",
    "answer": "natural",
    "ru": "Естественный"
  },
  {
    "id": 813,
    "question": "merkitty",
    "answer": "marked",
    "ru": "Отмеченный"
  },
  {
    "id": 814,
    "question": "lisättävää",
    "answer": "to add",
    "ru": "Добавить"
  },
  {
    "id": 815,
    "question": "korjattavaa",
    "answer": "to fix/ to correct",
    "ru": "Исправить"
  },
  {
    "id": 816,
    "question": "metsätalouden",
    "answer": "forestry",
    "ru": "Лесоводство"
  },
  {
    "id": 817,
    "question": "tositteita",
    "answer": "voucher",
    "ru": "Ваучер"
  },
  {
    "id": 818,
    "question": "ei enää",
    "answer": "no longer",
    "ru": "Больше не"
  },
  {
    "id": 819,
    "question": "Säilytä",
    "answer": "keep it",
    "ru": "Сохрани это"
  },
  {
    "id": 820,
    "question": "pyytää",
    "answer": "ask",
    "ru": "Просить"
  },
  {
    "id": 821,
    "question": "olevista",
    "answer": "existing",
    "ru": "Существующий"
  },
  {
    "id": 822,
    "question": "tilisiirtolomakkeet",
    "answer": "bank transfer forms",
    "ru": "Бланки банковских переводов"
  },
  {
    "id": 823,
    "question": "sähkölaitteita",
    "answer": "electrical equipment",
    "ru": "Электрооборудование"
  },
  {
    "id": 824,
    "question": "turvallisesti",
    "answer": "safely",
    "ru": "Безопасно"
  },
  {
    "id": 825,
    "question": "kuitenkin",
    "answer": "however",
    "ru": "Однако"
  },
  {
    "id": 826,
    "question": "harvemmin",
    "answer": "rarely/less often",
    "ru": "Редко/реже"
  },
  {
    "id": 827,
    "question": "laitteen",
    "answer": "device",
    "ru": "Устройство"
  },
  {
    "id": 828,
    "question": "Turvatekniikan",
    "answer": "security technology",
    "ru": "Технология безопасности"
  },
  {
    "id": 829,
    "question": "tutkimuksen",
    "answer": "research",
    "ru": "Исследование"
  },
  {
    "id": 830,
    "question": "saavatkin",
    "answer": "electrocuted",
    "ru": "Ударило током"
  },
  {
    "id": 831,
    "question": "ryhtyä",
    "answer": "start/ proceed",
    "ru": "Начать/приступить"
  },
  {
    "id": 832,
    "question": "noin vain",
    "answer": "just like that",
    "ru": "Вот так просто"
  },
  {
    "id": 833,
    "question": "lupakirja",
    "answer": "license",
    "ru": "Лицензия"
  },
  {
    "id": 834,
    "question": "ammattitutkinto",
    "answer": "professional degree",
    "ru": "Профессиональная степень"
  },
  {
    "id": 835,
    "question": "huolestuttava",
    "answer": "worrying",
    "ru": "Тревожный"
  },
  {
    "id": 836,
    "question": "Omatoiminen",
    "answer": "self working",
    "ru": "Самодеятельный"
  },
  {
    "id": 837,
    "question": "Ilmeisesti",
    "answer": "apparently, obviously",
    "ru": "По всей видимости"
  },
  {
    "id": 838,
    "question": "jotkut",
    "answer": "some",
    "ru": "Некоторые"
  },
  {
    "id": 839,
    "question": "yliarvioivat",
    "answer": "over estimate",
    "ru": "Переоценивают"
  },
  {
    "id": 840,
    "question": "kykynsä",
    "answer": "abilities",
    "ru": "Способности"
  },
  {
    "id": 841,
    "question": "arvelee",
    "answer": "thinks",
    "ru": "Считает"
  },
  {
    "id": 842,
    "question": "vaarallista",
    "answer": "dangerous",
    "ru": "Опасно"
  },
  {
    "id": 843,
    "question": "saattaa",
    "answer": "may",
    "ru": "Может"
  },
  {
    "id": 844,
    "question": "aiheuttaa",
    "answer": "cause",
    "ru": "Вызывать"
  },
  {
    "id": 845,
    "question": "vaaraa",
    "answer": "danger",
    "ru": "Опасность"
  },
  {
    "id": 846,
    "question": "Yleisesti",
    "answer": "generally",
    "ru": "Как правило"
  },
  {
    "id": 847,
    "question": "vähentynyt",
    "answer": "decreased",
    "ru": "Уменьшился"
  },
  {
    "id": 848,
    "question": "tilanteeseen",
    "answer": "situation",
    "ru": "Ситуация"
  },
  {
    "id": 849,
    "question": "verrattuna",
    "answer": "compared to",
    "ru": "По сравнению с"
  },
  {
    "id": 850,
    "question": "Useimmat",
    "answer": "most",
    "ru": "Большинство"
  },
  {
    "id": 851,
    "question": "noudattavansa",
    "answer": "comply with",
    "ru": "Соблюдать"
  },
  {
    "id": 852,
    "question": "sääntöjä",
    "answer": "rules",
    "ru": "Правила"
  },
  {
    "id": 853,
    "question": "kytkevät",
    "answer": "swtich/connect/hook",
    "ru": "Переключают/подключают"
  },
  {
    "id": 854,
    "question": "lähtiessään",
    "answer": "while leaving",
    "ru": "Уходя"
  },
  {
    "id": 855,
    "question": "enää",
    "answer": "anymore/no longer",
    "ru": "Больше/уже не"
  },
  {
    "id": 856,
    "question": "väittävät",
    "answer": "claim",
    "ru": "Утверждают"
  },
  {
    "id": 857,
    "question": "epäilevät",
    "answer": "doubt",
    "ru": "Сомневаются"
  },
  {
    "id": 858,
    "question": "nykyisin",
    "answer": "nowadays",
    "ru": "В наши дни"
  },
  {
    "id": 859,
    "question": "entistä",
    "answer": "former",
    "ru": "Бывший"
  },
  {
    "id": 860,
    "question": "taito",
    "answer": "skill",
    "ru": "Навык"
  },
  {
    "id": 861,
    "question": "katoaa",
    "answer": "lost",
    "ru": "Исчезает"
  },
  {
    "id": 862,
    "question": "sekaisin",
    "answer": "messed up",
    "ru": "Всё перепуталось"
  },
  {
    "id": 863,
    "question": "viemättä",
    "answer": "not taken",
    "ru": "Не вынесенный"
  },
  {
    "id": 864,
    "question": "roskat",
    "answer": "garbage",
    "ru": "Мусор"
  },
  {
    "id": 865,
    "question": "tiskit",
    "answer": "dishes",
    "ru": "Посуда"
  },
  {
    "id": 866,
    "question": "pölyt",
    "answer": "dust",
    "ru": "пыль"
  },
  {
    "id": 867,
    "question": "pyyhkimättä",
    "answer": "without sweeping",
    "ru": "без вытирания пыли"
  },
  {
    "id": 868,
    "question": "Epäsiisteys",
    "answer": "uncleanness",
    "ru": "нечистоплотность"
  },
  {
    "id": 869,
    "question": "ei tunnu",
    "answer": "does not feel",
    "ru": "не чувствуется"
  },
  {
    "id": 870,
    "question": "edes silloin",
    "answer": "even then",
    "ru": "даже тогда"
  },
  {
    "id": 871,
    "question": "haiseekin",
    "answer": "smells",
    "ru": "пахнет"
  },
  {
    "id": 872,
    "question": "pahalta",
    "answer": "bad",
    "ru": "плохо"
  },
  {
    "id": 873,
    "question": "Eräs",
    "answer": "One",
    "ru": "один"
  },
  {
    "id": 874,
    "question": "valitti",
    "answer": "complained",
    "ru": "жаловался"
  },
  {
    "id": 875,
    "question": "tukossa",
    "answer": "blocked",
    "ru": "заблокировано"
  },
  {
    "id": 876,
    "question": "iho kutisee",
    "answer": "skin itches",
    "ru": "кожа чешется"
  },
  {
    "id": 877,
    "question": "ihottumaa",
    "answer": "rash",
    "ru": "сыпь"
  },
  {
    "id": 878,
    "question": "Kehotin",
    "answer": "advice/recommend/urged",
    "ru": "посоветовал / рекомендовал / призвал"
  },
  {
    "id": 879,
    "question": "pölypunkit",
    "answer": "dust mites",
    "ru": "клещи домашней пыли"
  },
  {
    "id": 880,
    "question": "petivaatteet",
    "answer": "bedding",
    "ru": "постельное бельё"
  },
  {
    "id": 881,
    "question": "ihmeissään",
    "answer": "amazed",
    "ru": "удивлённый"
  },
  {
    "id": 882,
    "question": "oireet",
    "answer": "symptoms",
    "ru": "симптомы"
  },
  {
    "id": 883,
    "question": "hävisivät",
    "answer": "disappeared",
    "ru": "исчезли"
  },
  {
    "id": 884,
    "question": "myönteistä",
    "answer": "positive",
    "ru": "положительное"
  },
  {
    "id": 885,
    "question": "huolehtivat",
    "answer": "take care",
    "ru": "заботятся"
  },
  {
    "id": 886,
    "question": "aiempaa paremmin",
    "answer": "better than before",
    "ru": "лучше, чем раньше"
  },
  {
    "id": 887,
    "question": "hygieniastaan",
    "answer": "hygiene",
    "ru": "гигиена"
  },
  {
    "id": 888,
    "question": "Henkilökohtaisesta",
    "answer": "personal",
    "ru": "личный"
  },
  {
    "id": 889,
    "question": "aloitteellisempi",
    "answer": "more proactive",
    "ru": "более инициативный"
  },
  {
    "id": 890,
    "question": "vihdoinkin",
    "answer": "finally",
    "ru": "наконец-то"
  },
  {
    "id": 891,
    "question": "otteen",
    "answer": "grip",
    "ru": "хватка"
  },
  {
    "id": 892,
    "question": "jotka koet",
    "answer": "which you feel",
    "ru": "которые ты чувствуешь"
  },
  {
    "id": 893,
    "question": "mainio",
    "answer": "wonderful, great",
    "ru": "замечательный, отличный"
  },
  {
    "id": 894,
    "question": "riittävän",
    "answer": "enough",
    "ru": "достаточно"
  },
  {
    "id": 895,
    "question": "ylenmääräistä",
    "answer": "redundant",
    "ru": "избыточный"
  },
  {
    "id": 896,
    "question": "rynni",
    "answer": "rush",
    "ru": "ринулся"
  },
  {
    "id": 897,
    "question": "Maltti",
    "answer": "patience",
    "ru": "терпение"
  },
  {
    "id": 898,
    "question": "valttia",
    "answer": "virtue",
    "ru": "достоинство"
  },
  {
    "id": 899,
    "question": "ilmetä sotkuja",
    "answer": "make messes",
    "ru": "устраивать беспорядок"
  },
  {
    "id": 900,
    "question": "ilmetä",
    "answer": "manifest",
    "ru": "проявляться"
  },
  {
    "id": 901,
    "question": "ikävällä",
    "answer": "nostalgic",
    "ru": "тоскливо"
  },
  {
    "id": 902,
    "question": "pintaan",
    "answer": "surface, come up",
    "ru": "поверхность, всплыть"
  },
  {
    "id": 903,
    "question": "Säpinää",
    "answer": "chaos",
    "ru": "суета"
  },
  {
    "id": 904,
    "question": "edessäsi",
    "answer": "in front of you",
    "ru": "перед тобой"
  },
  {
    "id": 905,
    "question": "jakso",
    "answer": "period, phase, episode",
    "ru": "период, фаза, эпизод"
  },
  {
    "id": 906,
    "question": "merkittävä",
    "answer": "remarkable",
    "ru": "значительный"
  },
  {
    "id": 907,
    "question": "aatteita",
    "answer": "idea",
    "ru": "идея"
  },
  {
    "id": 908,
    "question": "omaksua",
    "answer": "adapt",
    "ru": "усвоить"
  },
  {
    "id": 909,
    "question": "varsinkin",
    "answer": "especially",
    "ru": "особенно"
  },
  {
    "id": 910,
    "question": "väistämättä",
    "answer": "inevitably",
    "ru": "неизбежно"
  },
  {
    "id": 911,
    "question": "arvioimaan",
    "answer": "to evaluate",
    "ru": "оценивать"
  },
  {
    "id": 912,
    "question": "asenteet",
    "answer": "attitude",
    "ru": "установки, отношение"
  },
  {
    "id": 913,
    "question": "syytä",
    "answer": "reason",
    "ru": "причина"
  },
  {
    "id": 914,
    "question": "heittää",
    "answer": "throw",
    "ru": "бросать"
  },
  {
    "id": 915,
    "question": "Toimi vaistosi varassa",
    "answer": "Go with your instincts",
    "ru": "следуй своим инстинктам"
  },
  {
    "id": 916,
    "question": "vaistosi",
    "answer": "your instincts",
    "ru": "твои инстинкты"
  },
  {
    "id": 917,
    "question": "Neitsyt",
    "answer": "virgin",
    "ru": "дева"
  },
  {
    "id": 918,
    "question": "valppaana",
    "answer": "to be alert",
    "ru": "быть начеку"
  },
  {
    "id": 919,
    "question": "kannattaa",
    "answer": "maintain",
    "ru": "стоит"
  },
  {
    "id": 920,
    "question": "tilaisuuden",
    "answer": "opportunity",
    "ru": "возможность"
  },
  {
    "id": 921,
    "question": "saatat",
    "answer": "you might",
    "ru": "ты можешь"
  },
  {
    "id": 922,
    "question": "menettää",
    "answer": "lose, miss",
    "ru": "потерять, упустить"
  },
  {
    "id": 923,
    "question": "herpaantua",
    "answer": "relax, wander",
    "ru": "расслабиться, рассеяться"
  },
  {
    "id": 924,
    "question": "tarkkaavaisuutesi",
    "answer": "attention",
    "ru": "внимание"
  },
  {
    "id": 925,
    "question": "Tuttavasi",
    "answer": "your acquintance",
    "ru": "твой знакомый"
  },
  {
    "id": 926,
    "question": "vastaan",
    "answer": "against",
    "ru": "против"
  },
  {
    "id": 927,
    "question": "sallit",
    "answer": "allow, permit",
    "ru": "позволять, разрешать"
  },
  {
    "id": 928,
    "question": "tapahtua",
    "answer": "happen",
    "ru": "происходить"
  },
  {
    "id": 929,
    "question": "yhtään",
    "answer": "any, anything",
    "ru": "ничего, что-либо"
  },
  {
    "id": 930,
    "question": "panematta",
    "answer": "without noticing, without observing",
    "ru": "не замечая, без наблюдения"
  },
  {
    "id": 931,
    "question": "riesan",
    "answer": "trouble",
    "ru": "неприятность"
  },
  {
    "id": 932,
    "question": "hallintaan",
    "answer": "control, trust, manage",
    "ru": "контроль, управление"
  },
  {
    "id": 933,
    "question": "tunnetilojesi",
    "answer": "your emotional states",
    "ru": "твои эмоциональные состояния"
  },
  {
    "id": 934,
    "question": "huomiota",
    "answer": "attention",
    "ru": "внимание"
  },
  {
    "id": 935,
    "question": "kiinnittää huomiota",
    "answer": "pay attention",
    "ru": "обращать внимание"
  },
  {
    "id": 936,
    "question": "kannattaisi",
    "answer": "it would be worth",
    "ru": "стоило бы"
  },
  {
    "id": 937,
    "question": "ylen määrin",
    "answer": "to a large extend",
    "ru": "в большой мере"
  },
  {
    "id": 938,
    "question": "lähipiiriäsi",
    "answer": "close circle",
    "ru": "близкое окружение"
  },
  {
    "id": 939,
    "question": "vetäytyä",
    "answer": "retreat, withdraw",
    "ru": "отступить, удалиться"
  },
  {
    "id": 940,
    "question": "omiin oloihisi",
    "answer": "your own circumstances",
    "ru": "твоё собственное окружение"
  },
  {
    "id": 941,
    "question": "pohtia",
    "answer": "consider",
    "ru": "обдумать"
  },
  {
    "id": 942,
    "question": "taustalla",
    "answer": "backgroud, context",
    "ru": "фон, контекст"
  },
  {
    "id": 943,
    "question": "syitä",
    "answer": "reasons",
    "ru": "причины"
  },
  {
    "id": 944,
    "question": "Joukkoliikenne",
    "answer": "Public transport",
    "ru": "общественный транспорт"
  },
  {
    "id": 945,
    "question": "Liki puolet",
    "answer": "about half",
    "ru": "около половины"
  },
  {
    "id": 946,
    "question": "kulkee",
    "answer": "travels, passes",
    "ru": "едет, проходит"
  },
  {
    "id": 947,
    "question": "edestakaista",
    "answer": "round trip,",
    "ru": "туда-обратно"
  },
  {
    "id": 948,
    "question": "selvityksen",
    "answer": "statement, report",
    "ru": "заявление, отчёт"
  },
  {
    "id": 949,
    "question": "ainoastaan",
    "answer": "only",
    "ru": "только"
  },
  {
    "id": 950,
    "question": "julkisella kulkuvälineellä",
    "answer": "by public transport",
    "ru": "на общественном транспорте"
  },
  {
    "id": 951,
    "question": "kokeiluun",
    "answer": "experiment",
    "ru": "эксперимент"
  },
  {
    "id": 952,
    "question": "johti",
    "answer": "led",
    "ru": "привело"
  },
  {
    "id": 953,
    "question": "työmatkalaisia",
    "answer": "commuters",
    "ru": "пассажиры-пригородники"
  },
  {
    "id": 954,
    "question": "houkutellaan",
    "answer": "attracted",
    "ru": "привлекли"
  },
  {
    "id": 955,
    "question": "jättämään",
    "answer": "to leave",
    "ru": "оставить"
  },
  {
    "id": 956,
    "question": "ajoneuvonsa",
    "answer": "their vehicle",
    "ru": "своё транспортное средство"
  },
  {
    "id": 957,
    "question": "kauemmaksi",
    "answer": "farther",
    "ru": "дальше"
  },
  {
    "id": 958,
    "question": "ruuhkia",
    "answer": "traffic jams",
    "ru": "пробки"
  },
  {
    "id": 959,
    "question": "Kimppakyydin",
    "answer": "car pooling",
    "ru": "совместные поездки"
  },
  {
    "id": 960,
    "question": "tutkittu",
    "answer": "studied, researched",
    "ru": "изученный, исследованный"
  },
  {
    "id": 961,
    "question": "Ilmeistä",
    "answer": "obvious",
    "ru": "очевидное"
  },
  {
    "id": 962,
    "question": "etenkin",
    "answer": "especially",
    "ru": "особенно"
  },
  {
    "id": 963,
    "question": "tapauksessa",
    "answer": "case, incident",
    "ru": "случай, инцидент"
  },
  {
    "id": 964,
    "question": "suunnalla",
    "answer": "direction",
    "ru": "направление"
  },
  {
    "id": 965,
    "question": "vuoroin",
    "answer": "alternatively",
    "ru": "поочерёдно"
  },
  {
    "id": 966,
    "question": "perinteistä",
    "answer": "traditional",
    "ru": "традиционный"
  },
  {
    "id": 967,
    "question": "suhtautuvat",
    "answer": "relate to",
    "ru": "относятся к"
  },
  {
    "id": 968,
    "question": "kaupankäyntiin",
    "answer": "trade",
    "ru": "торговля"
  },
  {
    "id": 969,
    "question": "sahatavaraa",
    "answer": "lumber",
    "ru": "пиломатериалы"
  },
  {
    "id": 970,
    "question": "luomutuotteita",
    "answer": "organic products",
    "ru": "органические продукты"
  },
  {
    "id": 971,
    "question": "porsaankyljyksiä",
    "answer": "pork chops",
    "ru": "свиные отбивные"
  },
  {
    "id": 972,
    "question": "eniten",
    "answer": "most",
    "ru": "больше всего"
  },
  {
    "id": 973,
    "question": "Kunhan",
    "answer": "as long as",
    "ru": "при условии, что"
  },
  {
    "id": 974,
    "question": "tuotevalikoima",
    "answer": "product range",
    "ru": "ассортимент товаров"
  },
  {
    "id": 975,
    "question": "laajenee",
    "answer": "expands",
    "ru": "расширяется"
  },
  {
    "id": 976,
    "question": "keino",
    "answer": "way, means",
    "ru": "способ, средство"
  },
  {
    "id": 977,
    "question": "ylivertainen",
    "answer": "superior",
    "ru": "превосходный"
  },
  {
    "id": 978,
    "question": "Väki",
    "answer": "people, folks",
    "ru": "люди, народ"
  },
  {
    "id": 979,
    "question": "viettää",
    "answer": "spend",
    "ru": "проводить"
  },
  {
    "id": 980,
    "question": "vähää",
    "answer": "little",
    "ru": "немного"
  },
  {
    "id": 981,
    "question": "tungoksessa",
    "answer": "crowd, congestion, hustle",
    "ru": "толпа, давка, суматоха"
  },
  {
    "id": 982,
    "question": "vaan",
    "answer": "but",
    "ru": "но"
  },
  {
    "id": 983,
    "question": "vaivattomuus",
    "answer": "effortlessness",
    "ru": "лёгкость"
  },
  {
    "id": 984,
    "question": "Juuri",
    "answer": "Just",
    "ru": "именно"
  },
  {
    "id": 985,
    "question": "syy",
    "answer": "reason",
    "ru": "причина"
  },
  {
    "id": 986,
    "question": "lisääntymiseen",
    "answer": "increase",
    "ru": "увеличение"
  },
  {
    "id": 987,
    "question": "Lisäksi",
    "answer": "in addition",
    "ru": "кроме того"
  },
  {
    "id": 988,
    "question": "viehättää",
    "answer": "attract",
    "ru": "привлекать"
  },
  {
    "id": 989,
    "question": "puoli",
    "answer": "side",
    "ru": "сторона"
  },
  {
    "id": 990,
    "question": "suhtautuvat",
    "answer": "relate to",
    "ru": "относятся к"
  },
  {
    "id": 991,
    "question": "myönteisimmin",
    "answer": "most positively",
    "ru": "наиболее положительно"
  },
  {
    "id": 992,
    "question": "aktiivisesti",
    "answer": "actively",
    "ru": "активно"
  },
  {
    "id": 993,
    "question": "Usein kyse",
    "answer": "its often about",
    "ru": "часто речь идёт о"
  },
  {
    "id": 994,
    "question": "tyyppikuva",
    "answer": "stereotype",
    "ru": "стереотип"
  },
  {
    "id": 995,
    "question": "hyödyntävät",
    "answer": "utilize",
    "ru": "используют"
  },
  {
    "id": 996,
    "question": "perheenäiditkin",
    "answer": "housewives too",
    "ru": "домохозяйки тоже"
  },
  {
    "id": 997,
    "question": "löytämässä",
    "answer": "finding",
    "ru": "находящий"
  },
  {
    "id": 998,
    "question": "nimittäin",
    "answer": "namely",
    "ru": "а именно"
  },
  {
    "id": 999,
    "question": "maksupuoli",
    "answer": "payment side",
    "ru": "платёжная сторона"
  },
  {
    "id": 1000,
    "question": "arveluttaa",
    "answer": "troubles",
    "ru": "беспокоит"
  },
  {
    "id": 1001,
    "question": "Kuluttajat",
    "answer": "consumers",
    "ru": "потребители"
  },
  {
    "id": 1002,
    "question": "maksutapana",
    "answer": "as a payment method",
    "ru": "в качестве способа оплаты"
  },
  {
    "id": 1003,
    "question": "tilisiirtoa",
    "answer": "bank transfer",
    "ru": "банковский перевод"
  },
  {
    "id": 1004,
    "question": "tuttua",
    "answer": "familiar",
    "ru": "знакомый"
  },
  {
    "id": 1005,
    "question": "postinennakkoa",
    "answer": "letter head",
    "ru": "наложенный платёж"
  },
  {
    "id": 1006,
    "question": "kulunut",
    "answer": "worn",
    "ru": "изношенный"
  },
  {
    "id": 1007,
    "question": "kaakeli",
    "answer": "tile",
    "ru": "плитка"
  },
  {
    "id": 1008,
    "question": "pilaantunut",
    "answer": "spoiled, rotten",
    "ru": "испорченный, гнилой"
  },
  {
    "id": 1009,
    "question": "laitos",
    "answer": "facility",
    "ru": "учреждение"
  },
  {
    "id": 1010,
    "question": "valtaosa",
    "answer": "the greater part",
    "ru": "большая часть"
  },
  {
    "id": 1011,
    "question": "kartano",
    "answer": "estate",
    "ru": "поместье"
  },
  {
    "id": 1012,
    "question": "palatsi",
    "answer": "palace",
    "ru": "дворец"
  },
  {
    "id": 1013,
    "question": "piilo",
    "answer": "hiding",
    "ru": "укрытие"
  },
  {
    "id": 1014,
    "question": "ilmapiiri",
    "answer": "atmosphere",
    "ru": "атмосфера"
  },
  {
    "id": 1015,
    "question": "syli",
    "answer": "lap",
    "ru": "колени"
  },
  {
    "id": 1016,
    "question": "sydän",
    "answer": "heart",
    "ru": "сердце"
  },
  {
    "id": 1017,
    "question": "lähiö",
    "answer": "suburb",
    "ru": "пригород"
  },
  {
    "id": 1018,
    "question": "kohtalo",
    "answer": "desitny, fate",
    "ru": "судьба, рок"
  },
  {
    "id": 1019,
    "question": "paljasjalkainen",
    "answer": "barefooted",
    "ru": "босоногий"
  },
  {
    "id": 1020,
    "question": "stressaava",
    "answer": "stressful",
    "ru": "стрессовый"
  },
  {
    "id": 1021,
    "question": "unelma",
    "answer": "dream",
    "ru": "мечта"
  },
  {
    "id": 1022,
    "question": "kortteli",
    "answer": "block",
    "ru": "квартал"
  },
  {
    "id": 1023,
    "question": "varttia",
    "answer": "quarter",
    "ru": "четверть"
  },
  {
    "id": 1024,
    "question": "sitä paitsi",
    "answer": "besides",
    "ru": "кроме того"
  },
  {
    "id": 1025,
    "question": "tilava",
    "answer": "spacious",
    "ru": "просторный"
  },
  {
    "id": 1026,
    "question": "parketti",
    "answer": "wood floor",
    "ru": "паркет"
  },
  {
    "id": 1027,
    "question": "tiukka",
    "answer": "strict, tight",
    "ru": "строгий, плотный"
  },
  {
    "id": 1028,
    "question": "lastulevy",
    "answer": "chipboard",
    "ru": "ДСП"
  },
  {
    "id": 1029,
    "question": "komero",
    "answer": "closet",
    "ru": "шкаф, кладовка"
  },
  {
    "id": 1030,
    "question": "sukupuutto",
    "answer": "extinction",
    "ru": "вымирание"
  },
  {
    "id": 1031,
    "question": "haukotella",
    "answer": "to yawn",
    "ru": "зевать"
  },
  {
    "id": 1032,
    "question": "punastua",
    "answer": "to blush",
    "ru": "краснеть"
  },
  {
    "id": 1033,
    "question": "väitellä",
    "answer": "to argue, debate it",
    "ru": "спорить, дискутировать"
  },
  {
    "id": 1034,
    "question": "kiipeillä",
    "answer": "to climb",
    "ru": "карабкаться"
  },
  {
    "id": 1035,
    "question": "kiivetä",
    "answer": "to climb",
    "ru": "взбираться"
  },
  {
    "id": 1036,
    "question": "suuttua",
    "answer": "to get angry",
    "ru": "злиться"
  },
  {
    "id": 1037,
    "question": "kuorsata",
    "answer": "to snore",
    "ru": "храпеть"
  },
  {
    "id": 1038,
    "question": "tähdenlento",
    "answer": "shooting star",
    "ru": "падающая звезда"
  },
  {
    "id": 1039,
    "question": "kaivata",
    "answer": "to miss, to long for",
    "ru": "скучать, тосковать по"
  },
  {
    "id": 1040,
    "question": "romu",
    "answer": "junk",
    "ru": "хлам"
  },
  {
    "id": 1041,
    "question": "pärjätä",
    "answer": "to get along",
    "ru": "справляться"
  },
  {
    "id": 1042,
    "question": "silittää",
    "answer": "to stroke, iron",
    "ru": "гладить"
  },
  {
    "id": 1043,
    "question": "hyräillä",
    "answer": "to hum",
    "ru": "мурлыкать"
  },
  {
    "id": 1044,
    "question": "lakata",
    "answer": "to stop",
    "ru": "прекращать"
  },
  {
    "id": 1045,
    "question": "kyetä",
    "answer": "to be able to",
    "ru": "быть способным"
  },
  {
    "id": 1046,
    "question": "alttari",
    "answer": "altar",
    "ru": "алтарь"
  },
  {
    "id": 1047,
    "question": "paljastua",
    "answer": "to be revealed, uncovered",
    "ru": "раскрываться, обнажаться"
  },
  {
    "id": 1048,
    "question": "purkautua",
    "answer": "to burst out",
    "ru": "вырываться"
  },
  {
    "id": 1049,
    "question": "kiristyä",
    "answer": "to worsen, tighten",
    "ru": "ухудшаться, натягиваться"
  },
  {
    "id": 1050,
    "question": "jäätyä",
    "answer": "to freeze",
    "ru": "замёрзнуть"
  },
  {
    "id": 1051,
    "question": "barrikadi",
    "answer": "barricade",
    "ru": "баррикада"
  },
  {
    "id": 1052,
    "question": "romahtaa",
    "answer": "to collapse",
    "ru": "рухнуть"
  },
  {
    "id": 1053,
    "question": "saniainen",
    "answer": "fern",
    "ru": "папоротник"
  },
  {
    "id": 1054,
    "question": "uhanalainen",
    "answer": "endangered",
    "ru": "находящийся под угрозой"
  },
  {
    "id": 1055,
    "question": "sekoittaa",
    "answer": "to mix",
    "ru": "смешивать"
  },
  {
    "id": 1056,
    "question": "hylätä",
    "answer": "to refuse, abandon",
    "ru": "отказаться, бросить"
  },
  {
    "id": 1057,
    "question": "alkeellinen",
    "answer": "primitive",
    "ru": "примитивный"
  },
  {
    "id": 1058,
    "question": "puutarhuri",
    "answer": "gardener",
    "ru": "садовник"
  },
  {
    "id": 1059,
    "question": "kekäle",
    "answer": "ember",
    "ru": "уголь"
  },
  {
    "id": 1060,
    "question": "hehkua",
    "answer": "to glow",
    "ru": "светиться"
  },
  {
    "id": 1061,
    "question": "hiili",
    "answer": "coal",
    "ru": "уголь"
  },
  {
    "id": 1062,
    "question": "neste",
    "answer": "liquid",
    "ru": "жидкость"
  },
  {
    "id": 1063,
    "question": "päihde",
    "answer": "intoxicant",
    "ru": "одурманивающее вещество"
  },
  {
    "id": 1064,
    "question": "painajainen",
    "answer": "nightmare",
    "ru": "кошмар"
  },
  {
    "id": 1065,
    "question": "tarttuva",
    "answer": "infectious",
    "ru": "заразный"
  },
  {
    "id": 1066,
    "question": "nomadi",
    "answer": "nomad",
    "ru": "кочевник"
  },
  {
    "id": 1067,
    "question": "vaeltaa",
    "answer": "to wander",
    "ru": "скитаться"
  },
  {
    "id": 1068,
    "question": "jodi",
    "answer": "iodine",
    "ru": "йод"
  },
  {
    "id": 1069,
    "question": "sprii",
    "answer": "spirit",
    "ru": "спирт"
  },
  {
    "id": 1070,
    "question": "desinfioida",
    "answer": "to disinfect",
    "ru": "дезинфицировать"
  },
  {
    "id": 1071,
    "question": "aine",
    "answer": "matter, material",
    "ru": "вещество, материал"
  },
  {
    "id": 1072,
    "question": "luksusristeilijä",
    "answer": "luxury cruiser",
    "ru": "роскошный круизный лайнер"
  },
  {
    "id": 1073,
    "question": "proosa",
    "answer": "prose",
    "ru": "проза"
  },
  {
    "id": 1074,
    "question": "monarkki",
    "answer": "monarch",
    "ru": "монарх"
  },
  {
    "id": 1075,
    "question": "meteoriitti",
    "answer": "meteorite",
    "ru": "метеорит"
  },
  {
    "id": 1076,
    "question": "lohikäärme",
    "answer": "dragon",
    "ru": "дракон"
  },
  {
    "id": 1077,
    "question": "majava",
    "answer": "beaver",
    "ru": "бобёр"
  },
  {
    "id": 1078,
    "question": "jyrsijä",
    "answer": "rodent",
    "ru": "грызун"
  },
  {
    "id": 1079,
    "question": "ravistaa",
    "answer": "to shake",
    "ru": "трясти"
  },
  {
    "id": 1080,
    "question": "koralliriutta",
    "answer": "coral reef",
    "ru": "коралловый риф"
  },
  {
    "id": 1081,
    "question": "laaja",
    "answer": "vast",
    "ru": "обширный"
  },
  {
    "id": 1082,
    "question": "verrattuna",
    "answer": "compared with",
    "ru": "по сравнению с"
  },
  {
    "id": 1083,
    "question": "välttämätön",
    "answer": "indispensable",
    "ru": "незаменимый"
  },
  {
    "id": 1084,
    "question": "seurakunta",
    "answer": "parish",
    "ru": "приход"
  },
  {
    "id": 1085,
    "question": "varoittaa",
    "answer": "to warn",
    "ru": "предупреждать"
  },
  {
    "id": 1086,
    "question": "ohut",
    "answer": "thin",
    "ru": "тонкий"
  },
  {
    "id": 1087,
    "question": "upota",
    "answer": "to sink",
    "ru": "тонуть"
  },
  {
    "id": 1088,
    "question": "kaksinkertainen",
    "answer": "double",
    "ru": "двойной"
  },
  {
    "id": 1089,
    "question": "piinata",
    "answer": "to torture",
    "ru": "мучить"
  },
  {
    "id": 1090,
    "question": "mieliala",
    "answer": "mood",
    "ru": "настроение"
  },
  {
    "id": 1091,
    "question": "eristää",
    "answer": "to isolate, quarantine",
    "ru": "изолировать, помещать на карантин"
  },
  {
    "id": 1092,
    "question": "valmius",
    "answer": "readiness",
    "ru": "готовность"
  },
  {
    "id": 1093,
    "question": "pykälä",
    "answer": "notch",
    "ru": "зарубка"
  },
  {
    "id": 1094,
    "question": "vaatia",
    "answer": "to demand",
    "ru": "требовать"
  },
  {
    "id": 1095,
    "question": "aiheuttaa",
    "answer": "to cause",
    "ru": "причинять"
  },
  {
    "id": 1096,
    "question": "ennustaa",
    "answer": "to forecast",
    "ru": "прогнозировать"
  },
  {
    "id": 1097,
    "question": "samanaikainen",
    "answer": "simultaneous",
    "ru": "одновременный"
  },
  {
    "id": 1098,
    "question": "päivittäistavara",
    "answer": "grocery",
    "ru": "продукты питания"
  },
  {
    "id": 1099,
    "question": "omavarainen",
    "answer": "self-sufficient",
    "ru": "самодостаточный"
  },
  {
    "id": 1100,
    "question": "ehdokas",
    "answer": "candidate, nominee",
    "ru": "кандидат, номинант"
  },
  {
    "id": 1101,
    "question": "paljastaa",
    "answer": "to reveal",
    "ru": "раскрывать"
  },
  {
    "id": 1102,
    "question": "sulku",
    "answer": "blockade, lock",
    "ru": "блокада, замок"
  },
  {
    "id": 1103,
    "question": "varusmies",
    "answer": "service man",
    "ru": "военнослужащий"
  },
  {
    "id": 1104,
    "question": "tuotanto",
    "answer": "production",
    "ru": "производство"
  },
  {
    "id": 1105,
    "question": "takaus",
    "answer": "warranty",
    "ru": "гарантия"
  },
  {
    "id": 1106,
    "question": "tuki",
    "answer": "assistant, support",
    "ru": "помощь, поддержка"
  },
  {
    "id": 1107,
    "question": "toistella",
    "answer": "to repeat",
    "ru": "повторять"
  },
  {
    "id": 1108,
    "question": "rakennuspalikka",
    "answer": "building block",
    "ru": "строительный блок"
  },
  {
    "id": 1109,
    "question": "sokeriton",
    "answer": "sugar-free",
    "ru": "без сахара"
  },
  {
    "id": 1110,
    "question": "asunnoton",
    "answer": "homeless",
    "ru": "бездомный"
  },
  {
    "id": 1111,
    "question": "laktoositon",
    "answer": "lactose-free",
    "ru": "без лактозы"
  },
  {
    "id": 1112,
    "question": "rahaton",
    "answer": "penniless",
    "ru": "без денег"
  },
  {
    "id": 1113,
    "question": "rasvaton",
    "answer": "fat-free",
    "ru": "обезжиренный"
  },
  {
    "id": 1114,
    "question": "perheetön",
    "answer": "no family",
    "ru": "без семьи"
  },
  {
    "id": 1115,
    "question": "kivetön",
    "answer": "pitted",
    "ru": "без косточек"
  },
  {
    "id": 1116,
    "question": "velaton",
    "answer": "free from debt",
    "ru": "без долгов"
  },
  {
    "id": 1117,
    "question": "mauton",
    "answer": "testeless",
    "ru": "безвкусный"
  },
  {
    "id": 1118,
    "question": "maustamaton",
    "answer": "unseasoned",
    "ru": "без приправ"
  },
  {
    "id": 1119,
    "question": "hetkellinen",
    "answer": "momentary",
    "ru": "мгновенный"
  },
  {
    "id": 1120,
    "question": "raidallinen",
    "answer": "striped",
    "ru": "полосатый"
  },
  {
    "id": 1121,
    "question": "ruudullinen",
    "answer": "grid patterned",
    "ru": "клетчатый"
  },
  {
    "id": 1122,
    "question": "maksullinen",
    "answer": "subject to a charge",
    "ru": "платный"
  },
  {
    "id": 1123,
    "question": "onnellinen",
    "answer": "happy",
    "ru": "счастливый"
  },
  {
    "id": 1124,
    "question": "lukollinen",
    "answer": "with a lock",
    "ru": "с замком"
  },
  {
    "id": 1125,
    "question": "roteva",
    "answer": "stocky",
    "ru": "коренастый"
  },
  {
    "id": 1126,
    "question": "jykevä",
    "answer": "robust",
    "ru": "крепкий"
  },
  {
    "id": 1127,
    "question": "tuppisuu",
    "answer": "silent person",
    "ru": "молчаливый человек"
  },
  {
    "id": 1128,
    "question": "skalpelli",
    "answer": "scalpel",
    "ru": "скальпель"
  },
  {
    "id": 1129,
    "question": "viehättävä",
    "answer": "attractive",
    "ru": "привлекательный"
  },
  {
    "id": 1130,
    "question": "elävä",
    "answer": "alive",
    "ru": "живой"
  },
  {
    "id": 1131,
    "question": "toivoton",
    "answer": "hopeless",
    "ru": "безнадёжный"
  },
  {
    "id": 1132,
    "question": "tilitoimisto",
    "answer": "accounting firm",
    "ru": "бухгалтерская фирма"
  },
  {
    "id": 1133,
    "question": "terävä",
    "answer": "sharp",
    "ru": "острый"
  },
  {
    "id": 1134,
    "question": "lukutoukka",
    "answer": "bookworm",
    "ru": "книжный червь"
  },
  {
    "id": 1135,
    "question": "kaunotar",
    "answer": "beauty",
    "ru": "красавица"
  },
  {
    "id": 1136,
    "question": "sarkastinen",
    "answer": "sarcastic",
    "ru": "саркастический"
  },
  {
    "id": 1137,
    "question": "ainutlaatuinen",
    "answer": "unique",
    "ru": "уникальный"
  },
  {
    "id": 1138,
    "question": "ihmeellinen",
    "answer": "miraculous",
    "ru": "чудесный"
  },
  {
    "id": 1139,
    "question": "säntillinen",
    "answer": "punctual",
    "ru": "пунктуальный"
  },
  {
    "id": 1140,
    "question": "kohtuullinen",
    "answer": "moderate, fair,reasonable",
    "ru": "умеренный, справедливый, разумный"
  },
  {
    "id": 1141,
    "question": "pienoisrautatie",
    "answer": "railway model",
    "ru": "модель железной дороги"
  },
  {
    "id": 1142,
    "question": "kiehtoa",
    "answer": "to fascinate",
    "ru": "завораживать"
  },
  {
    "id": 1143,
    "question": "navetta",
    "answer": "cowshed",
    "ru": "коровник"
  },
  {
    "id": 1144,
    "question": "talli",
    "answer": "stable",
    "ru": "конюшня"
  },
  {
    "id": 1145,
    "question": "tuijottaa",
    "answer": "to stare",
    "ru": "пялиться"
  },
  {
    "id": 1146,
    "question": "lippalakki",
    "answer": "cap",
    "ru": "кепка"
  },
  {
    "id": 1147,
    "question": "leiri",
    "answer": "camp",
    "ru": "лагерь"
  },
  {
    "id": 1148,
    "question": "rohkea",
    "answer": "brave",
    "ru": "храбрый"
  },
  {
    "id": 1149,
    "question": "herttainen",
    "answer": "nice, sweet",
    "ru": "милый, приятный"
  },
  {
    "id": 1150,
    "question": "hölösuu",
    "answer": "windbag",
    "ru": "болтун"
  },
  {
    "id": 1151,
    "question": "synkkä",
    "answer": "gloomy",
    "ru": "мрачный"
  },
  {
    "id": 1153,
    "question": "halata",
    "answer": "to hug",
    "ru": "обнимать"
  },
  {
    "id": 1154,
    "question": "nyökätä",
    "answer": "to nod",
    "ru": "кивать"
  },
  {
    "id": 1155,
    "question": "oksentaa",
    "answer": "to vomit, puke",
    "ru": "рвать, блевать"
  },
  {
    "id": 1156,
    "question": "ruuhka",
    "answer": "traffic jam",
    "ru": "дорожная пробка"
  },
  {
    "id": 1157,
    "question": "ilme",
    "answer": "facial expression",
    "ru": "выражение лица"
  },
  {
    "id": 1158,
    "question": "hengästyä",
    "answer": "get out of breath",
    "ru": "запыхаться"
  },
  {
    "id": 1159,
    "question": "rauhoittua",
    "answer": "calm down",
    "ru": "успокоиться"
  },
  {
    "id": 1160,
    "question": "röyhkeä",
    "answer": "arrogant",
    "ru": "высокомерный"
  },
  {
    "id": 1161,
    "question": "kosketus",
    "answer": "contact, touch",
    "ru": "контакт, прикосновение"
  },
  {
    "id": 1162,
    "question": "jäähtyä",
    "answer": "cool",
    "ru": "остывать"
  },
  {
    "id": 1163,
    "question": "tuijotella",
    "answer": "to stare",
    "ru": "пялиться"
  },
  {
    "id": 1164,
    "question": "suudella",
    "answer": "to kiss",
    "ru": "целовать"
  },
  {
    "id": 1165,
    "question": "älytön",
    "answer": "witless",
    "ru": "безмозглый"
  },
  {
    "id": 1166,
    "question": "epämääräinen",
    "answer": "vague",
    "ru": "расплывчатый"
  },
  {
    "id": 1167,
    "question": "kummitella",
    "answer": "haunt",
    "ru": "преследовать, являться привидением"
  },
  {
    "id": 1168,
    "question": "ulvoa",
    "answer": "to howl",
    "ru": "выть"
  },
  {
    "id": 1169,
    "question": "vaino",
    "answer": "persecution",
    "ru": "преследование"
  },
  {
    "id": 1170,
    "question": "vakoilla",
    "answer": "to spy",
    "ru": "шпионить"
  },
  {
    "id": 1171,
    "question": "reipas",
    "answer": "brisk",
    "ru": "бодрый"
  },
  {
    "id": 1172,
    "question": "restonomi",
    "answer": "hospitality management",
    "ru": "управление в сфере гостеприимства"
  },
  {
    "id": 1173,
    "question": "sydäninfarkti",
    "answer": "myocardial infarction",
    "ru": "инфаркт миокарда"
  },
  {
    "id": 1174,
    "question": "tuuri",
    "answer": "luck, fortune",
    "ru": "удача, везение"
  },
  {
    "id": 1175,
    "question": "kirurgi",
    "answer": "surgeon",
    "ru": "хирург"
  },
  {
    "id": 1176,
    "question": "hukata",
    "answer": "to waste, misplace",
    "ru": "потерять, упустить"
  },
  {
    "id": 1177,
    "question": "verrata",
    "answer": "to compare",
    "ru": "сравнивать"
  },
  {
    "id": 1178,
    "question": "virkistävä",
    "answer": "refreshing",
    "ru": "освежающий"
  },
  {
    "id": 1179,
    "question": "kestitä",
    "answer": "to treat",
    "ru": "угощать"
  },
  {
    "id": 1180,
    "question": "päänvaiva",
    "answer": "trouble, headache",
    "ru": "проблема, головная боль"
  },
  {
    "id": 1181,
    "question": "karpalo",
    "answer": "cranberry",
    "ru": "клюква"
  },
  {
    "id": 1182,
    "question": "siika",
    "answer": "European whitefish",
    "ru": "сиг"
  },
  {
    "id": 1183,
    "question": "maljapuhe",
    "answer": "toast",
    "ru": "тост"
  },
  {
    "id": 1184,
    "question": "puristaa",
    "answer": "to press, squash",
    "ru": "давить, сжимать"
  },
  {
    "id": 1185,
    "question": "toimeentulo",
    "answer": "living",
    "ru": "средства к существованию"
  },
  {
    "id": 1186,
    "question": "epätoivoinen",
    "answer": "desperate",
    "ru": "отчаянный"
  },
  {
    "id": 1187,
    "question": "ohimenevä",
    "answer": "momentary",
    "ru": "мимолётный"
  },
  {
    "id": 1188,
    "question": "tunnollinen",
    "answer": "conscientious",
    "ru": "добросовестный"
  },
  {
    "id": 1189,
    "question": "vastuuntuntoinen",
    "answer": "responsible",
    "ru": "ответственный"
  },
  {
    "id": 1190,
    "question": "reilu",
    "answer": "fair",
    "ru": "справедливый"
  },
  {
    "id": 1191,
    "question": "moka",
    "answer": "blunder",
    "ru": "промах, оплошность"
  },
  {
    "id": 1192,
    "question": "juoruta",
    "answer": "to gossip",
    "ru": "сплетничать"
  },
  {
    "id": 1193,
    "question": "mustamaalata",
    "answer": "to denigrate",
    "ru": "очернять"
  },
  {
    "id": 1194,
    "question": "mielenterveys",
    "answer": "mental health",
    "ru": "психическое здоровье"
  },
  {
    "id": 1195,
    "question": "vastoinkäyminen",
    "answer": "adversity",
    "ru": "невзгода"
  },
  {
    "id": 1196,
    "question": "hienotunteinen",
    "answer": "considerate",
    "ru": "тактичный"
  },
  {
    "id": 1197,
    "question": "nukahtaa",
    "answer": "fall asleep",
    "ru": "заснуть"
  },
  {
    "id": 1198,
    "question": "krapula",
    "answer": "hangover",
    "ru": "похмелье"
  },
  {
    "id": 1199,
    "question": "noidankehä",
    "answer": "vicious circle",
    "ru": "порочный круг"
  },
  {
    "id": 1200,
    "question": "sairaalloinen",
    "answer": "sick",
    "ru": "болезненный"
  },
  {
    "id": 1201,
    "question": "änkyttää",
    "answer": "stammer",
    "ru": "заикаться"
  },
  {
    "id": 1202,
    "question": "juuttua",
    "answer": "get stuck",
    "ru": "застрять"
  },
  {
    "id": 1203,
    "question": "haukkoa",
    "answer": "to gasp",
    "ru": "хватать ртом воздух"
  },
  {
    "id": 1204,
    "question": "häpeällinen",
    "answer": "shameful",
    "ru": "постыдный"
  },
  {
    "id": 1205,
    "question": "välttää",
    "answer": "escape, avoid",
    "ru": "избегать"
  },
  {
    "id": 1206,
    "question": "elintaso",
    "answer": "living standard",
    "ru": "уровень жизни"
  },
  {
    "id": 1207,
    "question": "massa",
    "answer": "mass",
    "ru": "масса"
  },
  {
    "id": 1208,
    "question": "noudattaa",
    "answer": "to obey, to follow",
    "ru": "соблюдать, следовать"
  },
  {
    "id": 1209,
    "question": "satama",
    "answer": "harbour",
    "ru": "гавань"
  },
  {
    "id": 1210,
    "question": "jatke",
    "answer": "extension",
    "ru": "расширение"
  },
  {
    "id": 1211,
    "question": "arvomaailma",
    "answer": "value system",
    "ru": "система ценностей"
  },
  {
    "id": 1212,
    "question": "räjähdysmäinen",
    "answer": "explosive",
    "ru": "взрывной"
  },
  {
    "id": 1213,
    "question": "taikoa",
    "answer": "to conjure",
    "ru": "колдовать"
  },
  {
    "id": 1214,
    "question": "ihmissuhde",
    "answer": "human relations",
    "ru": "межличностные отношения"
  },
  {
    "id": 1215,
    "question": "olemus",
    "answer": "being",
    "ru": "сущность"
  },
  {
    "id": 1216,
    "question": "peittää",
    "answer": "to cover",
    "ru": "покрывать"
  },
  {
    "id": 1217,
    "question": "tilaisuus",
    "answer": "occasion",
    "ru": "случай, мероприятие"
  },
  {
    "id": 1218,
    "question": "terapeutti",
    "answer": "therapist",
    "ru": "терапевт"
  },
  {
    "id": 1219,
    "question": "elehtiä",
    "answer": "to gesture",
    "ru": "жестикулировать"
  },
  {
    "id": 1220,
    "question": "ele",
    "answer": "sign, gesture",
    "ru": "знак, жест"
  },
  {
    "id": 1221,
    "question": "puristaa",
    "answer": "to press, squash",
    "ru": "давить, сжимать"
  },
  {
    "id": 1222,
    "question": "johto",
    "answer": "management",
    "ru": "руководство"
  },
  {
    "id": 1223,
    "question": "välinpitämätön",
    "answer": "indifferent",
    "ru": "равнодушный"
  },
  {
    "id": 1224,
    "question": "katkera",
    "answer": "resentful",
    "ru": "обиженный"
  },
  {
    "id": 1225,
    "question": "rytmi",
    "answer": "rhythm",
    "ru": "ритм"
  },
  {
    "id": 1226,
    "question": "luonteenpiirre",
    "answer": "personality trait",
    "ru": "черта характера"
  },
  {
    "id": 1227,
    "question": "päätellä",
    "answer": "to infer",
    "ru": "умозаключить"
  },
  {
    "id": 1228,
    "question": "muoti",
    "answer": "fashion, trend",
    "ru": "мода, тенденция"
  },
  {
    "id": 1229,
    "question": "alakuloinen",
    "answer": "melancholy",
    "ru": "меланхоличный"
  },
  {
    "id": 1230,
    "question": "kiusallinen",
    "answer": "awkward",
    "ru": "неловкий"
  },
  {
    "id": 1231,
    "question": "rasittava",
    "answer": "painful",
    "ru": "болезненный, мучительный"
  },
  {
    "id": 1232,
    "question": "kulaus",
    "answer": "draught, drink",
    "ru": "глоток"
  },
  {
    "id": 1233,
    "question": "tarkastella",
    "answer": "to examine",
    "ru": "изучать"
  },
  {
    "id": 1234,
    "question": "kellua",
    "answer": "to float",
    "ru": "плавать на поверхности"
  },
  {
    "id": 1235,
    "question": "kunnes",
    "answer": "until",
    "ru": "пока"
  },
  {
    "id": 1236,
    "question": "pidättäytyä",
    "answer": "to abstain",
    "ru": "воздерживаться"
  },
  {
    "id": 1238,
    "question": "hurmaava",
    "answer": "charming",
    "ru": "очаровательный"
  },
  {
    "id": 1239,
    "question": "parhaansa mukaan",
    "answer": "as best one can",
    "ru": "как можно лучше"
  },
  {
    "id": 1240,
    "question": "käsitteellinen",
    "answer": "conceptual, abstract",
    "ru": "концептуальный, абстрактный"
  },
  {
    "id": 1241,
    "question": "olento",
    "answer": "being",
    "ru": "существо"
  },
  {
    "id": 1242,
    "question": "olio",
    "answer": "creature, object",
    "ru": "существо, объект"
  },
  {
    "id": 1243,
    "question": "lihallinen",
    "answer": "fleshly",
    "ru": "плотский"
  },
  {
    "id": 1244,
    "question": "maineikas",
    "answer": "renowned",
    "ru": "знаменитый"
  },
  {
    "id": 1245,
    "question": "filologia",
    "answer": "philology",
    "ru": "филология"
  },
  {
    "id": 1246,
    "question": "taivutella",
    "answer": "to coax",
    "ru": "уговаривать"
  },
  {
    "id": 1247,
    "question": "päämäärä",
    "answer": "aim, goal, objective",
    "ru": "цель, задача"
  },
  {
    "id": 1248,
    "question": "skaala",
    "answer": "scale",
    "ru": "шкала"
  },
  {
    "id": 1249,
    "question": "keskinkertainen",
    "answer": "mediocre",
    "ru": "посредственный"
  },
  {
    "id": 1250,
    "question": "lukematon",
    "answer": "countless",
    "ru": "бесчисленный"
  },
  {
    "id": 1251,
    "question": "muistiinpano",
    "answer": "note",
    "ru": "заметка"
  },
  {
    "id": 1252,
    "question": "mutkikas",
    "answer": "complicated",
    "ru": "запутанный"
  },
  {
    "id": 1253,
    "question": "kantautua",
    "answer": "to carry",
    "ru": "доноситься"
  },
  {
    "id": 1254,
    "question": "puistaa",
    "answer": "to shake",
    "ru": "трясти"
  },
  {
    "id": 1255,
    "question": "puheenaihe",
    "answer": "topic",
    "ru": "тема разговора"
  },
  {
    "id": 1256,
    "question": "kourallinen",
    "answer": "handful, fistful",
    "ru": "горсть"
  },
  {
    "id": 1257,
    "question": "pähkinä",
    "answer": "nut",
    "ru": "орех"
  },
  {
    "id": 1258,
    "question": "kämmen",
    "answer": "palm",
    "ru": "ладонь"
  },
  {
    "id": 1259,
    "question": "ylläpitää",
    "answer": "to maintain",
    "ru": "поддерживать"
  },
  {
    "id": 1260,
    "question": "hämmennys",
    "answer": "confusion",
    "ru": "замешательство"
  },
  {
    "id": 1261,
    "question": "kallistaa",
    "answer": "to lean, incline",
    "ru": "наклонять"
  },
  {
    "id": 1262,
    "question": "äsken",
    "answer": "a moment ago",
    "ru": "только что"
  },
  {
    "id": 1263,
    "question": "kärsivä",
    "answer": "suffering",
    "ru": "страдающий"
  },
  {
    "id": 1264,
    "question": "siristää",
    "answer": "to squint",
    "ru": "щуриться"
  },
  {
    "id": 1265,
    "question": "kaikkeus",
    "answer": "universe",
    "ru": "вселенная"
  },
  {
    "id": 1266,
    "question": "vaalia",
    "answer": "to cherish",
    "ru": "беречь, хранить"
  },
  {
    "id": 1267,
    "question": "uusiutua",
    "answer": "recur",
    "ru": "возобновляться"
  },
  {
    "id": 1268,
    "question": "alkuräjähdys",
    "answer": "Big Bang",
    "ru": "Большой взрыв"
  },
  {
    "id": 1269,
    "question": "vuorijono",
    "answer": "chain of mountains",
    "ru": "горная цепь"
  },
  {
    "id": 1270,
    "question": "vyöhyke",
    "answer": "zone, sector",
    "ru": "зона, сектор"
  },
  {
    "id": 1271,
    "question": "vähäinen",
    "answer": "minor",
    "ru": "незначительный"
  },
  {
    "id": 1272,
    "question": "luoti",
    "answer": "bullet",
    "ru": "пуля"
  },
  {
    "id": 1273,
    "question": "saavuttaa",
    "answer": "to achieve",
    "ru": "достигать"
  },
  {
    "id": 1274,
    "question": "aavistus",
    "answer": "intuition",
    "ru": "интуиция"
  },
  {
    "id": 1275,
    "question": "tavanomainen",
    "answer": "conventional",
    "ru": "обычный"
  },
  {
    "id": 1276,
    "question": "tuttavallinen",
    "answer": "familiar",
    "ru": "фамильярный"
  },
  {
    "id": 1277,
    "question": "katkaista",
    "answer": "cut, split",
    "ru": "разрезать, расколоть"
  },
  {
    "id": 1278,
    "question": "etäisyys",
    "answer": "distance",
    "ru": "расстояние"
  },
  {
    "id": 1279,
    "question": "ihme",
    "answer": "miracle, wonder",
    "ru": "чудо"
  },
  {
    "id": 1280,
    "question": "hätäinen",
    "answer": "hasty",
    "ru": "торопливый"
  },
  {
    "id": 1281,
    "question": "nielaista",
    "answer": "gulp, swallow",
    "ru": "глотнуть, проглотить"
  },
  {
    "id": 1282,
    "question": "möhkäle",
    "answer": "lump, block, chunk",
    "ru": "ком, глыба, кусок"
  },
  {
    "id": 1283,
    "question": "sulattaa",
    "answer": "to digest, melt",
    "ru": "переваривать, плавить"
  },
  {
    "id": 1284,
    "question": "itsepäinen",
    "answer": "stubborn",
    "ru": "упрямый"
  },
  {
    "id": 1285,
    "question": "mykkä",
    "answer": "mute",
    "ru": "немой"
  },
  {
    "id": 1286,
    "question": "vaivautua",
    "answer": "to be bothered",
    "ru": "беспокоиться, утруждаться"
  },
  {
    "id": 1287,
    "question": "seikkaperäinen",
    "answer": "in-depth",
    "ru": "подробный"
  },
  {
    "id": 1288,
    "question": "siemailla",
    "answer": "to sip",
    "ru": "пить маленькими глотками"
  },
  {
    "id": 1289,
    "question": "tahra",
    "answer": "stain",
    "ru": "пятно"
  },
  {
    "id": 1290,
    "question": "kyse",
    "answer": "matter, about",
    "ru": "дело, суть"
  },
  {
    "id": 1291,
    "question": "kehä",
    "answer": "ring, circle",
    "ru": "кольцо, круг"
  },
  {
    "id": 1292,
    "question": "ruokahalu",
    "answer": "appetite",
    "ru": "аппетит"
  },
  {
    "id": 1293,
    "question": "liioitella",
    "answer": "to exaggerate",
    "ru": "преувеличивать"
  },
  {
    "id": 1294,
    "question": "kaiketi",
    "answer": "surely",
    "ru": "наверняка"
  },
  {
    "id": 1295,
    "question": "litteä",
    "answer": "flat",
    "ru": "плоский"
  },
  {
    "id": 1296,
    "question": "napauttaa",
    "answer": "to click, tap",
    "ru": "нажимать, стучать"
  },
  {
    "id": 1297,
    "question": "värähdellä",
    "answer": "to vibrate",
    "ru": "вибрировать"
  },
  {
    "id": 1298,
    "question": "suuttumus",
    "answer": "anger",
    "ru": "гнев"
  },
  {
    "id": 1299,
    "question": "niukka",
    "answer": "scarce",
    "ru": "скудный"
  },
  {
    "id": 1300,
    "question": "sysätä",
    "answer": "to push, off-load",
    "ru": "толкать, перекладывать"
  },
  {
    "id": 1301,
    "question": "erehtyä",
    "answer": "to mistake",
    "ru": "ошибаться"
  },
  {
    "id": 1302,
    "question": "typerä",
    "answer": "stupid, lame",
    "ru": "тупой, нелепый"
  },
  {
    "id": 1303,
    "question": "ponnistella",
    "answer": "to strive",
    "ru": "стараться"
  },
  {
    "id": 1304,
    "question": "viittilöidä",
    "answer": "to wave",
    "ru": "махать"
  },
  {
    "id": 1305,
    "question": "tippa",
    "answer": "drop",
    "ru": "капля"
  },
  {
    "id": 1306,
    "question": "turvota",
    "answer": "to swell",
    "ru": "распухать"
  },
  {
    "id": 1307,
    "question": "seurallinen",
    "answer": "sociable",
    "ru": "общительный"
  },
  {
    "id": 1308,
    "question": "älyllinen",
    "answer": "intellectual",
    "ru": "интеллектуальный"
  },
  {
    "id": 1309,
    "question": "pääkonttori",
    "answer": "headquarters",
    "ru": "штаб-квартира"
  },
  {
    "id": 1310,
    "question": "miltei",
    "answer": "almost, nearly",
    "ru": "почти"
  },
  {
    "id": 1311,
    "question": "surunvalittelu",
    "answer": "condolence",
    "ru": "соболезнование"
  },
  {
    "id": 1312,
    "question": "haikeus",
    "answer": "nostalgia",
    "ru": "ностальгия"
  },
  {
    "id": 1313,
    "question": "kenties",
    "answer": "possibly",
    "ru": "возможно"
  },
  {
    "id": 1314,
    "question": "kasa",
    "answer": "heap",
    "ru": "куча"
  },
  {
    "id": 1315,
    "question": "kamari",
    "answer": "chamber",
    "ru": "камера"
  },
  {
    "id": 1316,
    "question": "mahtipontinen",
    "answer": "grandiloquent",
    "ru": "напыщенный"
  },
  {
    "id": 1317,
    "question": "pauhata",
    "answer": "roar, rumble",
    "ru": "грохотать, реветь"
  },
  {
    "id": 1318,
    "question": "melankolinen",
    "answer": "melancholic",
    "ru": "меланхоличный"
  },
  {
    "id": 1319,
    "question": "ansiokas",
    "answer": "meritorious",
    "ru": "заслуженный"
  },
  {
    "id": 1320,
    "question": "nuotti",
    "answer": "note, melody",
    "ru": "нота, мелодия"
  },
  {
    "id": 1321,
    "question": "latistua",
    "answer": "to flatten",
    "ru": "сглаживаться"
  },
  {
    "id": 1322,
    "question": "pinnallinen",
    "answer": "superficial",
    "ru": "поверхностный"
  },
  {
    "id": 1323,
    "question": "ovela",
    "answer": "cunning",
    "ru": "хитрый"
  },
  {
    "id": 1324,
    "question": "kätketty",
    "answer": "concealed",
    "ru": "скрытый"
  },
  {
    "id": 1325,
    "question": "kohota",
    "answer": "to rise",
    "ru": "подниматься"
  },
  {
    "id": 1326,
    "question": "hämmästyttävä",
    "answer": "amazing",
    "ru": "удивительный"
  },
  {
    "id": 1327,
    "question": "kolmiulotteinen",
    "answer": "three-dimensional",
    "ru": "трёхмерный"
  },
  {
    "id": 1328,
    "question": "vastavirta",
    "answer": "upstream",
    "ru": "против течения"
  },
  {
    "id": 1329,
    "question": "virittää",
    "answer": "to adjust",
    "ru": "настраивать"
  },
  {
    "id": 1330,
    "question": "kampus",
    "answer": "campus",
    "ru": "кампус"
  },
  {
    "id": 1331,
    "question": "ilmestyä",
    "answer": "to be published",
    "ru": "выходить в свет, публиковаться"
  },
  {
    "id": 1332,
    "question": "intohimoinen",
    "answer": "passionate",
    "ru": "страстный"
  },
  {
    "id": 1333,
    "question": "pulassa",
    "answer": "screwed",
    "ru": "в беде"
  },
  {
    "id": 1334,
    "question": "kvartetti",
    "answer": "quartet",
    "ru": "квартет"
  },
  {
    "id": 1335,
    "question": "jousi",
    "answer": "spring, bow",
    "ru": "пружина, лук"
  },
  {
    "id": 1336,
    "question": "saavutus",
    "answer": "achievement",
    "ru": "достижение"
  },
  {
    "id": 1337,
    "question": "kiusoitella",
    "answer": "to tease",
    "ru": "дразнить"
  },
  {
    "id": 1338,
    "question": "häivä",
    "answer": "trace",
    "ru": "след"
  },
  {
    "id": 1339,
    "question": "pienoismalli",
    "answer": "miniature",
    "ru": "миниатюра"
  },
  {
    "id": 1340,
    "question": "asteittain",
    "answer": "step by step",
    "ru": "постепенно"
  },
  {
    "id": 1341,
    "question": "erikoistua",
    "answer": "to specialise",
    "ru": "специализироваться"
  },
  {
    "id": 1342,
    "question": "perin pohjin",
    "answer": "thoroughly",
    "ru": "основательно"
  },
  {
    "id": 1343,
    "question": "tyhjiö",
    "answer": "vacuum",
    "ru": "вакуум"
  },
  {
    "id": 1344,
    "question": "jonkin verran",
    "answer": "somewhat",
    "ru": "несколько"
  },
  {
    "id": 1345,
    "question": "heläyttää",
    "answer": "to clang",
    "ru": "звенеть"
  },
  {
    "id": 1346,
    "question": "hieroa",
    "answer": "to rub",
    "ru": "тереть"
  },
  {
    "id": 1347,
    "question": "viaton",
    "answer": "immaculate",
    "ru": "невинный"
  },
  {
    "id": 1348,
    "question": "sileä",
    "answer": "smooth",
    "ru": "гладкий"
  },
  {
    "id": 1349,
    "question": "kulmakarva",
    "answer": "eyebrow",
    "ru": "бровь"
  },
  {
    "id": 1350,
    "question": "tuuhea",
    "answer": "dense, bushy",
    "ru": "густой, пышный"
  },
  {
    "id": 1351,
    "question": "kaareutua",
    "answer": "to arch",
    "ru": "выгибаться дугой"
  },
  {
    "id": 1352,
    "question": "simpukankuori",
    "answer": "seashell",
    "ru": "ракушка"
  },
  {
    "id": 1353,
    "question": "nyökyttää",
    "answer": "to nod",
    "ru": "кивать"
  },
  {
    "id": 1354,
    "question": "kiitollinen",
    "answer": "thankful",
    "ru": "благодарный"
  },
  {
    "id": 1355,
    "question": "ilmeinen",
    "answer": "visible, obvious",
    "ru": "очевидный, явный"
  },
  {
    "id": 1356,
    "question": "omituinen",
    "answer": "bizarre",
    "ru": "странный"
  },
  {
    "id": 1357,
    "question": "nieleskellä",
    "answer": "to swallow",
    "ru": "глотать"
  },
  {
    "id": 1358,
    "question": "tahaton",
    "answer": "unintentional",
    "ru": "непреднамеренный"
  },
  {
    "id": 1359,
    "question": "raju",
    "answer": "fierce, violent",
    "ru": "жестокий, свирепый"
  },
  {
    "id": 1360,
    "question": "säännöllinen",
    "answer": "regular",
    "ru": "регулярный"
  },
  {
    "id": 1361,
    "question": "särmä",
    "answer": "edge",
    "ru": "грань, край"
  },
  {
    "id": 1362,
    "question": "veistää",
    "answer": "to carve",
    "ru": "вырезать"
  },
  {
    "id": 1363,
    "question": "pistää",
    "answer": "to sting",
    "ru": "жалить"
  },
  {
    "id": 1364,
    "question": "naamio",
    "answer": "mask, disguise",
    "ru": "маска, маскировка"
  },
  {
    "id": 1365,
    "question": "sentään",
    "answer": "nevertheless, although",
    "ru": "тем не менее, хотя"
  },
  {
    "id": 1366,
    "question": "luonnostella",
    "answer": "to sketch",
    "ru": "набрасывать эскиз"
  },
  {
    "id": 1367,
    "question": "tottumus",
    "answer": "habit, custom",
    "ru": "привычка, обычай"
  },
  {
    "id": 1368,
    "question": "nihkeä",
    "answer": "damp, moist",
    "ru": "влажный, сырой"
  },
  {
    "id": 1369,
    "question": "intuitiivinen",
    "answer": "intuitive",
    "ru": "интуитивный"
  },
  {
    "id": 1370,
    "question": "sulkeutua",
    "answer": "to close",
    "ru": "закрываться"
  },
  {
    "id": 1371,
    "question": "lukita",
    "answer": "to lock",
    "ru": "запирать"
  },
  {
    "id": 1372,
    "question": "kalteri",
    "answer": "bars",
    "ru": "прутья решётки"
  },
  {
    "id": 1373,
    "question": "pohdiskella",
    "answer": "to reflect",
    "ru": "размышлять"
  },
  {
    "id": 1374,
    "question": "minuus",
    "answer": "selfhood",
    "ru": "самость"
  },
  {
    "id": 1375,
    "question": "kiihkeä",
    "answer": "passionate",
    "ru": "страстный"
  },
  {
    "id": 1376,
    "question": "perimmäinen",
    "answer": "eventual, ultimate",
    "ru": "конечный, окончательный"
  },
  {
    "id": 1377,
    "question": "epätoivoisesti",
    "answer": "desperately contact, touch",
    "ru": "отчаянно"
  },
  {
    "id": 1378,
    "question": "tuijottaa valjeta",
    "answer": "to brighten",
    "ru": "светлеть, рассветать"
  },
  {
    "id": 1379,
    "question": "autio",
    "answer": "desolate",
    "ru": "опустошённый"
  },
  {
    "id": 1380,
    "question": "ontto",
    "answer": "hollow",
    "ru": "полый"
  },
  {
    "id": 1381,
    "question": "viisari",
    "answer": "pointer, hand",
    "ru": "указатель, стрелка часов"
  },
  {
    "id": 1382,
    "question": "harso",
    "answer": "gauze",
    "ru": "марля"
  },
  {
    "id": 1383,
    "question": "kutistua",
    "answer": "to shrink",
    "ru": "сжиматься"
  },
  {
    "id": 1384,
    "question": "heikentynyt",
    "answer": "weakened",
    "ru": "ослабленный"
  },
  {
    "id": 1385,
    "question": "vaitonainen",
    "answer": "silent",
    "ru": "молчаливый"
  },
  {
    "id": 1386,
    "question": "keho",
    "answer": "body",
    "ru": "тело"
  },
  {
    "id": 1387,
    "question": "mustasukkaisuus",
    "answer": "jealousy",
    "ru": "ревность"
  },
  {
    "id": 1388,
    "question": "kateus",
    "answer": "envy",
    "ru": "зависть"
  },
  {
    "id": 1389,
    "question": "omakohtainen",
    "answer": "personal, subjective",
    "ru": "личный, субъективный"
  },
  {
    "id": 1390,
    "question": "kutakuinkin",
    "answer": "more or less",
    "ru": "более или менее"
  },
  {
    "id": 1391,
    "question": "edellytys",
    "answer": "condition, qualification",
    "ru": "условие, предпосылка"
  },
  {
    "id": 1392,
    "question": "vallata",
    "answer": "to capture, to take; to occupy",
    "ru": "захватывать, занимать"
  },
  {
    "id": 1393,
    "question": "palava",
    "answer": "burning",
    "ru": "горящий"
  },
  {
    "id": 1394,
    "question": "hyväillä",
    "answer": "to caress",
    "ru": "ласкать"
  },
  {
    "id": 1395,
    "question": "kauna",
    "answer": "grudge",
    "ru": "обида"
  },
  {
    "id": 1396,
    "question": "katkeruus",
    "answer": "bitterness",
    "ru": "горечь"
  },
  {
    "id": 1397,
    "question": "himoita",
    "answer": "to desire",
    "ru": "желать"
  },
  {
    "id": 1398,
    "question": "kadehtia",
    "answer": "to envy",
    "ru": "завидовать"
  },
  {
    "id": 1399,
    "question": "puute",
    "answer": "shortage",
    "ru": "нехватка"
  },
  {
    "id": 1400,
    "question": "vuoksi",
    "answer": "because of",
    "ru": "из-за"
  },
  {
    "id": 1401,
    "question": "saostua",
    "answer": "to precipitate",
    "ru": "осаждаться"
  },
  {
    "id": 1402,
    "question": "tursua",
    "answer": "to extrude",
    "ru": "выдавливаться"
  },
  {
    "id": 1403,
    "question": "kaasu",
    "answer": "gas",
    "ru": "газ"
  },
  {
    "id": 1404,
    "question": "veri",
    "answer": "blood",
    "ru": "кровь"
  },
  {
    "id": 1405,
    "question": "täristä",
    "answer": "to shake, vibrate, tremble",
    "ru": "трясти, вибрировать, дрожать"
  },
  {
    "id": 1406,
    "question": "kiskoa",
    "answer": "to drag, haul",
    "ru": "тащить, тянуть"
  },
  {
    "id": 1407,
    "question": "hinkata",
    "answer": "to rub",
    "ru": "тереть"
  },
  {
    "id": 1408,
    "question": "harhailla",
    "answer": "to wander",
    "ru": "блуждать"
  },
  {
    "id": 1409,
    "question": "laihtua",
    "answer": "to lose weight",
    "ru": "худеть"
  },
  {
    "id": 1410,
    "question": "pullea",
    "answer": "round, chubby",
    "ru": "округлый, пухленький"
  },
  {
    "id": 1411,
    "question": "kuihtua",
    "answer": "to wither",
    "ru": "вянуть"
  },
  {
    "id": 1412,
    "question": "kiristää",
    "answer": "to tighten",
    "ru": "затягивать"
  },
  {
    "id": 1414,
    "question": "kylkiluu",
    "answer": "rib",
    "ru": "ребро"
  },
  {
    "id": 1415,
    "question": "rintakehä",
    "answer": "thorax",
    "ru": "грудная клетка"
  },
  {
    "id": 1416,
    "question": "lintuhäkki",
    "answer": "birdcage",
    "ru": "птичья клетка"
  },
  {
    "id": 1417,
    "question": "lihaksikas",
    "answer": "muscular",
    "ru": "мускулистый"
  },
  {
    "id": 1418,
    "question": "luiseva",
    "answer": "skinny, bony",
    "ru": "худой, костлявый"
  },
  {
    "id": 1419,
    "question": "takertua",
    "answer": "to cling, stick",
    "ru": "цепляться, прилипать"
  },
  {
    "id": 1420,
    "question": "kotelo",
    "answer": "case, cocoon",
    "ru": "чехол, кокон"
  },
  {
    "id": 1421,
    "question": "tuulenpuuska",
    "answer": "blast",
    "ru": "порыв ветра"
  },
  {
    "id": 1422,
    "question": "ikiajoiksi",
    "answer": "forever",
    "ru": "навсегда"
  },
  {
    "id": 1423,
    "question": "jysähtää",
    "answer": "to thump",
    "ru": "грохотать"
  },
  {
    "id": 1424,
    "question": "iskeä",
    "answer": "to strike / hit",
    "ru": "ударять"
  },
  {
    "id": 1425,
    "question": "edellinen",
    "answer": "previous",
    "ru": "предыдущий"
  },
  {
    "id": 1426,
    "question": "mitätöidä",
    "answer": "to invalidate",
    "ru": "аннулировать"
  },
  {
    "id": 1427,
    "question": "nipin napin",
    "answer": "barely",
    "ru": "еле-еле"
  },
  {
    "id": 1428,
    "question": "merkillinen",
    "answer": "odd, bizarre",
    "ru": "странный, причудливый"
  },
  {
    "id": 1429,
    "question": "hirvittävä",
    "answer": "horrible, monstrous",
    "ru": "ужасный, чудовищный"
  },
  {
    "id": 1430,
    "question": "armoton",
    "answer": "ruthless",
    "ru": "беспощадный"
  },
  {
    "id": 1431,
    "question": "koittaa",
    "answer": "to break, dawn",
    "ru": "рассвести, наступать"
  },
  {
    "id": 1432,
    "question": "kipu",
    "answer": "pain",
    "ru": "боль"
  },
  {
    "id": 1433,
    "question": "irtautua",
    "answer": "to secede",
    "ru": "отделяться"
  },
  {
    "id": 1434,
    "question": "kivuton",
    "answer": "painless",
    "ru": "безболезненный"
  },
  {
    "id": 1435,
    "question": "nipistää",
    "answer": "to pinch",
    "ru": "щипать"
  },
  {
    "id": 1436,
    "question": "vaiva",
    "answer": "trouble, discomfort",
    "ru": "неприятность, дискомфорт"
  },
  {
    "id": 1437,
    "question": "pohdinta",
    "answer": "deliberation",
    "ru": "обдумывание"
  },
  {
    "id": 1438,
    "question": "päättäväinen",
    "answer": "determined",
    "ru": "решительный"
  },
  {
    "id": 1439,
    "question": "sokki",
    "answer": "shock",
    "ru": "шок"
  },
  {
    "id": 1440,
    "question": "totuus",
    "answer": "truth",
    "ru": "правда"
  },
  {
    "id": 1441,
    "question": "ojentaa",
    "answer": "to hand over",
    "ru": "передавать"
  },
  {
    "id": 1442,
    "question": "irrottaa",
    "answer": "to detach",
    "ru": "отсоединять"
  },
  {
    "id": 1443,
    "question": "herkeämättä",
    "answer": "incessant",
    "ru": "неустанный"
  },
  {
    "id": 1444,
    "question": "ohimo",
    "answer": "temple",
    "ru": "висок"
  },
  {
    "id": 1445,
    "question": "kohdella",
    "answer": "to treat, deal with",
    "ru": "обращаться, обходиться"
  },
  {
    "id": 1446,
    "question": "syvä",
    "answer": "deep",
    "ru": "глубокий"
  },
  {
    "id": 1447,
    "question": "haudata",
    "answer": "to bury",
    "ru": "хоронить"
  },
  {
    "id": 1448,
    "question": "kätkeä",
    "answer": "to hide",
    "ru": "прятать"
  },
  {
    "id": 1449,
    "question": "upottaa",
    "answer": "to submerge",
    "ru": "погружать"
  },
  {
    "id": 1450,
    "question": "koostumus",
    "answer": "composition",
    "ru": "состав"
  },
  {
    "id": 1451,
    "question": "vääristellä",
    "answer": "to twist",
    "ru": "искажать"
  },
  {
    "id": 1452,
    "question": "kömpelö",
    "answer": "clumsy",
    "ru": "неуклюжий"
  },
  {
    "id": 1453,
    "question": "pohjaton",
    "answer": "bottomless",
    "ru": "бездонный"
  },
  {
    "id": 1454,
    "question": "tyhjyys",
    "answer": "emptiness, void",
    "ru": "пустота"
  },
  {
    "id": 1455,
    "question": "kuilu",
    "answer": "shaft",
    "ru": "шахта"
  },
  {
    "id": 1456,
    "question": "pisara",
    "answer": "droplet",
    "ru": "капля"
  },
  {
    "id": 1457,
    "question": "runsas",
    "answer": "rich, abundant",
    "ru": "богатый, обильный"
  },
  {
    "id": 1458,
    "question": "suosittu",
    "answer": "popular",
    "ru": "популярный"
  },
  {
    "id": 1459,
    "question": "maukas",
    "answer": "tasty",
    "ru": "вкусный"
  },
  {
    "id": 1460,
    "question": "tulinen",
    "answer": "spicy",
    "ru": "острый"
  },
  {
    "id": 1461,
    "question": "hyvänmakuinen",
    "answer": "good tasting",
    "ru": "вкусный"
  },
  {
    "id": 1462,
    "question": "pahanmakuinen",
    "answer": "bad tasting",
    "ru": "невкусный"
  },
  {
    "id": 1463,
    "question": "ällöttävä",
    "answer": "disgusting",
    "ru": "отвратительный"
  },
  {
    "id": 1464,
    "question": "keittokirja",
    "answer": "a cook book",
    "ru": "кулинарная книга"
  },
  {
    "id": 1465,
    "question": "karvas",
    "answer": "bitter",
    "ru": "горький"
  },
  {
    "id": 1466,
    "question": "tarpeeksi",
    "answer": "enough",
    "ru": "достаточно"
  },
  {
    "id": 1467,
    "question": "täydellinen",
    "answer": "perfect",
    "ru": "идеальный"
  },
  {
    "id": 1468,
    "question": "suolainen",
    "answer": "salty",
    "ru": "солёный"
  },
  {
    "id": 1469,
    "question": "vaihtoehto",
    "answer": "option",
    "ru": "вариант"
  },
  {
    "id": 1470,
    "question": "leivonnainen",
    "answer": "pastry",
    "ru": "выпечка"
  },
  {
    "id": 1471,
    "question": "ruokasali",
    "answer": "a dinning room",
    "ru": "столовая"
  },
  {
    "id": 1472,
    "question": "yksinkertainen",
    "answer": "simple",
    "ru": "простой"
  },
  {
    "id": 1473,
    "question": "tyylikäs",
    "answer": "stylish",
    "ru": "стильный"
  },
  {
    "id": 1474,
    "question": "sisustus",
    "answer": "interior design",
    "ru": "дизайн интерьера"
  },
  {
    "id": 1475,
    "question": "kasvissyöjä",
    "answer": "vegetarian",
    "ru": "вегетарианец"
  },
  {
    "id": 1476,
    "question": "pettyä",
    "answer": "be disappointed",
    "ru": "разочаровываться"
  },
  {
    "id": 1477,
    "question": "puhdas",
    "answer": "clean",
    "ru": "чистый"
  },
  {
    "id": 1478,
    "question": "raaka-aine",
    "answer": "raw material",
    "ru": "сырьё"
  },
  {
    "id": 1479,
    "question": "kokki",
    "answer": "cook",
    "ru": "повар"
  },
  {
    "id": 1480,
    "question": "taitava",
    "answer": "skilful",
    "ru": "умелый"
  },
  {
    "id": 1481,
    "question": "säännöllisesti",
    "answer": "regularly",
    "ru": "регулярно"
  },
  {
    "id": 1482,
    "question": "heikkous",
    "answer": "weakness",
    "ru": "слабость"
  },
  {
    "id": 1483,
    "question": "haaste",
    "answer": "challenge",
    "ru": "вызов"
  },
  {
    "id": 1484,
    "question": "suullinen",
    "answer": "oral",
    "ru": "устный"
  },
  {
    "id": 1485,
    "question": "tällä hetkellä",
    "answer": "at the moment",
    "ru": "в данный момент"
  },
  {
    "id": 1486,
    "question": "maahanmuuttaja",
    "answer": "immigrant",
    "ru": "иммигрант"
  },
  {
    "id": 1487,
    "question": "työntää",
    "answer": "to push",
    "ru": "толкать"
  },
  {
    "id": 1488,
    "question": "viuhka",
    "answer": "fan",
    "ru": "веер"
  },
  {
    "id": 1489,
    "question": "kammata",
    "answer": "to comb",
    "ru": "расчёсывать"
  },
  {
    "id": 1490,
    "question": "laturi",
    "answer": "charger",
    "ru": "зарядное устройство"
  },
  {
    "id": 1491,
    "question": "hakaneula",
    "answer": "pin",
    "ru": "булавка"
  },
  {
    "id": 1492,
    "question": "huulipuna",
    "answer": "lipstick",
    "ru": "помада"
  },
  {
    "id": 1493,
    "question": "lipputanko",
    "answer": "flagpole",
    "ru": "флагшток"
  },
  {
    "id": 1494,
    "question": "tapahtuma",
    "answer": "happening",
    "ru": "событие"
  },
  {
    "id": 1495,
    "question": "lahje",
    "answer": "pant leg",
    "ru": "штанина"
  },
  {
    "id": 1496,
    "question": "helma",
    "answer": "hem",
    "ru": "подол"
  },
  {
    "id": 1497,
    "question": "nukke",
    "answer": "doll",
    "ru": "кукла"
  },
  {
    "id": 1498,
    "question": "joulupukki",
    "answer": "Santa Claus",
    "ru": "Санта-Клаус"
  },
  {
    "id": 1499,
    "question": "julkinen",
    "answer": "public, national",
    "ru": "публичный, государственный"
  },
  {
    "id": 1500,
    "question": "aavikko",
    "answer": "desert",
    "ru": "пустыня"
  },
  {
    "id": 1501,
    "question": "kämppäkaveri",
    "answer": "roommate",
    "ru": "сосед по комнате"
  },
  {
    "id": 1502,
    "question": "kämppis",
    "answer": "roomie",
    "ru": "сосед по комнате (разг.)"
  },
  {
    "id": 1503,
    "question": "sananvapaus",
    "answer": "freedom of speech",
    "ru": "свобода слова"
  },
  {
    "id": 1504,
    "question": "sensuuri",
    "answer": "censorship",
    "ru": "цензура"
  },
  {
    "id": 1505,
    "question": "ihmisoikeus",
    "answer": "human right",
    "ru": "права человека"
  },
  {
    "id": 1506,
    "question": "itsestäänselvyys",
    "answer": "no-brainer",
    "ru": "само собой разумеющееся"
  },
  {
    "id": 1507,
    "question": "näennäinen",
    "answer": "apparent",
    "ru": "кажущийся"
  },
  {
    "id": 1508,
    "question": "vertailla",
    "answer": "to compare",
    "ru": "сравнивать"
  },
  {
    "id": 1509,
    "question": "säädös",
    "answer": "statute",
    "ru": "статут"
  },
  {
    "id": 1510,
    "question": "loukkaava",
    "answer": "insulting",
    "ru": "оскорбительный"
  },
  {
    "id": 1511,
    "question": "peikko",
    "answer": "goblin",
    "ru": "гоблин"
  },
  {
    "id": 1512,
    "question": "sekava",
    "answer": "mixed",
    "ru": "запутанный"
  },
  {
    "id": 1513,
    "question": "teippi",
    "answer": "tape",
    "ru": "скотч, лента"
  },
  {
    "id": 1514,
    "question": "lypsää",
    "answer": "to milk (the cows)",
    "ru": "доить коров"
  },
  {
    "id": 1515,
    "question": "kyntää",
    "answer": "to plough",
    "ru": "пахать"
  },
  {
    "id": 1516,
    "question": "kylvää",
    "answer": "to sow",
    "ru": "сеять"
  },
  {
    "id": 1517,
    "question": "kalja",
    "answer": "beer (colloquial)",
    "ru": "пиво (разг.)"
  },
  {
    "id": 1518,
    "question": "säilöä",
    "answer": "to preserve",
    "ru": "консервировать"
  },
  {
    "id": 1519,
    "question": "teurastaa",
    "answer": "to slaughter",
    "ru": "забивать скот"
  },
  {
    "id": 1520,
    "question": "kehrätä",
    "answer": "to spin",
    "ru": "прясть"
  },
  {
    "id": 1521,
    "question": "älypuhelin",
    "answer": "smart phone",
    "ru": "смартфон"
  },
  {
    "id": 1522,
    "question": "mielenosoitus",
    "answer": "demonstration",
    "ru": "демонстрация"
  },
  {
    "id": 1523,
    "question": "taistelu",
    "answer": "fight",
    "ru": "борьба"
  },
  {
    "id": 1524,
    "question": "riehua",
    "answer": "to rage",
    "ru": "бушевать"
  },
  {
    "id": 1525,
    "question": "raivokas",
    "answer": "fierce",
    "ru": "свирепый"
  },
  {
    "id": 1526,
    "question": "kukoistava",
    "answer": "booming",
    "ru": "процветающий"
  },
  {
    "id": 1527,
    "question": "päämäärätön",
    "answer": "aimless",
    "ru": "бесцельный"
  },
  {
    "id": 1528,
    "question": "murros",
    "answer": "changeover",
    "ru": "перелом, перемена"
  },
  {
    "id": 1529,
    "question": "ruumiillinen",
    "answer": "corporal",
    "ru": "телесный"
  },
  {
    "id": 1530,
    "question": "ahtaa",
    "answer": "to cram",
    "ru": "набивать"
  },
  {
    "id": 1531,
    "question": "ahmia",
    "answer": "to gobble",
    "ru": "жадно есть"
  },
  {
    "id": 1532,
    "question": "syrjässä",
    "answer": "apart",
    "ru": "в стороне"
  },
  {
    "id": 1533,
    "question": "ulottua",
    "answer": "to extend",
    "ru": "распространяться"
  },
  {
    "id": 1534,
    "question": "raikas",
    "answer": "fresh",
    "ru": "свежий"
  },
  {
    "id": 1535,
    "question": "kiinteä",
    "answer": "firm",
    "ru": "плотный"
  },
  {
    "id": 1536,
    "question": "eloisa",
    "answer": "lively",
    "ru": "живой, оживлённый"
  },
  {
    "id": 1537,
    "question": "villisika",
    "answer": "wild boar",
    "ru": "дикий кабан"
  },
  {
    "id": 1538,
    "question": "aareaitta",
    "answer": "treasury",
    "ru": "сокровищница"
  },
  {
    "id": 1539,
    "question": "kiiltävä",
    "answer": "shining",
    "ru": "блестящий"
  },
  {
    "id": 1540,
    "question": "sormenjälki",
    "answer": "fingerprint",
    "ru": "отпечаток пальца"
  },
  {
    "id": 1541,
    "question": "pedaali",
    "answer": "pedal",
    "ru": "педаль"
  },
  {
    "id": 1542,
    "question": "luovuus",
    "answer": "creativity",
    "ru": "творчество"
  },
  {
    "id": 1543,
    "question": "tarkka",
    "answer": "accurate",
    "ru": "точный"
  },
  {
    "id": 1544,
    "question": "kartella",
    "answer": "to avoid",
    "ru": "избегать"
  },
  {
    "id": 1545,
    "question": "syleillä",
    "answer": "to embrace",
    "ru": "обнимать"
  },
  {
    "id": 1546,
    "question": "sepittää",
    "answer": "to make up",
    "ru": "выдумывать"
  },
  {
    "id": 1547,
    "question": "akvarellipaperi",
    "answer": "watercolor paper",
    "ru": "акварельная бумага"
  },
  {
    "id": 1548,
    "question": "absorptiokyky",
    "answer": "absorption capacity",
    "ru": "поглощающая способность"
  },
  {
    "id": 1549,
    "question": "aihiolakkaus",
    "answer": "varnishing",
    "ru": "лакировка"
  },
  {
    "id": 1550,
    "question": "aikakauslehtipaperi",
    "answer": "magazine paper",
    "ru": "бумага для журналов"
  },
  {
    "id": 1551,
    "question": "alaindeksi",
    "answer": "subscript",
    "ru": "нижний индекс"
  },
  {
    "id": 1552,
    "question": "alaotsikko",
    "answer": "subtitle",
    "ru": "подзаголовок"
  },
  {
    "id": 1553,
    "question": "antiikva",
    "answer": "serif",
    "ru": "шрифт с засечками"
  },
  {
    "id": 1554,
    "question": "apinalaatikko",
    "answer": "monkey box",
    "ru": "выносной элемент"
  },
  {
    "id": 1555,
    "question": "asemointi",
    "answer": "layout",
    "ru": "вёрстка"
  },
  {
    "id": 1556,
    "question": "asettelumalli",
    "answer": "layout model",
    "ru": "макет"
  },
  {
    "id": 1557,
    "question": "aukko",
    "answer": "hole, aperture, counter",
    "ru": "отверстие, апертура"
  },
  {
    "id": 1558,
    "question": "bittikartta",
    "answer": "bitmap",
    "ru": "растровое изображение"
  },
  {
    "id": 1559,
    "question": "briiffi",
    "answer": "brief",
    "ru": "бриф"
  },
  {
    "id": 1560,
    "question": "typografia",
    "answer": "typography",
    "ru": "типографика"
  },
  {
    "id": 1561,
    "question": "painoasu",
    "answer": "typography",
    "ru": "типографское оформление"
  },
  {
    "id": 1562,
    "question": "mainostoimisto",
    "answer": "advertising agency",
    "ru": "рекламное агентство"
  },
  {
    "id": 1563,
    "question": "prosessivärit",
    "answer": "process colors",
    "ru": "технологические цвета"
  },
  {
    "id": 1564,
    "question": "leima",
    "answer": "stamp",
    "ru": "штамп"
  },
  {
    "id": 1565,
    "question": "etymologia",
    "answer": "etymology",
    "ru": "этимология"
  },
  {
    "id": 1566,
    "question": "jälki",
    "answer": "track, trace",
    "ru": "след, трек"
  },
  {
    "id": 1567,
    "question": "jälkimmäinen",
    "answer": "latter",
    "ru": "последний из двух"
  },
  {
    "id": 1568,
    "question": "määritellä",
    "answer": "to define",
    "ru": "определять"
  },
  {
    "id": 1569,
    "question": "skaalata",
    "answer": "to scale",
    "ru": "масштабировать"
  },
  {
    "id": 1570,
    "question": "koreografia",
    "answer": "choreography",
    "ru": "хореография"
  },
  {
    "id": 1571,
    "question": "monipuolistua",
    "answer": "to diversify",
    "ru": "расширяться, диверсифицироваться"
  },
  {
    "id": 1572,
    "question": "käyttäjä",
    "answer": "user",
    "ru": "пользователь"
  },
  {
    "id": 1573,
    "question": "päivittäin",
    "answer": "daily",
    "ru": "ежедневно"
  },
  {
    "id": 1574,
    "question": "viestintä",
    "answer": "communication",
    "ru": "коммуникация"
  },
  {
    "id": 1575,
    "question": "kasvava",
    "answer": "rising",
    "ru": "растущий"
  },
  {
    "id": 1576,
    "question": "ikäluokka",
    "answer": "age group",
    "ru": "возрастная группа"
  },
  {
    "id": 1577,
    "question": "ilmaisukeino",
    "answer": "means of expression",
    "ru": "средство выражения"
  },
  {
    "id": 1578,
    "question": "vastuu",
    "answer": "responsibility",
    "ru": "ответственность"
  },
  {
    "id": 1579,
    "question": "käsitys",
    "answer": "conception, idea, insight",
    "ru": "восприятие, идея, понимание"
  },
  {
    "id": 1580,
    "question": "runko",
    "answer": "stem",
    "ru": "ствол, основа"
  },
  {
    "id": 1581,
    "question": "pääte",
    "answer": "ending, suffix,",
    "ru": "окончание, суффикс"
  },
  {
    "id": 1582,
    "question": "vaakaviiva",
    "answer": "cross bar",
    "ru": "поперечная черта"
  },
  {
    "id": 1583,
    "question": "yläpidennys",
    "answer": "ascender",
    "ru": "верхний выносной элемент"
  },
  {
    "id": 1584,
    "question": "alapidennys",
    "answer": "descender",
    "ru": "нижний выносной элемент"
  },
  {
    "id": 1585,
    "question": "akseli",
    "answer": "axis",
    "ru": "ось"
  },
  {
    "id": 1586,
    "question": "silmukka",
    "answer": "bowl",
    "ru": "чаша буквы"
  },
  {
    "id": 1587,
    "question": "käsi",
    "answer": "hand",
    "ru": "рука"
  },
  {
    "id": 1588,
    "question": "ligatuuri",
    "answer": "ligature",
    "ru": "лигатура"
  },
  {
    "id": 1589,
    "question": "kirjain",
    "answer": "letter, character",
    "ru": "буква, символ"
  },
  {
    "id": 1590,
    "question": "versaalilinja",
    "answer": "cap line",
    "ru": "линия прописных букв"
  },
  {
    "id": 1591,
    "question": "versaalikorkeus",
    "answer": "cap height",
    "ru": "высота прописных букв"
  },
  {
    "id": 1592,
    "question": "peruslinja",
    "answer": "baseline",
    "ru": "базовая линия"
  },
  {
    "id": 1593,
    "question": "ylälinja",
    "answer": "ascender line",
    "ru": "линия верхних выносных элементов"
  },
  {
    "id": 1594,
    "question": "alalinja",
    "answer": "descender line",
    "ru": "линия нижних выносных элементов"
  },
  {
    "id": 1595,
    "question": "x-korkeus",
    "answer": "x-height",
    "ru": "x-высота"
  },
  {
    "id": 1596,
    "question": "gemenalinja",
    "answer": "mean line",
    "ru": "средняя линия"
  },
  {
    "id": 1597,
    "question": "versaali",
    "answer": "uppercase",
    "ru": "прописная буква"
  },
  {
    "id": 1598,
    "question": "gemena",
    "answer": "lowercase",
    "ru": "строчная буква"
  },
  {
    "id": 1599,
    "question": "kapiteeli",
    "answer": "small caps",
    "ru": "малые прописные"
  },
  {
    "id": 1600,
    "question": "päätteetön",
    "answer": "sans-serif",
    "ru": "без засечек"
  },
  {
    "id": 1601,
    "question": "päätteellinen",
    "answer": "serif",
    "ru": "с засечками"
  },
  {
    "id": 1602,
    "question": "anfangi",
    "answer": "drop cap",
    "ru": "буквица"
  },
  {
    "id": 1603,
    "question": "glyfi",
    "answer": "glyph",
    "ru": "глиф"
  },
  {
    "id": 1604,
    "question": "kirjake",
    "answer": "type",
    "ru": "литера"
  },
  {
    "id": 1605,
    "question": "kirjasin",
    "answer": "typeface",
    "ru": "гарнитура шрифта"
  },
  {
    "id": 1606,
    "question": "imarrella",
    "answer": "to flatter",
    "ru": "льстить"
  },
  {
    "id": 1607,
    "question": "unohtaa",
    "answer": "to forget",
    "ru": "забывать"
  },
  {
    "id": 1608,
    "question": "ruveta",
    "answer": "begin, take up",
    "ru": "начать, взяться"
  },
  {
    "id": 1609,
    "question": "pistäytyä",
    "answer": "pop in for a visit",
    "ru": "заскочить на минутку"
  },
  {
    "id": 1610,
    "question": "voittaa",
    "answer": "to win",
    "ru": "побеждать"
  },
  {
    "id": 1611,
    "question": "tapella",
    "answer": "to fight",
    "ru": "драться"
  },
  {
    "id": 1612,
    "question": "valehdella",
    "answer": "to lie",
    "ru": "лгать"
  },
  {
    "id": 1613,
    "question": "leikkiä",
    "answer": "to play",
    "ru": "играть"
  },
  {
    "id": 1614,
    "question": "herättää",
    "answer": "to wake, to raise",
    "ru": "будить, поднимать"
  },
  {
    "id": 1615,
    "question": "herätä",
    "answer": "wake up",
    "ru": "просыпаться"
  },
  {
    "id": 1616,
    "question": "sammua",
    "answer": "flame out",
    "ru": "гаснуть"
  },
  {
    "id": 1617,
    "question": "pudota",
    "answer": "to fall",
    "ru": "падать"
  },
  {
    "id": 1618,
    "question": "kylmetä",
    "answer": "become colder",
    "ru": "становиться холоднее"
  },
  {
    "id": 1619,
    "question": "lyhetä",
    "answer": "shorten",
    "ru": "укорачиваться"
  },
  {
    "id": 1620,
    "question": "taata",
    "answer": "to guarantee",
    "ru": "гарантировать"
  },
  {
    "id": 1621,
    "question": "ajatella",
    "answer": "to think",
    "ru": "думать"
  },
  {
    "id": 1622,
    "question": "muokata",
    "answer": "to edit",
    "ru": "редактировать"
  },
  {
    "id": 1623,
    "question": "kaapata",
    "answer": "to kidnap",
    "ru": "похищать"
  },
  {
    "id": 1624,
    "question": "hypätä",
    "answer": "to jump",
    "ru": "прыгать"
  },
  {
    "id": 1625,
    "question": "auttaa",
    "answer": "to help",
    "ru": "помогать"
  },
  {
    "id": 1626,
    "question": "odottaa",
    "answer": "to wait",
    "ru": "ждать"
  },
  {
    "id": 1627,
    "question": "muuttaa",
    "answer": "to change / to move",
    "ru": "менять / переезжать"
  },
  {
    "id": 1628,
    "question": "soittaa",
    "answer": "to play, to call",
    "ru": "играть, звонить"
  },
  {
    "id": 1629,
    "question": "hiihtää",
    "answer": "to ski",
    "ru": "кататься на лыжах"
  },
  {
    "id": 1630,
    "question": "piirtää",
    "answer": "to draw",
    "ru": "рисовать"
  },
  {
    "id": 1631,
    "question": "antaa",
    "answer": "to give",
    "ru": "давать"
  },
  {
    "id": 1632,
    "question": "ottaa",
    "answer": "to take, to select",
    "ru": "брать, выбирать"
  },
  {
    "id": 1633,
    "question": "kääntää",
    "answer": "to translate, to turn",
    "ru": "переводить, поворачивать"
  },
  {
    "id": 1634,
    "question": "viheltää",
    "answer": "whistle",
    "ru": "свистеть"
  },
  {
    "id": 1635,
    "question": "nukkua",
    "answer": "to sleep",
    "ru": "спать"
  },
  {
    "id": 1636,
    "question": "lukea",
    "answer": "to read",
    "ru": "читать"
  },
  {
    "id": 1637,
    "question": "pukea",
    "answer": "to dress",
    "ru": "одевать"
  },
  {
    "id": 1638,
    "question": "hiipiä",
    "answer": "sneak, tiptoe, creep",
    "ru": "красться, идти на цыпочках"
  },
  {
    "id": 1639,
    "question": "syöttää",
    "answer": "to input, to feed",
    "ru": "вводить, кормить"
  },
  {
    "id": 1640,
    "question": "soutaa",
    "answer": "to row",
    "ru": "грести"
  },
  {
    "id": 1641,
    "question": "onkia",
    "answer": "to fish",
    "ru": "рыбачить"
  },
  {
    "id": 1642,
    "question": "sataa",
    "answer": "it's raining",
    "ru": "идёт дождь"
  },
  {
    "id": 1643,
    "question": "ampua",
    "answer": "to shoot",
    "ru": "стрелять"
  },
  {
    "id": 1644,
    "question": "tappaa",
    "answer": "to kill",
    "ru": "убивать"
  },
  {
    "id": 1645,
    "question": "hoitaa",
    "answer": "to nurse, to care for, to treat",
    "ru": "ухаживать, заботиться"
  },
  {
    "id": 1646,
    "question": "puhua",
    "answer": "to talk",
    "ru": "говорить"
  },
  {
    "id": 1647,
    "question": "sanoa",
    "answer": "to say",
    "ru": "сказать"
  },
  {
    "id": 1648,
    "question": "seisoa",
    "answer": "to stand",
    "ru": "стоять"
  },
  {
    "id": 1649,
    "question": "istua",
    "answer": "to sit",
    "ru": "сидеть"
  },
  {
    "id": 1650,
    "question": "nauraa",
    "answer": "to laugh",
    "ru": "смеяться"
  },
  {
    "id": 1651,
    "question": "tanssia",
    "answer": "to dance",
    "ru": "танцевать"
  },
  {
    "id": 1652,
    "question": "itkeä",
    "answer": "to cry",
    "ru": "плакать"
  },
  {
    "id": 1653,
    "question": "maksaa",
    "answer": "to pay; to cost",
    "ru": "платить; стоить"
  },
  {
    "id": 1654,
    "question": "ajaa",
    "answer": "to drive",
    "ru": "ехать"
  },
  {
    "id": 1655,
    "question": "sienestää",
    "answer": "to pick mushrooms",
    "ru": "собирать грибы"
  },
  {
    "id": 1656,
    "question": "metsästää",
    "answer": "to hunt",
    "ru": "охотиться"
  },
  {
    "id": 1657,
    "question": "rakastaa",
    "answer": "to love",
    "ru": "любить"
  },
  {
    "id": 1658,
    "question": "asua",
    "answer": "to live, to reside",
    "ru": "жить, проживать"
  },
  {
    "id": 1659,
    "question": "katsoa",
    "answer": "to watch",
    "ru": "смотреть"
  },
  {
    "id": 1660,
    "question": "paistaa",
    "answer": "to fry, to shine",
    "ru": "жарить, светить"
  },
  {
    "id": 1662,
    "question": "matkustaa",
    "answer": "to travel",
    "ru": "путешествовать"
  },
  {
    "id": 1663,
    "question": "kasvaa",
    "answer": "to grow (intransitive)",
    "ru": "расти"
  },
  {
    "id": 1664,
    "question": "ratsastaa",
    "answer": "to ride",
    "ru": "ездить верхом"
  },
  {
    "id": 1665,
    "question": "kirjoittaa",
    "answer": "to write",
    "ru": "писать"
  },
  {
    "id": 1666,
    "question": "soitit",
    "answer": "you called",
    "ru": "ты позвонил"
  },
  {
    "id": 1667,
    "question": "parturiin",
    "answer": "to the barber shop",
    "ru": "в парикмахерскую"
  },
  {
    "id": 1668,
    "question": "hiustenleikkaukseen",
    "answer": "for a haircut",
    "ru": "на стрижку"
  },
  {
    "id": 1669,
    "question": "autamme",
    "answer": "we help",
    "ru": "мы помогаем"
  },
  {
    "id": 1670,
    "question": "mielellämme",
    "answer": "with pleasure",
    "ru": "с удовольствием"
  },
  {
    "id": 1671,
    "question": "saanko",
    "answer": "can i",
    "ru": "можно ли мне"
  },
  {
    "id": 1672,
    "question": "nimesi",
    "answer": "your name",
    "ru": "твоё имя"
  },
  {
    "id": 1673,
    "question": "ajattelit",
    "answer": "you thought",
    "ru": "ты думал"
  },
  {
    "id": 1674,
    "question": "no",
    "answer": "well",
    "ru": "ну, что ж"
  },
  {
    "id": 1675,
    "question": "viikonloppuisin",
    "answer": "weekends",
    "ru": "по выходным"
  },
  {
    "id": 1676,
    "question": "avoinna",
    "answer": "open",
    "ru": "открыто"
  },
  {
    "id": 1677,
    "question": "kumpi",
    "answer": "which",
    "ru": "который из двух"
  },
  {
    "id": 1678,
    "question": "millaisia",
    "answer": "what kind of",
    "ru": "какого рода"
  },
  {
    "id": 1679,
    "question": "hiustenleikkauksia",
    "answer": "haircuts",
    "ru": "стрижки"
  },
  {
    "id": 1680,
    "question": "tarjoat",
    "answer": "you offer",
    "ru": "ты предлагаешь"
  },
  {
    "id": 1681,
    "question": "klassisia",
    "answer": "classic ones",
    "ru": "классические"
  },
  {
    "id": 1682,
    "question": "leikkauksia",
    "answer": "surgeries",
    "ru": "стрижки"
  },
  {
    "id": 1683,
    "question": "haalistumia",
    "answer": "fades",
    "ru": "градиенты"
  },
  {
    "id": 1684,
    "question": "trendikkäämpiä",
    "answer": "more trendy",
    "ru": "более модные"
  },
  {
    "id": 1685,
    "question": "tyylejä",
    "answer": "styles",
    "ru": "стили"
  },
  {
    "id": 1686,
    "question": "etsitkö",
    "answer": "are you looking for",
    "ru": "ты ищешь"
  },
  {
    "id": 1687,
    "question": "suosituin",
    "answer": "the most popular",
    "ru": "самый популярный"
  },
  {
    "id": 1688,
    "question": "trendikkäin",
    "answer": "the trendiest",
    "ru": "самый модный"
  },
  {
    "id": 1689,
    "question": "käyttäjä",
    "answer": "user",
    "ru": "пользователь"
  },
  {
    "id": 1690,
    "question": "kysytyin",
    "answer": "most asked",
    "ru": "наиболее запрашиваемый"
  },
  {
    "id": 1691,
    "question": "teksturoitu",
    "answer": "textured",
    "ru": "текстурированный"
  },
  {
    "id": 1692,
    "question": "sato",
    "answer": "harvest",
    "ru": "урожай"
  },
  {
    "id": 1693,
    "question": "tyyli",
    "answer": "style",
    "ru": "стиль"
  },
  {
    "id": 1694,
    "question": "kasvojen",
    "answer": "of the face",
    "ru": "лица"
  },
  {
    "id": 1695,
    "question": "muotoihin",
    "answer": "to shapes",
    "ru": "к формам"
  },
  {
    "id": 1696,
    "question": "hmm",
    "answer": "ummm",
    "ru": "хм"
  },
  {
    "id": 1697,
    "question": "kuvioidusta",
    "answer": "texture",
    "ru": "текстура"
  },
  {
    "id": 1698,
    "question": "sadosta",
    "answer": "of the crop",
    "ru": "из урожая"
  },
  {
    "id": 1699,
    "question": "yksinkertainen",
    "answer": "simple",
    "ru": "простой"
  },
  {
    "id": 1700,
    "question": "häivytys",
    "answer": "fade out",
    "ru": "постепенное исчезновение"
  },
  {
    "id": 1701,
    "question": "häipymisen",
    "answer": "fading",
    "ru": "постепенное исчезновение"
  },
  {
    "id": 1702,
    "question": "klassinen",
    "answer": "classic",
    "ru": "классический"
  },
  {
    "id": 1703,
    "question": "hinnoittelussa",
    "answer": "in pricing",
    "ru": "в ценообразовании"
  },
  {
    "id": 1704,
    "question": "häipyminen",
    "answer": "fading",
    "ru": "постепенное исчезновение"
  },
  {
    "id": 1705,
    "question": "jyrkältä",
    "answer": "steeply",
    "ru": "круто"
  },
  {
    "id": 1706,
    "question": "euron",
    "answer": "euro",
    "ru": "евро"
  },
  {
    "id": 1707,
    "question": "luokkaa",
    "answer": "class",
    "ru": "класс"
  },
  {
    "id": 1708,
    "question": "huolesi",
    "answer": "your worries",
    "ru": "твои заботы"
  },
  {
    "id": 1709,
    "question": "hinnoittelumme",
    "answer": "our pricing",
    "ru": "наше ценообразование"
  },
  {
    "id": 1710,
    "question": "heijastelee",
    "answer": "reflects",
    "ru": "отражает"
  },
  {
    "id": 1711,
    "question": "parturimme",
    "answer": "our barber",
    "ru": "наш парикмахер"
  },
  {
    "id": 1712,
    "question": "palvelun",
    "answer": "service",
    "ru": "услуга"
  },
  {
    "id": 1713,
    "question": "laatua",
    "answer": "quality",
    "ru": "качество"
  },
  {
    "id": 1714,
    "question": "asiantuntemusta",
    "answer": "expertise",
    "ru": "экспертиза"
  },
  {
    "id": 1715,
    "question": "keskellä",
    "answer": "in the middle",
    "ru": "в середине"
  },
  {
    "id": 1716,
    "question": "pysyisin",
    "answer": "i would stay",
    "ru": "я бы остался"
  },
  {
    "id": 1717,
    "question": "eurossa",
    "answer": "in euros",
    "ru": "в евро"
  },
  {
    "id": 1718,
    "question": "budjettiasioitasi",
    "answer": "your budget matters",
    "ru": "твои бюджетные вопросы"
  },
  {
    "id": 1719,
    "question": "tehdään",
    "answer": "let's do it",
    "ru": "давайте сделаем это"
  },
  {
    "id": 1720,
    "question": "kompromissi",
    "answer": "compromise",
    "ru": "компромисс"
  },
  {
    "id": 1721,
    "question": "ssa",
    "answer": "in",
    "ru": "в"
  },
  {
    "id": 1722,
    "question": "selvä",
    "answer": "clear",
    "ru": "ясно"
  },
  {
    "id": 1723,
    "question": "suunnitelleet",
    "answer": "have planned",
    "ru": "запланировали"
  },
  {
    "id": 1724,
    "question": "häivytykseen",
    "answer": "to fade out",
    "ru": "к постепенному исчезновению"
  },
  {
    "id": 1725,
    "question": "yhteysnumeron",
    "answer": "contact number",
    "ru": "контактный номер"
  },
  {
    "id": 1726,
    "question": "siltä",
    "answer": "bridge",
    "ru": "мост"
  },
  {
    "id": 1727,
    "question": "varalta",
    "answer": "against",
    "ru": "на случай"
  },
  {
    "id": 1728,
    "question": "tavoittaa",
    "answer": "reach",
    "ru": "связаться"
  },
  {
    "id": 1729,
    "question": "perfect",
    "answer": "perfect",
    "ru": "идеально"
  },
  {
    "id": 1730,
    "question": "näkevämme",
    "answer": "that we see",
    "ru": "что мы увидим"
  },
  {
    "id": 1731,
    "question": "soita",
    "answer": "call",
    "ru": "позвони"
  },
  {
    "id": 1732,
    "question": "silloin",
    "answer": "then",
    "ru": "тогда"
  },
  {
    "id": 1733,
    "question": "ostamaan",
    "answer": "to buy",
    "ru": "купить"
  },
  {
    "id": 1734,
    "question": "polttoainetehokkuus",
    "answer": "fuel efficiency",
    "ru": "топливная эффективность"
  },
  {
    "id": 1735,
    "question": "polttoainetehokkaita",
    "answer": "fuel efficient",
    "ru": "экономичный"
  },
  {
    "id": 1736,
    "question": "mieltymyksesi",
    "answer": "your preference",
    "ru": "твоё предпочтение"
  },
  {
    "id": 1737,
    "question": "koon",
    "answer": "the size",
    "ru": "размер"
  },
  {
    "id": 1738,
    "question": "merkin",
    "answer": "sign",
    "ru": "знак"
  },
  {
    "id": 1739,
    "question": "suhteen",
    "answer": "regarding",
    "ru": "относительно"
  },
  {
    "id": 1740,
    "question": "ehdotuksille",
    "answer": "for proposals",
    "ru": "для предложений"
  },
  {
    "id": 1741,
    "question": "kompaktia",
    "answer": "compact",
    "ru": "компактный"
  },
  {
    "id": 1742,
    "question": "luotettavaa",
    "answer": "reliable",
    "ru": "надёжный"
  },
  {
    "id": 1743,
    "question": "sedanista",
    "answer": "from the sedan",
    "ru": "из седана"
  },
  {
    "id": 1744,
    "question": "tarpeisiisi",
    "answer": "to your needs",
    "ru": "к твоим потребностям"
  },
  {
    "id": 1745,
    "question": "erityisiä",
    "answer": "special",
    "ru": "особые"
  },
  {
    "id": 1746,
    "question": "ominaisuuksia",
    "answer": "features",
    "ru": "характеристики"
  },
  {
    "id": 1747,
    "question": "etsit",
    "answer": "you are looking for",
    "ru": "ты ищешь"
  },
  {
    "id": 1748,
    "question": "kattoluukun",
    "answer": "sunroof",
    "ru": "люк"
  },
  {
    "id": 1749,
    "question": "mahdollista",
    "answer": "possible",
    "ru": "возможно"
  },
  {
    "id": 1750,
    "question": "edistyneistä",
    "answer": "advanced ones",
    "ru": "продвинутые"
  },
  {
    "id": 1751,
    "question": "turvaominaisuuksista",
    "answer": "safety features",
    "ru": "функции безопасности"
  },
  {
    "id": 1752,
    "question": "huom",
    "answer": "note",
    "ru": "примечание"
  },
  {
    "id": 1753,
    "question": "valikoimastamme",
    "answer": "from our selection",
    "ru": "из нашего ассортимента"
  },
  {
    "id": 1754,
    "question": "kompaktin",
    "answer": "compact",
    "ru": "компактный"
  },
  {
    "id": 1755,
    "question": "sedanin",
    "answer": "sedan",
    "ru": "седан"
  },
  {
    "id": 1756,
    "question": "edistyneet",
    "answer": "advanced",
    "ru": "продвинутые"
  },
  {
    "id": 1757,
    "question": "turvaominaisuudet",
    "answer": "security features",
    "ru": "функции безопасности"
  },
  {
    "id": 1758,
    "question": "malli",
    "answer": "model",
    "ru": "модель"
  },
  {
    "id": 1759,
    "question": "kriteereihisi",
    "answer": "to your criteria",
    "ru": "к твоим критериям"
  },
  {
    "id": 1760,
    "question": "kompakti",
    "answer": "compact",
    "ru": "компактный"
  },
  {
    "id": 1761,
    "question": "uusin",
    "answer": "latest",
    "ru": "новейший"
  },
  {
    "id": 1762,
    "question": "turvallisuustekniikka",
    "answer": "security technology",
    "ru": "технология безопасности"
  },
  {
    "id": 1763,
    "question": "varata",
    "answer": "book",
    "ru": "забронировать"
  },
  {
    "id": 1764,
    "question": "rahoitusvaihtoehdoista",
    "answer": "financing options",
    "ru": "варианты финансирования"
  },
  {
    "id": 1765,
    "question": "rahoitussuunnitelmia",
    "answer": "financial plans",
    "ru": "финансовые планы"
  },
  {
    "id": 1766,
    "question": "erilaisilla",
    "answer": "with different ones",
    "ru": "с разными"
  },
  {
    "id": 1767,
    "question": "ehdoilla",
    "answer": "on terms",
    "ru": "на условиях"
  },
  {
    "id": 1768,
    "question": "niistä",
    "answer": "of them",
    "ru": "из них"
  },
  {
    "id": 1769,
    "question": "käsittelemme",
    "answer": "we deal with",
    "ru": "мы рассматриваем"
  },
  {
    "id": 1770,
    "question": "aihetta",
    "answer": "topic",
    "ru": "тема"
  },
  {
    "id": 1771,
    "question": "käynnissä",
    "answer": "in progress",
    "ru": "в процессе"
  },
  {
    "id": 1772,
    "question": "kampanjoita",
    "answer": "campaigns",
    "ru": "кампании"
  },
  {
    "id": 1773,
    "question": "tarjous",
    "answer": "offer",
    "ru": "предложение"
  },
  {
    "id": 1774,
    "question": "cashbackkannustimen",
    "answer": "cashback incentive",
    "ru": "кэшбэк-стимул"
  },
  {
    "id": 1775,
    "question": "alennettuja",
    "answer": "discounted",
    "ru": "со скидкой"
  },
  {
    "id": 1776,
    "question": "korkoja",
    "answer": "interest rates",
    "ru": "процентные ставки"
  },
  {
    "id": 1777,
    "question": "rahoituksesta",
    "answer": "about financing",
    "ru": "о финансировании"
  },
  {
    "id": 1778,
    "question": "hintapyyntö",
    "answer": "price request",
    "ru": "запрашиваемая цена"
  },
  {
    "id": 1779,
    "question": "rahoitussuunnitelma",
    "answer": "financial plan",
    "ru": "финансовый план"
  },
  {
    "id": 1780,
    "question": "vaihtosopimukset",
    "answer": "swap agreements",
    "ru": "соглашения об обмене"
  },
  {
    "id": 1781,
    "question": "pysyväni",
    "answer": "permanent",
    "ru": "постоянный"
  },
  {
    "id": 1782,
    "question": "dollarissa",
    "answer": "in dollars",
    "ru": "в долларах"
  },
  {
    "id": 1783,
    "question": "anna",
    "answer": "give it",
    "ru": "дай"
  },
  {
    "id": 1784,
    "question": "esimieheni",
    "answer": "those above me",
    "ru": "мои руководители"
  },
  {
    "id": 1785,
    "question": "nähdäksemme",
    "answer": "to see",
    "ru": "чтобы посмотреть"
  },
  {
    "id": 1786,
    "question": "budjettiani",
    "answer": "my budget",
    "ru": "мой бюджет"
  },
  {
    "id": 1787,
    "question": "paperityöstä",
    "answer": "paperwork",
    "ru": "бумажная работа"
  },
  {
    "id": 1788,
    "question": "asiakirjat",
    "answer": "documentation",
    "ru": "документация"
  },
  {
    "id": 1789,
    "question": "käymme",
    "answer": "we go",
    "ru": "мы идём"
  },
  {
    "id": 1790,
    "question": "auto",
    "answer": "car",
    "ru": "автомобиль"
  },
  {
    "id": 1791,
    "question": "valmiina",
    "answer": "at the ready",
    "ru": "готов"
  },
  {
    "id": 1792,
    "question": "koeajoa",
    "answer": "test drive",
    "ru": "тест-драйв"
  },
  {
    "id": 1793,
    "question": "viimeistelyä",
    "answer": "finishing",
    "ru": "завершение"
  },
  {
    "id": 1794,
    "question": "iloisia",
    "answer": "happy",
    "ru": "счастливые"
  },
  {
    "id": 1795,
    "question": "saadessamme",
    "answer": "upon receiving",
    "ru": "при получении"
  },
  {
    "id": 1796,
    "question": "asiakkaaksemme",
    "answer": "our customer",
    "ru": "наш клиент"
  },
  {
    "id": 1797,
    "question": "tapaamistamme",
    "answer": "our meeting",
    "ru": "наша встреча"
  },
  {
    "id": 1798,
    "question": "uuden",
    "answer": "new",
    "ru": "новый"
  },
  {
    "id": 1799,
    "question": "sähkösopimuksen",
    "answer": "electricity contract",
    "ru": "договор на электроснабжение"
  },
  {
    "id": 1800,
    "question": "kiinteitä",
    "answer": "fixed",
    "ru": "фиксированные"
  },
  {
    "id": 1801,
    "question": "joustavia",
    "answer": "flexible",
    "ru": "гибкие"
  },
  {
    "id": 1802,
    "question": "sopimuksia",
    "answer": "contracts",
    "ru": "договоры"
  },
  {
    "id": 1803,
    "question": "lukkiutuu",
    "answer": "locks up",
    "ru": "блокируется"
  },
  {
    "id": 1804,
    "question": "joustava",
    "answer": "flexible",
    "ru": "гибкий"
  },
  {
    "id": 1805,
    "question": "vaihtelee",
    "answer": "varies",
    "ru": "меняется"
  },
  {
    "id": 1806,
    "question": "määräajan",
    "answer": "deadline",
    "ru": "срок"
  },
  {
    "id": 1807,
    "question": "rikkomisesta",
    "answer": "violation",
    "ru": "нарушение"
  },
  {
    "id": 1808,
    "question": "mitään",
    "answer": "anything",
    "ru": "ничего"
  },
  {
    "id": 1809,
    "question": "seuraamuksia",
    "answer": "sanctions",
    "ru": "санкции"
  },
  {
    "id": 1810,
    "question": "ennenaikaisesta",
    "answer": "premature",
    "ru": "досрочное"
  },
  {
    "id": 1811,
    "question": "irtisanomisesta",
    "answer": "dismissal",
    "ru": "расторжение"
  },
  {
    "id": 1812,
    "question": "saatetaan",
    "answer": "maybe",
    "ru": "возможно"
  },
  {
    "id": 1813,
    "question": "periä",
    "answer": "charge",
    "ru": "взимать"
  },
  {
    "id": 1814,
    "question": "vertaa",
    "answer": "compare",
    "ru": "сравни"
  },
  {
    "id": 1815,
    "question": "koolla",
    "answer": "assembled",
    "ru": "в сборе"
  },
  {
    "id": 1816,
    "question": "väliä",
    "answer": "matter",
    "ru": "значение"
  },
  {
    "id": 1817,
    "question": "kokonaiskulutukseen",
    "answer": "to total consumption",
    "ru": "к общему потреблению"
  },
  {
    "id": 1818,
    "question": "räätälöidä",
    "answer": "tailor",
    "ru": "настроить"
  },
  {
    "id": 1819,
    "question": "suunnitelman",
    "answer": "the plan",
    "ru": "план"
  },
  {
    "id": 1820,
    "question": "tarpeidesi",
    "answer": "your needs",
    "ru": "твои потребности"
  },
  {
    "id": 1821,
    "question": "siistiä",
    "answer": "cool",
    "ru": "круто"
  },
  {
    "id": 1822,
    "question": "joustavasta",
    "answer": "flexible",
    "ru": "гибкий"
  },
  {
    "id": 1823,
    "question": "sopimushinnoittelusta",
    "answer": "contract pricing",
    "ru": "договорное ценообразование"
  },
  {
    "id": 1824,
    "question": "joustavat",
    "answer": "flexible",
    "ru": "гибкие"
  },
  {
    "id": 1825,
    "question": "vaihtelevat",
    "answer": "vary",
    "ru": "варьируются"
  },
  {
    "id": 1826,
    "question": "reaaliaikaisia",
    "answer": "real time",
    "ru": "в реальном времени"
  },
  {
    "id": 1827,
    "question": "päivityksiä",
    "answer": "updates",
    "ru": "обновления"
  },
  {
    "id": 1828,
    "question": "hyötyä",
    "answer": "put to account",
    "ru": "использовать в своих интересах"
  },
  {
    "id": 1829,
    "question": "alhaisemmista",
    "answer": "from lower ones",
    "ru": "от более низких"
  },
  {
    "id": 1830,
    "question": "päivämäärän",
    "answer": "the date",
    "ru": "дата"
  },
  {
    "id": 1831,
    "question": "sovittaa",
    "answer": "match",
    "ru": "согласовать"
  },
  {
    "id": 1832,
    "question": "haluamasi",
    "answer": "the one you want",
    "ru": "тот, что ты хочешь"
  },
  {
    "id": 1833,
    "question": "aloituspäivän",
    "answer": "start date",
    "ru": "дата начала"
  },
  {
    "id": 1834,
    "question": "yksityiskohdat",
    "answer": "detail",
    "ru": "детали"
  },
  {
    "id": 1835,
    "question": "viikko",
    "answer": "week",
    "ru": "неделя"
  },
  {
    "id": 1836,
    "question": "nykyisen",
    "answer": "of the current one",
    "ru": "текущего"
  },
  {
    "id": 1837,
    "question": "sopimuksesi",
    "answer": "your contract",
    "ru": "твой договор"
  },
  {
    "id": 1838,
    "question": "päättymistä",
    "answer": "termination",
    "ru": "окончание"
  },
  {
    "id": 1839,
    "question": "neuvotella",
    "answer": "negotiate",
    "ru": "переговоры"
  },
  {
    "id": 1840,
    "question": "hinnasta",
    "answer": "of the price",
    "ru": "о цене"
  },
  {
    "id": 1841,
    "question": "millaisen",
    "answer": "what kind of",
    "ru": "какой"
  },
  {
    "id": 1842,
    "question": "koron",
    "answer": "interest rate",
    "ru": "процентная ставка"
  },
  {
    "id": 1843,
    "question": "löytänyt",
    "answer": "found",
    "ru": "нашёл"
  },
  {
    "id": 1844,
    "question": "muualta",
    "answer": "from elsewhere",
    "ru": "из другого места"
  },
  {
    "id": 1845,
    "question": "löytyi",
    "answer": "found it",
    "ru": "нашёл"
  },
  {
    "id": 1846,
    "question": "pystytkö",
    "answer": "can you",
    "ru": "можешь ли ты"
  },
  {
    "id": 1847,
    "question": "vastaamaan",
    "answer": "to answer",
    "ru": "ответить"
  },
  {
    "id": 1848,
    "question": "lähelle",
    "answer": "close",
    "ru": "близко"
  },
  {
    "id": 1849,
    "question": "antakaa",
    "answer": "give it",
    "ru": "дайте"
  },
  {
    "id": 1850,
    "question": "per",
    "answer": "per",
    "ru": "за"
  },
  {
    "id": 1851,
    "question": "kwh",
    "answer": "kwh",
    "ru": "кВт·ч"
  },
  {
    "id": 1852,
    "question": "tarpeeksi",
    "answer": "enough",
    "ru": "достаточно"
  },
  {
    "id": 1853,
    "question": "viimeistetään",
    "answer": "let's finish",
    "ru": "давайте закончим"
  },
  {
    "id": 1854,
    "question": "kurssilla",
    "answer": "on the course",
    "ru": "на курсе"
  },
  {
    "id": 1855,
    "question": "paperit",
    "answer": "papers",
    "ru": "бумаги"
  },
  {
    "id": 1856,
    "question": "liittymään",
    "answer": "to join",
    "ru": "вступить"
  },
  {
    "id": 1857,
    "question": "jalkapalloharrastekurssille",
    "answer": "for a football hobby course",
    "ru": "на курс по футболу для любителей"
  },
  {
    "id": 1858,
    "question": "urheilukeskuksessasi",
    "answer": "at your sports center",
    "ru": "в твоём спортивном центре"
  },
  {
    "id": 1859,
    "question": "vaihtoehdoista",
    "answer": "of options",
    "ru": "из вариантов"
  },
  {
    "id": 1860,
    "question": "jalkapalloluokkia",
    "answer": "soccer classes",
    "ru": "занятия по футболу"
  },
  {
    "id": 1861,
    "question": "taitotasoille",
    "answer": "for skill levels",
    "ru": "для уровней навыков"
  },
  {
    "id": 1862,
    "question": "oletko",
    "answer": "are you",
    "ru": "ты"
  },
  {
    "id": 1863,
    "question": "tarvitsisin",
    "answer": "i would need",
    "ru": "мне бы понадобилось"
  },
  {
    "id": 1864,
    "question": "sopivaa",
    "answer": "appropriate",
    "ru": "подходящий"
  },
  {
    "id": 1865,
    "question": "aloittelijalle",
    "answer": "for a beginner",
    "ru": "для начинающих"
  },
  {
    "id": 1866,
    "question": "alkeiskurssi",
    "answer": "elementary course",
    "ru": "курс для начинающих"
  },
  {
    "id": 1867,
    "question": "keskittyy",
    "answer": "concentrates",
    "ru": "сосредоточен"
  },
  {
    "id": 1868,
    "question": "jalkapallon",
    "answer": "football",
    "ru": "футбол"
  },
  {
    "id": 1869,
    "question": "perusteisiin",
    "answer": "to the basics",
    "ru": "к основам"
  },
  {
    "id": 1870,
    "question": "arkiiltoja",
    "answer": "weeknights",
    "ru": "вечера в будни"
  },
  {
    "id": 1871,
    "question": "viikonloppuja",
    "answer": "weekends",
    "ru": "выходные"
  },
  {
    "id": 1872,
    "question": "arkiillat",
    "answer": "the weekdays",
    "ru": "будние вечера"
  },
  {
    "id": 1873,
    "question": "toimivat",
    "answer": "work",
    "ru": "работают"
  },
  {
    "id": 1874,
    "question": "luokilla",
    "answer": "in classes",
    "ru": "в классах"
  },
  {
    "id": 1875,
    "question": "ikäryhmiä",
    "answer": "age groups",
    "ru": "возрастные группы"
  },
  {
    "id": 1876,
    "question": "alkeisluokka",
    "answer": "elementary class",
    "ru": "класс для начинающих"
  },
  {
    "id": 1877,
    "question": "ikäryhmille",
    "answer": "for age groups",
    "ru": "для возрастных групп"
  },
  {
    "id": 1878,
    "question": "osallistujavalikoima",
    "answer": "selection of participants",
    "ru": "выбор участников"
  },
  {
    "id": 1879,
    "question": "pitääkö",
    "answer": "do you have to?",
    "ru": "нужно ли?"
  },
  {
    "id": 1880,
    "question": "varusteet",
    "answer": "equipment",
    "ru": "снаряжение"
  },
  {
    "id": 1881,
    "question": "perusvarusteita",
    "answer": "basic equipment",
    "ru": "базовое снаряжение"
  },
  {
    "id": 1882,
    "question": "palloja",
    "answer": "balls",
    "ru": "мячи"
  },
  {
    "id": 1883,
    "question": "kartioita",
    "answer": "cones",
    "ru": "конусы"
  },
  {
    "id": 1884,
    "question": "suositeltavaa",
    "answer": "recommendable",
    "ru": "рекомендуется"
  },
  {
    "id": 1885,
    "question": "mukavat",
    "answer": "nice ones",
    "ru": "удобные"
  },
  {
    "id": 1886,
    "question": "urheiluasut",
    "answer": "sportswear",
    "ru": "спортивная одежда"
  },
  {
    "id": 1887,
    "question": "kengät",
    "answer": "boots",
    "ru": "обувь"
  },
  {
    "id": 1888,
    "question": "kokeiluluokkaa",
    "answer": "trial class",
    "ru": "пробное занятие"
  },
  {
    "id": 1889,
    "question": "sitoutumista",
    "answer": "commitment",
    "ru": "обязательство"
  },
  {
    "id": 1890,
    "question": "tervetullut",
    "answer": "welcome",
    "ru": "добро пожаловать"
  },
  {
    "id": 1891,
    "question": "ensimmäiselle",
    "answer": "for the first one",
    "ru": "на первое"
  },
  {
    "id": 1892,
    "question": "tunnille",
    "answer": "for class",
    "ru": "на занятие"
  },
  {
    "id": 1893,
    "question": "kokeeksi",
    "answer": "by way of trial",
    "ru": "в качестве пробного"
  },
  {
    "id": 1894,
    "question": "pidät",
    "answer": "you like",
    "ru": "тебе нравится"
  },
  {
    "id": 1895,
    "question": "ilmoittautua",
    "answer": "register",
    "ru": "зарегистрироваться"
  },
  {
    "id": 1896,
    "question": "ohjelmaan",
    "answer": "to the program",
    "ru": "в программу"
  },
  {
    "id": 1897,
    "question": "paljonko",
    "answer": "how much",
    "ru": "сколько"
  },
  {
    "id": 1898,
    "question": "jalkapalloluokka",
    "answer": "football class",
    "ru": "занятие по футболу"
  },
  {
    "id": 1899,
    "question": "maksaa",
    "answer": "pay",
    "ru": "платить"
  },
  {
    "id": 1900,
    "question": "tunnit",
    "answer": "hours",
    "ru": "часы"
  },
  {
    "id": 1901,
    "question": "välineet",
    "answer": "means",
    "ru": "инвентарь"
  },
  {
    "id": 1902,
    "question": "pääsyn",
    "answer": "access",
    "ru": "доступ"
  },
  {
    "id": 1903,
    "question": "tiloihimme",
    "answer": "to our premises",
    "ru": "к нашим помещениям"
  },
  {
    "id": 1904,
    "question": "luokkaaikoina",
    "answer": "during class times",
    "ru": "во время занятий"
  },
  {
    "id": 1905,
    "question": "järkevältä",
    "answer": "reasonable",
    "ru": "разумным"
  },
  {
    "id": 1906,
    "question": "kampanja",
    "answer": "campaign",
    "ru": "кампания"
  },
  {
    "id": 1907,
    "question": "tarjoaa",
    "answer": "offers",
    "ru": "предлагает"
  },
  {
    "id": 1909,
    "question": "alennuksen",
    "answer": "discount",
    "ru": "скидку"
  },
  {
    "id": 1910,
    "question": "uusille",
    "answer": "for new ones",
    "ru": "для новых"
  },
  {
    "id": 1911,
    "question": "jäsenille",
    "answer": "for members",
    "ru": "для членов"
  },
  {
    "id": 1912,
    "question": "rekisteröityvät",
    "answer": "register",
    "ru": "регистрируются"
  },
  {
    "id": 1913,
    "question": "kuussa",
    "answer": "in the month",
    "ru": "в месяце"
  },
  {
    "id": 1914,
    "question": "hyödyntämään",
    "answer": "to utilize",
    "ru": "воспользоваться"
  },
  {
    "id": 1915,
    "question": "maksutiedoista",
    "answer": "payment information",
    "ru": "платёжные данные"
  },
  {
    "id": 1916,
    "question": "rekisteröintiprosessin",
    "answer": "registration process",
    "ru": "процесс регистрации"
  },
  {
    "id": 1917,
    "question": "maksutiedot",
    "answer": "payment information",
    "ru": "платёжные данные"
  },
  {
    "id": 1918,
    "question": "hyväksymme",
    "answer": "we accept",
    "ru": "мы принимаем"
  },
  {
    "id": 1919,
    "question": "verkko",
    "answer": "network",
    "ru": "сеть"
  },
  {
    "id": 1920,
    "question": "henkilökohtaiset",
    "answer": "personal",
    "ru": "личные"
  },
  {
    "id": 1921,
    "question": "maksut",
    "answer": "dues",
    "ru": "платежи"
  },
  {
    "id": 1922,
    "question": "rekisteröintiä",
    "answer": "registration",
    "ru": "регистрация"
  },
  {
    "id": 1923,
    "question": "innoissani",
    "answer": "excited",
    "ru": "в восторге"
  },
  {
    "id": 1924,
    "question": "aloittamisesta",
    "answer": "about getting started",
    "ru": "о начале"
  },
  {
    "id": 1925,
    "question": "ihanaa",
    "answer": "lovely",
    "ru": "замечательно"
  },
  {
    "id": 1926,
    "question": "ohjaan",
    "answer": "i'm directing",
    "ru": "я направляю"
  },
  {
    "id": 1927,
    "question": "ilmoittautumisprosessin",
    "answer": "registration process",
    "ru": "процесс регистрации"
  },
  {
    "id": 1928,
    "question": "pääset",
    "answer": "you can",
    "ru": "ты можешь"
  },
  {
    "id": 1929,
    "question": "jalkapalloluokillemme",
    "answer": "for our football classes",
    "ru": "на наши футбольные занятия"
  },
  {
    "id": 1930,
    "question": "lisää",
    "answer": "more",
    "ru": "больше"
  },
  {
    "id": 1931,
    "question": "kentällä",
    "answer": "in the field",
    "ru": "на поле"
  },
  {
    "id": 1932,
    "question": "lääketieteellistä",
    "answer": "medical",
    "ru": "медицинский"
  },
  {
    "id": 1933,
    "question": "päästään",
    "answer": "let's go",
    "ru": "пойдёмте"
  },
  {
    "id": 1934,
    "question": "kaupungin",
    "answer": "town's",
    "ru": "городской"
  },
  {
    "id": 1935,
    "question": "auttamassa",
    "answer": "helping out",
    "ru": "помогая"
  },
  {
    "id": 1936,
    "question": "pysy",
    "answer": "stay",
    "ru": "оставайся"
  },
  {
    "id": 1937,
    "question": "vamma",
    "answer": "injury",
    "ru": "травма"
  },
  {
    "id": 1938,
    "question": "kaatui",
    "answer": "fell down",
    "ru": "упал"
  },
  {
    "id": 1939,
    "question": "metrossa",
    "answer": "in the subway",
    "ru": "в метро"
  },
  {
    "id": 1940,
    "question": "otti",
    "answer": "took",
    "ru": "взял"
  },
  {
    "id": 1941,
    "question": "jyrkän",
    "answer": "steeply",
    "ru": "круто"
  },
  {
    "id": 1942,
    "question": "käännöksen",
    "answer": "the translation",
    "ru": "поворот"
  },
  {
    "id": 1943,
    "question": "huonossa",
    "answer": "in bad",
    "ru": "в плохом"
  },
  {
    "id": 1944,
    "question": "tarvitsemme",
    "answer": "we need",
    "ru": "нам нужно"
  },
  {
    "id": 1945,
    "question": "osaatko",
    "answer": "can you",
    "ru": "умеешь ли ты"
  },
  {
    "id": 1946,
    "question": "ensiapua",
    "answer": "first aid",
    "ru": "первая помощь"
  },
  {
    "id": 1947,
    "question": "odottaessasi",
    "answer": "while you wait",
    "ru": "пока ты ждёшь"
  },
  {
    "id": 1948,
    "question": "sekaisin",
    "answer": "tumbled",
    "ru": "перепутан"
  },
  {
    "id": 1949,
    "question": "painamme",
    "answer": "we press",
    "ru": "мы давим"
  },
  {
    "id": 1950,
    "question": "haavaa",
    "answer": "wound",
    "ru": "рану"
  },
  {
    "id": 1951,
    "question": "verenvuoto",
    "answer": "haemorrhage",
    "ru": "кровотечение"
  },
  {
    "id": 1952,
    "question": "kovaa",
    "answer": "hard",
    "ru": "сильно"
  },
  {
    "id": 1953,
    "question": "tultava",
    "answer": "to come",
    "ru": "прийти"
  },
  {
    "id": 1954,
    "question": "pysyttävä",
    "answer": "to stay",
    "ru": "оставаться"
  },
  {
    "id": 1955,
    "question": "linjassa",
    "answer": "down the line",
    "ru": "в линию"
  },
  {
    "id": 1956,
    "question": "hengittääkö",
    "answer": "is he breathing?",
    "ru": "он дышит?"
  },
  {
    "id": 1957,
    "question": "normaalisti",
    "answer": "normally",
    "ru": "нормально"
  },
  {
    "id": 1958,
    "question": "hengittää",
    "answer": "breathe",
    "ru": "дышать"
  },
  {
    "id": 1959,
    "question": "korosta",
    "answer": "highlight",
    "ru": "выдели"
  },
  {
    "id": 1960,
    "question": "välittänyt",
    "answer": "cared about",
    "ru": "заботился о"
  },
  {
    "id": 1961,
    "question": "hätätilanteen",
    "answer": "emergency",
    "ru": "чрезвычайная ситуация"
  },
  {
    "id": 1962,
    "question": "ambulanssille",
    "answer": "to the ambulance",
    "ru": "скорой помощи"
  },
  {
    "id": 1963,
    "question": "rauhoita",
    "answer": "calm down",
    "ru": "успокойся"
  },
  {
    "id": 1964,
    "question": "yritä",
    "answer": "try",
    "ru": "попробуй"
  },
  {
    "id": 1965,
    "question": "okei",
    "answer": "okay",
    "ru": "хорошо"
  },
  {
    "id": 1966,
    "question": "parhaamme",
    "answer": "our best",
    "ru": "наше лучшее"
  },
  {
    "id": 1967,
    "question": "kauanko",
    "answer": "how long",
    "ru": "как долго"
  },
  {
    "id": 1968,
    "question": "saapumiseen",
    "answer": "arrival",
    "ru": "прибытие"
  },
  {
    "id": 1969,
    "question": "minuuttien",
    "answer": "of minutes",
    "ru": "минут"
  },
  {
    "id": 1970,
    "question": "tilastaan",
    "answer": "from its state",
    "ru": "из своего состояния"
  },
  {
    "id": 1971,
    "question": "muuta",
    "answer": "change",
    "ru": "изменить"
  },
  {
    "id": 1972,
    "question": "minä",
    "answer": "i",
    "ru": "я"
  },
  {
    "id": 1973,
    "question": "pyydä",
    "answer": "ask",
    "ru": "попроси"
  },
  {
    "id": 1974,
    "question": "ambulanssia",
    "answer": "an ambulance",
    "ru": "скорую помощь"
  },
  {
    "id": 1975,
    "question": "kiirehtimään",
    "answer": "to hurry up",
    "ru": "поторопиться"
  },
  {
    "id": 1976,
    "question": "heikkenee",
    "answer": "weakens",
    "ru": "ухудшается"
  },
  {
    "id": 1977,
    "question": "ilmoittanut",
    "answer": "announced",
    "ru": "сообщил"
  },
  {
    "id": 1978,
    "question": "tilansa",
    "answer": "its state",
    "ru": "своё состояние"
  },
  {
    "id": 1979,
    "question": "huononee",
    "answer": "gets worse",
    "ru": "ухудшается"
  },
  {
    "id": 1980,
    "question": "ilmoita",
    "answer": "announce",
    "ru": "сообщи"
  },
  {
    "id": 1981,
    "question": "välittömästi",
    "answer": "direct",
    "ru": "немедленно"
  },
  {
    "id": 1982,
    "question": "tavoittaakseen",
    "answer": "to reach",
    "ru": "чтобы достичь"
  },
  {
    "id": 1983,
    "question": "jäämme",
    "answer": "we stay",
    "ru": "мы остаёмся"
  },
  {
    "id": 1984,
    "question": "odottamaan",
    "answer": "to wait",
    "ru": "ждать"
  },
  {
    "id": 1985,
    "question": "jokin",
    "answer": "one",
    "ru": "что-то"
  },
  {
    "id": 1986,
    "question": "muuttuu",
    "answer": "changes",
    "ru": "меняется"
  },
  {
    "id": 1987,
    "question": "älä",
    "answer": "area",
    "ru": "не"
  },
  {
    "id": 1988,
    "question": "epäröi",
    "answer": "hesitate",
    "ru": "колебайся"
  },
  {
    "id": 1989,
    "question": "pysykää",
    "answer": "stay",
    "ru": "оставайтесь"
  },
  {
    "id": 1990,
    "question": "linjalla",
    "answer": "on the line",
    "ru": "на линии"
  },
  {
    "id": 1991,
    "question": "kunnes",
    "answer": "until",
    "ru": "пока"
  },
  {
    "id": 1992,
    "question": "saapuvat",
    "answer": "in tray",
    "ru": "входящие"
  },
  {
    "id": 1993,
    "question": "vuokraamisesta",
    "answer": "about renting",
    "ru": "об аренде"
  },
  {
    "id": 1994,
    "question": "yksikkö",
    "answer": "unit",
    "ru": "единица"
  },
  {
    "id": 1995,
    "question": "sepä",
    "answer": "blacksmith",
    "ru": "кузнец"
  },
  {
    "id": 1996,
    "question": "haluaisit",
    "answer": "you would like",
    "ru": "ты бы хотел"
  },
  {
    "id": 1997,
    "question": "etsin",
    "answer": "i am looking for",
    "ru": "я ищу"
  },
  {
    "id": 1998,
    "question": "paikkaa",
    "answer": "place",
    "ru": "место"
  },
  {
    "id": 1999,
    "question": "sauna",
    "answer": "sauna",
    "ru": "сауна"
  },
  {
    "id": 2000,
    "question": "löytyykö",
    "answer": "can be found",
    "ru": "можно найти"
  },
  {
    "id": 2001,
    "question": "laitteesta",
    "answer": "from the device",
    "ru": "из устройства"
  },
  {
    "id": 2002,
    "question": "valitettavasti",
    "answer": "unfortunately",
    "ru": "к сожалению"
  },
  {
    "id": 2003,
    "question": "saunaa",
    "answer": "sauna",
    "ru": "сауну"
  },
  {
    "id": 2004,
    "question": "kiinnostaisiko",
    "answer": "would you be interested",
    "ru": "вас интересовало бы"
  },
  {
    "id": 2005,
    "question": "parkkitilaa",
    "answer": "parking space",
    "ru": "парковочное место"
  },
  {
    "id": 2006,
    "question": "pysäköintipaikat",
    "answer": "parking spaces",
    "ru": "парковочные места"
  },
  {
    "id": 2007,
    "question": "riittääkö",
    "answer": "is that enough?",
    "ru": "этого достаточно?"
  },
  {
    "id": 2008,
    "question": "jatkamme",
    "answer": "we continue",
    "ru": "мы продолжаем"
  },
  {
    "id": 2009,
    "question": "kouluista",
    "answer": "from schools",
    "ru": "из школ"
  },
  {
    "id": 2010,
    "question": "ostoskeskuksista",
    "answer": "shopping malls",
    "ru": "торговые центры"
  },
  {
    "id": 2011,
    "question": "muutaman",
    "answer": "a few",
    "ru": "нескольких"
  },
  {
    "id": 2012,
    "question": "korttelin",
    "answer": "the block",
    "ru": "квартал"
  },
  {
    "id": 2013,
    "question": "koulu",
    "answer": "school",
    "ru": "школа"
  },
  {
    "id": 2014,
    "question": "ostoskeskus",
    "answer": "shopping center",
    "ru": "торговый центр"
  },
  {
    "id": 2015,
    "question": "kävelymatkan",
    "answer": "walk",
    "ru": "прогулка"
  },
  {
    "id": 2016,
    "question": "pitäisikö",
    "answer": "should",
    "ru": "следует ли"
  },
  {
    "id": 2017,
    "question": "erinomaista",
    "answer": "excellent",
    "ru": "отлично"
  },
  {
    "id": 2018,
    "question": "puhutaan",
    "answer": "let's talk",
    "ru": "давайте поговорим"
  },
  {
    "id": 2019,
    "question": "laitteen",
    "answer": "device",
    "ru": "устройство"
  },
  {
    "id": 2020,
    "question": "kuukausihinta",
    "answer": "monthly price",
    "ru": "ежемесячная цена"
  },
  {
    "id": 2021,
    "question": "kuukausivuokra",
    "answer": "monthly rent",
    "ru": "ежемесячная арендная плата"
  },
  {
    "id": 2022,
    "question": "sopiiko",
    "answer": "is it okay?",
    "ru": "это подходит?"
  },
  {
    "id": 2023,
    "question": "budjettiisi",
    "answer": "to your budget",
    "ru": "к твоему бюджету"
  },
  {
    "id": 2024,
    "question": "vuokrausagentti",
    "answer": "rental agent",
    "ru": "агент по аренде"
  },
  {
    "id": 2025,
    "question": "ajankohtaisia",
    "answer": "topical",
    "ru": "актуальные"
  },
  {
    "id": 2026,
    "question": "kai",
    "answer": "probably",
    "ru": "наверное"
  },
  {
    "id": 2027,
    "question": "alennettua",
    "answer": "discounted",
    "ru": "со скидкой"
  },
  {
    "id": 2028,
    "question": "korkoa",
    "answer": "interest rate",
    "ru": "процентная ставка"
  },
  {
    "id": 2029,
    "question": "järkevämpää",
    "answer": "more reasonable",
    "ru": "более разумным"
  },
  {
    "id": 2030,
    "question": "mennään",
    "answer": "let's go",
    "ru": "пойдём"
  },
  {
    "id": 2031,
    "question": "eteenpäin",
    "answer": "ahead",
    "ru": "вперёд"
  },
  {
    "id": 2032,
    "question": "ehdoista",
    "answer": "of the conditions",
    "ru": "об условиях"
  },
  {
    "id": 2033,
    "question": "lähetän",
    "answer": "i will send",
    "ru": "я отправлю"
  },
  {
    "id": 2034,
    "question": "sähköpostitse",
    "answer": "by e-mail",
    "ru": "по электронной почте"
  },
  {
    "id": 2035,
    "question": "allekirjoittamaan",
    "answer": "to sign",
    "ru": "подписать"
  },
  {
    "id": 2036,
    "question": "suunnitelmalta",
    "answer": "from the plan",
    "ru": "от плана"
  },
  {
    "id": 2037,
    "question": "tarkistan",
    "answer": "i'll check",
    "ru": "я проверю"
  },
  {
    "id": 2038,
    "question": "palaan",
    "answer": "i'll be back",
    "ru": "я вернусь"
  },
  {
    "id": 2039,
    "question": "ota",
    "answer": "take it",
    "ru": "возьми"
  },
  {
    "id": 2040,
    "question": "saavamme",
    "answer": "we get",
    "ru": "мы получим"
  },
  {
    "id": 2041,
    "question": "asukkaaksi",
    "answer": "as a resident",
    "ru": "в качестве жильца"
  },
  {
    "id": 2042,
    "question": "voimakasta",
    "answer": "powerful",
    "ru": "сильную"
  },
  {
    "id": 2043,
    "question": "rintakipua",
    "answer": "chest pain",
    "ru": "боль в груди"
  },
  {
    "id": 2044,
    "question": "asun",
    "answer": "i live",
    "ru": "я живу"
  },
  {
    "id": 2045,
    "question": "minäkin",
    "answer": "me too",
    "ru": "я тоже"
  },
  {
    "id": 2046,
    "question": "kaaduin",
    "answer": "i fell",
    "ru": "я упал"
  },
  {
    "id": 2047,
    "question": "jalkani",
    "answer": "my leg",
    "ru": "моя нога"
  },
  {
    "id": 2048,
    "question": "ambulanssi",
    "answer": "ambulance",
    "ru": "скорая помощь"
  },
  {
    "id": 2049,
    "question": "illalliselle",
    "answer": "for dinner",
    "ru": "на ужин"
  },
  {
    "id": 2050,
    "question": "kolmelle",
    "answer": "for three",
    "ru": "на троих"
  },
  {
    "id": 2051,
    "question": "tälle",
    "answer": "for this",
    "ru": "для этого"
  },
  {
    "id": 2052,
    "question": "viikonlopulle",
    "answer": "for the weekend",
    "ru": "на выходные"
  },
  {
    "id": 2053,
    "question": "vapaata",
    "answer": "off",
    "ru": "выходной"
  },
  {
    "id": 2054,
    "question": "perjantaina",
    "answer": "on friday",
    "ru": "в пятницу"
  },
  {
    "id": 2055,
    "question": "ravintola",
    "answer": "restaurant",
    "ru": "ресторан"
  },
  {
    "id": 2056,
    "question": "sulkeutuu",
    "answer": "closes",
    "ru": "закрывается"
  },
  {
    "id": 2057,
    "question": "päivällisen",
    "answer": "dinner",
    "ru": "ужин"
  },
  {
    "id": 2058,
    "question": "maksaisi",
    "answer": "would pay",
    "ru": "заплатило бы"
  },
  {
    "id": 2059,
    "question": "sähkösopimusta",
    "answer": "electricity contract",
    "ru": "договор на электроснабжение"
  },
  {
    "id": 2060,
    "question": "sopimusvaihtoehdoista",
    "answer": "contract options",
    "ru": "варианты договора"
  },
  {
    "id": 2061,
    "question": "ehdot",
    "answer": "terms",
    "ru": "условия"
  },
  {
    "id": 2062,
    "question": "lisäksihaluaisin",
    "answer": "in addition, i would like to",
    "ru": "кроме того, я бы хотел"
  },
  {
    "id": 2063,
    "question": "menettelyn",
    "answer": "procedure",
    "ru": "процедуру"
  },
  {
    "id": 2064,
    "question": "aloittamiseksi",
    "answer": "to start",
    "ru": "для начала"
  },
  {
    "id": 2065,
    "question": "äskettäin",
    "answer": "recently",
    "ru": "недавно"
  },
  {
    "id": 2066,
    "question": "tehdystä",
    "answer": "of what has been done",
    "ru": "о сделанном"
  },
  {
    "id": 2067,
    "question": "remontista",
    "answer": "renovation",
    "ru": "ремонт"
  },
  {
    "id": 2068,
    "question": "keittiön",
    "answer": "the kitchen",
    "ru": "кухни"
  },
  {
    "id": 2069,
    "question": "suunnittelussa",
    "answer": "in planning",
    "ru": "при планировании"
  },
  {
    "id": 2070,
    "question": "lopputulokseen",
    "answer": "to the end result",
    "ru": "к конечному результату"
  },
  {
    "id": 2071,
    "question": "keittiössä",
    "answer": "in the kitchen",
    "ru": "на кухне"
  },
  {
    "id": 2072,
    "question": "vastanneet",
    "answer": "answered",
    "ru": "ответили"
  },
  {
    "id": 2073,
    "question": "odotuksiani",
    "answer": "my expectations",
    "ru": "моим ожиданиям"
  },
  {
    "id": 2074,
    "question": "parantamisen",
    "answer": "healing",
    "ru": "улучшение"
  },
  {
    "id": 2075,
    "question": "varaa",
    "answer": "reserve",
    "ru": "зарезервируй"
  },
  {
    "id": 2076,
    "question": "ratkaista",
    "answer": "solve",
    "ru": "решить"
  },
  {
    "id": 2077,
    "question": "huolenaiheet",
    "answer": "concerns",
    "ru": "опасения"
  },
  {
    "id": 2078,
    "question": "ratkaisemisessa",
    "answer": "in solving",
    "ru": "при решении"
  },
  {
    "id": 2079,
    "question": "pahoillani",
    "answer": "i'm sorry",
    "ru": "мне жаль"
  },
  {
    "id": 2080,
    "question": "syntymäpäiväjuhlillesi",
    "answer": "for your birthday party",
    "ru": "на твой день рождения"
  },
  {
    "id": 2081,
    "question": "vasta",
    "answer": "only",
    "ru": "только"
  },
  {
    "id": 2082,
    "question": "perhesitoumus",
    "answer": "family commitment",
    "ru": "семейное обязательство"
  },
  {
    "id": 2083,
    "question": "jättää",
    "answer": "leave",
    "ru": "оставить"
  },
  {
    "id": 2084,
    "question": "väliin",
    "answer": "between",
    "ru": "между"
  },
  {
    "id": 2085,
    "question": "teen",
    "answer": "i do",
    "ru": "я делаю"
  },
  {
    "id": 2086,
    "question": "parhaani",
    "answer": "my best",
    "ru": "моё лучшее"
  },
  {
    "id": 2087,
    "question": "päästäkseni",
    "answer": "to get to",
    "ru": "чтобы добраться"
  },
  {
    "id": 2088,
    "question": "anteeksi",
    "answer": "sorry",
    "ru": "извини"
  },
  {
    "id": 2089,
    "question": "myöhästymistäni",
    "answer": "my lateness",
    "ru": "моё опоздание"
  },
  {
    "id": 2090,
    "question": "jatkuva",
    "answer": "continuous",
    "ru": "постоянная"
  },
  {
    "id": 2091,
    "question": "päänsärky",
    "answer": "headache",
    "ru": "головная боль"
  },
  {
    "id": 2092,
    "question": "päivän",
    "answer": "of the day",
    "ru": "дня"
  },
  {
    "id": 2093,
    "question": "mietin",
    "answer": "i think",
    "ru": "я думаю"
  },
  {
    "id": 2094,
    "question": "suositella",
    "answer": "recommend",
    "ru": "рекомендовать"
  },
  {
    "id": 2095,
    "question": "auttaisivat",
    "answer": "would help",
    "ru": "помогли бы"
  },
  {
    "id": 2096,
    "question": "lievittämään",
    "answer": "to alleviate",
    "ru": "облегчить"
  },
  {
    "id": 2097,
    "question": "kipua",
    "answer": "pain",
    "ru": "боль"
  },
  {
    "id": 2098,
    "question": "melko",
    "answer": "quite",
    "ru": "довольно"
  },
  {
    "id": 2099,
    "question": "rasittavaa",
    "answer": "annoying",
    "ru": "раздражающее"
  },
  {
    "id": 2100,
    "question": "olisin",
    "answer": "i would be",
    "ru": "я был бы"
  },
  {
    "id": 2101,
    "question": "kiitollinen",
    "answer": "grateful",
    "ru": "благодарен"
  },
  {
    "id": 2102,
    "question": "kaikesta",
    "answer": "of everything",
    "ru": "за всё"
  },
  {
    "id": 2103,
    "question": "avusta",
    "answer": "for help",
    "ru": "за помощь"
  },
  {
    "id": 2104,
    "question": "voisitte",
    "answer": "you could",
    "ru": "вы могли бы"
  },
  {
    "id": 2105,
    "question": "setästä",
    "answer": "from uncle",
    "ru": "от дяди"
  },
  {
    "id": 2106,
    "question": "vaadittavasta",
    "answer": "required",
    "ru": "требуемый"
  },
  {
    "id": 2107,
    "question": "alkutakuusta",
    "answer": "from the initial guarantee",
    "ru": "от первоначального залога"
  },
  {
    "id": 2108,
    "question": "asunto",
    "answer": "housing",
    "ru": "жильё"
  },
  {
    "id": 2109,
    "question": "muuttoa",
    "answer": "moving",
    "ru": "переезд"
  },
  {
    "id": 2110,
    "question": "vuokraautojen",
    "answer": "rental cars",
    "ru": "прокатных автомобилей"
  },
  {
    "id": 2111,
    "question": "saatavuutta",
    "answer": "availability",
    "ru": "наличие"
  },
  {
    "id": 2112,
    "question": "paikkaisia",
    "answer": "local",
    "ru": "местные"
  },
  {
    "id": 2113,
    "question": "autoja",
    "answer": "cars",
    "ru": "автомобили"
  },
  {
    "id": 2114,
    "question": "viikoksi",
    "answer": "for a week",
    "ru": "на неделю"
  },
  {
    "id": 2115,
    "question": "suunnittelen",
    "answer": "i'm planning",
    "ru": "я планирую"
  },
  {
    "id": 2116,
    "question": "lomaa",
    "answer": "vacation",
    "ru": "отпуск"
  },
  {
    "id": 2117,
    "question": "perheeni",
    "answer": "my family",
    "ru": "моя семья"
  },
  {
    "id": 2118,
    "question": "ensi",
    "answer": "next",
    "ru": "следующий"
  },
  {
    "id": 2119,
    "question": "viikolla",
    "answer": "during the week",
    "ru": "на этой неделе"
  },
  {
    "id": 2120,
    "question": "junaaikataulut",
    "answer": "train timetables",
    "ru": "расписание поездов"
  },
  {
    "id": 2121,
    "question": "junista",
    "answer": "about trains",
    "ru": "о поездах"
  },
  {
    "id": 2122,
    "question": "lähtöajoista",
    "answer": "departure times",
    "ru": "времена отправления"
  },
  {
    "id": 2123,
    "question": "harkitsen",
    "answer": "i'm considering",
    "ru": "я рассматриваю"
  },
  {
    "id": 2124,
    "question": "matkustamista",
    "answer": "travelling",
    "ru": "путешествие"
  },
  {
    "id": 2125,
    "question": "espanjaan",
    "answer": "to spain",
    "ru": "в Испанию"
  },
  {
    "id": 2126,
    "question": "joko",
    "answer": "either",
    "ru": "либо"
  },
  {
    "id": 2127,
    "question": "maanantaina",
    "answer": "on monday",
    "ru": "в понедельник"
  },
  {
    "id": 2128,
    "question": "tiistaina",
    "answer": "on tuesday",
    "ru": "во вторник"
  },
  {
    "id": 2129,
    "question": "oho",
    "answer": "oops",
    "ru": "ой"
  },
  {
    "id": 2130,
    "question": "tosi",
    "answer": true,
    "ru": "правда"
  },
  {
    "id": 2131,
    "question": "kiva",
    "answer": "nice",
    "ru": "приятно"
  },
  {
    "id": 2132,
    "question": "aurinkoisia",
    "answer": "sunny",
    "ru": "солнечные"
  },
  {
    "id": 2133,
    "question": "päiviä",
    "answer": "days",
    "ru": "дни"
  },
  {
    "id": 2134,
    "question": "lempeällä",
    "answer": "gently",
    "ru": "мягко"
  },
  {
    "id": 2135,
    "question": "tuulella",
    "answer": "in the mood",
    "ru": "в настроении"
  },
  {
    "id": 2136,
    "question": "kävelyyn",
    "answer": "for a walk",
    "ru": "для прогулки"
  },
  {
    "id": 2137,
    "question": "nauttimiseen",
    "answer": "for enjoyment",
    "ru": "для удовольствия"
  },
  {
    "id": 2138,
    "question": "millainen",
    "answer": "what kind",
    "ru": "какой"
  },
  {
    "id": 2139,
    "question": "sujunut",
    "answer": "went well",
    "ru": "прошло хорошо"
  },
  {
    "id": 2140,
    "question": "ongelma",
    "answer": "problem",
    "ru": "проблема"
  },
  {
    "id": 2141,
    "question": "ostamieni",
    "answer": "my purchases",
    "ru": "мои покупки"
  },
  {
    "id": 2142,
    "question": "kananuggettien",
    "answer": "chicken nuggets",
    "ru": "куриных наггетсов"
  },
  {
    "id": 2143,
    "question": "myymäläpäällikkö",
    "answer": "store manager",
    "ru": "менеджер магазина"
  },
  {
    "id": 2144,
    "question": "jostakin",
    "answer": "from somewhere",
    "ru": "откуда-то"
  },
  {
    "id": 2145,
    "question": "pahasta",
    "answer": "from evil",
    "ru": "из плохого"
  },
  {
    "id": 2146,
    "question": "ostin",
    "answer": "i bought",
    "ru": "я купил"
  },
  {
    "id": 2147,
    "question": "myymälästäsi",
    "answer": "from your store",
    "ru": "из твоего магазина"
  },
  {
    "id": 2148,
    "question": "kananuggetteja",
    "answer": "chicken nuggets",
    "ru": "куриные наггетсы"
  },
  {
    "id": 2149,
    "question": "keitin",
    "answer": "stove",
    "ru": "плита"
  },
  {
    "id": 2150,
    "question": "illalliseksi",
    "answer": "for dinner",
    "ru": "на ужин"
  },
  {
    "id": 2151,
    "question": "tuoksu",
    "answer": "scent",
    "ru": "запах"
  },
  {
    "id": 2152,
    "question": "oikein",
    "answer": "properly",
    "ru": "правильно"
  },
  {
    "id": 2153,
    "question": "tuntuivat",
    "answer": "felt",
    "ru": "казались"
  },
  {
    "id": 2154,
    "question": "oudolta",
    "answer": "strangely",
    "ru": "странно"
  },
  {
    "id": 2155,
    "question": "katsoin",
    "answer": "i looked",
    "ru": "я посмотрел"
  },
  {
    "id": 2156,
    "question": "osat",
    "answer": "assemblies",
    "ru": "части"
  },
  {
    "id": 2157,
    "question": "vieläkään",
    "answer": "even now",
    "ru": "до сих пор"
  },
  {
    "id": 2158,
    "question": "kypsennettyjä",
    "answer": "cooked",
    "ru": "приготовленные"
  },
  {
    "id": 2159,
    "question": "noudatin",
    "answer": "i complied",
    "ru": "я следовал"
  },
  {
    "id": 2160,
    "question": "surulliseksi",
    "answer": "to be sad",
    "ru": "расстроиться"
  },
  {
    "id": 2161,
    "question": "huolestumaan",
    "answer": "to worry",
    "ru": "беспокоиться"
  },
  {
    "id": 2162,
    "question": "sairaaksi",
    "answer": "sick",
    "ru": "больной"
  },
  {
    "id": 2163,
    "question": "syömättä",
    "answer": "without eating",
    "ru": "не поев"
  },
  {
    "id": 2164,
    "question": "kypsennettyä",
    "answer": "cooked",
    "ru": "приготовленный"
  },
  {
    "id": 2165,
    "question": "rahani",
    "answer": "my money",
    "ru": "мои деньги"
  },
  {
    "id": 2166,
    "question": "huonoista",
    "answer": "bad ones",
    "ru": "плохие"
  },
  {
    "id": 2167,
    "question": "kananuggeteista",
    "answer": "of chicken nuggets",
    "ru": "куриных наггетсов"
  },
  {
    "id": 2168,
    "question": "asialle",
    "answer": "for that matter",
    "ru": "по этому поводу"
  },
  {
    "id": 2169,
    "question": "luottamaan",
    "answer": "to trust",
    "ru": "доверять"
  },
  {
    "id": 2170,
    "question": "jälleen",
    "answer": "again",
    "ru": "снова"
  },
  {
    "id": 2171,
    "question": "kauppaasi",
    "answer": "to your shop",
    "ru": "в твой магазин"
  },
  {
    "id": 2172,
    "question": "täytyy",
    "answer": "must",
    "ru": "нужно"
  },
  {
    "id": 2173,
    "question": "kylpyhuoneesta",
    "answer": "from the bathroom",
    "ru": "из ванной комнаты"
  },
  {
    "id": 2174,
    "question": "hanat",
    "answer": "faucets",
    "ru": "краны"
  },
  {
    "id": 2175,
    "question": "vuotavat",
    "answer": "are leaking",
    "ru": "текут"
  },
  {
    "id": 2176,
    "question": "laatat",
    "answer": "tiles",
    "ru": "плитка"
  },
  {
    "id": 2177,
    "question": "rikki",
    "answer": "sulfur",
    "ru": "сломана"
  },
  {
    "id": 2178,
    "question": "hometta",
    "answer": "mold",
    "ru": "плесень"
  },
  {
    "id": 2179,
    "question": "pahaa",
    "answer": "bad",
    "ru": "плохой"
  },
  {
    "id": 2180,
    "question": "hajua",
    "answer": "smell",
    "ru": "запах"
  },
  {
    "id": 2181,
    "question": "voiko",
    "answer": "can you",
    "ru": "можно ли"
  },
  {
    "id": 2182,
    "question": "rakennusyhtiö",
    "answer": "construction company",
    "ru": "строительная компания"
  },
  {
    "id": 2183,
    "question": "lopettaa",
    "answer": "stop",
    "ru": "прекратить"
  },
  {
    "id": 2184,
    "question": "ongelmat",
    "answer": "ills",
    "ru": "проблемы"
  },
  {
    "id": 2185,
    "question": "asunnosta",
    "answer": "from the apartment",
    "ru": "из квартиры"
  },
  {
    "id": 2186,
    "question": "parempi",
    "answer": "better",
    "ru": "лучше"
  },
  {
    "id": 2187,
    "question": "työ",
    "answer": "job",
    "ru": "работа"
  },
  {
    "id": 2188,
    "question": "päättyy",
    "answer": "ends",
    "ru": "заканчивается"
  },
  {
    "id": 2189,
    "question": "numeroon",
    "answer": "to the number",
    "ru": "на номер"
  },
  {
    "id": 2190,
    "question": "lähettää",
    "answer": "send",
    "ru": "отправить"
  },
  {
    "id": 2191,
    "question": "sähköpostia",
    "answer": "e-mail",
    "ru": "электронное письмо"
  },
  {
    "id": 2192,
    "question": "osoitteeseen",
    "answer": "to the address",
    "ru": "по адресу"
  },
  {
    "id": 2193,
    "question": "example@emailcom",
    "answer": "example@emailcom",
    "ru": "example@emailcom"
  },
  {
    "id": 2194,
    "question": "junan",
    "answer": "the train",
    "ru": "поезда"
  },
  {
    "id": 2195,
    "question": "myöhästymistä",
    "answer": "being late",
    "ru": "опоздание"
  },
  {
    "id": 2196,
    "question": "koskeva",
    "answer": "relative to",
    "ru": "относительно"
  },
  {
    "id": 2197,
    "question": "koskettaa",
    "answer": "touch",
    "ru": "касаться"
  },
  {
    "id": 2198,
    "question": "syvän",
    "answer": "deep",
    "ru": "глубокого"
  },
  {
    "id": 2199,
    "question": "turhautumiseni",
    "answer": "my frustration",
    "ru": "моё разочарование"
  },
  {
    "id": 2200,
    "question": "junamatkani",
    "answer": "my train journey",
    "ru": "моя поездка на поезде"
  },
  {
    "id": 2201,
    "question": "vrn",
    "answer": "vrn",
    "ru": "VRN"
  },
  {
    "id": 2202,
    "question": "merkittävästä",
    "answer": "significant",
    "ru": "значительного"
  },
  {
    "id": 2203,
    "question": "viivästymisestä",
    "answer": "of the delay",
    "ru": "задержки"
  },
  {
    "id": 2204,
    "question": "juna",
    "answer": "train",
    "ru": "поезд"
  },
  {
    "id": 2205,
    "question": "johon",
    "answer": "to which",
    "ru": "на который"
  },
  {
    "id": 2206,
    "question": "nousin",
    "answer": "i got up",
    "ru": "я сел"
  },
  {
    "id": 2207,
    "question": "päivämäärä",
    "answer": "date",
    "ru": "дата"
  },
  {
    "id": 2208,
    "question": "määränpäähäni",
    "answer": "to my destination",
    "ru": "к моему пункту назначения"
  },
  {
    "id": 2209,
    "question": "minuuttia",
    "answer": "minutes",
    "ru": "минут"
  },
  {
    "id": 2210,
    "question": "aikataulusta",
    "answer": "from the schedule",
    "ru": "от расписания"
  },
  {
    "id": 2211,
    "question": "myöhässä",
    "answer": "late",
    "ru": "опоздал"
  },
  {
    "id": 2212,
    "question": "myöhästymisen",
    "answer": "being late",
    "ru": "опоздание"
  },
  {
    "id": 2213,
    "question": "tärkeästä",
    "answer": "important",
    "ru": "важного"
  },
  {
    "id": 2214,
    "question": "kokouksesta",
    "answer": "from the meeting",
    "ru": "с совещания"
  },
  {
    "id": 2215,
    "question": "viivästys",
    "answer": "lag",
    "ru": "задержка"
  },
  {
    "id": 2216,
    "question": "vaikutti",
    "answer": "affected",
    "ru": "повлияло"
  },
  {
    "id": 2217,
    "question": "merkittävästi",
    "answer": "significantly",
    "ru": "значительно"
  },
  {
    "id": 2218,
    "question": "ammatillisiin",
    "answer": "professional",
    "ru": "профессиональных"
  },
  {
    "id": 2219,
    "question": "sitoumuksiini",
    "answer": "to my commitments",
    "ru": "к моим обязательствам"
  },
  {
    "id": 2220,
    "question": "seurauksena",
    "answer": "as a result",
    "ru": "в результате"
  },
  {
    "id": 2221,
    "question": "menetetyt",
    "answer": "the lost ones",
    "ru": "потерянные"
  },
  {
    "id": 2222,
    "question": "seuraukset",
    "answer": "consequences",
    "ru": "последствия"
  },
  {
    "id": 2223,
    "question": "aiheutti",
    "answer": "caused",
    "ru": "причинило"
  },
  {
    "id": 2224,
    "question": "stressiä",
    "answer": "stress",
    "ru": "стресс"
  },
  {
    "id": 2225,
    "question": "häiritsevät",
    "answer": "disturbing",
    "ru": "мешающие"
  },
  {
    "id": 2226,
    "question": "suunniteltuani",
    "answer": "as planned",
    "ru": "как запланировано"
  },
  {
    "id": 2227,
    "question": "päiväohjelmaani",
    "answer": "my daily schedule",
    "ru": "мой распорядок дня"
  },
  {
    "id": 2228,
    "question": "kehotan",
    "answer": "i urge",
    "ru": "я призываю"
  },
  {
    "id": 2229,
    "question": "vrtä",
    "answer": "vr",
    "ru": "VR"
  },
  {
    "id": 2230,
    "question": "ryhtymään",
    "answer": "to undertake",
    "ru": "предпринять"
  },
  {
    "id": 2231,
    "question": "välittömiin",
    "answer": "to the immediate ones",
    "ru": "к немедленным"
  },
  {
    "id": 2232,
    "question": "junaliikenteen",
    "answer": "train traffic",
    "ru": "железнодорожное движение"
  },
  {
    "id": 2233,
    "question": "täsmällisyyden",
    "answer": "punctuality",
    "ru": "пунктуальность"
  },
  {
    "id": 2234,
    "question": "tällaisia",
    "answer": "like these",
    "ru": "подобные"
  },
  {
    "id": 2235,
    "question": "merkittäviä",
    "answer": "significant",
    "ru": "значительные"
  },
  {
    "id": 2236,
    "question": "viivästyksiä",
    "answer": "delays",
    "ru": "задержки"
  },
  {
    "id": 2237,
    "question": "tapahdu",
    "answer": "happen",
    "ru": "происходить"
  },
  {
    "id": 2238,
    "question": "jatkossa",
    "answer": "in the future",
    "ru": "в будущем"
  },
  {
    "id": 2239,
    "question": "parempien",
    "answer": "better ones",
    "ru": "лучших"
  },
  {
    "id": 2240,
    "question": "ylläpitokäytäntöjen",
    "answer": "maintenance practices",
    "ru": "практики технического обслуживания"
  },
  {
    "id": 2241,
    "question": "tehokkaampien",
    "answer": "more efficient",
    "ru": "более эффективных"
  },
  {
    "id": 2242,
    "question": "aikatauluprotokollien",
    "answer": "of scheduling protocols",
    "ru": "протоколов расписания"
  },
  {
    "id": 2243,
    "question": "noudattaminen",
    "answer": "compliance",
    "ru": "соблюдение"
  },
  {
    "id": 2244,
    "question": "vähentämään",
    "answer": "to reduce",
    "ru": "сократить"
  },
  {
    "id": 2245,
    "question": "tällaisten",
    "answer": "of such",
    "ru": "таких"
  },
  {
    "id": 2246,
    "question": "häiriöiden",
    "answer": "disturbances",
    "ru": "сбоев"
  },
  {
    "id": 2247,
    "question": "esiintymistiheyttä",
    "answer": "frequency of occurrence",
    "ru": "частоту возникновения"
  },
  {
    "id": 2248,
    "question": "ylläpitämään",
    "answer": "to maintain",
    "ru": "поддерживать"
  },
  {
    "id": 2249,
    "question": "palvelujesi",
    "answer": "your services",
    "ru": "твоих услуг"
  },
  {
    "id": 2250,
    "question": "luotettavuutta",
    "answer": "reliability",
    "ru": "надёжность"
  },
  {
    "id": 2251,
    "question": "toteutetaan",
    "answer": "will be implemented",
    "ru": "будут реализованы"
  },
  {
    "id": 2252,
    "question": "vastaavien",
    "answer": "of the like",
    "ru": "аналогичных"
  },
  {
    "id": 2253,
    "question": "tapausten",
    "answer": "cases",
    "ru": "случаев"
  },
  {
    "id": 2254,
    "question": "toistumisen",
    "answer": "recurrence",
    "ru": "повторение"
  },
  {
    "id": 2255,
    "question": "estämiseksi",
    "answer": "to prevent",
    "ru": "для предотвращения"
  },
  {
    "id": 2256,
    "question": "katoamisesta",
    "answer": "about disappearing",
    "ru": "об исчезновении"
  },
  {
    "id": 2257,
    "question": "asiakaspalvelu",
    "answer": "customer service",
    "ru": "служба поддержки клиентов"
  },
  {
    "id": 2258,
    "question": "katosivat",
    "answer": "disappeared",
    "ru": "исчезли"
  },
  {
    "id": 2259,
    "question": "lennon",
    "answer": "the flight",
    "ru": "рейс"
  },
  {
    "id": 2260,
    "question": "aikana",
    "answer": "during",
    "ru": "во время"
  },
  {
    "id": 2261,
    "question": "saapuneet",
    "answer": "arrived",
    "ru": "прибывшие"
  },
  {
    "id": 2262,
    "question": "määränpäähän",
    "answer": "to the destination",
    "ru": "к пункту назначения"
  },
  {
    "id": 2263,
    "question": "aiheuttanut",
    "answer": "caused by",
    "ru": "причинённый"
  },
  {
    "id": 2264,
    "question": "paikantamisessa",
    "answer": "in positioning",
    "ru": "при поиске"
  },
  {
    "id": 2265,
    "question": "nopean",
    "answer": "fast",
    "ru": "быстрой"
  },
  {
    "id": 2266,
    "question": "toimituksen",
    "answer": "editorial",
    "ru": "доставки"
  },
  {
    "id": 2267,
    "question": "sisältö",
    "answer": "contents",
    "ru": "содержание"
  },
  {
    "id": 2268,
    "question": "tilaa",
    "answer": "room",
    "ru": "место"
  },
  {
    "id": 2269,
    "question": "koskevista",
    "answer": "concerning",
    "ru": "относительно"
  },
  {
    "id": 2270,
    "question": "päivityksistä",
    "answer": "updates",
    "ru": "обновления"
  },
  {
    "id": 2271,
    "question": "toimittamaan",
    "answer": "to deliver",
    "ru": "доставить"
  },
  {
    "id": 2272,
    "question": "aikataulun",
    "answer": "schedule",
    "ru": "расписание"
  },
  {
    "id": 2273,
    "question": "toimittamiselle",
    "answer": "for delivery",
    "ru": "для доставки"
  },
  {
    "id": 2274,
    "question": "finnair",
    "answer": "finnair",
    "ru": "Finnair"
  },
  {
    "id": 2275,
    "question": "ryhtyy",
    "answer": "undertakes",
    "ru": "предпринимает"
  },
  {
    "id": 2276,
    "question": "ratkaisemiseksi",
    "answer": "to resolve",
    "ru": "для решения"
  },
  {
    "id": 2277,
    "question": "tehokkaasti",
    "answer": "effectively",
    "ru": "эффективно"
  },
  {
    "id": 2278,
    "question": "ravintolakäynnistäni",
    "answer": "from my visit to the restaurant",
    "ru": "от посещения ресторана"
  },
  {
    "id": 2279,
    "question": "manageri",
    "answer": "manager",
    "ru": "менеджер"
  },
  {
    "id": 2280,
    "question": "kokemuksestani",
    "answer": "from my experience",
    "ru": "из моего опыта"
  },
  {
    "id": 2281,
    "question": "ravintolassasi",
    "answer": "in your restaurant",
    "ru": "в твоём ресторане"
  },
  {
    "id": 2282,
    "question": "söin",
    "answer": "i ate",
    "ru": "я ел"
  },
  {
    "id": 2283,
    "question": "eilen",
    "answer": "yesterday",
    "ru": "вчера"
  },
  {
    "id": 2284,
    "question": "ruoastani",
    "answer": "of my food",
    "ru": "о моей еде"
  },
  {
    "id": 2285,
    "question": "hiuksen",
    "answer": "the hair",
    "ru": "волос"
  },
  {
    "id": 2286,
    "question": "karua",
    "answer": "rough",
    "ru": "грубый"
  },
  {
    "id": 2287,
    "question": "tarjoilija",
    "answer": "waiter",
    "ru": "официант"
  },
  {
    "id": 2288,
    "question": "kerroin",
    "answer": "factor",
    "ru": "коэффициент"
  },
  {
    "id": 2289,
    "question": "töykeitä",
    "answer": "rude",
    "ru": "грубые"
  },
  {
    "id": 2290,
    "question": "näyttäneet",
    "answer": "have shown",
    "ru": "показали"
  },
  {
    "id": 2291,
    "question": "välittävän",
    "answer": "caring",
    "ru": "заботливый"
  },
  {
    "id": 2292,
    "question": "varmista",
    "answer": "make sure",
    "ru": "убедись"
  },
  {
    "id": 2293,
    "question": "ravintolasi",
    "answer": "your restaurant",
    "ru": "твой ресторан"
  },
  {
    "id": 2294,
    "question": "puhdas",
    "answer": "clean",
    "ru": "чистый"
  },
  {
    "id": 2295,
    "question": "henkilökuntasi",
    "answer": "your staff",
    "ru": "твой персонал"
  },
  {
    "id": 2296,
    "question": "kohtelias",
    "answer": "polite",
    "ru": "вежливый"
  },
  {
    "id": 2297,
    "question": "asiakkaita",
    "answer": "customers",
    "ru": "клиентов"
  },
  {
    "id": 2298,
    "question": "anteeksipyynnön",
    "answer": "an apology",
    "ru": "извинение"
  },
  {
    "id": 2299,
    "question": "pyykinpesukoneen",
    "answer": "washing machine",
    "ru": "стиральная машина"
  },
  {
    "id": 2300,
    "question": "arvoisa",
    "answer": "honorable",
    "ru": "уважаемый"
  },
  {
    "id": 2301,
    "question": "isännöitsijä",
    "answer": "housing manager",
    "ru": "управляющий домом"
  },
  {
    "id": 2302,
    "question": "ongelmasta",
    "answer": "about the problem",
    "ru": "о проблеме"
  },
  {
    "id": 2303,
    "question": "pesukoneessa",
    "answer": "in the washing machine",
    "ru": "в стиральной машине"
  },
  {
    "id": 2304,
    "question": "koneesta",
    "answer": "from the machine",
    "ru": "из машины"
  },
  {
    "id": 2305,
    "question": "vettä",
    "answer": "water",
    "ru": "вода"
  },
  {
    "id": 2306,
    "question": "suorita",
    "answer": "perform",
    "ru": "выполни"
  },
  {
    "id": 2307,
    "question": "pesujaksoa",
    "answer": "washing cycle",
    "ru": "цикл стирки"
  },
  {
    "id": 2308,
    "question": "kunnolla",
    "answer": "properly",
    "ru": "нормально"
  },
  {
    "id": 2309,
    "question": "huolissani",
    "answer": "worried",
    "ru": "обеспокоен"
  },
  {
    "id": 2310,
    "question": "vesi",
    "answer": "water",
    "ru": "вода"
  },
  {
    "id": 2311,
    "question": "asuntoa",
    "answer": "apartment",
    "ru": "квартиру"
  },
  {
    "id": 2312,
    "question": "kasa",
    "answer": "pile",
    "ru": "куча"
  },
  {
    "id": 2313,
    "question": "pyykkiä",
    "answer": "laundry",
    "ru": "бельё"
  },
  {
    "id": 2314,
    "question": "pestä",
    "answer": "wash",
    "ru": "стирать"
  },
  {
    "id": 2315,
    "question": "korjaamaan",
    "answer": "to fix",
    "ru": "починить"
  },
  {
    "id": 2316,
    "question": "pesukone",
    "answer": "washing machine",
    "ru": "стиральная машина"
  },
  {
    "id": 2317,
    "question": "työskentelevätkö",
    "answer": "do they work",
    "ru": "они работают ли"
  },
  {
    "id": 2318,
    "question": "perustavat",
    "answer": "establish",
    "ru": "основывают"
  },
  {
    "id": 2319,
    "question": "työskentelet",
    "answer": "you work",
    "ru": "ты работаешь"
  },
  {
    "id": 2320,
    "question": "tasaista",
    "answer": "steady",
    "ru": "стабильный"
  },
  {
    "id": 2321,
    "question": "etuja",
    "answer": "benefits",
    "ru": "льготы"
  },
  {
    "id": 2322,
    "question": "sairausvakuutusta",
    "answer": "health insurance",
    "ru": "медицинская страховка"
  },
  {
    "id": 2323,
    "question": "lomaaikaa",
    "answer": "vacation time",
    "ru": "отпускное время"
  },
  {
    "id": 2324,
    "question": "määrittänyt",
    "answer": "determined by",
    "ru": "определённый"
  },
  {
    "id": 2325,
    "question": "työajat",
    "answer": "working hours",
    "ru": "рабочие часы"
  },
  {
    "id": 2326,
    "question": "suunnittelemaan",
    "answer": "to plan",
    "ru": "планировать"
  },
  {
    "id": 2327,
    "question": "päivääsi",
    "answer": "your day",
    "ru": "твой день"
  },
  {
    "id": 2328,
    "question": "perustaminen",
    "answer": "establishment",
    "ru": "основание"
  },
  {
    "id": 2329,
    "question": "jännittävää",
    "answer": "exciting",
    "ru": "захватывающе"
  },
  {
    "id": 2330,
    "question": "päätöksiäsi",
    "answer": "your decisions",
    "ru": "твои решения"
  },
  {
    "id": 2331,
    "question": "oma",
    "answer": "own",
    "ru": "собственный"
  },
  {
    "id": 2332,
    "question": "pomosi",
    "answer": "your boss",
    "ru": "твой начальник"
  },
  {
    "id": 2333,
    "question": "mahdollisuus",
    "answer": "opportunity",
    "ru": "возможность"
  },
  {
    "id": 2334,
    "question": "ansaita",
    "answer": "earn",
    "ru": "зарабатывать"
  },
  {
    "id": 2335,
    "question": "yrityksesi",
    "answer": "your company",
    "ru": "твоя компания"
  },
  {
    "id": 2336,
    "question": "menee",
    "answer": "goes",
    "ru": "идёт"
  },
  {
    "id": 2337,
    "question": "riskialtista",
    "answer": "risky",
    "ru": "рискованно"
  },
  {
    "id": 2338,
    "question": "et",
    "answer": "you don't",
    "ru": "ты не"
  },
  {
    "id": 2339,
    "question": "ansaitse",
    "answer": "earn",
    "ru": "зарабатываешь"
  },
  {
    "id": 2340,
    "question": "aluksi",
    "answer": "at first",
    "ru": "сначала"
  },
  {
    "id": 2341,
    "question": "hoidettava",
    "answer": "to be cared for",
    "ru": "нуждающийся в уходе"
  },
  {
    "id": 2342,
    "question": "parempana",
    "answer": "preferred",
    "ru": "предпочтительный"
  },
  {
    "id": 2343,
    "question": "palkkatyön",
    "answer": "paid work",
    "ru": "наёмная работа"
  },
  {
    "id": 2344,
    "question": "vakautta",
    "answer": "stability",
    "ru": "стабильность"
  },
  {
    "id": 2345,
    "question": "yrittäjyyden",
    "answer": "entrepreneurship",
    "ru": "предпринимательство"
  },
  {
    "id": 2346,
    "question": "vapaudesta",
    "answer": "of freedom",
    "ru": "о свободе"
  },
  {
    "id": 2347,
    "question": "haasteista",
    "answer": "challenges",
    "ru": "трудности"
  },
  {
    "id": 2348,
    "question": "tasaarvoisesti",
    "answer": "equally",
    "ru": "одинаково"
  },
  {
    "id": 2349,
    "question": "oikeudenmukaisesti",
    "answer": "fairly",
    "ru": "справедливо"
  },
  {
    "id": 2350,
    "question": "eteen",
    "answer": "in front of",
    "ru": "перед"
  },
  {
    "id": 2351,
    "question": "esimerkiksi",
    "answer": "for example",
    "ru": "например"
  },
  {
    "id": 2352,
    "question": "ihonvärin",
    "answer": "skin color",
    "ru": "цвет кожи"
  },
  {
    "id": 2353,
    "question": "kulttuurin",
    "answer": "culture",
    "ru": "культура"
  },
  {
    "id": 2354,
    "question": "kotoisuuden",
    "answer": "of origin",
    "ru": "происхождение"
  },
  {
    "id": 2355,
    "question": "elämässä",
    "answer": "in life",
    "ru": "в жизни"
  },
  {
    "id": 2356,
    "question": "samoja",
    "answer": "the same ones",
    "ru": "одни и те же"
  },
  {
    "id": 2357,
    "question": "töitä",
    "answer": "work",
    "ru": "работу"
  },
  {
    "id": 2358,
    "question": "saman",
    "answer": "the same",
    "ru": "одинаковую"
  },
  {
    "id": 2359,
    "question": "palkan",
    "answer": "wage",
    "ru": "зарплату"
  },
  {
    "id": 2360,
    "question": "samasta",
    "answer": "of the same",
    "ru": "за одинаковую"
  },
  {
    "id": 2361,
    "question": "varmistamaan",
    "answer": "to make sure",
    "ru": "удостовериться"
  },
  {
    "id": 2362,
    "question": "vammaisilla",
    "answer": "with disabilities",
    "ru": "с ограниченными возможностями"
  },
  {
    "id": 2363,
    "question": "kouluihin",
    "answer": "to schools",
    "ru": "в школы"
  },
  {
    "id": 2364,
    "question": "rakennuksiin",
    "answer": "to buildings",
    "ru": "в здания"
  },
  {
    "id": 2365,
    "question": "ihmisarvoisesti",
    "answer": "with human dignity",
    "ru": "с человеческим достоинством"
  },
  {
    "id": 2366,
    "question": "tasaarvosta",
    "answer": "about equality",
    "ru": "о равенстве"
  },
  {
    "id": 2367,
    "question": "oikeudenmukaisuudesta",
    "answer": "of justice",
    "ru": "о справедливости"
  },
  {
    "id": 2368,
    "question": "varmistaakseen",
    "answer": "to make sure",
    "ru": "убедиться"
  },
  {
    "id": 2369,
    "question": "kuuluvansa",
    "answer": "belong",
    "ru": "принадлежать"
  },
  {
    "id": 2370,
    "question": "arvostetaan",
    "answer": "is appreciated",
    "ru": "ценится"
  },
  {
    "id": 2371,
    "question": "jatkaa",
    "answer": "continue",
    "ru": "продолжать"
  },
  {
    "id": 2372,
    "question": "maailmaa",
    "answer": "the world",
    "ru": "мир"
  },
  {
    "id": 2373,
    "question": "suosikkieläimistäni",
    "answer": "about my favorite animals",
    "ru": "о моих любимых животных"
  },
  {
    "id": 2374,
    "question": "poro",
    "answer": "reindeer",
    "ru": "олень"
  },
  {
    "id": 2375,
    "question": "elävät",
    "answer": "are living",
    "ru": "живут"
  },
  {
    "id": 2376,
    "question": "selviytymään",
    "answer": "to survive",
    "ru": "выжить"
  },
  {
    "id": 2377,
    "question": "poroilla",
    "answer": "reindeer",
    "ru": "у оленей"
  },
  {
    "id": 2378,
    "question": "paksu",
    "answer": "thick",
    "ru": "толстый"
  },
  {
    "id": 2379,
    "question": "turkki",
    "answer": "turkey",
    "ru": "мех"
  },
  {
    "id": 2380,
    "question": "lämpimänä",
    "answer": "warm",
    "ru": "тёплым"
  },
  {
    "id": 2381,
    "question": "leveät",
    "answer": "wide",
    "ru": "широкие"
  },
  {
    "id": 2382,
    "question": "kaviot",
    "answer": "hooves",
    "ru": "копыта"
  },
  {
    "id": 2383,
    "question": "kävelemään",
    "answer": "to walk",
    "ru": "ходить"
  },
  {
    "id": 2384,
    "question": "lumella",
    "answer": "on snow",
    "ru": "по снегу"
  },
  {
    "id": 2385,
    "question": "uppoamatta",
    "answer": "without sinking",
    "ru": "не проваливаясь"
  },
  {
    "id": 2386,
    "question": "helpompi",
    "answer": "easier",
    "ru": "легче"
  },
  {
    "id": 2387,
    "question": "sammalta",
    "answer": "from moss",
    "ru": "со мха"
  },
  {
    "id": 2388,
    "question": "sataa",
    "answer": "rain",
    "ru": "идёт дождь"
  },
  {
    "id": 2389,
    "question": "lunta",
    "answer": "snow",
    "ru": "снег"
  },
  {
    "id": 2390,
    "question": "suurista",
    "answer": "big ones",
    "ru": "больших"
  },
  {
    "id": 2391,
    "question": "sarvistaan",
    "answer": "from his horn",
    "ru": "от своих рогов"
  },
  {
    "id": 2392,
    "question": "puolustavat",
    "answer": "defending",
    "ru": "защищают"
  },
  {
    "id": 2393,
    "question": "etsivät",
    "answer": "are looking for",
    "ru": "ищут"
  },
  {
    "id": 2394,
    "question": "sarvet",
    "answer": "antlers",
    "ru": "рога"
  },
  {
    "id": 2395,
    "question": "kaivamaan",
    "answer": "to dig",
    "ru": "копать"
  },
  {
    "id": 2396,
    "question": "lumen",
    "answer": "the snow",
    "ru": "снег"
  },
  {
    "id": 2397,
    "question": "löytääkseen",
    "answer": "to find",
    "ru": "чтобы найти"
  },
  {
    "id": 2398,
    "question": "joissain",
    "answer": "in some",
    "ru": "в некоторых"
  },
  {
    "id": 2399,
    "question": "kelkkojen",
    "answer": "sledges",
    "ru": "саней"
  },
  {
    "id": 2400,
    "question": "vetämiseen",
    "answer": "for pulling",
    "ru": "для буксировки"
  },
  {
    "id": 2401,
    "question": "raskaiden",
    "answer": "heavy ones",
    "ru": "тяжёлых"
  },
  {
    "id": 2402,
    "question": "tavaroiden",
    "answer": "of goods",
    "ru": "товаров"
  },
  {
    "id": 2403,
    "question": "kantamiseen",
    "answer": "for carrying",
    "ru": "для перевозки"
  },
  {
    "id": 2404,
    "question": "uskomattomia",
    "answer": "incredible",
    "ru": "невероятные"
  },
  {
    "id": 2405,
    "question": "selviävät",
    "answer": "survive",
    "ru": "выживают"
  },
  {
    "id": 2406,
    "question": "sydämessään",
    "answer": "within",
    "ru": "в своём сердце"
  },
  {
    "id": 2407,
    "question": "suosikkikirjoistani",
    "answer": "of my favorite books",
    "ru": "о моих любимых книгах"
  },
  {
    "id": 2408,
    "question": "pienet",
    "answer": "small ones",
    "ru": "маленькие"
  },
  {
    "id": 2409,
    "question": "muutokset",
    "answer": "changes",
    "ru": "изменения"
  },
  {
    "id": 2410,
    "question": "suuren",
    "answer": "the big one",
    "ru": "большое"
  },
  {
    "id": 2411,
    "question": "muutoksen",
    "answer": "change",
    "ru": "изменение"
  },
  {
    "id": 2412,
    "question": "selittää",
    "answer": "explain",
    "ru": "объяснить"
  },
  {
    "id": 2413,
    "question": "meidän",
    "answer": "our",
    "ru": "наш"
  },
  {
    "id": 2414,
    "question": "aloittaa",
    "answer": "start",
    "ru": "начать"
  },
  {
    "id": 2415,
    "question": "pienistä",
    "answer": "of small ones",
    "ru": "с маленьких"
  },
  {
    "id": 2416,
    "question": "tavoista",
    "answer": "of manners",
    "ru": "о привычках"
  },
  {
    "id": 2417,
    "question": "kirjoittaja",
    "answer": "author",
    "ru": "автор"
  },
  {
    "id": 2418,
    "question": "sanoo",
    "answer": "says",
    "ru": "говорит"
  },
  {
    "id": 2419,
    "question": "muodostua",
    "answer": "form",
    "ru": "формироваться"
  },
  {
    "id": 2420,
    "question": "suurta",
    "answer": "big",
    "ru": "большой"
  },
  {
    "id": 2421,
    "question": "esimerkkejä",
    "answer": "examples",
    "ru": "примеры"
  },
  {
    "id": 2422,
    "question": "tekemällä",
    "answer": "by doing",
    "ru": "делая"
  },
  {
    "id": 2423,
    "question": "pieniä",
    "answer": "chop",
    "ru": "маленький"
  },
  {
    "id": 2424,
    "question": "tapamme",
    "answer": "we kill",
    "ru": "наш способ"
  },
  {
    "id": 2425,
    "question": "keiksi",
    "answer": "for cookies",
    "ru": "для печенья"
  },
  {
    "id": 2426,
    "question": "meistä",
    "answer": "about us",
    "ru": "о нас"
  },
  {
    "id": 2427,
    "question": "tavoitteemme",
    "answer": "our goal",
    "ru": "наша цель"
  },
  {
    "id": 2428,
    "question": "päivittäisiin",
    "answer": "for daily ones",
    "ru": "для повседневных"
  },
  {
    "id": 2429,
    "question": "asioihin",
    "answer": "to things",
    "ru": "к вещам"
  },
  {
    "id": 2430,
    "question": "helppolukuinen",
    "answer": "easy to read",
    "ru": "лёгкий для чтения"
  },
  {
    "id": 2431,
    "question": "selittämään",
    "answer": "to explain",
    "ru": "объяснять"
  },
  {
    "id": 2432,
    "question": "ajatuksia",
    "answer": "thoughts",
    "ru": "мысли"
  },
  {
    "id": 2433,
    "question": "käytännön",
    "answer": "practical",
    "ru": "практический"
  },
  {
    "id": 2434,
    "question": "vinkkejä",
    "answer": "tips",
    "ru": "советы"
  },
  {
    "id": 2435,
    "question": "myönteisiä",
    "answer": "positive ones",
    "ru": "положительные"
  },
  {
    "id": 2436,
    "question": "innostaa",
    "answer": "inspire",
    "ru": "вдохновлять"
  },
  {
    "id": 2437,
    "question": "motivoida",
    "answer": "motivate",
    "ru": "мотивировать"
  },
  {
    "id": 2438,
    "question": "työskentelemään",
    "answer": "to work",
    "ru": "работать"
  },
  {
    "id": 2439,
    "question": "tavoitteitaan",
    "answer": "their goals",
    "ru": "своих целей"
  },
  {
    "id": 2440,
    "question": "pieni",
    "answer": "small",
    "ru": "маленький"
  },
  {
    "id": 2441,
    "question": "askel",
    "answer": "step",
    "ru": "шаг"
  },
  {
    "id": 2442,
    "question": "kerrallaan",
    "answer": "at a time",
    "ru": "за раз"
  },
  {
    "id": 2443,
    "question": "pysyviä",
    "answer": "permanent",
    "ru": "постоянные"
  },
  {
    "id": 2444,
    "question": "jokapäiväisiin",
    "answer": "for everyday",
    "ru": "для повседневных"
  },
  {
    "id": 2445,
    "question": "tottumuksiin",
    "answer": "habits",
    "ru": "привычки"
  },
  {
    "id": 2446,
    "question": "tavoitteensa",
    "answer": "their goals",
    "ru": "своих целей"
  },
  {
    "id": 2447,
    "question": "parhaista",
    "answer": "of the best",
    "ru": "из лучших"
  },
  {
    "id": 2448,
    "question": "päivistä",
    "answer": "of days",
    "ru": "дней"
  },
  {
    "id": 2449,
    "question": "iloa",
    "answer": "joy",
    "ru": "радость"
  },
  {
    "id": 2450,
    "question": "unohda",
    "answer": "forget it",
    "ru": "забудь об этом"
  },
  {
    "id": 2451,
    "question": "tunsin",
    "answer": "i felt",
    "ru": "я почувствовал"
  },
  {
    "id": 2452,
    "question": "tuntenut",
    "answer": "felt",
    "ru": "почувствовал"
  },
  {
    "id": 2453,
    "question": "nähdessäni",
    "answer": "when i see",
    "ru": "когда я вижу"
  },
  {
    "id": 2454,
    "question": "pitäessäni",
    "answer": "while holding",
    "ru": "пока держу"
  },
  {
    "id": 2455,
    "question": "sylissäni",
    "answer": "in my arms",
    "ru": "на руках"
  },
  {
    "id": 2456,
    "question": "ensimmäistä",
    "answer": "the first one",
    "ru": "первый"
  },
  {
    "id": 2457,
    "question": "kertaa",
    "answer": "times",
    "ru": "раз"
  },
  {
    "id": 2458,
    "question": "perhe",
    "answer": "family",
    "ru": "семья"
  },
  {
    "id": 2459,
    "question": "tulivat",
    "answer": "came",
    "ru": "пришли"
  },
  {
    "id": 2460,
    "question": "kanssamme",
    "answer": "with us",
    "ru": "с нами"
  },
  {
    "id": 2461,
    "question": "toivat",
    "answer": "brought",
    "ru": "принесли"
  },
  {
    "id": 2462,
    "question": "jakoivat",
    "answer": "shared",
    "ru": "поделились"
  },
  {
    "id": 2463,
    "question": "rakkautensa",
    "answer": "his love",
    "ru": "его любовь"
  },
  {
    "id": 2464,
    "question": "tukensa",
    "answer": "their support",
    "ru": "их поддержку"
  },
  {
    "id": 2465,
    "question": "teki",
    "answer": "did",
    "ru": "сделал"
  },
  {
    "id": 2466,
    "question": "päivästä",
    "answer": "of the day",
    "ru": "дня"
  },
  {
    "id": 2467,
    "question": "entistä",
    "answer": "former",
    "ru": "прежний"
  },
  {
    "id": 2468,
    "question": "ikimuistoisemman",
    "answer": "more memorable",
    "ru": "более памятным"
  },
  {
    "id": 2469,
    "question": "iloisemman",
    "answer": "happier",
    "ru": "более радостным"
  },
  {
    "id": 2470,
    "question": "onnen",
    "answer": "luck",
    "ru": "счастье"
  },
  {
    "id": 2471,
    "question": "jännityksen",
    "answer": "tension",
    "ru": "волнение"
  },
  {
    "id": 2472,
    "question": "täytti",
    "answer": "filled",
    "ru": "заполнило"
  },
  {
    "id": 2473,
    "question": "huoneen",
    "answer": "room",
    "ru": "комнату"
  },
  {
    "id": 2474,
    "question": "puhtaan",
    "answer": "clean",
    "ru": "чистый"
  },
  {
    "id": 2475,
    "question": "ilon",
    "answer": "joy",
    "ru": "радость"
  },
  {
    "id": 2476,
    "question": "rakkauden",
    "answer": "of love",
    "ru": "любви"
  },
  {
    "id": 2477,
    "question": "tunne",
    "answer": "feeling",
    "ru": "чувство"
  },
  {
    "id": 2478,
    "question": "sydäntäni",
    "answer": "my heart",
    "ru": "моё сердце"
  },
  {
    "id": 2479,
    "question": "toivoa",
    "answer": "hope",
    "ru": "надежда"
  },
  {
    "id": 2480,
    "question": "alkuja",
    "answer": "beginnings",
    "ru": "начала"
  },
  {
    "id": 2481,
    "question": "muutti",
    "answer": "moved",
    "ru": "переехал"
  },
  {
    "id": 2482,
    "question": "lopullisesti",
    "answer": "finally",
    "ru": "окончательно"
  },
  {
    "id": 2483,
    "question": "toi",
    "answer": "brought",
    "ru": "принёс"
  },
  {
    "id": 2484,
    "question": "maailmaani",
    "answer": "my world",
    "ru": "мой мир"
  },
  {
    "id": 2485,
    "question": "suosituimmista",
    "answer": "the most popular",
    "ru": "самых популярных"
  },
  {
    "id": 2486,
    "question": "juhlapäivistä",
    "answer": "holidays",
    "ru": "праздники"
  },
  {
    "id": 2487,
    "question": "viettämään",
    "answer": "to spend",
    "ru": "провести"
  },
  {
    "id": 2488,
    "question": "toistensa",
    "answer": "each other",
    "ru": "друг друга"
  },
  {
    "id": 2489,
    "question": "aikaan",
    "answer": "at the time",
    "ru": "в то время"
  },
  {
    "id": 2490,
    "question": "koristelevat",
    "answer": "decorating",
    "ru": "украшают"
  },
  {
    "id": 2491,
    "question": "kotinsa",
    "answer": "his home",
    "ru": "свой дом"
  },
  {
    "id": 2492,
    "question": "valoilla",
    "answer": "with lights",
    "ru": "огнями"
  },
  {
    "id": 2493,
    "question": "puilla",
    "answer": "on trees",
    "ru": "деревьями"
  },
  {
    "id": 2494,
    "question": "koristeilla",
    "answer": "with decorations",
    "ru": "украшениями"
  },
  {
    "id": 2495,
    "question": "vaihtavat",
    "answer": "are changing",
    "ru": "обмениваются"
  },
  {
    "id": 2496,
    "question": "keskenään",
    "answer": "among themselves",
    "ru": "между собой"
  },
  {
    "id": 2497,
    "question": "herkullisesta",
    "answer": "delicious",
    "ru": "вкусной"
  },
  {
    "id": 2498,
    "question": "ruoasta",
    "answer": "about food",
    "ru": "о еде"
  },
  {
    "id": 2499,
    "question": "kinkusta",
    "answer": "of ham",
    "ru": "ветчины"
  },
  {
    "id": 2500,
    "question": "kalasta",
    "answer": "of fish",
    "ru": "рыбы"
  },
  {
    "id": 2501,
    "question": "piparkakuista",
    "answer": "of gingerbread",
    "ru": "имбирного печенья"
  },
  {
    "id": 2502,
    "question": "saunassa",
    "answer": "in the sauna",
    "ru": "в сауне"
  },
  {
    "id": 2503,
    "question": "lämmöstä",
    "answer": "from the heat",
    "ru": "от тепла"
  },
  {
    "id": 2504,
    "question": "kylminä",
    "answer": "cold",
    "ru": "холодные"
  },
  {
    "id": 2505,
    "question": "talvipäivinä",
    "answer": "on winter days",
    "ru": "в зимние дни"
  },
  {
    "id": 2506,
    "question": "kirkossa",
    "answer": "in the church",
    "ru": "в церкви"
  },
  {
    "id": 2507,
    "question": "juhlimassa",
    "answer": "celebrating",
    "ru": "празднуя"
  },
  {
    "id": 2508,
    "question": "juhlaa",
    "answer": "party",
    "ru": "праздник"
  },
  {
    "id": 2509,
    "question": "muistamassa",
    "answer": "remembering",
    "ru": "вспоминая"
  },
  {
    "id": 2510,
    "question": "erityispiirteistä",
    "answer": "special features",
    "ru": "особые черты"
  },
  {
    "id": 2511,
    "question": "joulupukin",
    "answer": "santa claus too",
    "ru": "Деда Мороза"
  },
  {
    "id": 2512,
    "question": "perinne",
    "answer": "tradition",
    "ru": "традиция"
  },
  {
    "id": 2513,
    "question": "tuovan",
    "answer": "to bring",
    "ru": "принести"
  },
  {
    "id": 2514,
    "question": "jouluaattona",
    "answer": "on christmas eve",
    "ru": "в канун Рождества"
  },
  {
    "id": 2515,
    "question": "kulhollisen",
    "answer": "bowl",
    "ru": "миску"
  },
  {
    "id": 2516,
    "question": "puuroa",
    "answer": "porridge",
    "ru": "каша"
  },
  {
    "id": 2517,
    "question": "joulupukille",
    "answer": "to santa claus",
    "ru": "Деду Морозу"
  },
  {
    "id": 2518,
    "question": "nautittavaksi",
    "answer": "to enjoy",
    "ru": "для угощения"
  },
  {
    "id": 2519,
    "question": "vierailee",
    "answer": "is visiting",
    "ru": "посещает"
  },
  {
    "id": 2520,
    "question": "kotonaan",
    "answer": "at home",
    "ru": "дома"
  },
  {
    "id": 2521,
    "question": "iloista",
    "answer": "cheerful",
    "ru": "весёлое"
  },
  {
    "id": 2522,
    "question": "juhlavaa",
    "answer": "festive",
    "ru": "праздничное"
  },
  {
    "id": 2523,
    "question": "lämpöä",
    "answer": "heat",
    "ru": "тепло"
  },
  {
    "id": 2524,
    "question": "yhdessäoloa",
    "answer": "togetherness",
    "ru": "единство"
  },
  {
    "id": 2525,
    "question": "luomaan",
    "answer": "to create",
    "ru": "создавать"
  },
  {
    "id": 2526,
    "question": "kestäviä",
    "answer": "durable",
    "ru": "долговечные"
  },
  {
    "id": 2527,
    "question": "muistoja",
    "answer": "memories",
    "ru": "воспоминания"
  },
  {
    "id": 2528,
    "question": "rakkaittensa",
    "answer": "loved ones",
    "ru": "своих близких"
  },
  {
    "id": 2529,
    "question": "suosikkielokuvistani",
    "answer": "of my favorite movies",
    "ru": "о моих любимых фильмах"
  },
  {
    "id": 2530,
    "question": "tarinan",
    "answer": "the story",
    "ru": "история"
  },
  {
    "id": 2531,
    "question": "vanhemmasta",
    "answer": "from the parent",
    "ru": "от родителя"
  },
  {
    "id": 2532,
    "question": "tapahtuviin",
    "answer": "events",
    "ru": "происходящим"
  },
  {
    "id": 2533,
    "question": "muutoksiin",
    "answer": "to changes",
    "ru": "к изменениям"
  },
  {
    "id": 2534,
    "question": "koskettavia",
    "answer": "touching",
    "ru": "трогательные"
  },
  {
    "id": 2535,
    "question": "rakkaudesta",
    "answer": "for love",
    "ru": "ради любви"
  },
  {
    "id": 2536,
    "question": "ystävyydestä",
    "answer": "about friendship",
    "ru": "о дружбе"
  },
  {
    "id": 2537,
    "question": "tiellemme",
    "answer": "our way",
    "ru": "наш путь"
  },
  {
    "id": 2538,
    "question": "tulevien",
    "answer": "future ones",
    "ru": "будущих"
  },
  {
    "id": 2539,
    "question": "muutosten",
    "answer": "changes",
    "ru": "перемен"
  },
  {
    "id": 2540,
    "question": "rakastettavat",
    "answer": "loved ones",
    "ru": "любимые"
  },
  {
    "id": 2541,
    "question": "samanhenkiset",
    "answer": "like minded",
    "ru": "единомышленники"
  },
  {
    "id": 2542,
    "question": "ystävällisyyden",
    "answer": "kindness",
    "ru": "доброта"
  },
  {
    "id": 2543,
    "question": "ymmärryksen",
    "answer": "understanding",
    "ru": "понимание"
  },
  {
    "id": 2544,
    "question": "tärkeyden",
    "answer": "importance",
    "ru": "важность"
  },
  {
    "id": 2545,
    "question": "kaunis",
    "answer": "beautiful",
    "ru": "красивый"
  },
  {
    "id": 2546,
    "question": "tarinankerronta",
    "answer": "storytelling",
    "ru": "рассказывание историй"
  },
  {
    "id": 2547,
    "question": "merkitykselliset",
    "answer": "meaningful",
    "ru": "значимые"
  },
  {
    "id": 2548,
    "question": "viestit",
    "answer": "messages",
    "ru": "сообщения"
  },
  {
    "id": 2549,
    "question": "katsojaan",
    "answer": "to the viewer",
    "ru": "к зрителю"
  },
  {
    "id": 2550,
    "question": "pysyvän",
    "answer": "permanently",
    "ru": "навсегда"
  },
  {
    "id": 2551,
    "question": "vaikutuksen",
    "answer": "effect",
    "ru": "впечатление"
  },
  {
    "id": 2552,
    "question": "itkemään",
    "answer": "to cry",
    "ru": "плакать"
  },
  {
    "id": 2553,
    "question": "yhtä",
    "answer": "equally",
    "ru": "одинаково"
  },
  {
    "id": 2554,
    "question": "pysyy",
    "answer": "remains",
    "ru": "остаётся"
  },
  {
    "id": 2555,
    "question": "mielessäsi",
    "answer": "in your mind",
    "ru": "в твоём уме"
  },
  {
    "id": 2556,
    "question": "päättymisen",
    "answer": "ending",
    "ru": "окончание"
  },
  {
    "id": 2557,
    "question": "muistuttaa",
    "answer": "resemble",
    "ru": "напоминает"
  },
  {
    "id": 2558,
    "question": "vaalia",
    "answer": "cherish",
    "ru": "беречь"
  },
  {
    "id": 2559,
    "question": "erityisen",
    "answer": "particularly",
    "ru": "особенно"
  },
  {
    "id": 2560,
    "question": "suosikkiohjelmistani",
    "answer": "of my favorite shows",
    "ru": "о моих любимых передачах"
  },
  {
    "id": 2561,
    "question": "komediasarja",
    "answer": "comedy series",
    "ru": "комедийный сериал"
  },
  {
    "id": 2562,
    "question": "nimeltä",
    "answer": "by name",
    "ru": "по имени"
  },
  {
    "id": 2563,
    "question": "hauska",
    "answer": "fun",
    "ru": "весёлый"
  },
  {
    "id": 2564,
    "question": "luottomiesnimisestä",
    "answer": "from the creditor's name",
    "ru": "от имени доверенного лица"
  },
  {
    "id": 2565,
    "question": "ongelmissaan",
    "answer": "in his problems",
    "ru": "в своих проблемах"
  },
  {
    "id": 2566,
    "question": "kiltti",
    "answer": "kind",
    "ru": "добрый"
  },
  {
    "id": 2567,
    "question": "hauskoihin",
    "answer": "for fun",
    "ru": "к весёлым"
  },
  {
    "id": 2568,
    "question": "tilanteisiin",
    "answer": "situations",
    "ru": "ситуации"
  },
  {
    "id": 2569,
    "question": "erittäin",
    "answer": "very",
    "ru": "очень"
  },
  {
    "id": 2570,
    "question": "persoonallisuuksia",
    "answer": "personalities",
    "ru": "личности"
  },
  {
    "id": 2571,
    "question": "viihdyttävää",
    "answer": "entertaining",
    "ru": "развлекательный"
  },
  {
    "id": 2572,
    "question": "näyttelijät",
    "answer": "cast",
    "ru": "актёры"
  },
  {
    "id": 2573,
    "question": "herättääkseen",
    "answer": "to wake up",
    "ru": "чтобы оживить"
  },
  {
    "id": 2574,
    "question": "eloon",
    "answer": "alive",
    "ru": "живой"
  },
  {
    "id": 2575,
    "question": "tehdäkseen",
    "answer": "in order to do",
    "ru": "чтобы сделать"
  },
  {
    "id": 2576,
    "question": "nautinnollisen",
    "answer": "enjoyable",
    "ru": "приятный"
  },
  {
    "id": 2577,
    "question": "unohtamaan",
    "answer": "to forget",
    "ru": "забыть"
  },
  {
    "id": 2578,
    "question": "huolensa",
    "answer": "his worries",
    "ru": "его заботы"
  },
  {
    "id": 2579,
    "question": "kevytmielinen",
    "answer": "frivolous",
    "ru": "легкомысленный"
  },
  {
    "id": 2580,
    "question": "sarja",
    "answer": "series",
    "ru": "сериал"
  },
  {
    "id": 2581,
    "question": "täydellisesti",
    "answer": "perfectly",
    "ru": "идеально"
  },
  {
    "id": 2582,
    "question": "rentoutumiseen",
    "answer": "for relaxation",
    "ru": "для отдыха"
  },
  {
    "id": 2583,
    "question": "hauskanpitoon",
    "answer": "for fun",
    "ru": "для развлечения"
  },
  {
    "id": 2584,
    "question": "katsominen",
    "answer": "watching",
    "ru": "просмотр"
  },
  {
    "id": 2585,
    "question": "hymyn",
    "answer": "smile",
    "ru": "улыбку"
  },
  {
    "id": 2586,
    "question": "huulille",
    "answer": "to the lips",
    "ru": "на губы"
  },
  {
    "id": 2587,
    "question": "päivästäni",
    "answer": "about my day",
    "ru": "о моём дне"
  },
  {
    "id": 2588,
    "question": "paremman",
    "answer": "better",
    "ru": "лучший"
  },
  {
    "id": 2589,
    "question": "vanheneminen",
    "answer": "aging",
    "ru": "старение"
  },
  {
    "id": 2590,
    "question": "vanhenevat",
    "answer": "are getting old",
    "ru": "стареют"
  },
  {
    "id": 2591,
    "question": "kehonsa",
    "answer": "his body",
    "ru": "его тело"
  },
  {
    "id": 2592,
    "question": "yksinäisiksi",
    "answer": "lonely",
    "ru": "одинокими"
  },
  {
    "id": 2593,
    "question": "ystävänsä",
    "answer": "his friend",
    "ru": "его друг"
  },
  {
    "id": 2594,
    "question": "kaipaamaan",
    "answer": "to miss",
    "ru": "скучать"
  },
  {
    "id": 2595,
    "question": "tekivät",
    "answer": "did",
    "ru": "сделали"
  },
  {
    "id": 2596,
    "question": "nuorempana",
    "answer": "when younger",
    "ru": "в молодости"
  },
  {
    "id": 2597,
    "question": "urheilua",
    "answer": "sports",
    "ru": "спорт"
  },
  {
    "id": 2598,
    "question": "pitkiä",
    "answer": "long ones",
    "ru": "длинные"
  },
  {
    "id": 2599,
    "question": "kävelylenkkejä",
    "answer": "walks",
    "ru": "прогулки"
  },
  {
    "id": 2600,
    "question": "terveysongelmat",
    "answer": "health problems",
    "ru": "проблемы со здоровьем"
  },
  {
    "id": 2601,
    "question": "joutua",
    "answer": "get",
    "ru": "оказаться"
  },
  {
    "id": 2602,
    "question": "ottamaan",
    "answer": "to take",
    "ru": "брать"
  },
  {
    "id": 2603,
    "question": "käymään",
    "answer": "to visit",
    "ru": "навещать"
  },
  {
    "id": 2604,
    "question": "lääkärissä",
    "answer": "at the doctor's",
    "ru": "у врача"
  },
  {
    "id": 2605,
    "question": "useammin",
    "answer": "more often",
    "ru": "чаще"
  },
  {
    "id": 2606,
    "question": "heikoksi",
    "answer": "weak",
    "ru": "слабым"
  },
  {
    "id": 2607,
    "question": "muistaa",
    "answer": "remember",
    "ru": "помнить"
  },
  {
    "id": 2608,
    "question": "vanhenemisessa",
    "answer": "in aging",
    "ru": "при старении"
  },
  {
    "id": 2609,
    "question": "nähneet",
    "answer": "have seen",
    "ru": "видели"
  },
  {
    "id": 2610,
    "question": "ansaitsevat",
    "answer": "deserve",
    "ru": "заслуживают"
  },
  {
    "id": 2611,
    "question": "elämänsä",
    "answer": "his life",
    "ru": "его жизнь"
  },
  {
    "id": 2612,
    "question": "onnellisesti",
    "answer": "happily",
    "ru": "счастливо"
  },
  {
    "id": 2613,
    "question": "tarjoavat",
    "answer": "offer",
    "ru": "предлагают"
  },
  {
    "id": 2614,
    "question": "hoitoa",
    "answer": "treatment",
    "ru": "лечение"
  },
  {
    "id": 2615,
    "question": "iäkkäille",
    "answer": "for the elderly",
    "ru": "для пожилых"
  },
  {
    "id": 2616,
    "question": "ihmisille",
    "answer": "to people",
    "ru": "людям"
  },
  {
    "id": 2617,
    "question": "rakastettu",
    "answer": "loved",
    "ru": "любимый"
  },
  {
    "id": 2618,
    "question": "arvostettu",
    "answer": "rating",
    "ru": "уважаемый"
  },
  {
    "id": 2619,
    "question": "lastensa",
    "answer": "their children",
    "ru": "их детей"
  },
  {
    "id": 2620,
    "question": "auttamisessa",
    "answer": "in helping",
    "ru": "в помощи"
  },
  {
    "id": 2621,
    "question": "käyttämään",
    "answer": "to use",
    "ru": "использовать"
  },
  {
    "id": 2622,
    "question": "asettavat",
    "answer": "set",
    "ru": "устанавливают"
  },
  {
    "id": 2623,
    "question": "rajoituksia",
    "answer": "restrictions",
    "ru": "ограничения"
  },
  {
    "id": 2624,
    "question": "sille",
    "answer": "for it",
    "ru": "для него"
  },
  {
    "id": 2625,
    "question": "internetissä",
    "answer": "on the internet",
    "ru": "в интернете"
  },
  {
    "id": 2626,
    "question": "koulutussivustoja",
    "answer": "educational sites",
    "ru": "образовательные сайты"
  },
  {
    "id": 2627,
    "question": "pelejä",
    "answer": "games",
    "ru": "игры"
  },
  {
    "id": 2628,
    "question": "varmistettava",
    "answer": "ensure",
    "ru": "обеспечить"
  },
  {
    "id": 2629,
    "question": "käytön",
    "answer": "of use",
    "ru": "использования"
  },
  {
    "id": 2630,
    "question": "rajojen",
    "answer": "borders",
    "ru": "границы"
  },
  {
    "id": 2631,
    "question": "asettaminen",
    "answer": "application",
    "ru": "установление"
  },
  {
    "id": 2632,
    "question": "kehittämään",
    "answer": "to develop",
    "ru": "развивать"
  },
  {
    "id": 2633,
    "question": "terveellisiä",
    "answer": "healthy ones",
    "ru": "здоровые"
  },
  {
    "id": 2634,
    "question": "tasapainoista",
    "answer": "balanced",
    "ru": "сбалансированный"
  },
  {
    "id": 2635,
    "question": "elämää",
    "answer": "life",
    "ru": "жизнь"
  },
  {
    "id": 2636,
    "question": "leikkien",
    "answer": "playing",
    "ru": "играя"
  },
  {
    "id": 2637,
    "question": "läksyjen",
    "answer": "homework",
    "ru": "домашнее задание"
  },
  {
    "id": 2638,
    "question": "tekemiseen",
    "answer": "to do",
    "ru": "делать"
  },
  {
    "id": 2639,
    "question": "asettamalla",
    "answer": "by setting",
    "ru": "устанавливая"
  },
  {
    "id": 2640,
    "question": "sääntöjä",
    "answer": "rules",
    "ru": "правила"
  },
  {
    "id": 2641,
    "question": "lapsiaan",
    "answer": "their children",
    "ru": "своих детей"
  },
  {
    "id": 2642,
    "question": "ymmärtämään",
    "answer": "to understand",
    "ru": "понимать"
  },
  {
    "id": 2643,
    "question": "välttämään",
    "answer": "to avoid",
    "ru": "избегать"
  },
  {
    "id": 2644,
    "question": "mahdollisia",
    "answer": "possible",
    "ru": "возможные"
  },
  {
    "id": 2645,
    "question": "riskejä",
    "answer": "risks",
    "ru": "риски"
  },
  {
    "id": 2646,
    "question": "puhuvat",
    "answer": "are talking",
    "ru": "разговаривают"
  },
  {
    "id": 2647,
    "question": "lapsilleen",
    "answer": "to their children",
    "ru": "своим детям"
  },
  {
    "id": 2648,
    "question": "turvallisuudesta",
    "answer": "about security",
    "ru": "о безопасности"
  },
  {
    "id": 2649,
    "question": "verkkotoimintoihinsa",
    "answer": "to their network functions",
    "ru": "к своим сетевым действиям"
  },
  {
    "id": 2650,
    "question": "positiivisen",
    "answer": "positive",
    "ru": "положительный"
  },
  {
    "id": 2651,
    "question": "turvallisen",
    "answer": "safe",
    "ru": "безопасный"
  },
  {
    "id": 2652,
    "question": "kokemuksen",
    "answer": "the experience",
    "ru": "опыт"
  },
  {
    "id": 2653,
    "question": "vanhuksia",
    "answer": "elderly people",
    "ru": "пожилых людей"
  },
  {
    "id": 2654,
    "question": "huolella",
    "answer": "carefully",
    "ru": "тщательно"
  },
  {
    "id": 2655,
    "question": "vanhemmista",
    "answer": "about parents",
    "ru": "о родителях"
  },
  {
    "id": 2656,
    "question": "jäsenistään",
    "answer": "of its members",
    "ru": "своих членов"
  },
  {
    "id": 2657,
    "question": "onnellisia",
    "answer": "happy ones",
    "ru": "счастливые"
  },
  {
    "id": 2658,
    "question": "kutsutaan",
    "answer": "is called",
    "ru": "называется"
  },
  {
    "id": 2659,
    "question": "hoitokodeiksi",
    "answer": "nursing homes",
    "ru": "дома престарелых"
  },
  {
    "id": 2660,
    "question": "asua",
    "answer": "live",
    "ru": "жить"
  },
  {
    "id": 2661,
    "question": "sairaanhoitajat",
    "answer": "nurses",
    "ru": "медсёстры"
  },
  {
    "id": 2662,
    "question": "omaishoitajat",
    "answer": "caregivers",
    "ru": "сиделки"
  },
  {
    "id": 2663,
    "question": "huolehtivat",
    "answer": "take care of",
    "ru": "заботятся"
  },
  {
    "id": 2664,
    "question": "tarvitsemansa",
    "answer": "what they need",
    "ru": "то, что им нужно"
  },
  {
    "id": 2665,
    "question": "iäkkäät",
    "answer": "the elderly",
    "ru": "пожилые люди"
  },
  {
    "id": 2666,
    "question": "muilta",
    "answer": "from others",
    "ru": "от других"
  },
  {
    "id": 2667,
    "question": "palveluita",
    "answer": "services",
    "ru": "услуги"
  },
  {
    "id": 2668,
    "question": "organisaatioita",
    "answer": "organizations",
    "ru": "организации"
  },
  {
    "id": 2669,
    "question": "ostoksilla",
    "answer": "shopping",
    "ru": "за покупками"
  },
  {
    "id": 2670,
    "question": "lääkärillä",
    "answer": "with a doctor",
    "ru": "у врача"
  },
  {
    "id": 2671,
    "question": "käynnillä",
    "answer": "in progress",
    "ru": "на приёме"
  },
  {
    "id": 2672,
    "question": "itsenäisesti",
    "answer": "independently",
    "ru": "самостоятельно"
  },
  {
    "id": 2673,
    "question": "kunnioitetaan",
    "answer": "be respected",
    "ru": "уважать"
  },
  {
    "id": 2674,
    "question": "pidetään",
    "answer": "is held",
    "ru": "считается"
  },
  {
    "id": 2675,
    "question": "yhteisöä",
    "answer": "community",
    "ru": "сообщество"
  },
  {
    "id": 2676,
    "question": "rakastettuja",
    "answer": "loved ones",
    "ru": "любимые люди"
  },
  {
    "id": 2677,
    "question": "arvostettuja",
    "answer": "respected",
    "ru": "уважаемые"
  },
  {
    "id": 2678,
    "question": "nykymaailmassa",
    "answer": "in today's world",
    "ru": "в современном мире"
  },
  {
    "id": 2679,
    "question": "opiskelijoilla",
    "answer": "students",
    "ru": "студентам"
  },
  {
    "id": 2680,
    "question": "oppimiseen",
    "answer": "learning",
    "ru": "обучение"
  },
  {
    "id": 2681,
    "question": "oppilaat",
    "answer": "pupils",
    "ru": "ученики"
  },
  {
    "id": 2682,
    "question": "opiskelevat",
    "answer": "are studying",
    "ru": "учатся"
  },
  {
    "id": 2683,
    "question": "tietokoneen",
    "answer": "computer",
    "ru": "компьютер"
  },
  {
    "id": 2684,
    "question": "opiskelu",
    "answer": "study",
    "ru": "учёба"
  },
  {
    "id": 2685,
    "question": "mielenkiintoista",
    "answer": "interesting",
    "ru": "интересно"
  },
  {
    "id": 2686,
    "question": "luettavaa",
    "answer": "something to read",
    "ru": "что почитать"
  },
  {
    "id": 2687,
    "question": "tietokoneella",
    "answer": "on a computer",
    "ru": "на компьютере"
  },
  {
    "id": 2688,
    "question": "keskittyneenä",
    "answer": "focused",
    "ru": "сосредоточенно"
  },
  {
    "id": 2689,
    "question": "opettaja",
    "answer": "teacher",
    "ru": "учитель"
  },
  {
    "id": 2690,
    "question": "saatat",
    "answer": "you might",
    "ru": "вы можете"
  },
  {
    "id": 2691,
    "question": "puhumatta",
    "answer": "without speaking",
    "ru": "не говоря"
  },
  {
    "id": 2692,
    "question": "käyminen",
    "answer": "fermentation",
    "ru": "посещение"
  },
  {
    "id": 2693,
    "question": "kasvokkain",
    "answer": "face to face",
    "ru": "лицом к лицу"
  },
  {
    "id": 2694,
    "question": "hauskaa",
    "answer": "fun",
    "ru": "весело"
  },
  {
    "id": 2695,
    "question": "jokapäiväinen",
    "answer": "mundane",
    "ru": "повседневный"
  },
  {
    "id": 2696,
    "question": "koulunkäynti",
    "answer": "schooling",
    "ru": "посещение школы"
  },
  {
    "id": 2697,
    "question": "sinne",
    "answer": "there",
    "ru": "туда"
  },
  {
    "id": 2698,
    "question": "varsinkin",
    "answer": "especially",
    "ru": "особенно"
  },
  {
    "id": 2699,
    "question": "asut",
    "answer": "wear",
    "ru": "носишь"
  },
  {
    "id": 2700,
    "question": "kaukana",
    "answer": "far",
    "ru": "далеко"
  },
  {
    "id": 2701,
    "question": "oppimistavalla",
    "answer": "in a learning way",
    "ru": "способом обучения"
  },
  {
    "id": 2702,
    "question": "koulusta",
    "answer": "from school",
    "ru": "из школы"
  },
  {
    "id": 2703,
    "question": "itselleen",
    "answer": "to himself",
    "ru": "себе"
  },
  {
    "id": 2704,
    "question": "sopivan",
    "answer": "suitable",
    "ru": "подходящий"
  },
  {
    "id": 2705,
    "question": "ihonvärinsä",
    "answer": "his skin color",
    "ru": "цвет его кожи"
  },
  {
    "id": 2706,
    "question": "lähtökohtansa",
    "answer": "its starting point",
    "ru": "его отправная точка"
  },
  {
    "id": 2707,
    "question": "kohdata",
    "answer": "face",
    "ru": "столкнуться"
  },
  {
    "id": 2708,
    "question": "tasapuolisesti",
    "answer": "equally",
    "ru": "одинаково"
  },
  {
    "id": 2709,
    "question": "olivatpa",
    "answer": "whatever they were",
    "ru": "какими бы они ни были"
  },
  {
    "id": 2710,
    "question": "kotoisin",
    "answer": "indigenous",
    "ru": "родом"
  },
  {
    "id": 2711,
    "question": "oikeudenmukaisia",
    "answer": "fair",
    "ru": "справедливые"
  },
  {
    "id": 2712,
    "question": "antamaan",
    "answer": "to give",
    "ru": "давать"
  },
  {
    "id": 2713,
    "question": "keitä",
    "answer": "who",
    "ru": "кто"
  },
  {
    "id": 2714,
    "question": "vähentävät",
    "answer": "reduce",
    "ru": "сокращают"
  },
  {
    "id": 2715,
    "question": "mahdollisuuksiaan",
    "answer": "their opportunities",
    "ru": "свои возможности"
  },
  {
    "id": 2716,
    "question": "taantuma",
    "answer": "recession",
    "ru": "рецессия"
  },
  {
    "id": 2717,
    "question": "työttömyys",
    "answer": "unemployment",
    "ru": "безработица"
  },
  {
    "id": 2718,
    "question": "alkoholismi",
    "answer": "alcoholism",
    "ru": "алкоголизм"
  },
  {
    "id": 2719,
    "question": "vahingollisiin",
    "answer": "to the harmful ones",
    "ru": "к вредным"
  },
  {
    "id": 2720,
    "question": "ajatuksiin",
    "answer": "to thoughts",
    "ru": "к мыслям"
  },
  {
    "id": 2721,
    "question": "käyttäytyvät",
    "answer": "behave",
    "ru": "ведут себя"
  },
  {
    "id": 2722,
    "question": "epäreilusti",
    "answer": "unfairly",
    "ru": "несправедливо"
  },
  {
    "id": 2723,
    "question": "alkuperää",
    "answer": "origin",
    "ru": "происхождение"
  },
  {
    "id": 2724,
    "question": "hyvästä",
    "answer": "of good",
    "ru": "о хорошем"
  },
  {
    "id": 2725,
    "question": "loukkaantuneiksi",
    "answer": "injured",
    "ru": "обиженными"
  },
  {
    "id": 2726,
    "question": "ystäviä",
    "answer": "friends",
    "ru": "друзья"
  },
  {
    "id": 2727,
    "question": "reilua",
    "answer": "fair",
    "ru": "справедливо"
  },
  {
    "id": 2728,
    "question": "kokemuksia",
    "answer": "experiences",
    "ru": "опыт"
  },
  {
    "id": 2729,
    "question": "saatettu",
    "answer": "maybe",
    "ru": "возможно"
  },
  {
    "id": 2730,
    "question": "kuulla",
    "answer": "hear",
    "ru": "слышать"
  },
  {
    "id": 2731,
    "question": "ilkeitä",
    "answer": "nasty",
    "ru": "злые"
  },
  {
    "id": 2732,
    "question": "luonteensa",
    "answer": "its nature",
    "ru": "его природа"
  },
  {
    "id": 2733,
    "question": "yksinäiseksi",
    "answer": "lonely",
    "ru": "одиноким"
  },
  {
    "id": 2734,
    "question": "tukevat",
    "answer": "support",
    "ru": "поддерживают"
  },
  {
    "id": 2735,
    "question": "vastustavat",
    "answer": "oppose",
    "ru": "выступают против"
  },
  {
    "id": 2736,
    "question": "koe",
    "answer": "test",
    "ru": "тест"
  },
  {
    "id": 2737,
    "question": "ollenkaan",
    "answer": "at all",
    "ru": "вовсе"
  },
  {
    "id": 2738,
    "question": "emme",
    "answer": "we do not",
    "ru": "мы не"
  },
  {
    "id": 2739,
    "question": "yleistää",
    "answer": "generalize",
    "ru": "обобщать"
  },
  {
    "id": 2740,
    "question": "sanoa",
    "answer": "say",
    "ru": "говорить"
  },
  {
    "id": 2741,
    "question": "toisillemme",
    "answer": "to each other",
    "ru": "друг другу"
  },
  {
    "id": 2742,
    "question": "toisiltamme",
    "answer": "from each other",
    "ru": "друг от друга"
  },
  {
    "id": 2743,
    "question": "ymmärtää",
    "answer": "understand",
    "ru": "понимать"
  },
  {
    "id": 2744,
    "question": "riippumatta",
    "answer": "apart",
    "ru": "независимо"
  },
  {
    "id": 2745,
    "question": "mistä",
    "answer": "where from",
    "ru": "откуда"
  },
  {
    "id": 2746,
    "question": "näyttävät",
    "answer": "seem",
    "ru": "кажутся"
  },
  {
    "id": 2747,
    "question": "kävely",
    "answer": "walking",
    "ru": "ходьба"
  },
  {
    "id": 2748,
    "question": "turvallista",
    "answer": "safe",
    "ru": "безопасно"
  },
  {
    "id": 2749,
    "question": "avuliaita",
    "answer": "helpful fences",
    "ru": "полезные"
  },
  {
    "id": 2750,
    "question": "maa",
    "answer": "i",
    "ru": "страна"
  },
  {
    "id": 2751,
    "question": "turvallisena",
    "answer": "as safe",
    "ru": "как безопасный"
  },
  {
    "id": 2752,
    "question": "kadut",
    "answer": "the streets",
    "ru": "улицы"
  },
  {
    "id": 2753,
    "question": "valaistuja",
    "answer": "enlightened",
    "ru": "освещённые"
  },
  {
    "id": 2754,
    "question": "vaaratilanteita",
    "answer": "dangerous situations",
    "ru": "опасные ситуации"
  },
  {
    "id": 2755,
    "question": "poliisi",
    "answer": "police",
    "ru": "полиция"
  },
  {
    "id": 2756,
    "question": "valmis",
    "answer": "ready",
    "ru": "готов"
  },
  {
    "id": 2757,
    "question": "auttamaan",
    "answer": "to help",
    "ru": "помогать"
  },
  {
    "id": 2758,
    "question": "turvallisemmaksi",
    "answer": "safer",
    "ru": "более безопасным"
  },
  {
    "id": 2759,
    "question": "ollessaan",
    "answer": "while being",
    "ru": "находясь"
  },
  {
    "id": 2760,
    "question": "opiskelijat",
    "answer": "students",
    "ru": "студенты"
  },
  {
    "id": 2761,
    "question": "työntekijät",
    "answer": "employees",
    "ru": "работники"
  },
  {
    "id": 2762,
    "question": "kävelevät",
    "answer": "are walking",
    "ru": "идут пешком"
  },
  {
    "id": 2763,
    "question": "luottaa",
    "answer": "trust",
    "ru": "доверять"
  },
  {
    "id": 2764,
    "question": "oleviin",
    "answer": "to those who are",
    "ru": "тем, кто есть"
  },
  {
    "id": 2765,
    "question": "kävellä",
    "answer": "walk",
    "ru": "ходить"
  },
  {
    "id": 2766,
    "question": "turvallinen",
    "answer": "safe",
    "ru": "безопасный"
  },
  {
    "id": 2767,
    "question": "kävellessä",
    "answer": "while walking",
    "ru": "при ходьбе"
  },
  {
    "id": 2768,
    "question": "tietoinen",
    "answer": "aware",
    "ru": "осведомлённый"
  },
  {
    "id": 2769,
    "question": "ympäristöstäsi",
    "answer": "your environment",
    "ru": "свою окружающую среду"
  },
  {
    "id": 2770,
    "question": "ryhtyä",
    "answer": "start",
    "ru": "начать"
  },
  {
    "id": 2771,
    "question": "varotoimiin",
    "answer": "precautions",
    "ru": "меры предосторожности"
  },
  {
    "id": 2772,
    "question": "yleisesti",
    "answer": "generally",
    "ru": "в целом"
  },
  {
    "id": 2773,
    "question": "ottaen",
    "answer": "taking",
    "ru": "принимая"
  },
  {
    "id": 2774,
    "question": "kävelemisestä",
    "answer": "from walking",
    "ru": "от ходьбы"
  },
  {
    "id": 2775,
    "question": "kaduilla",
    "answer": "in the streets",
    "ru": "на улицах"
  },
  {
    "id": 2776,
    "question": "petteri",
    "answer": "peter",
    "ru": "Петтери"
  },
  {
    "id": 2777,
    "question": "eniten",
    "answer": "the most",
    "ru": "больше всего"
  },
  {
    "id": 2778,
    "question": "pettymys",
    "answer": "frustration",
    "ru": "разочарование"
  },
  {
    "id": 2779,
    "question": "ravintolassa",
    "answer": "in the restaurant",
    "ru": "в ресторане"
  },
  {
    "id": 2780,
    "question": "jaettava",
    "answer": "dividend",
    "ru": "распределяемый"
  },
  {
    "id": 2781,
    "question": "näytti",
    "answer": "seemed",
    "ru": "казалось"
  },
  {
    "id": 2782,
    "question": "menevän",
    "answer": "to go",
    "ru": "идти"
  },
  {
    "id": 2783,
    "question": "pieleen",
    "answer": "wrong",
    "ru": "не так"
  },
  {
    "id": 2784,
    "question": "ensinnäkin",
    "answer": "in the first place",
    "ru": "прежде всего"
  },
  {
    "id": 2785,
    "question": "palvelu",
    "answer": "service",
    "ru": "обслуживание"
  },
  {
    "id": 2786,
    "question": "uskomattoman",
    "answer": "incredibly",
    "ru": "невероятно"
  },
  {
    "id": 2787,
    "question": "hidasta",
    "answer": "slow down",
    "ru": "медленно"
  },
  {
    "id": 2788,
    "question": "kesti",
    "answer": "lasted",
    "ru": "длился"
  },
  {
    "id": 2789,
    "question": "ruokamme",
    "answer": "our food",
    "ru": "наша еда"
  },
  {
    "id": 2790,
    "question": "lopulta",
    "answer": "eventually",
    "ru": "в конце концов"
  },
  {
    "id": 2791,
    "question": "tilaukseni",
    "answer": "my order",
    "ru": "мой заказ"
  },
  {
    "id": 2792,
    "question": "väärä",
    "answer": "wrong",
    "ru": "неправильный"
  },
  {
    "id": 2793,
    "question": "tuntui",
    "answer": "felt",
    "ru": "ощущалось"
  },
  {
    "id": 2794,
    "question": "sarjalta",
    "answer": "from the series",
    "ru": "из серии"
  },
  {
    "id": 2795,
    "question": "ikäviä",
    "answer": "boring",
    "ru": "неприятные"
  },
  {
    "id": 2796,
    "question": "tapahtumia",
    "answer": "events",
    "ru": "события"
  },
  {
    "id": 2797,
    "question": "odotin",
    "answer": "i waited",
    "ru": "я ждал"
  },
  {
    "id": 2798,
    "question": "mukavan",
    "answer": "nice",
    "ru": "приятного"
  },
  {
    "id": 2799,
    "question": "aterian",
    "answer": "a meal",
    "ru": "трапезу"
  },
  {
    "id": 2800,
    "question": "nauttimista",
    "answer": "enjoyment",
    "ru": "удовольствие"
  },
  {
    "id": 2801,
    "question": "kokemus",
    "answer": "experience",
    "ru": "опыт"
  },
  {
    "id": 2802,
    "question": "turhautumaan",
    "answer": "to get frustrated",
    "ru": "раздражаться"
  },
  {
    "id": 2803,
    "question": "pettymään",
    "answer": "to be disappointed",
    "ru": "разочаровываться"
  },
  {
    "id": 2804,
    "question": "sääli",
    "answer": "shawl",
    "ru": "жаль"
  },
  {
    "id": 2805,
    "question": "kuullut",
    "answer": "heard",
    "ru": "слышал"
  },
  {
    "id": 2806,
    "question": "paikasta",
    "answer": "from the place",
    "ru": "о месте"
  },
  {
    "id": 2807,
    "question": "aiemmin",
    "answer": "previously",
    "ru": "ранее"
  },
  {
    "id": 2808,
    "question": "juuri",
    "answer": "just",
    "ru": "только что"
  },
  {
    "id": 2809,
    "question": "ravintolan",
    "answer": "the restaurant",
    "ru": "ресторана"
  },
  {
    "id": 2810,
    "question": "johtoon",
    "answer": "to the lead",
    "ru": "руководству"
  },
  {
    "id": 2811,
    "question": "huoleni",
    "answer": "my worries",
    "ru": "мои беспокойства"
  },
  {
    "id": 2812,
    "question": "katsoa",
    "answer": "look",
    "ru": "посмотреть"
  },
  {
    "id": 2813,
    "question": "selviävätkö",
    "answer": "will they survive?",
    "ru": "выживут ли они"
  },
  {
    "id": 2814,
    "question": "jotenkin",
    "answer": "somehow",
    "ru": "как-нибудь"
  },
  {
    "id": 2815,
    "question": "palautetta",
    "answer": "feedback",
    "ru": "обратная связь"
  },
  {
    "id": 2816,
    "question": "palveluitaan",
    "answer": "their services",
    "ru": "свои услуги"
  },
  {
    "id": 2817,
    "question": "asiakkaille",
    "answer": "to customers",
    "ru": "клиентам"
  },
  {
    "id": 2818,
    "question": "toivottavasti",
    "answer": "hopefully",
    "ru": "надеюсь"
  },
  {
    "id": 2819,
    "question": "palautteeni",
    "answer": "my feedback",
    "ru": "мой отзыв"
  },
  {
    "id": 2820,
    "question": "vakavasti",
    "answer": "seriously",
    "ru": "серьёзно"
  },
  {
    "id": 2821,
    "question": "parantamaan",
    "answer": "to heal",
    "ru": "улучшать"
  },
  {
    "id": 2822,
    "question": "rakas",
    "answer": "love",
    "ru": "дорогой"
  },
  {
    "id": 2823,
    "question": "mika",
    "answer": "what",
    "ru": "Мика"
  },
  {
    "id": 2824,
    "question": "viihdyt",
    "answer": "you're having fun",
    "ru": "тебе хорошо"
  },
  {
    "id": 2825,
    "question": "italiassa",
    "answer": "in italy",
    "ru": "в Италии"
  },
  {
    "id": 2826,
    "question": "kissasi",
    "answer": "your cat",
    "ru": "твой кот"
  },
  {
    "id": 2827,
    "question": "käynyt",
    "answer": "visited",
    "ru": "заходил"
  },
  {
    "id": 2828,
    "question": "varmistamassa",
    "answer": "making sure",
    "ru": "убеждаясь"
  },
  {
    "id": 2829,
    "question": "hänellä",
    "answer": "he has",
    "ru": "у него есть"
  },
  {
    "id": 2830,
    "question": "kotisi",
    "answer": "your home",
    "ru": "твой дом"
  },
  {
    "id": 2831,
    "question": "hyvässä",
    "answer": "in good",
    "ru": "в хорошем"
  },
  {
    "id": 2832,
    "question": "mistään",
    "answer": "anything",
    "ru": "ничем"
  },
  {
    "id": 2833,
    "question": "italia",
    "answer": "italy",
    "ru": "Италия"
  },
  {
    "id": 2834,
    "question": "uskomattomalta",
    "answer": "unbelievable",
    "ru": "невероятно"
  },
  {
    "id": 2835,
    "question": "kuulemaan",
    "answer": "to hear",
    "ru": "услышать"
  },
  {
    "id": 2836,
    "question": "seikkailuistasi",
    "answer": "about your adventures",
    "ru": "о твоих приключениях"
  },
  {
    "id": 2837,
    "question": "palaat",
    "answer": "you return",
    "ru": "ты возвращаешься"
  },
  {
    "id": 2838,
    "question": "lyön",
    "answer": "i'm hitting",
    "ru": "я держу пари"
  },
  {
    "id": 2839,
    "question": "vetoa",
    "answer": "bet",
    "ru": "пари"
  },
  {
    "id": 2840,
    "question": "uskomatonta",
    "answer": "unbelievable",
    "ru": "невероятное"
  },
  {
    "id": 2841,
    "question": "tuo",
    "answer": "that",
    "ru": "тот"
  },
  {
    "id": 2842,
    "question": "matkamuisto",
    "answer": "souvenir",
    "ru": "сувенир"
  },
  {
    "id": 2843,
    "question": "italiasta",
    "answer": "from italy",
    "ru": "из Италии"
  },
  {
    "id": 2844,
    "question": "sain",
    "answer": "i got it",
    "ru": "я получил"
  },
  {
    "id": 2845,
    "question": "vihdoin",
    "answer": "finally",
    "ru": "наконец"
  },
  {
    "id": 2846,
    "question": "viimeisteltyä",
    "answer": "finished",
    "ru": "завершённый"
  },
  {
    "id": 2847,
    "question": "olohuoneeni",
    "answer": "my living room",
    "ru": "моя гостиная"
  },
  {
    "id": 2848,
    "question": "remontin",
    "answer": "renovation",
    "ru": "ремонт"
  },
  {
    "id": 2849,
    "question": "upealta",
    "answer": "wonderful",
    "ru": "замечательно"
  },
  {
    "id": 2850,
    "question": "katsomaan",
    "answer": "to watch",
    "ru": "смотреть"
  },
  {
    "id": 2851,
    "question": "nauti",
    "answer": "enjoy",
    "ru": "наслаждайся"
  },
  {
    "id": 2852,
    "question": "loppulomastasi",
    "answer": "the end of your vacation",
    "ru": "конец твоего отпуска"
  },
  {
    "id": 2853,
    "question": "parhaat",
    "answer": "best",
    "ru": "лучшие"
  },
  {
    "id": 2854,
    "question": "olga",
    "answer": "olga",
    "ru": "Ольга"
  },
  {
    "id": 2855,
    "question": "piti",
    "answer": "had to",
    "ru": "должна была"
  },
  {
    "id": 2856,
    "question": "yllätyksestä",
    "answer": "out of surprise",
    "ru": "от неожиданности"
  },
  {
    "id": 2857,
    "question": "koin",
    "answer": "i felt",
    "ru": "я почувствовал"
  },
  {
    "id": 2858,
    "question": "työssäni",
    "answer": "in my work",
    "ru": "в своей работе"
  },
  {
    "id": 2859,
    "question": "uskoa",
    "answer": "believe",
    "ru": "верить"
  },
  {
    "id": 2860,
    "question": "järjestivät",
    "answer": "organized",
    "ru": "организовали"
  },
  {
    "id": 2861,
    "question": "pienen",
    "answer": "a small one",
    "ru": "небольшой"
  },
  {
    "id": 2862,
    "question": "tervetuliaisjuhlan",
    "answer": "welcome party",
    "ru": "вечеринку в честь прихода"
  },
  {
    "id": 2863,
    "question": "aavistustakaan",
    "answer": "no idea",
    "ru": "ни малейшего понятия"
  },
  {
    "id": 2864,
    "question": "tekisivät",
    "answer": "would do",
    "ru": "сделали бы"
  },
  {
    "id": 2865,
    "question": "saadakseen",
    "answer": "for",
    "ru": "чтобы получить"
  },
  {
    "id": 2866,
    "question": "tervetulleeksi",
    "answer": "welcome",
    "ru": "добро пожаловать"
  },
  {
    "id": 2867,
    "question": "ele",
    "answer": "gesture",
    "ru": "жест"
  },
  {
    "id": 2868,
    "question": "auttoi",
    "answer": "helped",
    "ru": "помог"
  },
  {
    "id": 2869,
    "question": "helpottamaan",
    "answer": "to facilitate",
    "ru": "облегчить"
  },
  {
    "id": 2870,
    "question": "hermojani",
    "answer": "my nerves",
    "ru": "мои нервы"
  },
  {
    "id": 2871,
    "question": "aloittaessani",
    "answer": "when i started",
    "ru": "когда я начинал"
  },
  {
    "id": 2872,
    "question": "innostunut",
    "answer": "enthusiastic",
    "ru": "воодушевлённый"
  },
  {
    "id": 2873,
    "question": "luottavainen",
    "answer": "confident",
    "ru": "уверенный"
  },
  {
    "id": 2874,
    "question": "aion",
    "answer": "i will",
    "ru": "я намерен"
  },
  {
    "id": 2875,
    "question": "kollegoihini",
    "answer": "to my colleagues",
    "ru": "своим коллегам"
  },
  {
    "id": 2876,
    "question": "hyödyntää",
    "answer": "utilize",
    "ru": "использовать"
  },
  {
    "id": 2877,
    "question": "mahdollisuutta",
    "answer": "possibility",
    "ru": "возможность"
  },
  {
    "id": 2878,
    "question": "parhaalla",
    "answer": "at its best",
    "ru": "наилучшим образом"
  },
  {
    "id": 2879,
    "question": "mahdollisella",
    "answer": "possible",
    "ru": "возможный"
  },
  {
    "id": 2880,
    "question": "mahtavalta",
    "answer": "awesome",
    "ru": "великолепно"
  },
  {
    "id": 2881,
    "question": "joukkueelta",
    "answer": "from the team",
    "ru": "от команды"
  },
  {
    "id": 2882,
    "question": "näen",
    "answer": "i see",
    "ru": "я вижу"
  },
  {
    "id": 2883,
    "question": "minua",
    "answer": "me",
    "ru": "меня"
  },
  {
    "id": 2884,
    "question": "tarjolla",
    "answer": "on offer",
    "ru": "в наличии"
  },
  {
    "id": 2885,
    "question": "terveisiä",
    "answer": "greetings",
    "ru": "привет"
  },
  {
    "id": 2886,
    "question": "vanhemmille",
    "answer": "for parents",
    "ru": "родителям"
  },
  {
    "id": 2887,
    "question": "hoitaa",
    "answer": "to take care",
    "ru": "заботиться"
  },
  {
    "id": 2888,
    "question": "lasta",
    "answer": "spatula",
    "ru": "ребёнка"
  },
  {
    "id": 2889,
    "question": "rakastetuksi",
    "answer": "to be loved",
    "ru": "быть любимым"
  },
  {
    "id": 2890,
    "question": "joustaa",
    "answer": "be elastic",
    "ru": "быть гибким"
  },
  {
    "id": 2891,
    "question": "päivittäisessä",
    "answer": "in the daily",
    "ru": "в ежедневном"
  },
  {
    "id": 2892,
    "question": "rutiinissaan",
    "answer": "in his routine",
    "ru": "в своём распорядке"
  },
  {
    "id": 2893,
    "question": "huomiota",
    "answer": "attention",
    "ru": "внимание"
  },
  {
    "id": 2894,
    "question": "pelaamatta",
    "answer": "without playing",
    "ru": "не играя"
  },
  {
    "id": 2895,
    "question": "ystävystyä",
    "answer": "make friends",
    "ru": "подружиться"
  },
  {
    "id": 2896,
    "question": "päiväkodit",
    "answer": "kindergartens",
    "ru": "детские сады"
  },
  {
    "id": 2897,
    "question": "noudattavat",
    "answer": "comply with",
    "ru": "соблюдают"
  },
  {
    "id": 2898,
    "question": "rutiinia",
    "answer": "routine",
    "ru": "распорядок"
  },
  {
    "id": 2899,
    "question": "valmistautumaan",
    "answer": "to prepare",
    "ru": "подготовиться"
  },
  {
    "id": 2900,
    "question": "sairastuu",
    "answer": "gets sick",
    "ru": "заболевает"
  },
  {
    "id": 2901,
    "question": "toisista",
    "answer": "from others",
    "ru": "от других"
  },
  {
    "id": 2902,
    "question": "lapsista",
    "answer": "about children",
    "ru": "о детях"
  },
  {
    "id": 2903,
    "question": "hyvän",
    "answer": "good",
    "ru": "хорошего"
  },
  {
    "id": 2904,
    "question": "löytämisestä",
    "answer": "about finding",
    "ru": "о нахождении"
  },
  {
    "id": 2905,
    "question": "huolehtivien",
    "answer": "caring",
    "ru": "заботливых"
  },
  {
    "id": 2906,
    "question": "lapselleen",
    "answer": "to his child",
    "ru": "своему ребёнку"
  },
  {
    "id": 2907,
    "question": "perheelleen",
    "answer": "to his family",
    "ru": "своей семье"
  },
  {
    "id": 2908,
    "question": "lapsen",
    "answer": "of the child",
    "ru": "ребёнка"
  },
  {
    "id": 2909,
    "question": "keskusteleminen",
    "answer": "talking",
    "ru": "разговор"
  },
  {
    "id": 2910,
    "question": "vieraileminen",
    "answer": "visiting",
    "ru": "посещение"
  },
  {
    "id": 2911,
    "question": "päiväkodeissa",
    "answer": "in kindergartens",
    "ru": "в детских садах"
  },
  {
    "id": 2912,
    "question": "oikean",
    "answer": "the right one",
    "ru": "правильного"
  },
  {
    "id": 2913,
    "question": "valinnan",
    "answer": "choice",
    "ru": "выбор"
  },
  {
    "id": 2914,
    "question": "tärkeintä",
    "answer": "the most important thing",
    "ru": "самое важное"
  },
  {
    "id": 2915,
    "question": "yhdelle",
    "answer": "for one",
    "ru": "для одного"
  },
  {
    "id": 2916,
    "question": "vaistoihisi",
    "answer": "to your instincts",
    "ru": "своим инстинктам"
  },
  {
    "id": 2917,
    "question": "vanhempana",
    "answer": "as a parent",
    "ru": "как родитель"
  },
  {
    "id": 2918,
    "question": "parhaan",
    "answer": "the best",
    "ru": "наилучшего"
  },
  {
    "id": 2919,
    "question": "päätöksen",
    "answer": "the decision",
    "ru": "решение"
  },
  {
    "id": 2920,
    "question": "pikkuisellesi",
    "answer": "for your little one",
    "ru": "для своего малыша"
  },
  {
    "id": 2921,
    "question": "monissa",
    "answer": "in many",
    "ru": "во многих"
  },
  {
    "id": 2922,
    "question": "muissakin",
    "answer": "in others too",
    "ru": "и в других тоже"
  },
  {
    "id": 2923,
    "question": "maissa",
    "answer": "ashore",
    "ru": "в странах"
  },
  {
    "id": 2924,
    "question": "myönnetään",
    "answer": "granted",
    "ru": "предоставляется"
  },
  {
    "id": 2925,
    "question": "ikä",
    "answer": "age",
    "ru": "возраст"
  },
  {
    "id": 2926,
    "question": "hankkia",
    "answer": "acquire",
    "ru": "получить"
  },
  {
    "id": 2927,
    "question": "meitä",
    "answer": "us",
    "ru": "нас"
  },
  {
    "id": 2928,
    "question": "ajamaan",
    "answer": "to drive",
    "ru": "водить"
  },
  {
    "id": 2929,
    "question": "autoa",
    "answer": "car",
    "ru": "машину"
  },
  {
    "id": 2930,
    "question": "liikkumaan",
    "answer": "to move",
    "ru": "передвигаться"
  },
  {
    "id": 2931,
    "question": "minunkin",
    "answer": "mine too",
    "ru": "и моё тоже"
  },
  {
    "id": 2932,
    "question": "maassani",
    "answer": "in my country",
    "ru": "в моей стране"
  },
  {
    "id": 2933,
    "question": "yläikärajan",
    "answer": "the upper age limit",
    "ru": "верхнюю возрастную границу"
  },
  {
    "id": 2934,
    "question": "henkilön",
    "answer": "person",
    "ru": "человека"
  },
  {
    "id": 2935,
    "question": "terveys",
    "answer": "health",
    "ru": "здоровье"
  },
  {
    "id": 2936,
    "question": "salli",
    "answer": "fellow",
    "ru": "позволять"
  },
  {
    "id": 2937,
    "question": "ajokoe",
    "answer": "driving test",
    "ru": "экзамен по вождению"
  },
  {
    "id": 2938,
    "question": "yksinkertaisempi",
    "answer": "more simple",
    "ru": "более простой"
  },
  {
    "id": 2939,
    "question": "halvempi",
    "answer": "cheaper",
    "ru": "дешевле"
  },
  {
    "id": 2940,
    "question": "saamiseksi",
    "answer": "to obtain",
    "ru": "для получения"
  },
  {
    "id": 2941,
    "question": "opittava",
    "answer": "to learn",
    "ru": "выучить"
  },
  {
    "id": 2942,
    "question": "liikennesäännöt",
    "answer": "traffic rules",
    "ru": "правила дорожного движения"
  },
  {
    "id": 2943,
    "question": "asioiden",
    "answer": "things",
    "ru": "вещей"
  },
  {
    "id": 2944,
    "question": "ajokorttinsa",
    "answer": "his driver's license",
    "ru": "его водительские права"
  },
  {
    "id": 2945,
    "question": "asentaa",
    "answer": "install",
    "ru": "устанавливать"
  },
  {
    "id": 2946,
    "question": "laitteita",
    "answer": "devices",
    "ru": "устройства"
  },
  {
    "id": 2947,
    "question": "käyttäjän",
    "answer": "of the user",
    "ru": "пользователя"
  },
  {
    "id": 2948,
    "question": "autoon",
    "answer": "to the car",
    "ru": "в автомобиль"
  },
  {
    "id": 2949,
    "question": "valvoa",
    "answer": "stay up",
    "ru": "следить"
  },
  {
    "id": 2950,
    "question": "suorituskykyä",
    "answer": "performance",
    "ru": "производительность"
  },
  {
    "id": 2951,
    "question": "tiellä",
    "answer": "on the road",
    "ru": "на дороге"
  },
  {
    "id": 2952,
    "question": "perusteella",
    "answer": "by",
    "ru": "на основании"
  },
  {
    "id": 2953,
    "question": "tarvitseeko",
    "answer": "do you need",
    "ru": "нужно ли"
  },
  {
    "id": 2954,
    "question": "teistämme",
    "answer": "of our roads",
    "ru": "наших дорог"
  },
  {
    "id": 2955,
    "question": "turvallisempia",
    "answer": "safer",
    "ru": "более безопасными"
  },
  {
    "id": 2956,
    "question": "ekomatkailuna",
    "answer": "as ecotourism",
    "ru": "как экотуризм"
  },
  {
    "id": 2957,
    "question": "matkustustapa",
    "answer": "mode of travel",
    "ru": "способ передвижения"
  },
  {
    "id": 2958,
    "question": "yritetään",
    "answer": "let's try",
    "ru": "давайте попробуем"
  },
  {
    "id": 2959,
    "question": "ympäristöstä",
    "answer": "from the environment",
    "ru": "из окружающей среды"
  },
  {
    "id": 2960,
    "question": "käyntiä",
    "answer": "visits",
    "ru": "визиты"
  },
  {
    "id": 2961,
    "question": "metsissä",
    "answer": "in the forests",
    "ru": "в лесах"
  },
  {
    "id": 2962,
    "question": "vuorilla",
    "answer": "in the mountains",
    "ru": "в горах"
  },
  {
    "id": 2963,
    "question": "vahingoittamatta",
    "answer": "without harming",
    "ru": "не причиняя вреда"
  },
  {
    "id": 2964,
    "question": "ajatuksesta",
    "answer": "of thought",
    "ru": "о мысли"
  },
  {
    "id": 2965,
    "question": "suojelemaan",
    "answer": "to protect",
    "ru": "защищать"
  },
  {
    "id": 2966,
    "question": "tapa",
    "answer": "way",
    "ru": "способ"
  },
  {
    "id": 2967,
    "question": "kasveista",
    "answer": "of plants",
    "ru": "о растениях"
  },
  {
    "id": 2968,
    "question": "eläimistä",
    "answer": "about animals",
    "ru": "о животных"
  },
  {
    "id": 2969,
    "question": "varmistaen",
    "answer": "making sure",
    "ru": "убеждаясь"
  },
  {
    "id": 2970,
    "question": "pysyvät",
    "answer": "are permanent",
    "ru": "остаются"
  },
  {
    "id": 2971,
    "question": "puoli",
    "answer": "half",
    "ru": "половина"
  },
  {
    "id": 2972,
    "question": "ekologisessa",
    "answer": "in ecological",
    "ru": "в экологическом"
  },
  {
    "id": 2973,
    "question": "matkailussa",
    "answer": "in tourism",
    "ru": "в туризме"
  },
  {
    "id": 2974,
    "question": "paikallisiin",
    "answer": "to the locals",
    "ru": "к местным жителям"
  },
  {
    "id": 2975,
    "question": "kaupunkeihin",
    "answer": "to cities",
    "ru": "в города"
  },
  {
    "id": 2976,
    "question": "kyliin",
    "answer": "to the villages",
    "ru": "в деревни"
  },
  {
    "id": 2977,
    "question": "yöpyä",
    "answer": "bunk",
    "ru": "ночевать"
  },
  {
    "id": 2978,
    "question": "hotelleissa",
    "answer": "in hotels",
    "ru": "в отелях"
  },
  {
    "id": 2979,
    "question": "syödä",
    "answer": "eat",
    "ru": "есть"
  },
  {
    "id": 2980,
    "question": "ravintoloissa",
    "answer": "in restaurants",
    "ru": "в ресторанах"
  },
  {
    "id": 2981,
    "question": "tavaroita",
    "answer": "goods",
    "ru": "товары"
  },
  {
    "id": 2982,
    "question": "paikallisista",
    "answer": "from locals",
    "ru": "от местных жителей"
  },
  {
    "id": 2983,
    "question": "kaupoista",
    "answer": "from shops",
    "ru": "из магазинов"
  },
  {
    "id": 2984,
    "question": "näitä",
    "answer": "these",
    "ru": "эти"
  },
  {
    "id": 2985,
    "question": "kehittymään",
    "answer": "to develop",
    "ru": "развиваться"
  },
  {
    "id": 2986,
    "question": "paremmiksi",
    "answer": "to be better",
    "ru": "стать лучше"
  },
  {
    "id": 2987,
    "question": "rohkaista",
    "answer": "encourage",
    "ru": "поощрять"
  },
  {
    "id": 2988,
    "question": "paikallisia",
    "answer": "locals",
    "ru": "местных жителей"
  },
  {
    "id": 2989,
    "question": "ympäristöstään",
    "answer": "from their environment",
    "ru": "из своей окружающей среды"
  },
  {
    "id": 2990,
    "question": "olevan",
    "answer": "to be",
    "ru": "быть"
  },
  {
    "id": 2991,
    "question": "yritykselleen",
    "answer": "to his company",
    "ru": "своей компании"
  },
  {
    "id": 2992,
    "question": "asiassa",
    "answer": "in the matter",
    "ru": "в данном вопросе"
  },
  {
    "id": 2993,
    "question": "luonnolle",
    "answer": "to nature",
    "ru": "природе"
  },
  {
    "id": 2994,
    "question": "ajattelevat",
    "answer": "are thinking",
    "ru": "думают"
  },
  {
    "id": 2995,
    "question": "pelotella",
    "answer": "scare",
    "ru": "пугать"
  },
  {
    "id": 2996,
    "question": "hotellien",
    "answer": "of hotels",
    "ru": "гостиниц"
  },
  {
    "id": 2997,
    "question": "teiden",
    "answer": "you did",
    "ru": "дорог"
  },
  {
    "id": 2998,
    "question": "rakentaminen",
    "answer": "construction",
    "ru": "строительство"
  },
  {
    "id": 2999,
    "question": "turisteille",
    "answer": "for tourists",
    "ru": "для туристов"
  },
  {
    "id": 3000,
    "question": "kuluttaa",
    "answer": "consume",
    "ru": "потреблять"
  },
  {
    "id": 3001,
    "question": "maapallon",
    "answer": "terrestrial",
    "ru": "земные"
  },
  {
    "id": 3002,
    "question": "luonnonvaroja",
    "answer": "natural resources",
    "ru": "природные ресурсы"
  },
  {
    "id": 3003,
    "question": "saastumista",
    "answer": "pollution",
    "ru": "загрязнение"
  },
  {
    "id": 3004,
    "question": "osalliset",
    "answer": "involved",
    "ru": "причастные"
  },
  {
    "id": 3005,
    "question": "muuten",
    "answer": "otherwise",
    "ru": "в противном случае"
  },
  {
    "id": 3006,
    "question": "auta",
    "answer": "help",
    "ru": "помоги"
  },
  {
    "id": 3007,
    "question": "tilannetta",
    "answer": "the situation.",
    "ru": "ситуацию"
  },
  {
    "id": 3008,
    "question": "työssä",
    "answer": "at work",
    "ru": "на работе"
  },
  {
    "id": 3009,
    "question": "tunnet",
    "answer": "you know",
    "ru": "ты знаешь"
  },
  {
    "id": 3010,
    "question": "tehdessäsi",
    "answer": "while doing",
    "ru": "делая"
  },
  {
    "id": 3011,
    "question": "työtäsi",
    "answer": "your work",
    "ru": "твою работу"
  },
  {
    "id": 3012,
    "question": "toimeen",
    "answer": "get along",
    "ru": "ладить"
  },
  {
    "id": 3013,
    "question": "helpompaa",
    "answer": "easier",
    "ru": "легче"
  },
  {
    "id": 3014,
    "question": "nautinnollisempaa",
    "answer": "more enjoyable",
    "ru": "более приятным"
  },
  {
    "id": 3015,
    "question": "mukavaa",
    "answer": "nice",
    "ru": "приятно"
  },
  {
    "id": 3016,
    "question": "pomo",
    "answer": "boss",
    "ru": "начальник"
  },
  {
    "id": 3017,
    "question": "työtoverit",
    "answer": "colleagues",
    "ru": "коллеги"
  },
  {
    "id": 3018,
    "question": "kuuntelevat",
    "answer": "are listening",
    "ru": "слушают"
  },
  {
    "id": 3019,
    "question": "ajatuksiasi",
    "answer": "your thoughts",
    "ru": "твои мысли"
  },
  {
    "id": 3020,
    "question": "motivoituneempia",
    "answer": "more motivated",
    "ru": "более мотивированными"
  },
  {
    "id": 3021,
    "question": "yhteydessä",
    "answer": "in connection with",
    "ru": "в связи"
  },
  {
    "id": 3022,
    "question": "työhönsä",
    "answer": "to his work",
    "ru": "к своей работе"
  },
  {
    "id": 3023,
    "question": "joukkueesta",
    "answer": "from the team",
    "ru": "из команды"
  },
  {
    "id": 3024,
    "question": "vahvemman",
    "answer": "stronger",
    "ru": "более сильной"
  },
  {
    "id": 3025,
    "question": "menestyvämmän",
    "answer": "more successful",
    "ru": "более успешной"
  },
  {
    "id": 3026,
    "question": "kuitenkaan",
    "answer": "however",
    "ru": "однако"
  },
  {
    "id": 3027,
    "question": "onnettomaksi",
    "answer": "unhappy",
    "ru": "несчастным"
  },
  {
    "id": 3028,
    "question": "stressaantuneeksi",
    "answer": "stressed out",
    "ru": "в стрессе"
  },
  {
    "id": 3029,
    "question": "pomot",
    "answer": "the bosses",
    "ru": "начальники"
  },
  {
    "id": 3030,
    "question": "ymmärtäväisiä",
    "answer": "understanding",
    "ru": "понимающими"
  },
  {
    "id": 3031,
    "question": "pärjätä",
    "answer": "to manage",
    "ru": "справляться"
  },
  {
    "id": 3032,
    "question": "onnellisemmaksi",
    "answer": "happier",
    "ru": "счастливее"
  },
  {
    "id": 3033,
    "question": "elämässäni",
    "answer": "in my life",
    "ru": "в моей жизни"
  },
  {
    "id": 3034,
    "question": "isoisäni",
    "answer": "my grandfather",
    "ru": "мой дедушка"
  },
  {
    "id": 3035,
    "question": "horjumattoman",
    "answer": "unwavering",
    "ru": "непоколебимой"
  },
  {
    "id": 3036,
    "question": "tuen",
    "answer": "support",
    "ru": "поддержка"
  },
  {
    "id": 3037,
    "question": "ohjauksen",
    "answer": "guidance",
    "ru": "руководство"
  },
  {
    "id": 3038,
    "question": "lähde",
    "answer": "source",
    "ru": "источник"
  },
  {
    "id": 3039,
    "question": "myötätuntoinen",
    "answer": "compassionate",
    "ru": "сострадательный"
  },
  {
    "id": 3040,
    "question": "viisas",
    "answer": "wise",
    "ru": "мудрый"
  },
  {
    "id": 3041,
    "question": "yksilö",
    "answer": "individual",
    "ru": "личность"
  },
  {
    "id": 3042,
    "question": "runsaasti",
    "answer": "in abundance",
    "ru": "в изобилии"
  },
  {
    "id": 3043,
    "question": "elämänkokemusta",
    "answer": "life experience",
    "ru": "жизненный опыт"
  },
  {
    "id": 3044,
    "question": "avokätisesti",
    "answer": "generously",
    "ru": "щедро"
  },
  {
    "id": 3045,
    "question": "voimanpylväs",
    "answer": "pillar of strength",
    "ru": "столп силы"
  },
  {
    "id": 3046,
    "question": "tarjoten",
    "answer": "offering",
    "ru": "предлагая"
  },
  {
    "id": 3047,
    "question": "korvaamattomia",
    "answer": "irreplaceable",
    "ru": "неоценимые"
  },
  {
    "id": 3048,
    "question": "neuvoja",
    "answer": "counselor",
    "ru": "советы"
  },
  {
    "id": 3049,
    "question": "rohkaisua",
    "answer": "encouragement",
    "ru": "поощрение"
  },
  {
    "id": 3050,
    "question": "haastavina",
    "answer": "as challenging",
    "ru": "в трудные"
  },
  {
    "id": 3051,
    "question": "iloisinakin",
    "answer": "even when happy",
    "ru": "и в радостные"
  },
  {
    "id": 3052,
    "question": "hetkinä",
    "answer": "in moments",
    "ru": "в моменты"
  },
  {
    "id": 3053,
    "question": "isoisässäni",
    "answer": "in my grandfather",
    "ru": "в моём дедушке"
  },
  {
    "id": 3054,
    "question": "kykynsä",
    "answer": "his abilities",
    "ru": "его способности"
  },
  {
    "id": 3055,
    "question": "kuunnella",
    "answer": "listen",
    "ru": "слушать"
  },
  {
    "id": 3056,
    "question": "tuomitsematta",
    "answer": "without judgement",
    "ru": "без осуждения"
  },
  {
    "id": 3057,
    "question": "oivaltavia",
    "answer": "insightful",
    "ru": "проницательные"
  },
  {
    "id": 3058,
    "question": "näkökulmia",
    "answer": "perspectives",
    "ru": "точки зрения"
  },
  {
    "id": 3059,
    "question": "auttaneet",
    "answer": "have helped",
    "ru": "помогли"
  },
  {
    "id": 3060,
    "question": "muotoilemaan",
    "answer": "to shape",
    "ru": "формировать"
  },
  {
    "id": 3061,
    "question": "luonnettani",
    "answer": "my character",
    "ru": "мой характер"
  },
  {
    "id": 3062,
    "question": "arvojani",
    "answer": "my values",
    "ru": "мои ценности"
  },
  {
    "id": 3063,
    "question": "vietämme",
    "answer": "we celebrate",
    "ru": "мы отмечаем"
  },
  {
    "id": 3064,
    "question": "elämän",
    "answer": "life",
    "ru": "жизни"
  },
  {
    "id": 3065,
    "question": "puolista",
    "answer": "sides",
    "ru": "стороны"
  },
  {
    "id": 3066,
    "question": "jaamme",
    "answer": "we share",
    "ru": "мы делимся"
  },
  {
    "id": 3067,
    "question": "nautimme",
    "answer": "we enjoy",
    "ru": "мы наслаждаемся"
  },
  {
    "id": 3068,
    "question": "toistemme",
    "answer": "each other",
    "ru": "друг друга"
  },
  {
    "id": 3069,
    "question": "seurasta",
    "answer": "from the club",
    "ru": "из компании"
  },
  {
    "id": 3070,
    "question": "häneltä",
    "answer": "from her",
    "ru": "от неё"
  },
  {
    "id": 3071,
    "question": "kärsivällisyyden",
    "answer": "of patience",
    "ru": "терпения"
  },
  {
    "id": 3072,
    "question": "taitoa",
    "answer": "skill",
    "ru": "умение"
  },
  {
    "id": 3073,
    "question": "empatian",
    "answer": "empathy",
    "ru": "эмпатия"
  },
  {
    "id": 3074,
    "question": "hyvettä",
    "answer": "virtue",
    "ru": "добродетель"
  },
  {
    "id": 3075,
    "question": "josta",
    "answer": "whereof",
    "ru": "о которой"
  },
  {
    "id": 3076,
    "question": "vaivattomasti",
    "answer": "with ease",
    "ru": "непринуждённо"
  },
  {
    "id": 3077,
    "question": "esimerkkinä",
    "answer": "by way of illustration",
    "ru": "в качестве примера"
  },
  {
    "id": 3078,
    "question": "vuorovaikutuksessaan",
    "answer": "in their interaction",
    "ru": "в их взаимодействии"
  },
  {
    "id": 3079,
    "question": "mautonta",
    "answer": "tasteless",
    "ru": "безвкусный"
  },
  {
    "id": 3080,
    "question": "puuttuu",
    "answer": "is missing",
    "ru": "недостаёт"
  },
  {
    "id": 3081,
    "question": "aikaisempien",
    "answer": "of earlier ones",
    "ru": "прежних"
  },
  {
    "id": 3082,
    "question": "tyylien",
    "answer": "styles",
    "ru": "стили"
  },
  {
    "id": 3083,
    "question": "eleganssi",
    "answer": "elegance",
    "ru": "элегантность"
  },
  {
    "id": 3084,
    "question": "kriitikot",
    "answer": "critics",
    "ru": "критики"
  },
  {
    "id": 3085,
    "question": "korostavat",
    "answer": "emphasize",
    "ru": "подчёркивают"
  },
  {
    "id": 3086,
    "question": "keskittymistä",
    "answer": "concentration",
    "ru": "сосредоточенность"
  },
  {
    "id": 3087,
    "question": "paljastaviin",
    "answer": "revealing",
    "ru": "открывающим"
  },
  {
    "id": 3088,
    "question": "vaatteisiin",
    "answer": "to clothes",
    "ru": "на одежду"
  },
  {
    "id": 3089,
    "question": "mielestään",
    "answer": "in his opinion",
    "ru": "по его мнению"
  },
  {
    "id": 3090,
    "question": "heikentää",
    "answer": "weaken",
    "ru": "ослабляет"
  },
  {
    "id": 3091,
    "question": "hienostuneisuutta",
    "answer": "sophistication",
    "ru": "изысканность"
  },
  {
    "id": 3092,
    "question": "säädyllisyyttä",
    "answer": "decency",
    "ru": "благопристойность"
  },
  {
    "id": 3093,
    "question": "tiukat",
    "answer": "tight",
    "ru": "обтягивающие"
  },
  {
    "id": 3094,
    "question": "rohkeat",
    "answer": "brave ones",
    "ru": "смелые"
  },
  {
    "id": 3095,
    "question": "mallit",
    "answer": "models",
    "ru": "модели"
  },
  {
    "id": 3096,
    "question": "näkemään",
    "answer": "to see",
    "ru": "видеть"
  },
  {
    "id": 3097,
    "question": "modernin",
    "answer": "modern",
    "ru": "современного"
  },
  {
    "id": 3098,
    "question": "tärkeysarvon",
    "answer": "importance value",
    "ru": "ценность значимости"
  },
  {
    "id": 3099,
    "question": "etusijalle",
    "answer": "priority",
    "ru": "в приоритет"
  },
  {
    "id": 3100,
    "question": "hienostuneisuuden",
    "answer": "sophistication",
    "ru": "изысканность"
  },
  {
    "id": 3101,
    "question": "kannattajat",
    "answer": "supporters",
    "ru": "сторонники"
  },
  {
    "id": 3102,
    "question": "juhlii",
    "answer": "celebration",
    "ru": "празднует"
  },
  {
    "id": 3103,
    "question": "yksilöllistä",
    "answer": "individual",
    "ru": "индивидуальный"
  },
  {
    "id": 3104,
    "question": "ilmaisua",
    "answer": "expression",
    "ru": "выражение"
  },
  {
    "id": 3105,
    "question": "voimaantumista",
    "answer": "empowerment",
    "ru": "расширение возможностей"
  },
  {
    "id": 3106,
    "question": "näkevät",
    "answer": "can see",
    "ru": "видят"
  },
  {
    "id": 3107,
    "question": "vapautumisena",
    "answer": "as liberation",
    "ru": "как освобождение"
  },
  {
    "id": 3108,
    "question": "normeista",
    "answer": "of norms",
    "ru": "от норм"
  },
  {
    "id": 3109,
    "question": "monimuotoisuuden",
    "answer": "diversity",
    "ru": "разнообразие"
  },
  {
    "id": 3110,
    "question": "rohkeana",
    "answer": "bravely",
    "ru": "смело"
  },
  {
    "id": 3111,
    "question": "ilmaista",
    "answer": "express",
    "ru": "выражать"
  },
  {
    "id": 3112,
    "question": "yhdestä",
    "answer": "from one",
    "ru": "из одного"
  },
  {
    "id": 3113,
    "question": "mauttomalta",
    "answer": "tasteless",
    "ru": "безвкусным"
  },
  {
    "id": 3114,
    "question": "vapauttavaa",
    "answer": "liberating",
    "ru": "освобождающее"
  },
  {
    "id": 3115,
    "question": "muoti",
    "answer": "fashion",
    "ru": "мода"
  },
  {
    "id": 3116,
    "question": "edustaa",
    "answer": "represent",
    "ru": "представлять"
  },
  {
    "id": 3117,
    "question": "henkilökohtaista",
    "answer": "personal column",
    "ru": "личное"
  },
  {
    "id": 3118,
    "question": "identiteettiä",
    "answer": "identity",
    "ru": "идентичность"
  },
  {
    "id": 3119,
    "question": "sallia",
    "answer": "allow",
    "ru": "позволять"
  },
  {
    "id": 3120,
    "question": "itseilmaisu",
    "answer": "self expression",
    "ru": "самовыражение"
  },
  {
    "id": 3121,
    "question": "vapaus",
    "answer": "freedom",
    "ru": "свобода"
  },
  {
    "id": 3122,
    "question": "tarvitsemmeko",
    "answer": "do we need to",
    "ru": "нужно ли нам"
  },
  {
    "id": 3123,
    "question": "muuttanut",
    "answer": "moved",
    "ru": "переехавший"
  },
  {
    "id": 3124,
    "question": "seurauksia",
    "answer": "consequences",
    "ru": "последствия"
  },
  {
    "id": 3125,
    "question": "sanomalehdille",
    "answer": "to newspapers",
    "ru": "газетам"
  },
  {
    "id": 3126,
    "question": "osta",
    "answer": "buy",
    "ru": "купи"
  },
  {
    "id": 3127,
    "question": "lukea",
    "answer": "read",
    "ru": "читать"
  },
  {
    "id": 3128,
    "question": "vaikeuttanut",
    "answer": "made difficult",
    "ru": "усложнил"
  },
  {
    "id": 3129,
    "question": "sanomalehtien",
    "answer": "newspapers",
    "ru": "газет"
  },
  {
    "id": 3130,
    "question": "ansaitsemista",
    "answer": "earning",
    "ru": "заработок"
  },
  {
    "id": 3131,
    "question": "sulkeneet",
    "answer": "have closed",
    "ru": "закрылись"
  },
  {
    "id": 3132,
    "question": "auttaakseen",
    "answer": "to help",
    "ru": "чтобы помочь"
  },
  {
    "id": 3133,
    "question": "paikallista",
    "answer": "local",
    "ru": "местный"
  },
  {
    "id": 3134,
    "question": "alueellaan",
    "answer": "in their area",
    "ru": "в своём регионе"
  },
  {
    "id": 3135,
    "question": "verkkolehdissä",
    "answer": "in online magazines",
    "ru": "в онлайн-журналах"
  },
  {
    "id": 3136,
    "question": "huonoja",
    "answer": "bad ones",
    "ru": "плохие"
  },
  {
    "id": 3137,
    "question": "ovatko",
    "answer": "are they",
    "ru": "являются ли они"
  },
  {
    "id": 3138,
    "question": "niissä",
    "answer": "in them",
    "ru": "в них"
  },
  {
    "id": 3139,
    "question": "mainoksia",
    "answer": "advertisements",
    "ru": "реклама"
  },
  {
    "id": 3140,
    "question": "ärsyttävää",
    "answer": "annoying",
    "ru": "раздражающее"
  },
  {
    "id": 3141,
    "question": "muuttua",
    "answer": "shift",
    "ru": "меняться"
  },
  {
    "id": 3142,
    "question": "useammat",
    "answer": "more",
    "ru": "больше"
  },
  {
    "id": 3143,
    "question": "lukevat",
    "answer": "are reading",
    "ru": "читают"
  },
  {
    "id": 3144,
    "question": "sanomalehdistä",
    "answer": "from newspapers",
    "ru": "из газет"
  },
  {
    "id": 3145,
    "question": "yleisiä",
    "answer": "common ones",
    "ru": "распространённые"
  },
  {
    "id": 3146,
    "question": "sanomalehdissä",
    "answer": "in newspapers",
    "ru": "в газетах"
  },
  {
    "id": 3147,
    "question": "maailmassa",
    "answer": "in the world",
    "ru": "в мире"
  },
  {
    "id": 3148,
    "question": "iso",
    "answer": "major",
    "ru": "крупный"
  },
  {
    "id": 3149,
    "question": "huonot",
    "answer": "the bad ones",
    "ru": "плохие"
  },
  {
    "id": 3150,
    "question": "vuokraaminen",
    "answer": "lease",
    "ru": "аренда"
  },
  {
    "id": 3151,
    "question": "sitoutua",
    "answer": "commit",
    "ru": "брать на себя обязательство"
  },
  {
    "id": 3152,
    "question": "pitkäaikaiseen",
    "answer": "long-term",
    "ru": "долгосрочным"
  },
  {
    "id": 3153,
    "question": "sijoitukseen",
    "answer": "to the investment",
    "ru": "к инвестиции"
  },
  {
    "id": 3154,
    "question": "liikkua",
    "answer": "move",
    "ru": "переезжать"
  },
  {
    "id": 3155,
    "question": "helposti",
    "answer": "easily",
    "ru": "легко"
  },
  {
    "id": 3156,
    "question": "tarvittaessa",
    "answer": "if necessary",
    "ru": "при необходимости"
  },
  {
    "id": 3157,
    "question": "omaisuuden",
    "answer": "property",
    "ru": "имущество"
  },
  {
    "id": 3158,
    "question": "ylläpitovastuuta",
    "answer": "maintenance responsibility",
    "ru": "ответственность за обслуживание"
  },
  {
    "id": 3159,
    "question": "tuntua",
    "answer": "seem",
    "ru": "казаться"
  },
  {
    "id": 3160,
    "question": "turvalliselta",
    "answer": "safe",
    "ru": "безопасным"
  },
  {
    "id": 3161,
    "question": "vuokrankorotuksen",
    "answer": "rent increase",
    "ru": "повышение арендной платы"
  },
  {
    "id": 3162,
    "question": "käsittelemistä",
    "answer": "processing",
    "ru": "обработку"
  },
  {
    "id": 3163,
    "question": "ostaminen",
    "answer": "purchase",
    "ru": "покупка"
  },
  {
    "id": 3164,
    "question": "tunteen",
    "answer": "feeling",
    "ru": "чувство"
  },
  {
    "id": 3165,
    "question": "pitkän",
    "answer": "long",
    "ru": "длинного"
  },
  {
    "id": 3166,
    "question": "aikavälin",
    "answer": "interval",
    "ru": "промежуток времени"
  },
  {
    "id": 3167,
    "question": "investoinnin",
    "answer": "investment",
    "ru": "инвестиция"
  },
  {
    "id": 3168,
    "question": "tilaasi",
    "answer": "your space",
    "ru": "своё пространство"
  },
  {
    "id": 3169,
    "question": "liittyy",
    "answer": "is related",
    "ru": "связано"
  },
  {
    "id": 3170,
    "question": "vastuu",
    "answer": "responsibility",
    "ru": "ответственность"
  },
  {
    "id": 3171,
    "question": "ylläpidosta",
    "answer": "maintenance",
    "ru": "за обслуживание"
  },
  {
    "id": 3172,
    "question": "liittyä",
    "answer": "be joined",
    "ru": "присоединяться"
  },
  {
    "id": 3173,
    "question": "pitkäaikainen",
    "answer": "prolonged",
    "ru": "долгосрочный"
  },
  {
    "id": 3174,
    "question": "sitoumus",
    "answer": "commitment",
    "ru": "обязательство"
  },
  {
    "id": 3175,
    "question": "asuntolainamaksut",
    "answer": "mortgage payments",
    "ru": "выплаты по ипотеке"
  },
  {
    "id": 3176,
    "question": "kiinteistövero",
    "answer": "property tax",
    "ru": "налог на имущество"
  },
  {
    "id": 3177,
    "question": "vuokrauksen",
    "answer": "rental",
    "ru": "аренды"
  },
  {
    "id": 3178,
    "question": "henkilökohtaisista",
    "answer": "personal ones",
    "ru": "личных"
  },
  {
    "id": 3179,
    "question": "mieltymyksistä",
    "answer": "preferences",
    "ru": "предпочтения"
  },
  {
    "id": 3180,
    "question": "taloudellisesta",
    "answer": "financial",
    "ru": "финансового"
  },
  {
    "id": 3181,
    "question": "suosivat",
    "answer": "favored",
    "ru": "предпочитают"
  },
  {
    "id": 3182,
    "question": "arvostavat",
    "answer": "appreciate",
    "ru": "ценят"
  },
  {
    "id": 3183,
    "question": "kiinteistön",
    "answer": "real estate",
    "ru": "недвижимости"
  },
  {
    "id": 3184,
    "question": "omistamisen",
    "answer": "ownership",
    "ru": "владение"
  },
  {
    "id": 3185,
    "question": "turvallisuutta",
    "answer": "security",
    "ru": "безопасность"
  },
  {
    "id": 3186,
    "question": "investointipotentiaalia",
    "answer": "investment potential",
    "ru": "инвестиционный потенциал"
  },
  {
    "id": 3187,
    "question": "yksilölliset",
    "answer": "individual",
    "ru": "индивидуальные"
  },
  {
    "id": 3188,
    "question": "tarpeet",
    "answer": "requisites",
    "ru": "потребности"
  },
  {
    "id": 3189,
    "question": "tavoitteet",
    "answer": "goals",
    "ru": "цели"
  },
  {
    "id": 3190,
    "question": "päätöstä",
    "answer": "decision",
    "ru": "решения"
  },
  {
    "id": 3191,
    "question": "tehdessä",
    "answer": "while doing",
    "ru": "при принятии"
  },
  {
    "id": 3192,
    "question": "talous",
    "answer": "economic",
    "ru": "экономика"
  },
  {
    "id": 3193,
    "question": "herättää",
    "answer": "wake",
    "ru": "пробуждает"
  },
  {
    "id": 3194,
    "question": "kotitalouksissa",
    "answer": "in households",
    "ru": "в домохозяйствах"
  },
  {
    "id": 3195,
    "question": "mielipiteitä",
    "answer": "opinions",
    "ru": "мнения"
  },
  {
    "id": 3196,
    "question": "keskustelua",
    "answer": "conversation",
    "ru": "разговор"
  },
  {
    "id": 3197,
    "question": "ymmärtäminen",
    "answer": "understanding",
    "ru": "понимание"
  },
  {
    "id": 3198,
    "question": "mihin",
    "answer": "where",
    "ru": "куда"
  },
  {
    "id": 3199,
    "question": "menevät",
    "answer": "are going",
    "ru": "идут"
  },
  {
    "id": 3200,
    "question": "ratkaisevan",
    "answer": "decisively",
    "ru": "решающим образом"
  },
  {
    "id": 3201,
    "question": "taloudellisen",
    "answer": "financial",
    "ru": "финансовый"
  },
  {
    "id": 3202,
    "question": "ylläpitämiseksi",
    "answer": "to maintain",
    "ru": "для поддержания"
  },
  {
    "id": 3203,
    "question": "tarpeiden",
    "answer": "needs",
    "ru": "потребностей"
  },
  {
    "id": 3204,
    "question": "tyydyttämiseksi",
    "answer": "to satisfy",
    "ru": "для удовлетворения"
  },
  {
    "id": 3205,
    "question": "sisältyy",
    "answer": "is included",
    "ru": "включает"
  },
  {
    "id": 3206,
    "question": "tyypillisesti",
    "answer": "typically",
    "ru": "как правило"
  },
  {
    "id": 3207,
    "question": "tarpeita",
    "answer": "needs",
    "ru": "нужды"
  },
  {
    "id": 3208,
    "question": "asuminen",
    "answer": "residence",
    "ru": "проживание"
  },
  {
    "id": 3209,
    "question": "apurahat",
    "answer": "scholarships",
    "ru": "стипендии"
  },
  {
    "id": 3210,
    "question": "koulutus",
    "answer": "training",
    "ru": "образование"
  },
  {
    "id": 3211,
    "question": "terveydenhuolto",
    "answer": "health care",
    "ru": "здравоохранение"
  },
  {
    "id": 3212,
    "question": "varoja",
    "answer": "funds",
    "ru": "средства"
  },
  {
    "id": 3213,
    "question": "vapaaajan",
    "answer": "free time",
    "ru": "свободное время"
  },
  {
    "id": 3214,
    "question": "toimintaan",
    "answer": "into action",
    "ru": "в деятельность"
  },
  {
    "id": 3215,
    "question": "säästöihin",
    "answer": "to savings",
    "ru": "на сбережения"
  },
  {
    "id": 3216,
    "question": "odottamattomiin",
    "answer": "to the unexpected",
    "ru": "к непредвиденным"
  },
  {
    "id": 3217,
    "question": "taloudellisia",
    "answer": "economical",
    "ru": "финансовые"
  },
  {
    "id": 3218,
    "question": "tehtäessä",
    "answer": "while doing",
    "ru": "при принятии"
  },
  {
    "id": 3219,
    "question": "kommunikoivat",
    "answer": "communicate",
    "ru": "общаются"
  },
  {
    "id": 3220,
    "question": "pääsevät",
    "answer": "can get",
    "ru": "могут получить"
  },
  {
    "id": 3221,
    "question": "yhteisymmärrykseen",
    "answer": "to consensus",
    "ru": "к консенсусу"
  },
  {
    "id": 3222,
    "question": "valitsevat",
    "answer": "choose",
    "ru": "выбирают"
  },
  {
    "id": 3223,
    "question": "molemmat",
    "answer": "both",
    "ru": "оба"
  },
  {
    "id": 3224,
    "question": "puolisot",
    "answer": "spouses",
    "ru": "супруги"
  },
  {
    "id": 3225,
    "question": "budjetointi",
    "answer": "budgeting",
    "ru": "составление бюджета"
  },
  {
    "id": 3226,
    "question": "menopäätöksiin",
    "answer": "spending decisions",
    "ru": "решения о расходах"
  },
  {
    "id": 3227,
    "question": "riippumattomampaa",
    "answer": "more independent",
    "ru": "более независимый"
  },
  {
    "id": 3228,
    "question": "lähestymistapaa",
    "answer": "approach",
    "ru": "подход"
  },
  {
    "id": 3229,
    "question": "kumppani",
    "answer": "companion",
    "ru": "партнёр"
  },
  {
    "id": 3230,
    "question": "hallita",
    "answer": "control",
    "ru": "управлять"
  },
  {
    "id": 3231,
    "question": "omaa",
    "answer": "own",
    "ru": "собственный"
  },
  {
    "id": 3232,
    "question": "valittu",
    "answer": "chosen",
    "ru": "выбранный"
  },
  {
    "id": 3233,
    "question": "lähestymistapa",
    "answer": "approach",
    "ru": "подход"
  },
  {
    "id": 3234,
    "question": "kulutustottumuksista",
    "answer": "consumption habits",
    "ru": "привычки потребления"
  },
  {
    "id": 3235,
    "question": "yleisestä",
    "answer": "from the general",
    "ru": "от общего"
  },
  {
    "id": 3236,
    "question": "luottamuksen",
    "answer": "trust",
    "ru": "доверие"
  },
  {
    "id": 3237,
    "question": "kommunikoinnin",
    "answer": "communication",
    "ru": "общения"
  },
  {
    "id": 3238,
    "question": "tasosta",
    "answer": "level",
    "ru": "уровень"
  },
  {
    "id": 3239,
    "question": "pankkitilin",
    "answer": "bank account",
    "ru": "банковский счёт"
  },
  {
    "id": 3240,
    "question": "erillisistä",
    "answer": "of separate ones",
    "ru": "отдельных"
  },
  {
    "id": 3241,
    "question": "tileistä",
    "answer": "accounts",
    "ru": "счетов"
  },
  {
    "id": 3242,
    "question": "henkilökohtainen",
    "answer": "personal",
    "ru": "личный"
  },
  {
    "id": 3243,
    "question": "yhteiset",
    "answer": "common",
    "ru": "общие"
  },
  {
    "id": 3244,
    "question": "avoimuutta",
    "answer": "transparency",
    "ru": "прозрачность"
  },
  {
    "id": 3245,
    "question": "helpottaa",
    "answer": "facilitate",
    "ru": "облегчает"
  },
  {
    "id": 3246,
    "question": "yhteisten",
    "answer": "common",
    "ru": "общих"
  },
  {
    "id": 3247,
    "question": "taloudellisten",
    "answer": "financial",
    "ru": "финансовых"
  },
  {
    "id": 3248,
    "question": "tavoitteiden",
    "answer": "goals",
    "ru": "целей"
  },
  {
    "id": 3249,
    "question": "saavuttamista",
    "answer": "achievement",
    "ru": "достижение"
  },
  {
    "id": 3250,
    "question": "erilliset",
    "answer": "separate",
    "ru": "раздельные"
  },
  {
    "id": 3251,
    "question": "säilyttää",
    "answer": "retain",
    "ru": "сохранять"
  },
  {
    "id": 3252,
    "question": "riippumattomuus",
    "answer": "independence",
    "ru": "независимость"
  },
  {
    "id": 3253,
    "question": "yksityisyys",
    "answer": "privacy",
    "ru": "конфиденциальность"
  },
  {
    "id": 3254,
    "question": "avainasemassa",
    "answer": "in a key position",
    "ru": "в ключевой позиции"
  },
  {
    "id": 3255,
    "question": "harmonisen",
    "answer": "harmonious",
    "ru": "гармоничного"
  },
  {
    "id": 3256,
    "question": "taloudenhoidossa",
    "answer": "in economics",
    "ru": "в управлении финансами"
  },
  {
    "id": 3257,
    "question": "osallistumiseen",
    "answer": "participation",
    "ru": "участию"
  },
  {
    "id": 3258,
    "question": "talousasioihin",
    "answer": "financial matters",
    "ru": "в финансовых делах"
  },
  {
    "id": 3259,
    "question": "viikkorahan",
    "answer": "weekly allowance",
    "ru": "карманные деньги"
  },
  {
    "id": 3260,
    "question": "myöntämisestä",
    "answer": "granting",
    "ru": "предоставления"
  },
  {
    "id": 3261,
    "question": "useista",
    "answer": "of several",
    "ru": "из нескольких"
  },
  {
    "id": 3262,
    "question": "tuki",
    "answer": "support",
    "ru": "поддержка"
  },
  {
    "id": 3263,
    "question": "taloudellista",
    "answer": "financial",
    "ru": "финансовую"
  },
  {
    "id": 3264,
    "question": "vastuuta",
    "answer": "responsibility",
    "ru": "ответственность"
  },
  {
    "id": 3265,
    "question": "arvoa",
    "answer": "value",
    "ru": "ценность"
  },
  {
    "id": 3266,
    "question": "oikeutettua",
    "answer": "justified",
    "ru": "обоснованный"
  },
  {
    "id": 3267,
    "question": "ajattelutapaa",
    "answer": "way of thinking",
    "ru": "образ мышления"
  },
  {
    "id": 3268,
    "question": "avustusjärjestelmän",
    "answer": "assistance system",
    "ru": "систему помощи"
  },
  {
    "id": 3269,
    "question": "kannustaa",
    "answer": "encourage",
    "ru": "поощрять"
  },
  {
    "id": 3270,
    "question": "budjetointia",
    "answer": "budgeting",
    "ru": "составление бюджета"
  },
  {
    "id": 3271,
    "question": "säästämistä",
    "answer": "saving",
    "ru": "сбережение"
  },
  {
    "id": 3272,
    "question": "valmistaa",
    "answer": "prepare",
    "ru": "готовить"
  },
  {
    "id": 3273,
    "question": "taloudelliseen",
    "answer": "to financial",
    "ru": "к финансовой"
  },
  {
    "id": 3274,
    "question": "riippumattomuuteen",
    "answer": "to independence",
    "ru": "к независимости"
  },
  {
    "id": 3275,
    "question": "määrittäminen",
    "answer": "determining",
    "ru": "определение"
  },
  {
    "id": 3276,
    "question": "riittävän",
    "answer": "enough",
    "ru": "достаточно"
  },
  {
    "id": 3277,
    "question": "vanha",
    "answer": "old",
    "ru": "старый"
  },
  {
    "id": 3278,
    "question": "hoitamaan",
    "answer": "to take care of",
    "ru": "заботиться"
  },
  {
    "id": 3279,
    "question": "suurelta",
    "answer": "from the big one",
    "ru": "от большого"
  },
  {
    "id": 3280,
    "question": "osin",
    "answer": "partly",
    "ru": "частично"
  },
  {
    "id": 3281,
    "question": "kypsyydestään",
    "answer": "of its maturity",
    "ru": "о его зрелости"
  },
  {
    "id": 3282,
    "question": "ymmärtämisestä",
    "answer": "about understanding",
    "ru": "о понимании"
  },
  {
    "id": 3283,
    "question": "osoittaa",
    "answer": "point",
    "ru": "указывать"
  },
  {
    "id": 3284,
    "question": "vastuullisia",
    "answer": "responsible",
    "ru": "ответственные"
  },
  {
    "id": 3285,
    "question": "rahanhallintataitoja",
    "answer": "money management skills",
    "ru": "навыки управления деньгами"
  },
  {
    "id": 3286,
    "question": "varhaisessa",
    "answer": "early on",
    "ru": "в раннем"
  },
  {
    "id": 3287,
    "question": "iässä",
    "answer": "at the age of",
    "ru": "в возрасте"
  },
  {
    "id": 3288,
    "question": "ohjausta",
    "answer": "guidance",
    "ru": "руководство"
  },
  {
    "id": 3289,
    "question": "koulutusta",
    "answer": "education",
    "ru": "образование"
  },
  {
    "id": 3290,
    "question": "talouslukutaidon",
    "answer": "financial literacy",
    "ru": "финансовая грамотность"
  },
  {
    "id": 3291,
    "question": "esittely",
    "answer": "demonstration",
    "ru": "введение"
  },
  {
    "id": 3292,
    "question": "nuorena",
    "answer": "when young",
    "ru": "в молодости"
  },
  {
    "id": 3293,
    "question": "asteittainen",
    "answer": "gradual",
    "ru": "постепенный"
  },
  {
    "id": 3294,
    "question": "antaminen",
    "answer": "administration",
    "ru": "предоставление"
  },
  {
    "id": 3295,
    "question": "kulutuspäätöksiään",
    "answer": "their consumption decisions",
    "ru": "свои решения о расходах"
  },
  {
    "id": 3296,
    "question": "edistämään",
    "answer": "to promote",
    "ru": "для продвижения"
  },
  {
    "id": 3297,
    "question": "tervettä",
    "answer": "hi",
    "ru": "здоровое"
  },
  {
    "id": 3298,
    "question": "suhdetta",
    "answer": "relationship",
    "ru": "отношение"
  },
  {
    "id": 3299,
    "question": "rahaan",
    "answer": "to money",
    "ru": "к деньгам"
  },
  {
    "id": 3300,
    "question": "kädessä",
    "answer": "on",
    "ru": "в руке"
  },
  {
    "id": 3301,
    "question": "kunnioitus",
    "answer": "respect",
    "ru": "уважение"
  },
  {
    "id": 3302,
    "question": "yhteinen",
    "answer": "common",
    "ru": "общий"
  },
  {
    "id": 3303,
    "question": "ymmärrys",
    "answer": "understanding",
    "ru": "понимание"
  },
  {
    "id": 3304,
    "question": "terveen",
    "answer": "cheers",
    "ru": "здорового"
  },
  {
    "id": 3305,
    "question": "säilyttämiseksi",
    "answer": "for preservation",
    "ru": "для сохранения"
  },
  {
    "id": 3306,
    "question": "kulutuksessa",
    "answer": "in consumption",
    "ru": "в потреблении"
  },
  {
    "id": 3307,
    "question": "edistämällä",
    "answer": "by promoting",
    "ru": "продвигая"
  },
  {
    "id": 3308,
    "question": "kannustavaa",
    "answer": "encouraging",
    "ru": "поощрительную"
  },
  {
    "id": 3309,
    "question": "ympäristöä",
    "answer": "environment",
    "ru": "среду"
  },
  {
    "id": 3310,
    "question": "rohkaisee",
    "answer": "encourages",
    "ru": "поощряет"
  },
  {
    "id": 3311,
    "question": "talouskasvatusta",
    "answer": "economic education",
    "ru": "финансовое воспитание"
  },
  {
    "id": 3312,
    "question": "vastuullisuutta",
    "answer": "responsibility",
    "ru": "ответственность"
  },
  {
    "id": 3313,
    "question": "kehittää",
    "answer": "develop",
    "ru": "развивать"
  },
  {
    "id": 3314,
    "question": "positiivisia",
    "answer": "positive ones",
    "ru": "положительные"
  },
  {
    "id": 3315,
    "question": "rahankäyttötottumuksia",
    "answer": "spending habits",
    "ru": "привычки расходов"
  },
  {
    "id": 3316,
    "question": "hyödyttävät",
    "answer": "are beneficial",
    "ru": "полезны"
  },
  {
    "id": 3317,
    "question": "jäseniä",
    "answer": "members",
    "ru": "членов"
  },
  {
    "id": 3318,
    "question": "pitkällä",
    "answer": "far",
    "ru": "в долгосрочной"
  },
  {
    "id": 3319,
    "question": "aikavälillä",
    "answer": "time interval",
    "ru": "временной промежуток"
  },
  {
    "id": 3320,
    "question": "nykyaikaisen",
    "answer": "modern",
    "ru": "современного"
  },
  {
    "id": 3321,
    "question": "terveydenhuollon",
    "answer": "healthcare",
    "ru": "здравоохранения"
  },
  {
    "id": 3322,
    "question": "vallitsevat",
    "answer": "prevail",
    "ru": "преобладают"
  },
  {
    "id": 3323,
    "question": "trendit",
    "answer": "trends",
    "ru": "тенденции"
  },
  {
    "id": 3324,
    "question": "herättävät",
    "answer": "rousing",
    "ru": "вызывают"
  },
  {
    "id": 3325,
    "question": "liiallisesta",
    "answer": "from excessive",
    "ru": "о чрезмерной"
  },
  {
    "id": 3326,
    "question": "riippuvuudesta",
    "answer": "of addiction",
    "ru": "о зависимости"
  },
  {
    "id": 3327,
    "question": "erilaisten",
    "answer": "of different kinds",
    "ru": "различных"
  },
  {
    "id": 3328,
    "question": "lisääntyessä",
    "answer": "increasing",
    "ru": "с увеличением"
  },
  {
    "id": 3329,
    "question": "kasvava",
    "answer": "rising",
    "ru": "растущий"
  },
  {
    "id": 3330,
    "question": "pelko",
    "answer": "fear",
    "ru": "страх"
  },
  {
    "id": 3331,
    "question": "liikaa",
    "answer": "too much",
    "ru": "слишком много"
  },
  {
    "id": 3332,
    "question": "liiallinen",
    "answer": "excessive",
    "ru": "чрезмерный"
  },
  {
    "id": 3333,
    "question": "riippuvuus",
    "answer": "addiction",
    "ru": "зависимость"
  },
  {
    "id": 3334,
    "question": "johtua",
    "answer": "be due to",
    "ru": "быть вызванным"
  },
  {
    "id": 3335,
    "question": "itsediagnoosista",
    "answer": "of self-diagnosis",
    "ru": "о самодиагностике"
  },
  {
    "id": 3336,
    "question": "käsikauppalääkkeiden",
    "answer": "of over-the-counter medicines",
    "ru": "безрецептурных лекарств"
  },
  {
    "id": 3337,
    "question": "laajasta",
    "answer": "from extensive",
    "ru": "из широкого"
  },
  {
    "id": 3338,
    "question": "halu",
    "answer": "desire",
    "ru": "желание"
  },
  {
    "id": 3339,
    "question": "nopeisiin",
    "answer": "to fast ones",
    "ru": "к быстрым"
  },
  {
    "id": 3340,
    "question": "korjauksiin",
    "answer": "for repairs",
    "ru": "для ремонта"
  },
  {
    "id": 3341,
    "question": "ollen",
    "answer": "being",
    "ru": "будучи"
  },
  {
    "id": 3342,
    "question": "suuntaus",
    "answer": "trend",
    "ru": "тенденция"
  },
  {
    "id": 3343,
    "question": "osaltaan",
    "answer": "for his part",
    "ru": "со своей стороны"
  },
  {
    "id": 3344,
    "question": "peittää",
    "answer": "cover",
    "ru": "скрывать"
  },
  {
    "id": 3345,
    "question": "taustalla",
    "answer": "in the background",
    "ru": "на заднем плане"
  },
  {
    "id": 3346,
    "question": "terveysongelmia",
    "answer": "health problems",
    "ru": "проблемы со здоровьем"
  },
  {
    "id": 3347,
    "question": "haitata",
    "answer": "hinder",
    "ru": "препятствовать"
  },
  {
    "id": 3348,
    "question": "kokonaisvaltaisten",
    "answer": "comprehensive",
    "ru": "комплексных"
  },
  {
    "id": 3349,
    "question": "lähestymistapojen",
    "answer": "of approaches",
    "ru": "подходов"
  },
  {
    "id": 3350,
    "question": "omaksumista",
    "answer": "adoption",
    "ru": "принятие"
  },
  {
    "id": 3351,
    "question": "hyvinvointiin",
    "answer": "to well-being",
    "ru": "к благополучию"
  },
  {
    "id": 3352,
    "question": "keskustelunaihe",
    "answer": "conversation topic",
    "ru": "тема для разговора"
  },
  {
    "id": 3353,
    "question": "olennaisena",
    "answer": "essential",
    "ru": "как существенный"
  },
  {
    "id": 3354,
    "question": "välineenä",
    "answer": "as a tool",
    "ru": "как инструмент"
  },
  {
    "id": 3355,
    "question": "tietoisuuden",
    "answer": "consciousness",
    "ru": "осведомлённость"
  },
  {
    "id": 3356,
    "question": "lisäämisessä",
    "answer": "adding",
    "ru": "в повышении"
  },
  {
    "id": 3357,
    "question": "yleisön",
    "answer": "the audience",
    "ru": "аудиторию"
  },
  {
    "id": 3358,
    "question": "valistamisessa",
    "answer": "in enlightenment",
    "ru": "в просвещении"
  },
  {
    "id": 3359,
    "question": "hoitovaihtoehdoista",
    "answer": "treatment options",
    "ru": "варианты лечения"
  },
  {
    "id": 3360,
    "question": "kuluttajille",
    "answer": "for consumers",
    "ru": "для потребителей"
  },
  {
    "id": 3361,
    "question": "markkinoinnin",
    "answer": "marketing",
    "ru": "маркетинг"
  },
  {
    "id": 3362,
    "question": "mahdollisista",
    "answer": "of possible ones",
    "ru": "о возможных"
  },
  {
    "id": 3363,
    "question": "kielteisistä",
    "answer": "of the negative ones",
    "ru": "об отрицательных"
  },
  {
    "id": 3364,
    "question": "vaikutuksista",
    "answer": "effects",
    "ru": "последствия"
  },
  {
    "id": 3365,
    "question": "kriittinen",
    "answer": "critical",
    "ru": "критический"
  },
  {
    "id": 3366,
    "question": "näkökohta",
    "answer": "aspect",
    "ru": "аспект"
  },
  {
    "id": 3367,
    "question": "tasapainossa",
    "answer": "in equilibrium",
    "ru": "в равновесии"
  },
  {
    "id": 3368,
    "question": "arvokkaan",
    "answer": "valuable",
    "ru": "ценную"
  },
  {
    "id": 3369,
    "question": "tiedon",
    "answer": "of information",
    "ru": "информации"
  },
  {
    "id": 3370,
    "question": "tarjoamisen",
    "answer": "offering",
    "ru": "предоставления"
  },
  {
    "id": 3371,
    "question": "varmistamisen",
    "answer": "verification",
    "ru": "проверка"
  },
  {
    "id": 3372,
    "question": "edistä",
    "answer": "promote",
    "ru": "продвигай"
  },
  {
    "id": 3373,
    "question": "sopimatonta",
    "answer": "inappropriate",
    "ru": "неподходящего"
  },
  {
    "id": 3374,
    "question": "tietyt",
    "answer": "certain ones",
    "ru": "определённые"
  },
  {
    "id": 3375,
    "question": "oikeuta",
    "answer": "justify",
    "ru": "оправдывать"
  },
  {
    "id": 3376,
    "question": "vaihtoehtoiset",
    "answer": "alternative ones",
    "ru": "альтернативные"
  },
  {
    "id": 3377,
    "question": "lähestymistavat",
    "answer": "approaches",
    "ru": "подходы"
  },
  {
    "id": 3378,
    "question": "elämäntapamuutokset",
    "answer": "lifestyle changes",
    "ru": "изменения образа жизни"
  },
  {
    "id": 3379,
    "question": "ruokavaliomuutokset",
    "answer": "dietary changes",
    "ru": "изменения в питании"
  },
  {
    "id": 3380,
    "question": "eilääkehoidot",
    "answer": "non-drug treatments",
    "ru": "немедикаментозное лечение"
  },
  {
    "id": 3381,
    "question": "tehokkaita",
    "answer": "effective",
    "ru": "эффективные"
  },
  {
    "id": 3382,
    "question": "ratkaisuja",
    "answer": "solutions",
    "ru": "решения"
  },
  {
    "id": 3383,
    "question": "tapauksissa",
    "answer": "cases",
    "ru": "в случаях"
  },
  {
    "id": 3384,
    "question": "eihuumetoimenpiteiden",
    "answer": "non-drug interventions",
    "ru": "немедикаментозные вмешательства"
  },
  {
    "id": 3385,
    "question": "harkitulla",
    "answer": "thoughtfully",
    "ru": "обдуманно"
  },
  {
    "id": 3386,
    "question": "soveltamisella",
    "answer": "by applying",
    "ru": "путём применения"
  },
  {
    "id": 3387,
    "question": "merkittävä",
    "answer": "significant",
    "ru": "значительный"
  },
  {
    "id": 3388,
    "question": "yleisen",
    "answer": "general",
    "ru": "общего"
  },
  {
    "id": 3389,
    "question": "hyvinvoinnin",
    "answer": "well-being",
    "ru": "благополучие"
  },
  {
    "id": 3390,
    "question": "edistämisessä",
    "answer": "in promotion",
    "ru": "в продвижении"
  },
  {
    "id": 3391,
    "question": "riippuvuuden",
    "answer": "addiction",
    "ru": "зависимость"
  },
  {
    "id": 3392,
    "question": "vähentämisessä",
    "answer": "in reduction",
    "ru": "в снижении"
  },
  {
    "id": 3393,
    "question": "tiettyjen",
    "answer": "certain",
    "ru": "определённых"
  },
  {
    "id": 3394,
    "question": "terveystilojen",
    "answer": "of health facilities",
    "ru": "медицинских учреждений"
  },
  {
    "id": 3395,
    "question": "hallinnassa",
    "answer": "under control",
    "ru": "под контролем"
  },
  {
    "id": 3396,
    "question": "sellaisia",
    "answer": "such",
    "ru": "такие"
  },
  {
    "id": 3397,
    "question": "voimakkaita",
    "answer": "powerful",
    "ru": "мощные"
  },
  {
    "id": 3398,
    "question": "mahdollisesti",
    "answer": "possibly",
    "ru": "возможно"
  },
  {
    "id": 3399,
    "question": "sivuvaikutuksia",
    "answer": "side effects",
    "ru": "побочные эффекты"
  },
  {
    "id": 3400,
    "question": "tule",
    "answer": "come",
    "ru": "приди"
  },
  {
    "id": 3401,
    "question": "määräämää",
    "answer": "determined by",
    "ru": "назначенного"
  },
  {
    "id": 3402,
    "question": "reseptiä",
    "answer": "recipe",
    "ru": "рецепт"
  },
  {
    "id": 3403,
    "question": "käytäntö",
    "answer": "practice",
    "ru": "практика"
  },
  {
    "id": 3404,
    "question": "suojaamaan",
    "answer": "to protect",
    "ru": "защищать"
  },
  {
    "id": 3405,
    "question": "yksilöitä",
    "answer": "individuals",
    "ru": "людей"
  },
  {
    "id": 3406,
    "question": "mahdollisilta",
    "answer": "possible",
    "ru": "возможных"
  },
  {
    "id": 3407,
    "question": "riskeiltä",
    "answer": "from risks",
    "ru": "от рисков"
  },
  {
    "id": 3408,
    "question": "haittavaikutuksilta",
    "answer": "from side effects",
    "ru": "от побочных эффектов"
  },
  {
    "id": 3409,
    "question": "asianmukaisesti",
    "answer": "duly",
    "ru": "надлежащим образом"
  },
  {
    "id": 3410,
    "question": "yksilön",
    "answer": "individual",
    "ru": "личности"
  },
  {
    "id": 3411,
    "question": "sairaushistoria",
    "answer": "medical history",
    "ru": "история болезни"
  },
  {
    "id": 3412,
    "question": "kattava",
    "answer": "comprehensive",
    "ru": "всесторонний"
  },
  {
    "id": 3413,
    "question": "käsitys",
    "answer": "understanding",
    "ru": "понимание"
  },
  {
    "id": 3414,
    "question": "olevat",
    "answer": "those",
    "ru": "те, которые"
  },
  {
    "id": 3415,
    "question": "yhteisvaikutukset",
    "answer": "combined effects",
    "ru": "совместные эффекты"
  },
  {
    "id": 3416,
    "question": "kontekstissa",
    "answer": "in context",
    "ru": "в контексте"
  },
  {
    "id": 3417,
    "question": "keskeinen",
    "answer": "key",
    "ru": "ключевой"
  },
  {
    "id": 3418,
    "question": "terveydenhuoltomaisemaa",
    "answer": "healthcare landscape",
    "ru": "сфера здравоохранения"
  },
  {
    "id": 3419,
    "question": "laadukkaat",
    "answer": "quality ones",
    "ru": "качественные"
  },
  {
    "id": 3420,
    "question": "terveydenhuoltopalvelut",
    "answer": "healthcare services",
    "ru": "услуги здравоохранения"
  },
  {
    "id": 3421,
    "question": "laajasti",
    "answer": "extensively",
    "ru": "широко"
  },
  {
    "id": 3422,
    "question": "hinta",
    "answer": "price",
    "ru": "цена"
  },
  {
    "id": 3423,
    "question": "haaste",
    "answer": "challenge",
    "ru": "вызов"
  },
  {
    "id": 3424,
    "question": "rajalliset",
    "answer": "limited",
    "ru": "ограниченные"
  },
  {
    "id": 3425,
    "question": "resurssit",
    "answer": "resources",
    "ru": "ресурсы"
  },
  {
    "id": 3426,
    "question": "löydettävä",
    "answer": "to be found",
    "ru": "которые нужно найти"
  },
  {
    "id": 3427,
    "question": "tasapaino",
    "answer": "balance",
    "ru": "баланс"
  },
  {
    "id": 3428,
    "question": "välttämättömät",
    "answer": "necessary",
    "ru": "необходимые"
  },
  {
    "id": 3429,
    "question": "lääkkeet",
    "answer": "medicines",
    "ru": "лекарства"
  },
  {
    "id": 3430,
    "question": "edullisia",
    "answer": "affordable",
    "ru": "доступные по цене"
  },
  {
    "id": 3431,
    "question": "väestöryhmien",
    "answer": "population groups",
    "ru": "групп населения"
  },
  {
    "id": 3432,
    "question": "edistetään",
    "answer": "will be promoted",
    "ru": "будет продвигаться"
  },
  {
    "id": 3433,
    "question": "tasapuolista",
    "answer": "equal",
    "ru": "равноправное"
  },
  {
    "id": 3434,
    "question": "terveydenhuoltoa",
    "answer": "healthcare",
    "ru": "здравоохранение"
  },
  {
    "id": 3435,
    "question": "tänne",
    "answer": "here",
    "ru": "сюда"
  },
  {
    "id": 3436,
    "question": "monella",
    "answer": "with many",
    "ru": "многими"
  },
  {
    "id": 3437,
    "question": "tapaa",
    "answer": "to meet",
    "ru": "встречать"
  },
  {
    "id": 3438,
    "question": "maahan",
    "answer": "down",
    "ru": "в страну"
  },
  {
    "id": 3439,
    "question": "ideoita",
    "answer": "ideas",
    "ru": "идеи"
  },
  {
    "id": 3440,
    "question": "taitoja",
    "answer": "skills",
    "ru": "навыки"
  },
  {
    "id": 3441,
    "question": "olevilla",
    "answer": "those who are",
    "ru": "теми, кто есть"
  },
  {
    "id": 3442,
    "question": "vahvistaa",
    "answer": "confirm",
    "ru": "укреплять"
  },
  {
    "id": 3443,
    "question": "yrityksiä",
    "answer": "companies",
    "ru": "компании"
  },
  {
    "id": 3444,
    "question": "taloutta",
    "answer": "economy",
    "ru": "экономику"
  },
  {
    "id": 3445,
    "question": "työperäisestä",
    "answer": "from work",
    "ru": "связанной с работой"
  },
  {
    "id": 3446,
    "question": "maahanmuutosta",
    "answer": "immigration",
    "ru": "иммиграция"
  },
  {
    "id": 3447,
    "question": "voisi",
    "answer": "could",
    "ru": "мог бы"
  },
  {
    "id": 3448,
    "question": "viedä",
    "answer": "to take",
    "ru": "перевозить"
  },
  {
    "id": 3449,
    "question": "muuttavat",
    "answer": "moving",
    "ru": "переезжающие"
  },
  {
    "id": 3450,
    "question": "elämäntapaa",
    "answer": "lifestyle",
    "ru": "образ жизни"
  },
  {
    "id": 3451,
    "question": "vie",
    "answer": "takes",
    "ru": "переносит"
  },
  {
    "id": 3452,
    "question": "suomeen",
    "answer": "to finland",
    "ru": "в Финляндию"
  },
  {
    "id": 3453,
    "question": "oppivat",
    "answer": "are learning",
    "ru": "учатся"
  },
  {
    "id": 3454,
    "question": "suomalaisesta",
    "answer": "from finnish",
    "ru": "от финского"
  },
  {
    "id": 3455,
    "question": "elämäntavasta",
    "answer": "lifestyle",
    "ru": "образ жизни"
  },
  {
    "id": 3456,
    "question": "kunnioittavat",
    "answer": "respect",
    "ru": "уважают"
  },
  {
    "id": 3457,
    "question": "toimimalla",
    "answer": "by acting",
    "ru": "действуя"
  },
  {
    "id": 3458,
    "question": "vahvistumaan",
    "answer": "to get stronger",
    "ru": "Укрепляться"
  },
  {
    "id": 3459,
    "question": "monipuolistumaan",
    "answer": "to diversify",
    "ru": "Диверсифицироваться"
  },
  {
    "id": 3460,
    "question": "säilyttäen",
    "answer": "while preserving",
    "ru": "Сохраняя"
  },
  {
    "id": 3461,
    "question": "identiteettinsä",
    "answer": "their identity",
    "ru": "Свою идентичность"
  }
]
  export default extra_vocabulary;